import * as Sentry from "@sentry/browser";
import '@material/web/button/filled-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/button/text-button.js';
import '@material/web/checkbox/checkbox.js';
import '@material/web/progress/circular-progress.js';
import '@material/web/textfield/outlined-text-field.js';
import '@material/web/textfield/filled-text-field.js';
import '@material/web/dialog/dialog.js';
import '@material/web/icon/icon.js';
import '@material/web/menu/menu.js';
import '@material/web/menu/menu-item.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/list/list.js';
import '@material/web/list/list-item.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';
import '@material/web/button/filled-tonal-button.js';
import '@material/web/iconbutton/filled-tonal-icon-button.js';
import '@material/web/labs/navigationdrawer/navigation-drawer.js';
import '@material/web/chips/chip-set.js';
import '@material/web/chips/input-chip.js';
import '@material/web/chips/filter-chip.js';
import '@material/web/chips/suggestion-chip.js';
import '@material/web/chips/assist-chip.js';
import '@material/web/progress/linear-progress.js';
import '@material/web/divider/divider.js';
import '@material/web/switch/switch.js';
import '@material/web/radio/radio.js';
import moment from 'moment/moment';
import 'moment/locale/ca';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import './style.css';
import { initializeApp } from 'firebase/app';
import { getAnalytics, setUserId } from "firebase/analytics";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, setPersistence, sendPasswordResetEmail, browserLocalPersistence, multiFactor, TotpMultiFactorGenerator, getMultiFactorResolver, sendEmailVerification, updateProfile, useDeviceLanguage, updatePassword, confirmPasswordReset, getIdToken, applyActionCode } from 'firebase/auth';
import { startMcpLogin } from './mcp-login.mjs';
import { getFirestore, collection, getDocs, addDoc, doc, setDoc, getDoc, query, onSnapshot, orderBy, deleteDoc, updateDoc, arrayUnion, writeBatch, where, arrayRemove } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL, uploadBytesResumable, deleteObject } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getPerformance } from "firebase/performance";
import QRCode from 'qrcode';
import {
    getLegacyCommercialFields,
    getProductDetails,
    getProductLines,
    getProductTotal,
    normalizeProductLines,
    normalizeProductText,
    parseProductNumber,
    productLinesMatchFilters,
    productLinesAreValid,
    productMatchesText,
    removeProductHistoryEntry,
    renameSingleProductLine,
    replaceProductHistoryEntry,
    replaceMatchingProductLines
} from './product-lines.mjs';

Sentry.init({
    dsn: "https://e25e93cfa4342fc1585a9e9e5e3564a5@o4508897083654144.ingest.de.sentry.io/4508897085423697"
});

const firebaseConfig = {
    apiKey: "AIzaSyDpM5IRFGfXDV4O_sWNpaHy1XqsBM8XMPg",
    authDomain: "customer.zonatic.tech",
    projectId: "customer-zonatic",
    storageBucket: "customer-zonatic.appspot.com",
    messagingSenderId: "728585533976",
    appId: "1:728585533976:web:f356fb3c373658f89f616d",
    measurementId: "G-HX2PZXTXE4"
};


// Check domain
const domain = window.location.hostname;
if (domain !== 'customer.zonatic.cat' && domain !== 'customer.zonatic.tech' && domain !== 'localhost') {
    window.location.href = 'https://customer.zonatic.tech';
}

// Check query params
const urlParams = new URLSearchParams(window.location.search);
const openProduct = urlParams.get('product');
const openCustomer = urlParams.get('customer');
const verifyEmail = urlParams.get('verifyEmail');
const verifyString = urlParams.get('verifyString');
const action = urlParams.get('action');
const oobCode = urlParams.get('oobCode');
const mode = urlParams.get('mode');
const apiKey = urlParams.get('apiKey');
const lang = urlParams.get('lang');

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth();
startMcpLogin(auth);
const storage = getStorage(app);
const messaging = getMessaging(app);
const perf = getPerformance(app);

setPersistence(auth, browserLocalPersistence);

function cl(...args) {
    if (domain == 'localhost') {
        console.log(...args)
    }
}

function pushGetToken() {
    getToken(messaging, { vapidKey: "BDGR5jH_gHHFfgn3tnxeC3Mq8p5PEGY1OVSfeN0q9rAwcufRI1xoErS0WDrJh1G1psss6kSKKhZER_GjjUfdDjA" }).then((currentToken) => {
        if (currentToken) {
            console.log('Token:', currentToken);
        } else {
            console.log('No registration token available. Request permission to generate one.');
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
}

onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    // Display notification
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
        body: payload.notification.body,
        icon: payload.notification.icon
    };
    new Notification(notificationTitle, notificationOptions);
});

function requestPermission() {
    console.log('Requesting permission...');
    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
        }
    });
}

self.addEventListener('notificationclick', function (event) {
    event.notification.close();
    event.waitUntil(
        clients.openWindow('https://customer.zonatic.tech')
    );
    console.log('Notification click.');
    console.log(event);
    // Do something as the result of the notification click
});

setTimeout(() => {
    if (verifyEmail && verifyString) {
        // if (validateEmail(verifyEmail)) {
        fetch('https://customer-services.zonatic.tech/verify-email?email=' + verifyEmail + '&validationString=' + verifyString)
            .then(response => response.json())
            .then(data => {
                if (data.status == 'success') {
                    showMessage('success', 'email_verified');
                } else {
                    showError('error', 'an_error_has_occurred');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                showError('error', 'an_error_has_occurred');
            });
        // }
    }
    if (mode === 'resetPassword' && oobCode) {
        document.getElementById('dialog_reset_password').show();
        setTimeout(() => {
            document.getElementById('dialog_reset_password_new_password').focus();
        }, 100);
    } else if (mode === 'revertSecondFactorAddition' && oobCode) {
        applyActionCode(auth, oobCode).then((resp) => {
            console.log(resp);
            showMessage('success', 'second_factor_removed');
        })
            .catch((error) => {
                console.error('Error:', error);
                showError('error', 'an_error_has_occurred');
            });
    }
}, 1000);

document.getElementById('dialog_reset_password_confirm_new_password').addEventListener('keyup', (e) => {
    if (e.key === 'Enter') {
        document.getElementById('dialog_reset_password_save').click();
    }
});

document.getElementById('dialog_reset_password_save').addEventListener('click', () => {
    const newPassword = document.getElementById('dialog_reset_password_new_password').value;
    const confirmPassword = document.getElementById('dialog_reset_password_confirm_new_password').value;
    if (!newPassword || !confirmPassword) {
        return;
    }
    if (newPassword !== confirmPassword) {
        return;
    }
    // Check password strength: require uppercase, lowercase, number, min 8 characters, max 4096 characters. Can include other characters (optionally)
    if (!newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+={}\[\]:;"'<>,.?/~`-]{8,4096}$/)) {
        showError('error', 'password_requirements');
        return;
    }



    // fetch('https://customer-services.zonatic.tech/reset-password?oobCode=' + oobCode + '&newPassword=' + newPassword + '&apiKey=' + apiKey)
    //     .then(response => response.json())
    //     .then(data => {
    //         if (data.status == 'success') {
    //             document.getElementById('dialog_reset_password').close();
    //             window.location.href = 'https://customer.zonatic.tech';
    //         } else {
    //             showError('error', 'an_error_has_occurred');
    //         }
    //     })
    //     .catch((error) => {
    //         console.error('Error:', error);
    //         showError('error', 'an_error_has_occurred');
    //     });
    confirmPasswordReset(auth, oobCode, newPassword).then((resp) => {
        document.getElementById('dialog_reset_password').close();
        window.location.href = 'https://customer.zonatic.tech';
    })
        .catch((error) => {
            console.error('Error:', error);
            showError('error', 'an_error_has_occurred');
        })
});

function updateContent(langData) {
    document.querySelectorAll('[data-i18n]').forEach(element => {
        const key = element.getAttribute('data-i18n');
        if (langData[key]) {
            element.textContent = langData[key];
        }
    });
    document.querySelectorAll('[data-label-i18n]').forEach(element => {
        const key = element.getAttribute('data-label-i18n');
        if (langData[key]) {
            element.label = langData[key];
        }
    });
    document.querySelectorAll('[data-title-i18n]').forEach(element => {
        const key = element.getAttribute('data-title-i18n');
        if (langData[key]) {
            element.title = langData[key];
        }
    });
    document.getElementById('footerSpan').innerHTML = 'Zonatic Customer Portal<br>' + langDataLocal['version'] + ' ' + VERSION + '<br><span style="font-family: sans-serif;">©</span> ' + new Date().getFullYear() + ' Zonatic. ' + langDataLocal['all_rights_reserved'] + '.';
}

let langDataLocal = {};
async function setLanguagePreference(lang) {
    localStorage.setItem('language', lang);
    document.documentElement.setAttribute('lang', lang);
    // location.reload();
    fetchLanguageData(lang).then((langData) => {
        langDataLocal = langData;
        updateContent(langData);
    });
}

async function fetchLanguageData(lang) {
    const response = await fetch('assets/lang/' + lang + '.json?t=' + new Date().getTime());
    return response.json();
}

async function changeLanguage(lang) {
    if (lang.startsWith('en')) {
        moment.locale('en-gb');
        await setLanguagePreference('en');
        const langData = await fetchLanguageData('en');
        updateContent(langData);
    } else if (lang.startsWith('ca')) {
        moment.locale('ca');
        await setLanguagePreference('ca');
        const langData = await fetchLanguageData('ca');
        updateContent(langData);
    } else if (lang.startsWith('es')) {
        moment.locale('es');
        await setLanguagePreference('es');
        const langData = await fetchLanguageData('es');
        updateContent(langData);
    } else {
        moment.locale('en-gb');
        await setLanguagePreference('en');
        const langData = await fetchLanguageData('en');
        updateContent(langData);
    }
}

let userData = null;
let userClaims = {};
let passedTOTP = false;
let products = [];
let productsById = new Map();
let customers = [];
let customerFilterValues = new Set();
let customer_data = null;
let customersAdmin = [];

const PRODUCTS_RENDER_BATCH_SIZE = 250;
let productsRenderLimit = PRODUCTS_RENDER_BATCH_SIZE;
let lastRenderedProducts = [];
let lastRenderedSearchedText = [];

function rebuildProductsIndex() {
    productsById = new Map();
    products.forEach((product) => {
        if (product && product.id) {
            productsById.set(product.id, product);
        }
    });
}

function registerCustomerFilterValue(customer) {
    if (!customer || customerFilterValues.has(customer)) {
        return;
    }
    customerFilterValues.add(customer);
    customers.push(customer);
}

if (localStorage.getItem('language')) {
    changeLanguage(localStorage.getItem('language'));
} else {
    auth.useDeviceLanguage();
    changeLanguage(auth.languageCode);
}

document.getElementById('loginScreen__email').addEventListener('focusout', (event) => {
    document.getElementById('loginScreen__email').reportValidity();
});

const BADGE_COLORS = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000'];

let wildixInjected = false;

onAuthStateChanged(auth, (user) => {

    if (user) {
        Sentry.setUser({
            id: user.uid,
            email: user.email
        });
        if (!user.emailVerified) {
            document.getElementById('splash').style.display = 'none';
            document.getElementById('loginScreen').style.display = 'flex';
            setTimeout(() => {
                document.getElementById('loginScreen__email').focus();
            }, 100);
            return;
        }
        if (multiFactor(user).enrolledFactors.length === 0) {
            document.getElementById('splash').style.display = 'none';
            document.getElementById('loginScreen').style.display = 'none';
            document.getElementById('main').style.display = 'none';
            document.getElementById('enrollTOTP').style.display = 'flex';
            startTOTPenrollment(user);
            return;
        }
        user.getIdTokenResult().then((result) => {

            userClaims = result.claims || {};

            if (userClaims.customerAdmin) {
                document.getElementById('main_dialog_my_profile_manage_users').style.visibility = 'visible';
            } else {
                document.getElementById('main_dialog_my_profile_manage_users').style.visibility = 'hidden';
            }

            if (userClaims.subcustomer !== undefined) {
                document.getElementById('main__header__right__customers').style.display = 'none';
                document.getElementById('main__header__right__manufacturers').style.display = 'none';
            }

            if (userClaims.admin) {
                isAdmin = true;
                if (!wildixInjected) {
                    const wildixFlag = urlParams.get('wildix');
                    if (!wildixFlag) {

                    } else {
                        wildixInjected = true;
                        window.Wildix = window.Wildix || {};

                        Wildix.Interaction = (function () {

                            var apiVersion = 1;
                            var COLLABORATION_WEB_APP_API = "COLLABORATION_WEB_APP";

                            var pbxVersion = null;
                            var initialized = false;

                            var _requestsCallback = {};
                            var _eventCallback = {};

                            function _generateID(len) {
                                if (!len) {
                                    len = 32;
                                }
                                var text = "";
                                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                                for (var i = 0; i < len; i++)
                                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                                return text;
                            }

                            function processPostMessage(event) {
                                try {
                                    var message = null;
                                    if (event.data && event.data != '') {
                                        try {
                                            message = JSON.parse(event.data);
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }

                                    if (message && message.hasOwnProperty('message')) {
                                        switch (message.message.substr(0, 2)) {
                                            case 'E_': message.type = 'event';
                                                break;
                                            case 'R_': message.type = 'response';
                                                break;
                                            default: message.type = 'message';
                                                break;
                                        }
                                        var app = message.message.substr(2);
                                        if (app != COLLABORATION_WEB_APP_API) {
                                            return;
                                        }
                                    }
                                } catch (e) {
                                    console.log("Failed to process API response: ", e);
                                }

                                if (message && message.hasOwnProperty('id')) {
                                    if (message.type == 'response' && _requestsCallback.hasOwnProperty(message.id)) {
                                        if (_requestsCallback[message.id].hasOwnProperty('callback')) {
                                            _requestsCallback[message.id]['callback'](message.msgdata);
                                        }
                                        delete _requestsCallback[message.id];
                                    } else if (message.type == 'event' && _eventCallback.hasOwnProperty(message.msgdata.event)) {
                                        var eventCallbacks = _eventCallback[message.msgdata.event];
                                        if (eventCallbacks.length > 0) {
                                            for (var i = 0; i < eventCallbacks.length; i++) {
                                                eventCallbacks[i](message.msgdata.msgdata);
                                            }
                                        }
                                    }
                                }
                            }

                            function send(message) {
                                return new Promise((resolve, reject) => {
                                    if (!message) {
                                        reject("Message is undefined");
                                        return;
                                    }

                                    if (!message.hasOwnProperty('id')) {
                                        message.id = _generateID();
                                    }

                                    _requestsCallback[message.id] = {
                                        callback: resolve
                                    };

                                    message.version = apiVersion;
                                    message.message = "M_" + COLLABORATION_WEB_APP_API;

                                    window.parent.postMessage(JSON.stringify(message), '*');

                                    // Set a timeout for the response
                                    setTimeout(() => {
                                        if (_requestsCallback[message.id]) {
                                            delete _requestsCallback[message.id];
                                            reject("Request timed out");
                                        }
                                    }, 5000); // Timeout set to 5 seconds
                                });
                            }

                            return {
                                initialize: function () {
                                    return new Promise((resolve, reject) => {
                                        try {
                                            if (window.parent) {
                                                // attach postMessage event to handler
                                                if (window.attachEvent) {
                                                    window.attachEvent('onmessage', processPostMessage);
                                                } else {
                                                    window.addEventListener('message', processPostMessage, false);
                                                }

                                                this.getVersion().then(response => {
                                                    if (response && response.type === 'result') {
                                                        pbxVersion = response.result;
                                                        initialized = true;
                                                        resolve("API initialized successfully.");
                                                    } else {
                                                        reject("Failed to initialize API.");
                                                    }
                                                }).catch(reject);
                                            } else {
                                                reject("No parent window detected.");
                                            }
                                        } catch (e) {
                                            reject(e);
                                        }
                                    });
                                },

                                isInitialized: function () {
                                    return Promise.resolve({
                                        type: 'result',
                                        result: initialized
                                    });
                                },

                                getVersion: function () {
                                    return send({
                                        'msgdata': {
                                            'command': 'getVersion'
                                        }
                                    });
                                },

                                getCalls: function () {
                                    return send({
                                        'msgdata': {
                                            'command': 'getCalls'
                                        }
                                    });
                                },

                                call: function (number) {
                                    return send({
                                        'msgdata': {
                                            'command': 'call',
                                            'msgdata': {
                                                'number': number
                                            }
                                        }
                                    });
                                },

                                on: function (event, callback) {
                                    if (_eventCallback.hasOwnProperty(event) && _eventCallback[event].length > 0) {
                                        _eventCallback[event].push(callback);
                                        return Promise.resolve();
                                    }

                                    return send({
                                        'msgdata': {
                                            'command': 'onEvent',
                                            'msgdata': {
                                                'event': event
                                            }
                                        }
                                    }).then(result => {
                                        if (!_eventCallback.hasOwnProperty(event)) {
                                            _eventCallback[event] = [];
                                        }
                                        _eventCallback[event].push(callback);
                                        return result;
                                    });
                                },

                                off: function (event, callback) {
                                    return new Promise((resolve) => {
                                        if (!callback) {
                                            if (_eventCallback.hasOwnProperty(event)) {
                                                delete _eventCallback[event];
                                            }
                                        } else {
                                            if (_eventCallback.hasOwnProperty(event)) {
                                                var eventCallbacks = _eventCallback[event];
                                                if (eventCallbacks.length > 0) {
                                                    for (var i = 0; i < eventCallbacks.length; i++) {
                                                        if (eventCallbacks[i] === callback) {
                                                            eventCallbacks.splice(i, 1);
                                                        }
                                                    }
                                                }

                                                if (eventCallbacks.length == 0) {
                                                    delete _eventCallback[event];
                                                }
                                            }
                                        }

                                        if (!_eventCallback.hasOwnProperty(event)) {
                                            send({
                                                'msgdata': {
                                                    'command': 'offEvent',
                                                    'msgdata': {
                                                        'event': event
                                                    }
                                                }
                                            }).then(resolve).catch(resolve);
                                        } else {
                                            resolve();
                                        }
                                    });
                                }
                            };
                        })();


                        Wildix.Interaction.initialize()
                            .then(response => {
                                console.log(response);

                                Wildix.Interaction.on('call', function (data) {
                                    console.log('Call event:', data);
                                });

                                Wildix.Interaction.on('callEnd', function (data) {
                                    console.log('Call end event:', data);
                                });

                                Wildix.Interaction.on('callStart', function (data) {
                                    console.log('Call start event:', data);
                                });

                                Wildix.Interaction.on('callIncoming', function (data) {
                                    console.log('Call incoming event:', data);
                                });

                                Wildix.Interaction.on('callAnswered', function (data) {
                                    console.log('Call answered event:', data);
                                });

                                Wildix.Interaction.on('callRejected', function (data) {
                                    console.log('Call rejected event:', data);
                                });

                                Wildix.Interaction.on('callMissed', function (data) {
                                    console.log('Call missed event:', data);
                                });

                                Wildix.Interaction.on('callTransfer', function (data) {
                                    console.log('Call transfer event:', data);
                                });

                                Wildix.Interaction.on('callTransferEnd', function (data) {
                                    console.log('Call transfer end event:', data);
                                });
                            })
                            .catch(err => {
                                console.error(err);
                            });
                    }


                }
            } else {
                isAdmin = false;
            }


            // Check if there is an open incident
            getDoc(doc(db, "public", "incidents")).then((doc) => {
                if (doc.exists()) {
                    let incident = doc.data();
                    if (incident.open) {
                        document.getElementById('main__content__card__incidences__text').innerHTML = incident.text[auth.languageCode.substring(0, 2)] || '';
                        document.getElementById('main__content__card__incidences').style.display = 'flex';
                    } else {
                        document.getElementById('main__content__card__incidences').style.display = 'none';
                    }
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });


            // async function admin_fetchCustomers() {
            //     console.log('admin_fetchCustomers');
            //     document.getElementById('main__content__card__customers').style.display = 'flex';
            //     let customersList = document.getElementById('main_list_customers');
            //     customersList.innerHTML = '';
            //     let customers = [];
            //     const q = query(collection(db, "customers"), orderBy("name"));
            //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
            //         customers = [];
            //         querySnapshot.forEach((doc) => {
            //             let customer = doc.data();
            //             customer.id = doc.id;
            //             customers.push(customer);
            //         });
            //         customersList.innerHTML = '';
            //         customers.forEach((customer, index) => {
            //             let customerItem = document.createElement('md-list-item');
            //             customerItem.setAttribute('data-customer-id', customer.id);
            //             customerItem.setAttribute('interactive', 'true');
            //             let mainDiv = document.createElement('div');
            //             mainDiv.classList.add('listMainDiv');
            //             let leftDiv = document.createElement('div');
            //             leftDiv.classList.add('listLeftDiv');
            //             let customerIcon = document.createElement('md-icon');
            //             customerIcon.setAttribute('translate', 'no');
            //             customerIcon.innerText = 'person';
            //             customerIcon.setAttribute('slot', 'start');
            //             customerIcon.classList.add('listMR16');
            //             leftDiv.appendChild(customerIcon);
            //             let divCustomerMeta1 = document.createElement('div');
            //             let customerName = document.createElement('span');
            //             customerName.innerText = customer.name;
            //             divCustomerMeta1.appendChild(customerName);
            //             divCustomerMeta1.classList.add('verticalDiv');
            //             let customerNumberOfProducts = document.createElement('span');
            //             customerNumberOfProducts.classList.add('sub');
            //             customerNumberOfProducts.innerText = customer.products.length || 0;
            //             if (customerNumberOfProducts.innerText === '1') {
            //                 customerNumberOfProducts.innerText += ' ' + langDataLocal['product'].toLowerCase();
            //             } else {
            //                 customerNumberOfProducts.innerText += ' ' + langDataLocal['products'].toLowerCase();
            //             }
            //             divCustomerMeta1.appendChild(customerNumberOfProducts);
            //             leftDiv.appendChild(divCustomerMeta1);
            //             mainDiv.appendChild(leftDiv);
            //             let rightDiv = document.createElement('div');
            //             rightDiv.classList.add('listRightDiv');
            //             let buttonDetails = document.createElement('md-icon-button');
            //             let buttonDetailsIcon = document.createElement('md-icon');
            //             buttonDetailsIcon.innerText = 'expand_content';
            //             buttonDetailsIcon.setAttribute('translate', 'no');
            //             buttonDetails.appendChild(buttonDetailsIcon);
            //             buttonDetails.addEventListener('click', () => {
            //                 customers.forEach((customer) => {
            //                     if (customer.id === customerItem.getAttribute('data-customer-id')) {
            //                         openCustomerDetails(customer);
            //                     }
            //                 });
            //             });
            //             rightDiv.appendChild(buttonDetails);
            //             mainDiv.appendChild(rightDiv);
            //             customerItem.appendChild(mainDiv);
            //             customersList.appendChild(customerItem);
            //             if (index < customers.length - 1) {
            //                 let divider = document.createElement('md-divider');
            //                 customersList.appendChild(divider);
            //             }
            //         });
            //     });
            // }
            // if (userClaims.admin) {
            //     // document.getElementById('main__content__card__my_products').style.display = 'none';
            //     admin_fetchCustomers();
            // }
            async function fetchProducts() {
                try {
                    const cData = await getCustomerData();

                    customer_data = cData;

                    console.log(cData);

                    startTagsListener();

                    if (cData && cData.logo) {
                        document.getElementById('main__header__left__brandedLogo').src = cData.logo;
                        document.getElementById('separatorBrandedLogo').style.display = 'block';
                        document.getElementById('main__header__left__brandedLogo').style.display = 'block';
                    } else {
                        document.getElementById('separatorBrandedLogo').style.display = 'none';
                        document.getElementById('main__header__left__brandedLogo').style.display = 'none';
                    }

                    if (!isSubcustomer) {
                        console.log('b')
                        if (!isAdmin) {
                            if (cData && cData.products.length > 0) {
                                let length = cData.products.length;
                                const productPromises = cData.products.map(productId => getProductData(productId, 1 / length));

                                products = await Promise.all(productPromises);

                                // Remove undefined products
                                products = products.filter(product => product !== undefined);

                                // Add products with external access
                                // Get firebase auth token
                                const token = await getIdToken(user);
                                const response = await fetch('https://customer-services.zonatic.tech/productsWithExternalAccess?token=' + token);
                                const data = await response.json();
                                products = products.concat(data);

                                // Remove duplicates
                                products = products.filter((product, index, self) =>
                                    index === self.findIndex((t) => (
                                        t.id === product.id
                                    ))
                                );

                                renderProducts(products);


                            }
                        } else {
                            console.log('isAdmin')
                            document.getElementById('main__header__right__global_tools').style.display = 'inline-flex';
                            document.getElementById('main__content__card__my_products__add').style.display = 'inline-flex';
                            ensureProvidersLoaded().catch((error) => {
                                console.error('Error preloading providers', error);
                            });
                            document.getElementById('my_products__filters__customers').style.display = 'none';
                            document.getElementById('my_products__filters__customersadmin').style.display = 'flex';
                            document.getElementById('my_products__filters__subcustomersadmin').style.display = 'flex';
                            // Get all customers
                            const qCustomersAdmin = query(collection(db, "customers"), orderBy("name"));
                            const unsubscribeCustomersAdmin = onSnapshot(qCustomersAdmin, (querySnapshot) => {
                                customersAdmin = [];
                                querySnapshot.forEach((doc) => {
                                    let customer = doc.data();
                                    customer.id = doc.id;
                                    customersAdmin.push(customer);
                                });
                            })
                            // All products from database
                            const q = query(collection(db, "products"), orderBy("name"));
                            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                                products = [];
                                querySnapshot.forEach((doc) => {
                                    let product = doc.data();
                                    product.id = doc.id;
                                    products.push(product);
                                });
                                //renderProducts(products);
                                filterProducts();
                            });
                        }
                    } else {
                        products = cData.products;
                        renderProducts(cData.products);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }

            fetchProducts();

        })

        getDoc(doc(db, "users", user.uid)).then((doc) => {
            document.getElementById('splash').style.display = 'none';
            document.getElementById('main').style.display = 'flex';
            if (doc.exists()) {
                auth.languageCode = doc.data().lang;
                changeLanguage(doc.data().lang);
                userData = doc.data();
            } else {
                useDeviceLanguage(auth);
                changeLanguage(auth.languageCode);
                setDoc(doc(db, "users", user.uid), {
                    lang: auth.languageCode,
                })
                    .then((docRef) => {
                        console.log("Document written with ID: ", docRef.id);
                        userData = docRef.data();
                    })
                    .catch((error) => {
                        console.error("Error adding document: ", error);
                    });
            }
        }).catch((error) => {
            document.getElementById('splash').style.display = 'none';
            document.getElementById('main').style.display = 'flex';
            useDeviceLanguage(auth);
            changeLanguage(auth.languageCode);
            setDoc(doc(db, "users", user.uid), {
                lang: auth.languageCode,
            })
                .then((docRef) => {
                    console.log("Document written with ID: ", docRef.id);
                    userData = docRef.data();
                })
                .catch((error) => {
                    console.error("Error adding document: ", error);
                });
        });

    } else {
        Sentry.setUser(null);
        document.getElementById('splash').style.display = 'none';
        useDeviceLanguage(auth);
        changeLanguage(auth.languageCode);
        document.getElementById('loginScreen').style.display = 'flex';
        setTimeout(() => {
            document.getElementById('loginScreen__email').focus();
        }, 100);
        if (tagsListenerUnsubscribe) {
            tagsListenerUnsubscribe();
            tagsListenerUnsubscribe = null;
        }
        tags = [];
        addProductAssignedTags = [];
        editProductAssignedTags = [];
        bulkEditTagsToAdd = [];
        bulkEditTagsToRemove = [];
    }
});

async function refetchProduct(id) {
    return await getDoc(doc(db, "products", id)).then((doc) => {
        if (doc.exists()) {
            let product = doc.data();
            product.id = doc.id;
            products.forEach((p, index) => {
                if (p.id === id) {
                    products[index] = product;
                }
            });
            // renderProducts(products);
            filterProducts();
            renderTagsInProductDetailsIfOpen();
        } else {
            console.log("No such document!");
        }
    }).catch((error) => {
        console.log("Error getting document:", error);
    });
}

let mfaResolver = null;

document.getElementById('loginScreen__login_button').addEventListener('click', () => {
    const email = document.getElementById('loginScreen__email').value;
    const password = document.getElementById('loginScreen__password').value;
    if (!email || !password) {
        return;
    }
    signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            const user = userCredential.user;
            console.log('User is signed in', user);
            setUserId(analytics, user.uid);
            // Check if user's email is verified
            if (user.emailVerified === true) {
                document.getElementById('loginScreen').style.display = 'none';
            } else {
                sendEmailVerification(user).then(() => {
                    document.getElementById('loginScreen__dialog_verifyEmail').show();
                });
            }
        })
        .catch((error) => {
            switch (error.code) {
                case "auth/multi-factor-auth-required":
                    // Initiate your second factor sign-in flow. (See next step.)
                    // ...
                    mfaResolver = getMultiFactorResolver(getAuth(), error);
                    document.getElementById('loginScreen__dialog_totp').show();
                    break;
                case "auth/too-many-requests":
                    // The user has triggered too many requests to sign in
                    // (e.g. due to forgotten password requests).
                    // ...
                    showError('too_many_requests', 'try_again_later');
                    break;
                case "auth/user-disabled":
                    // The user has been disabled (e.g. in the Firebase console)
                    // ...
                    showError('user_disabled', 'this_user_is_disabled');
                    break;
                // Handle any other errors.
                default:
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log('Error', errorCode, errorMessage);
                    document.getElementById('loginScreen__dialog').show();
            }

        });
});

document.getElementById('loginScreen__totp_code').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('loginScreen__dialog_totp_send').click();
    }
});

document.getElementById('loginScreen__dialog_totp_send').addEventListener('click', () => {
    let code = document.getElementById('loginScreen__totp_code').value;
    if (!code) {
        return;
    }
    let uid = null;
    mfaResolver.hints.forEach((hint) => {
        if (hint.factorId === "totp") {
            uid = hint.uid;
        }
    });
    console.log(mfaResolver.hints)
    const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(uid, code);
    mfaResolver.resolveSignIn(multiFactorAssertion)
        .then((userCredential) => {
            passedTOTP = true;
            document.getElementById('loginScreen__dialog_totp').close();
            document.getElementById('loginScreen').style.display = 'none';
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log('Error', errorCode, errorMessage);

        });
});

document.getElementById('loginScreen__dialog_verifyEmail_close').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog_verifyEmail').close();
});

document.getElementById('loginScreen__dialog_close').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog').close();
});

document.getElementById('loginScreen__email').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('loginScreen__login_button').click();
    }
});

document.getElementById('loginScreen__password').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('loginScreen__login_button').click();
    }
});

document.getElementById('loginScreen__forgot_password').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog_resetPassword').show();
});

document.getElementById('loginScreen__dialog_resetPassword_close').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog_resetPassword').close();
    document.getElementById('loginScreen__email_resetPassword').value = '';
});

document.getElementById('loginScreen__email_resetPassword').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('loginScreen__dialog_resetPassword_send').click();
    }
});

let temp_email_resetPassword = '';
document.getElementById('loginScreen__dialog_resetPassword_send').addEventListener('click', () => {
    const email = document.getElementById('loginScreen__email_resetPassword').value;
    if (!email) {
        return;
    }
    temp_email_resetPassword = email;
    sendPasswordResetEmail(auth, email)
        .then(() => {
            document.getElementById('loginScreen__dialog_resetPassword').close();
            document.getElementById('loginScreen__email_resetPassword').value = '';
            document.getElementById('loginScreen__dialog_resetPassword_success').show();
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log('Error', errorCode, errorMessage);
            document.getElementById('loginScreen__dialog_resetPassword').close();
            document.getElementById('loginScreen__email_resetPassword').value = '';
            document.getElementById('loginScreen__dialog_resetPassword_error').show();
        });
});

document.getElementById('loginScreen__dialog_resetPassword_success_close').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog_resetPassword_success').close();
});

document.getElementById('loginScreen__dialog_resetPassword_error_close').addEventListener('click', () => {
    document.getElementById('loginScreen__dialog_resetPassword_error').close();
    setTimeout(() => {
        document.getElementById('loginScreen__dialog_resetPassword').show();
        document.getElementById('loginScreen__email_resetPassword').value = temp_email_resetPassword;
    }, 100);
});

let totpSecret = null;

async function startTOTPenrollment(user) {
    totpSecret = null;
    document.getElementById('enrollTOTP__dialog_verify_code').value = '';
    // Generate a TOTP secret.
    await multiFactor(user).getSession()
        .then(async (session) => {
            totpSecret = await TotpMultiFactorGenerator.generateSecret(
                session
            );
            const totpUri = totpSecret.generateQrCodeUrl(
                user.email,
                "Customer Zonatic"
            );
            QRCode.toCanvas(document.getElementById('enrollTOTP__qrCode'), totpUri).then(() => {
                // Add logo to QR code
                const canvas = document.getElementById('enrollTOTP__qrCode');
                const ctx = canvas.getContext('2d');
                const img = new Image();
                img.src = 'assets/32.png';
                img.onload = function () {
                    // Add logo to center of QR code
                    const x = (canvas.width - img.width) / 2;
                    const y = (canvas.height - img.height) / 2;
                    ctx.drawImage(img, x, y);
                };
            })
            // Also display this key:
            const secret = totpSecret.secretKey;
            document.getElementById('enrollTOTP_code').value = secret;
        })
        .catch((error) => {
            document.getElementById('enrollTOTP').style.display = 'none';
            document.getElementById('loginScreen').style.display = 'flex';
            document.getElementById('loginScreen__email').value = user.email;
        });

}

document.getElementById('enrollTOTP_button').addEventListener('click', () => {
    document.getElementById('enrollTOTP__dialog_verify').show();
});

document.getElementById('enrollTOTP__dialog_close').addEventListener('click', () => {
    document.getElementById('enrollTOTP__dialog_verify').close();
});

document.getElementById('enrollTOTP__dialog_verify_code').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('enrollTOTP__dialog_send').click();
    }
});

document.getElementById('enrollTOTP__dialog_send').addEventListener('click', async () => {
    const verificationCode = document.getElementById('enrollTOTP__dialog_verify_code').value;
    if (!verificationCode) {
        return;
    }
    if (!totpSecret) return;
    const button = document.getElementById('enrollTOTP__dialog_send');
    button.disabled = true;
    try {
        const multiFactorAssertion = TotpMultiFactorGenerator.assertionForEnrollment(totpSecret, verificationCode);
        await multiFactor(auth.currentUser).enroll(multiFactorAssertion, 'TOTP');
        document.getElementById('enrollTOTP__dialog_verify').close();
        window.location.reload();
    } catch (error) {
        showError('error', 'an_error_has_occurred');
    } finally {
        button.disabled = false;
    }
});

document.getElementById('main__header__right__profile').addEventListener('click', () => {
    document.getElementById('main__header__right__profile_menu').open = !document.getElementById('main__header__right__profile_menu').open;
});

document.getElementById('main__header__right__profile_menu_logout').addEventListener('click', () => {
    document.getElementById('main_dialog_logout').show();
});

document.getElementById('main_dialog_logout_close').addEventListener('click', () => {
    document.getElementById('main_dialog_logout').close();
});

document.getElementById('main_dialog_logout_logout').addEventListener('click', () => {
    document.getElementById('main_dialog_logout').close();
    signOut(auth).then(() => {
        console.log('User signed out successfully');
        window.location.reload();
    }).catch((error) => {
        console.log('Error signing out', error);
    });
});

document.getElementById('main__header__right__profile_menu_my_profile').addEventListener('click', () => {
    document.getElementById('main_dialog_my_profile').show();
    document.getElementById('main_dialog_my_profile_name').value = auth.currentUser.displayName || '';
    document.getElementById('main_dialog_my_profile_email').value = auth.currentUser.email || '';
    document.getElementById('main_dialog_my_profile_language').value = auth.languageCode || 'en';
});

document.getElementById('main_dialog_my_profile_close').addEventListener('click', () => {
    document.getElementById('main_dialog_my_profile').close();
});

document.getElementById('main_dialog_my_profile_save').addEventListener('click', () => {
    const name = document.getElementById('main_dialog_my_profile_name').value;
    if (!name) {
        return;
    }
    updateProfile(auth.currentUser, {
        displayName: name
    }).then(() => {
        auth.languageCode = document.getElementById('main_dialog_my_profile_language').value;
        updateDoc(doc(db, "users", auth.currentUser.uid), {
            lang: auth.languageCode,
        })
            .then(() => {
                changeLanguage(auth.languageCode);
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
            });
        document.getElementById('main_dialog_my_profile').close();
    }).catch((error) => {
        console.log('Error', error);
    });
});

document.getElementById('main_dialog_my_profile_change_password').addEventListener('click', () => {
    document.getElementById('main_dialog_change_password').show();
});

document.getElementById('main_dialog_change_password_close').addEventListener('click', () => {
    document.getElementById('main_dialog_change_password').close();
    document.getElementById('main_dialog_my_profile').show();
});

let temp_email_changePassword = '';
let temp_password_changePassword = '';
let temp_new_password_changePassword = '';

document.getElementById('main_dialog_change_password_save').addEventListener('click', () => {
    const currentPassword = document.getElementById('main_dialog_change_password_current_password').value;
    const newPassword = document.getElementById('main_dialog_change_password_new_password').value;
    const confirmPassword = document.getElementById('main_dialog_change_password_confirm_new_password').value;
    if (!currentPassword || !newPassword || !confirmPassword) {
        return;
    }
    if (newPassword !== confirmPassword) {
        return;
    }
    // Check password strength, minimum 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, can contain special characters
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
        showError('error', 'password_strength');
        return;
    }
    temp_email_changePassword = auth.currentUser.email;
    temp_password_changePassword = currentPassword;
    temp_new_password_changePassword = newPassword;
    document.getElementById('main_dialog_change_password_totp').show();
});

document.getElementById('main_dialog_change_password_totp_code').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('main_dialog_change_password_totp_send').click();
    }
});

document.getElementById('main_dialog_change_password_totp_send').addEventListener('click', () => {
    let code = document.getElementById('main_dialog_change_password_totp_code').value;
    if (!code) {
        return;
    }
    signInWithEmailAndPassword(auth, auth.currentUser.email, temp_password_changePassword)
        .then((userCredential) => {

        })
        .catch((error) => {
            if (error.code === 'auth/multi-factor-auth-required') {
                let uid = null;
                mfaResolver = getMultiFactorResolver(auth, error);
                mfaResolver.hints.forEach((hint) => {
                    if (hint.factorId === "totp") {
                        uid = hint.uid;
                    }
                });
                const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(uid, code);
                mfaResolver.resolveSignIn(multiFactorAssertion)
                    .then((userCredential) => {
                        updatePassword(auth.currentUser, temp_new_password_changePassword).then(() => {
                            document.getElementById('main_dialog_change_password').close();
                            document.getElementById('main_dialog_change_password_totp').close();
                            document.getElementById('main_dialog_my_profile').close();
                        }).catch((error) => {
                            console.log('Error', error);
                        });
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        console.log('Error', errorCode, errorMessage);

                    });
            } else {
                showError('error', 'password_incorrect_try_again');
            }
        });

});


let globalNotifications = [];
let prev_globalNotifications = [];

document.getElementById('main__header__right__global_notifications').addEventListener('click', () => {
    if (!isSubcustomer) {
        openNotificationDialog('customer', null);
    } else {
        openNotificationDialog('subcustomer', products[0].subcustomer);
    }
});

let notification_dialog_type = null;
let notification_dialog_id = null;
let notification_admin_opened_customer = null;
let notification_number = 0;
function openNotificationDialog(type, id) {
    console.log('openNotificationDialog', type, id)
    notification_dialog_type = type;
    notification_dialog_id = id;
    document.getElementById('main_dialog_global_notifications__settings_card').style.display = 'none';
    globalNotifications = [];
    prev_globalNotifications = [];
    document.getElementById('main_dialog_global_notifications').show();
    let chipSet = document.getElementById('main_dialog_global_notifications__mails');
    chipSet.innerHTML = '';
    let addEmailChip = document.createElement('md-assist-chip');
    addEmailChip.label = langDataLocal['add_email'];
    addEmailChip.addEventListener('click', () => {
        if (document.getElementById('main_dialog_global_notifications__mails__add__div').style.display !== 'flex') {
            document.getElementById('main_dialog_global_notifications__mails__add__div').style.display = 'flex';
            document.getElementById('main_dialog_global_notifications__mails__add').value = '';
            setTimeout(() => {
                document.getElementById('main_dialog_global_notifications__mails__add').focus();
            }, 100);
        } else {
            document.getElementById('main_dialog_global_notifications__mails__add__div').style.display = 'none';
        }
    });
    addEmailChip.classList.add('chipAdd');
    let addEmailChipIcon = document.createElement('md-icon');
    addEmailChipIcon.innerText = 'add';
    addEmailChipIcon.setAttribute('slot', 'icon');
    addEmailChipIcon.setAttribute('translate', 'no');
    addEmailChip.appendChild(addEmailChipIcon);
    chipSet.appendChild(addEmailChip);
    notification_number = 0;
    if (!isSubcustomer) {
        if (type === 'customer') {
            if (customerData && customerData.notifications) {
                customerData.notifications.forEach((notification, index) => {
                    getNotification(notification, index, chipSet, customerData.notifications.length);
                });
            } else {
                renderDefaultNotification(chipSet, type);
            }
        } else if (type === 'subcustomer') {
            if (!isSubcustomer) {
                if (customerData && customerData.subcustomers && customerData.subcustomers[id] && customerData.subcustomers[id].notifications) {
                    customerData.subcustomers[id].notifications.forEach((notification, index) => {
                        getNotification(notification, index, chipSet);
                    });
                }
            } else {
                if (customer_data && customer_data.notifications) {
                    customer_data.notifications.forEach((notification, index) => {
                        console.log(notification, index)
                        getNotification(notification, index, chipSet);
                    });
                } else {
                    renderDefaultNotification(chipSet, type);
                }
            }
        } else if (type === 'product') {
            console.log('product!');
            let product = products.find((p) => p.id === id);
            console.log('product', product)
            if (product && product.notifications) {
                product.notifications.forEach((notification, index) => {
                    getNotification(notification, index, chipSet);
                });
            }
        }
    } else {
        console.log('subcustomer');
        if (type === 'subcustomer') {
            if (customer_data && customer_data.notifications && customer_data.notifications.length > 0) {
                console.log(customer_data)
                customer_data.notifications.forEach((notification, index) => {
                    console.log(notification, index)
                    if (notification.type === 'subcustomer') {
                        getNotification(notification, index, chipSet);
                    }
                });
            } else {
                console.log('subcustomer 2');
                renderDefaultNotification(chipSet, 'subcustomer');
            }
        } else if (type === 'product') {
            console.log('product!');
            let product = products.find((p) => p.id === id);
            console.log('product', product)
            if (customer_data && customer_data.notifications && customer_data.notifications.length > 0) {
                console.log(customer_data)
                customer_data.notifications.forEach((notification, index) => {
                    if (notification.type === 'product') {
                        getNotification(notification, index, chipSet);
                    }
                });
            } else {
                renderDefaultNotification(chipSet, 'product');
            }
        }

    }
}

document.getElementById('main_dialog_product_details_notifications_button').addEventListener('click', () => {
    openNotificationDialog('product', openedProduct);
});

function getNotification(notification, index, chipSet, total) {
    if (!isSubcustomer) {
        getDoc(doc(db, "notifications", notification)).then((doc) => {
            if (doc.exists()) {
                let notif = doc.data();
                if ((isAdmin && notif.type === 'customer' && notif.customer === notification_admin_opened_customer) || !isAdmin) {
                    notification_number++;
                    notif.id = doc.id;
                    globalNotifications.push(notif);
                    prev_globalNotifications.push(notif);
                    let chip = document.createElement('md-filter-chip');
                    chip.label = notif.email;
                    if (index == 0) {
                        chip.selected = true;
                        renderNotificationSettings(notif);
                    } else {
                        chip.selected = false;
                    }
                    chip.addEventListener('click', () => {
                        chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {
                            chip.selected = false;
                        });
                        chip.selected = true;
                        renderNotificationSettings(notif);
                    });
                    console.log(notif, notification_admin_opened_customer)
                    chipSet.appendChild(chip);
                }
            }
            if (index === total - 1) {
                if (notification_number === 0) {
                    renderDefaultNotification(chipSet, notification_dialog_type);
                }
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    } else {
        console.log('deb', notification, index, chipSet)
        let notif = notification;
        notification_number++;
        globalNotifications.push(notif);
        prev_globalNotifications.push(notif);
        let chip = document.createElement('md-filter-chip');
        chip.label = notif.email;
        if (index == 0) {
            chip.selected = true;
            renderNotificationSettings(notif);
        } else {
            chip.selected = false;
        }
        chip.addEventListener('click', () => {
            chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {
                chip.selected = false;
            });
            chip.selected = true;
            renderNotificationSettings(notif);
        });
        console.log(notif, notification_admin_opened_customer)
        chipSet.appendChild(chip);
    }
}

function renderDefaultNotification(chipSet, type) {
    let chip = document.createElement('md-filter-chip');
    chip.label = auth.currentUser.email;
    chip.selected = true;
    if (type === 'customer') {
        renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } } });
    } else if (type === 'subcustomer' && isSubcustomer) {
        console.log(customer_data)
        renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } }, subcustomer: customer_data.name });
    } else {
        renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } }, product: openedProduct });
    }
    globalNotifications = [];
    if (type === 'customer') {
        globalNotifications.push({ email: auth.currentUser.email, type: type, data: { notifyExpirations: { enabled: false, schedule: [] } } });
    } else if (type === 'subcustomer' && isSubcustomer) {
        globalNotifications.push({ email: auth.currentUser.email, type: type, data: { notifyExpirations: { enabled: false, schedule: [] } }, subcustomer: customer_data.name });
    } else {
        globalNotifications.push({ email: auth.currentUser.email, type: type, data: { notifyExpirations: { enabled: false, schedule: [] } }, product: openedProduct });
    }
    chip.addEventListener('click', () => {
        chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {
            chip.selected = false;
        });
        chip.selected = true;
        if (type === 'customer') {
            renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } } });
        } else if (type === 'subcustomer' && isSubcustomer) {
            renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } }, subcustomer: customer_data.name });
        } else {
            renderNotificationSettings({ email: auth.currentUser.email, verified: auth.currentUser.emailVerified, data: { notifyExpirations: { enabled: false, schedule: [] } }, product: openedProduct });
        }
    });
    chipSet.appendChild(chip);
}

document.getElementById('main_dialog_global_notifications__mails__add__button').addEventListener('click', (e) => {
    e.preventDefault();
    let email = document.getElementById('main_dialog_global_notifications__mails__add').value;
    if (!email) {
        return;
    }
    // Check if email is valid
    if (!validateEmail(email)) {
        return;
    }
    // Check if email is already in the list
    let exists = false;
    globalNotifications.forEach((notification) => {
        if (notification.email === email) {
            exists = true;
        }
    });
    if (exists) {
        return;
    }

    let chipSet = document.getElementById('main_dialog_global_notifications__mails');
    let chip = document.createElement('md-filter-chip');
    chip.label = email;
    chip.selected = true;
    // Check if email is verified
    // fetch()
    chip.addEventListener('click', () => {
        chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {
            chip.selected = false;
        });
        chip.selected = true;
        renderNotificationSettings({ email: email, verified: true, data: { notifyExpirations: { enabled: false, schedule: [] } }, mod: true });
    });
    chipSet.appendChild(chip);
    setTimeout(() => {
        chip.click();
    }, 100);
    document.getElementById('main_dialog_global_notifications__mails__add__div').style.display = 'none';
    if (notification_dialog_type === 'customer') {
        globalNotifications.push({ email: email, type: notification_dialog_type, data: { notifyExpirations: { enabled: false, schedule: [] } }, mod: true });
    } else if (notification_dialog_type === 'subcustomer') {
        globalNotifications.push({ email: email, type: notification_dialog_type, subcustomer: notification_dialog_id, data: { notifyExpirations: { enabled: false, schedule: [] } }, mod: true });
    } else if (notification_dialog_type === 'product') {
        globalNotifications.push({ email: email, type: notification_dialog_type, product: notification_dialog_id, data: { notifyExpirations: { enabled: false, schedule: [] } }, mod: true });
    }
    document.getElementById('main_dialog_global_notifications__mails__add').value = '';
    document.getElementById('main_dialog_global_notifications__mails__add').focus();
});

document.getElementById('main_dialog_global_notifications__mails__add').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('main_dialog_global_notifications__mails__add__button').click();
    }
});

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

document.getElementById('main_dialog_global_notifications_notify_expirations').addEventListener('change', (event) => {
    if (event.target.selected) {
        document.getElementById('main_dialog_global_notifications_notify_expirations_schedule_div').style.display = 'block';
        // Modify object in globalNotifications
        globalNotifications.forEach((notification) => {
            if (notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label) {
                notification.data.notifyExpirations.enabled = true;
                notification.mod = true;
            }
        });
    } else {
        document.getElementById('main_dialog_global_notifications_notify_expirations_schedule_div').style.display = 'none';
        // Modify object in globalNotifications
        globalNotifications.forEach((notification) => {
            if (notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label) {
                notification.data.notifyExpirations.enabled = false;
                notification.mod = true;
            }
        });
    }
});

function setNotificationLangauge(lang, data) {
    if (lang.length > 2) {
        lang = lang.substring(0, 2);
    }
    console.log(lang, data);
    document.getElementById('main_dialog_global_notifications_language_ca').selected = false;
    document.getElementById('main_dialog_global_notifications_language_en').selected = false;
    document.getElementById('main_dialog_global_notifications_language_es').selected = false;
    document.getElementById('main_dialog_global_notifications_language_' + lang).selected = true;
    // Modify object in globalNotifications
    globalNotifications.forEach((notification, index) => {
        if (notification.email === data.email) {
            notification.data.lang = lang;
            notification.mod = true;
            globalNotifications[index] = notification;
        }
    });
}

function getNotificationLangauge() {
    if (document.getElementById('main_dialog_global_notifications_language_ca').selected) {
        return 'ca';
    } else if (document.getElementById('main_dialog_global_notifications_language_en').selected) {
        return 'en';
    } else if (document.getElementById('main_dialog_global_notifications_language_es').selected) {
        return 'es';
    } else {
        return 'en';
    }
}

document.getElementById('main_dialog_global_notifications_language_ca').addEventListener('click', () => {
    let data = globalNotifications.find((notification) => {
        return notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label;
    });
    setNotificationLangauge('ca', data);
});

document.getElementById('main_dialog_global_notifications_language_en').addEventListener('click', () => {
    let data = globalNotifications.find((notification) => {
        return notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label;
    });
    setNotificationLangauge('en', data);
});

document.getElementById('main_dialog_global_notifications_language_es').addEventListener('click', () => {
    let data = globalNotifications.find((notification) => {
        return notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label;
    });
    setNotificationLangauge('es', data);
});

function renderNotificationSettings(data) {
    if (!data.email) {
        return
    }
    if (data.data) {
        if (data.data.lang) {
            setNotificationLangauge(data.data.lang, data);
        } else {
            setNotificationLangauge(auth.languageCode, data);
        }
    } else {
        setNotificationLangauge(auth.languageCode, data);
    }
    document.getElementById('main_dialog_global_notifications__settings_card').style.display = 'block';
    document.getElementById('main_dialog_global_notifications_notification_types').innerHTML = langDataLocal['notifications_for'] + ' ' + data.email;
    document.getElementById('main_dialog_global_notifications_notify_expirations_schedule').innerHTML = '';
    if (!data.verified) {
        document.getElementById('main_dialog_global_notifications_email_not_verified').style.display = 'flex';
    } else {
        document.getElementById('main_dialog_global_notifications_email_not_verified').style.display = 'none';
    }
    let dateAddChip = document.createElement('md-assist-chip');
    dateAddChip.label = langDataLocal['add_date'];
    dateAddChip.id = 'main_dialog_global_notifications_notify_expirations_schedule__menu__add';
    dateAddChip.addEventListener('click', () => {
        let smenu = document.getElementById('main_dialog_global_notifications_notify_expirations_schedule__menu');
        if (smenu.style.display === 'block') {
            smenu.innerHTML = '';
            smenu.style.display = 'none';
            return;
        }
        smenu.classList.add('smenu');
        let horizontalDiv = document.createElement('div');
        horizontalDiv.style.padding = '16px';
        horizontalDiv.classList.add('align');
        let textField = document.createElement('md-filled-text-field');
        textField.style.marginRight = '16px';
        textField.type = 'number';
        textField.min = 1;
        textField.max = 365;
        let daysSpan = document.createElement('span');
        daysSpan.innerText = langDataLocal['days'];
        horizontalDiv.appendChild(textField);
        horizontalDiv.appendChild(daysSpan);
        smenu.appendChild(horizontalDiv);
        smenu.addEventListener('click', (event) => {
            event.stopPropagation();
        });
        let button = document.createElement('md-filled-button');
        button.style.margin = '16px';
        button.innerText = langDataLocal['add'];
        button.addEventListener('click', (e) => {
            e.preventDefault();
            let days = textField.value;
            if (days) {
                let chip = document.createElement('md-input-chip');
                if (days === '1' || days === 1) {
                    chip.label = days + ' ' + langDataLocal['day'];
                } else {
                    chip.label = days + ' ' + langDataLocal['days'];
                }
                chip.setAttribute('translate', 'no');
                chip.setAttribute('data-days', days);
                // Modify object in globalNotifications
                globalNotifications.forEach((notification) => {
                    if (notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label) {
                        notification.data.notifyExpirations.schedule.push(Number(days));
                        notification.mod = true;
                    }
                });
                console.log(globalNotifications);
                document.getElementById('main_dialog_global_notifications_notify_expirations_schedule').appendChild(chip);
                setTimeout(() => {
                    let shadow = chip.shadowRoot;
                    shadow.querySelector('.trailing').addEventListener('click', (e) => {
                        chip.remove();
                        // Modify object in globalNotifications
                        globalNotifications.forEach((notification, index) => {
                            if (notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label) {
                                notification.data.notifyExpirations.schedule = notification.data.notifyExpirations.schedule.filter((date) => {
                                    return date !== parseInt(chip.getAttribute('data-days'));
                                });
                                notification.mod = true;
                                globalNotifications[index] = notification;
                            }
                        });
                        console.log(globalNotifications);
                    })
                }, 100);

                smenu.innerHTML = '';
                smenu.style.display = 'none';
            }
        });
        textField.addEventListener('keyup', (event) => {
            if (event.keyCode === 13) {
                event.preventDefault();
                button.click();
            }
        });
        smenu.appendChild(button);
        smenu.style.display = 'block';
        setTimeout(() => {
            textField.focus();
        }, 100);

    });
    dateAddChip.classList.add('chipAdd');
    let dateAddChipIcon = document.createElement('md-icon');
    dateAddChipIcon.innerText = 'add';
    dateAddChipIcon.setAttribute('slot', 'icon');
    dateAddChipIcon.setAttribute('translate', 'no');
    dateAddChip.appendChild(dateAddChipIcon);
    document.getElementById('main_dialog_global_notifications_notify_expirations_schedule').appendChild(dateAddChip);
    if (data.data.notifyExpirations) {
        if (data.data.notifyExpirations.enabled) {
            document.getElementById('main_dialog_global_notifications_notify_expirations').selected = true;
            document.getElementById('main_dialog_global_notifications_notify_expirations_schedule_div').style.display = 'block';
        } else {
            document.getElementById('main_dialog_global_notifications_notify_expirations').selected = false;
            document.getElementById('main_dialog_global_notifications_notify_expirations_schedule_div').style.display = 'none';
        }
        if (data.data.notifyExpirations.schedule) {
            data.data.notifyExpirations.schedule.forEach((days) => {
                let chip = document.createElement('md-input-chip');
                if (days === '1' || days === 1) {
                    chip.label = days + ' ' + langDataLocal['day'];
                } else {
                    chip.label = days + ' ' + langDataLocal['days'];
                }
                chip.setAttribute('translate', 'no');
                chip.setAttribute('data-days', days);
                // chip.addEventListener('click', () => {
                //     chip.remove();
                // });
                document.getElementById('main_dialog_global_notifications_notify_expirations_schedule').appendChild(chip);
                setTimeout(() => {
                    let shadow = chip.shadowRoot;
                    shadow.querySelector('.trailing').addEventListener('click', (e) => {
                        chip.remove();
                        // Modify object in globalNotifications
                        globalNotifications.forEach((notification, index) => {
                            if (notification.email === document.getElementById('main_dialog_global_notifications__mails').querySelector('md-filter-chip[selected]').label) {
                                notification.data.notifyExpirations.schedule = notification.data.notifyExpirations.schedule.filter((date) => {
                                    return date !== parseInt(chip.getAttribute('data-days'));
                                });
                                notification.mod = true;
                                globalNotifications[index] = notification;
                            }
                        });
                        console.log(globalNotifications);
                    })
                }, 100);
            })
        }

    }
}

document.addEventListener('click', (event) => {
    if (document.getElementById('main_dialog_global_notifications_notify_expirations_schedule__menu').style.display === 'block') {
        if (event.target.id !== 'main_dialog_global_notifications_notify_expirations_schedule__menu' && event.target.id !== 'main_dialog_global_notifications_notify_expirations_schedule__menu__add') {
            document.getElementById('main_dialog_global_notifications_notify_expirations_schedule__menu').innerHTML = '';
            document.getElementById('main_dialog_global_notifications_notify_expirations_schedule__menu').style.display = 'none';
        }
    }
});

document.getElementById('main_dialog_global_notifications_close').addEventListener('click', () => {
    document.getElementById('main_dialog_global_notifications').close();
    document.getElementById('main_dialog_global_notifications__settings_card').style.display = 'none';
});

function checkIfModified(notification, prev) {
    // Check if notification is modified compared to previous state. It also checks if the notification is new.
    let modified = true;
    prev.forEach((prevNotification) => {
        if (prevNotification.email === notification.email) {
            if (JSON.stringify(prevNotification) === JSON.stringify(notification)) {
                modified = false;
            }
        }
    });
}

document.getElementById('main_dialog_global_notifications_save').addEventListener('click', () => {
    console.log(globalNotifications);
    auth.currentUser.getIdToken().then((token) => {
        globalNotifications.forEach((notification, index) => {
            if (notification.mod || checkIfModified(notification, prev_globalNotifications)) {
                if (notification.data && notification.data.notifyExpirations && notification.data.notifyExpirations.schedule) {
                    notification.data.notifyExpirations.schedule.sort((a, b) => a - b);
                }
                if (notification.id) {
                    // Update
                    notification.token = token;
                    if (isAdmin) {
                        notification.customer = notification_admin_opened_customer;
                    }
                    if (isSubcustomer) {
                        notification.customer = products[0].customer;
                        notification.subcustomer = products[0].subcustomer;
                    }
                    fetch('https://customer-services.zonatic.tech/notifications', {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(notification)
                    })
                        .then(res => {
                            if (res.status === 200) {
                                console.log('Notification updated');
                            } else {
                                console.log('Error updating notification', res.status);
                            }
                        })
                        .catch(error => {
                            console.error('Error updating notification', error);
                        });
                } else {
                    // Create
                    notification.token = token;
                    if (isAdmin) {
                        notification.customer = notification_admin_opened_customer;
                    }
                    if (isSubcustomer) {
                        notification.customer = products[0].customer;
                        notification.subcustomer = products[0].subcustomer;
                    }
                    fetch('https://customer-services.zonatic.tech/notifications', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(notification)
                    })
                        .then(res => {
                            if (res.status === 200) {
                                console.log('Notification created');
                            } else {
                                console.log('Error creating notification', res.status);
                            }
                        })
                        .catch(error => {
                            console.error('Error creating notification', error);
                        });
                }
            }
            if (index === globalNotifications.length - 1) {
                setTimeout(() => {
                    getCustomerData().then((data) => {
                        customerData = data;
                    })
                        .catch((error) => {
                            console.log('Error', error);
                        });
                }, 500);
            }
        });
        document.getElementById('main_dialog_global_notifications').close();
        document.getElementById('main_dialog_global_notifications__settings_card').style.display = 'none';
    })
        .catch((error) => {
            showError('error', 'something_went_wrong_try_again');
        });
});



document.getElementById('main__header__right__feedback').addEventListener('click', () => {
    document.getElementById('main_dialog_feedback').show();
});

document.getElementById('main_dialog_feedback_close').addEventListener('click', () => {
    document.getElementById('main_dialog_feedback').close();
});

document.getElementById('main_dialog_feedback_send').addEventListener('click', () => {
    const feedback = document.getElementById('main_dialog_feedback_text').value;
    if (!feedback) {
        return;
    }
    addDoc(collection(db, "feedback"), {
        uid: auth.currentUser.uid,
        feedback: feedback,
        timestamp: new Date()
    })
        .then((docRef) => {
            console.log("Document written with ID: ", docRef.id);
            document.getElementById('main_dialog_feedback').close();
            document.getElementById('main_dialog_feedback_text').value = '';
            showMessage('success', 'feedback_sent_successfully');
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
            showError('error', 'something_went_wrong_try_again');
        });
});

function showMessage(title, content) {
    document.getElementById('main_dialog_message_title').innerText = langDataLocal[title] || title || '';
    document.getElementById('main_dialog_message_content').innerText = langDataLocal[content] || content || '';
    document.getElementById('main_dialog_message').show();
}

document.getElementById('main_dialog_message_close').addEventListener('click', () => {
    document.getElementById('main_dialog_message').close();
});

function showError(title, content) {
    document.getElementById('main_dialog_error_title').innerText = langDataLocal[title] || title || '';
    document.getElementById('main_dialog_error_content').innerText = langDataLocal[content] || content || '';
    document.getElementById('main_dialog_error').show();
}

document.getElementById('main_dialog_error_close').addEventListener('click', () => {
    document.getElementById('main_dialog_error').close();
});

function showErrorAI(title, content) {
    document.getElementById('main_dialog_error_ai_title').innerText = langDataLocal[title] || title || '';
    document.getElementById('main_dialog_error_ai_content').innerText = langDataLocal[content] || content || '';
    document.getElementById('main_dialog_error_ai').show();
}

document.getElementById('main_dialog_error_ai_close').addEventListener('click', () => {
    document.getElementById('main_dialog_error_ai').close();
});

// Tag manager wiring
document.getElementById('main__header__right__tags')?.addEventListener('click', () => {
    openTagManager();
});

document.getElementById('main_dialog_tag_manager_close')?.addEventListener('click', () => {
    document.getElementById('main_dialog_tag_manager').close();
});

function openTagManager() {
    renderTagManagerList();
    document.getElementById('main_dialog_tag_manager').show();
}

function renderTagManagerList() {
    const container = document.getElementById('main_dialog_tag_manager_list');
    if (!container) return;
    container.innerHTML = '';
    const counts = getTagUsageCounts();
    // sort tags by name
    const sorted = (tags || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    if (sorted.length === 0) {
        const p = document.createElement('p');
        p.className = 'tag-placeholder';
        p.innerText = langDataLocal['no_tags_available'] || 'No tags available';
        container.appendChild(p);
        return;
    }
    sorted.forEach(tag => {
        const row = document.createElement('div');
        row.className = 'tag-manager__row';
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.justifyContent = 'flex-start';
        row.style.padding = '6px 0';

        const left = document.createElement('div');
    left.style.display = 'flex';
    left.style.alignItems = 'center';
    left.style.flex = '1';

        const dot = document.createElement('div');
        dot.className = 'tag-menu-dot';
        dot.style.background = tag.color || '#999';
        dot.style.width = '16px';
        dot.style.height = '16px';
        dot.style.borderRadius = '50%';
        dot.style.marginRight = '10px';
        left.appendChild(dot);

        const name = document.createElement('span');
        name.innerText = tag.name || '';
        name.style.marginRight = '10px';
        left.appendChild(name);

        const count = document.createElement('span');
        count.innerText = `(${counts[tag.id] || 0})`;
        count.style.color = '#666';
        left.appendChild(count);

        row.appendChild(left);

    const actions = document.createElement('div');
    actions.style.display = 'flex';
    actions.style.gap = '8px';
    actions.style.marginLeft = '20px';

        // Rename button
        const rename = document.createElement('md-icon-button');
        rename.title = langDataLocal['rename_tag'] || 'Rename';
        const renameIcon = document.createElement('md-icon');
        renameIcon.innerText = 'edit';
        rename.appendChild(renameIcon);
        rename.addEventListener('click', () => {
            const newName = prompt(langDataLocal['rename_tag'] || 'Rename tag', tag.name || '');
            if (!newName || newName.trim() === '' || newName.trim() === tag.name) return;
            // validate uniqueness
            const exists = (tags || []).some(t => t.name && t.name.toLowerCase() === newName.trim().toLowerCase() && t.id !== tag.id);
            if (exists) {
                showError('error', 'tag_already_exists');
                return;
            }
            handleRenameTag(tag.id, newName.trim());
        });
        actions.appendChild(rename);

        // Delete button
        const del = document.createElement('md-icon-button');
        del.title = langDataLocal['delete_tag'] || 'Delete';
        const delIcon = document.createElement('md-icon');
        delIcon.innerText = 'delete';
        del.appendChild(delIcon);
        if ((counts[tag.id] || 0) > 0) {
            del.setAttribute('disabled', '');
            del.title = langDataLocal['cannot_delete_tag_in_use'] || 'Cannot delete tag because it\'s assigned to products';
        } else {
            del.addEventListener('click', () => {
                const ok = confirm(langDataLocal['confirm_deletion'] || 'Confirm deletion');
                if (!ok) return;
                handleDeleteTag(tag.id);
            });
        }
        actions.appendChild(del);

        row.appendChild(actions);
        container.appendChild(row);
    });
}

function handleRenameTag(tagId, newName) {
    const tagDoc = doc(db, 'tags', tagId);
    updateDoc(tagDoc, { name: newName })
        .then(() => {
            showMessage('success', 'tag_created');
            // re-render to reflect the updated name immediately
            renderTagManagerList();
        })
        .catch((err) => {
            console.error(err);
            showError('error', 'an_error_has_occurred');
        });
}

function handleDeleteTag(tagId) {
    // re-check local counts
    const counts = getTagUsageCounts();
    if ((counts[tagId] || 0) > 0) {
        showError('error', 'cannot_delete_tag_in_use');
        return;
    }
    const tagDoc = doc(db, 'tags', tagId);
    deleteDoc(tagDoc)
        .then(() => {
            showMessage('success', 'tag_created');
            // re-render to remove the deleted tag immediately
            renderTagManagerList();
        })
        .catch((err) => {
            console.error(err);
            showError('error', 'an_error_has_occurred');
        });
}

// setTimeout(() => {
//     showErrorAI('error', 'something_went_wrong_try_again');
// }, 3000)

let customerData = null;
let isSubcustomer = false;
let isAdmin = false;

async function getCustomerData() {
    let customerId = userClaims.customer;
    let subcustomerId = userClaims.subcustomer;
    console.log(userClaims);
    if (userClaims.admin === true) {
        isAdmin = true;
        getDoc(doc(db, "admin", "admin")).then((doc) => {
            if (doc.exists()) {
                customerData = doc.data();
                console.log("Document data:", doc.data());
                return doc.data();
            } else {
                console.log("No such document!");
                return null;
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
            return null;
        });
    } else {
        isAdmin = false;
    }
    if (!customerId) {
        return;
    }
    if (!subcustomerId) {
        return await getDoc(doc(db, "customers", customerId)).then((doc) => {
            if (doc.exists()) {
                customerData = doc.data();
                console.log("Document data:", doc.data());
                return doc.data();
            } else {
                console.log("No such document!");
                return null;
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
            return null;
        });
    } else {
        isSubcustomer = true;
        return auth.currentUser.getIdToken().then((token) => {
            return fetch('https://customer-services.zonatic.tech/subcustomers/' + subcustomerId + '?token=' + token)
                .then(response => response.json())
                .then(data => {
                    return data;
                })
                .catch((error) => {
                    console.error('Error:', error);
                    return null;
                });
        });
    }
}

async function getProductData(productId, increment) {
    return await getDoc(doc(db, "products", productId)).then((doc) => {
        if (doc.exists()) {
            let product = doc.data();
            product.id = doc.id;
            // Create artificial delay that waits to return the product
            document.getElementById('main__content__card__my_products__progress').value = document.getElementById('main__content__card__my_products__progress').value + increment;
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(product);
                }, 1000 * increment);
            });
        } else {
            console.log("No such document!");
            return;
        }
    }).catch((error) => {
        console.log(productId)
        console.log("Error getting document:", error);
        return;
    });
}

function startTagsListener() {
    if (tagsListenerUnsubscribe) {
        return;
    }
    const tagsQuery = query(collection(db, 'tags'), orderBy('name'));
    tagsListenerUnsubscribe = onSnapshot(tagsQuery, (snapshot) => {
        const snapshotTags = [];
        snapshot.forEach((docSnap) => {
            const tagData = docSnap.data();
            tagData.id = docSnap.id;
            snapshotTags.push(tagData);
        });
        tags = snapshotTags;
        tagsById = new Map(tags.map((tag) => [tag.id, tag]));
        addProductAssignedTags = ensureUniqueTagIds(addProductAssignedTags.filter((id) => getTagById(id)));
        editProductAssignedTags = ensureUniqueTagIds(editProductAssignedTags.filter((id) => getTagById(id)));
        bulkEditTagsToAdd = ensureUniqueTagIds(bulkEditTagsToAdd.filter((id) => getTagById(id)));
        bulkEditTagsToRemove = ensureUniqueTagIds(bulkEditTagsToRemove.filter((id) => getTagById(id)));
        if (typeof my_products__filters__tags_activeFilters !== 'undefined') {
            const filtered = ensureUniqueTagIds(my_products__filters__tags_activeFilters.filter((id) => {
                return id === '__WITHOUT__' || !!getTagById(id);
            }));
            const changed = filtered.length !== my_products__filters__tags_activeFilters.length;
            my_products__filters__tags_activeFilters = filtered;
            if (changed) {
                updateTagFilterSelectionState();
            }
        }
        refreshTagAssignmentsUI();
        renderTagsInProductDetailsIfOpen();
        filterProducts();
    }, (error) => {
        console.error('Error listening to tags', error);
    });
}

let openedProduct = null;
let openedProductCustomer = null;
let openedProductHistoryIndex = null;
let currentCustomerNotes = null;
let currentProductNotes = null;

let providers = [];
let providersById = new Map();
let providersRequested = new Set();
function upsertProvider(provider) {
    if (!provider || !provider.id) {
        return;
    }
    const existingIndex = providers.findIndex((p) => p.id === provider.id);
    const nextProvider = existingIndex > -1 ? { ...providers[existingIndex], ...provider } : provider;
    if (existingIndex > -1) {
        providers[existingIndex] = nextProvider;
    } else {
        providers.push(nextProvider);
    }
    providersById.set(provider.id, nextProvider);
}

function getProviderById(providerId) {
    if (!providerId) {
        return null;
    }
    return providersById.get(providerId) || providers.find((provider) => provider.id === providerId) || null;
}

function normalizeEntityName(value) {
    return (value || '').trim().toLocaleUpperCase('ca-ES');
}

function normalizeProductName(value) {
    return String(value ?? '').trim();
}

function getContractDurationMs(durationNumber, durationUnit) {
    const value = parseInt(durationNumber, 10);
    if (isNaN(value) || value <= 0) {
        return 0;
    }
    if (durationUnit === 'years') {
        return value * 31536000000;
    }
    if (durationUnit === 'months') {
        return value * 2592000000;
    }
    if (durationUnit === 'days') {
        return value * 86400000;
    }
    return 0;
}

function isBroadcomProvider(providerId) {
    const providerName = getProviderById(providerId)?.name || '';
    return providerName.toLowerCase().includes('broadcom');
}

function getContractEndDate(contractStart, durationNumber, durationUnit, providerId) {
    const value = parseInt(durationNumber, 10);
    const start = moment(contractStart);
    if (!start.isValid() || isNaN(value) || value <= 0) {
        return null;
    }
    if (!['days', 'months', 'years'].includes(durationUnit)) {
        return null;
    }
    const end = start.clone().add(value, durationUnit);
    if (durationUnit === 'years' && isBroadcomProvider(providerId)) {
        end.subtract(1, 'day');
    }
    return end.valueOf();
}

function getNextContractStart(product) {
    if (product?.expires) {
        const nextStart = moment(product.expires);
        if (nextStart.isValid()) {
            if (isBroadcomProvider(product.provider)) {
                nextStart.add(1, 'day');
            }
            return nextStart.format('YYYY-MM-DD');
        }
    }
    return moment(product.contractStart).add(product.contractDuration || 0, 'ms').format('YYYY-MM-DD');
}

function ensureProviderLoaded(providerId) {
    if (!providerId || getProviderById(providerId) || providersRequested.has(providerId)) {
        return;
    }
    providersRequested.add(providerId);
    getDoc(doc(db, "providers", providerId)).then((docSnap) => {
        if (docSnap.exists()) {
            const provider = docSnap.data();
            provider.id = docSnap.id;
            upsertProvider(provider);
        }
    }).catch((error) => {
        console.log("Error getting provider:", error);
        providersRequested.delete(providerId);
    });
}

let tags = [];
let tagsById = new Map();
let tagsListenerUnsubscribe = null;

let addProductAssignedTags = [];
let editProductAssignedTags = [];
let bulkEditTagsToAdd = [];
let bulkEditTagsToRemove = [];

function upsertTag(tag) {
    if (!tag || !tag.id) {
        return;
    }
    const existingIndex = tags.findIndex((t) => t.id === tag.id);
    if (existingIndex > -1) {
        tags[existingIndex] = { ...tags[existingIndex], ...tag };
    } else {
        tags.push(tag);
    }
    tagsById.set(tag.id, tag);
}

function getTagById(tagId) {
    return tagsById.get(tagId) || null;
}

function getTagUsageCounts() {
    const counts = {};
    products.forEach((product) => {
        (product.tags || []).forEach((tagId) => {
            if (!tagId) {
                return;
            }
            counts[tagId] = (counts[tagId] || 0) + 1;
        });
    });
    return counts;
}

function ensureUniqueTagIds(tagIds) {
    return Array.from(new Set((tagIds || []).filter((tagId) => !!tagId)));
}

function getAccessibleTextColor(color) {
    if (!color) {
        return '#000000';
    }
    let hex = color.toString().replace('#', '').trim();
    if (hex.length === 3) {
        hex = hex.split('').map((char) => char + char).join('');
    }
    if (hex.length !== 6) {
        return '#000000';
    }
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 0.6 ? '#000000' : '#FFFFFF';
}

function renderTagChipList(containerId, tagIds, options = {}) {
    const { removable = true, onRemove, placeholderId } = options;
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }
    container.innerHTML = '';
    const uniqueTagIds = ensureUniqueTagIds(tagIds);
    uniqueTagIds.forEach((tagId) => {
        const tag = getTagById(tagId);
        if (!tag) {
            return;
        }
        const chip = document.createElement('div');
        chip.classList.add('tag-chip');
        chip.style.setProperty('--tag-bg-color', tag.color || '#CBD5F5');
        chip.style.setProperty('--tag-text-color', getAccessibleTextColor(tag.color || '#CBD5F5'));
        const label = document.createElement('span');
        label.innerText = tag.name || '—';
        chip.appendChild(label);
        if (removable && typeof onRemove === 'function') {
            const removeButton = document.createElement('button');
            removeButton.classList.add('tag-chip-remove');
            removeButton.setAttribute('type', 'button');
            removeButton.setAttribute('aria-label', langDataLocal?.remove || 'Remove');
            removeButton.innerHTML = '&times;';
            removeButton.addEventListener('click', (event) => {
                event.stopPropagation();
                onRemove(tagId);
            });
            chip.appendChild(removeButton);
        }
        container.appendChild(chip);
    });

    if (placeholderId) {
        const placeholder = document.getElementById(placeholderId);
        if (placeholder) {
            placeholder.style.display = uniqueTagIds.length === 0 ? 'block' : 'none';
        }
    }
}

function refreshTagAssignmentsUI() {
    renderTagChipList('main_dialog_product_add_tags_container', addProductAssignedTags, {
        placeholderId: 'main_dialog_product_add_tags_empty',
        onRemove: (tagId) => {
            addProductAssignedTags = addProductAssignedTags.filter((id) => id !== tagId);
            refreshTagAssignmentsUI();
        }
    });

    renderTagChipList('main_dialog_product_edit_tags_container', editProductAssignedTags, {
        placeholderId: 'main_dialog_product_edit_tags_empty',
        onRemove: (tagId) => {
            editProductAssignedTags = editProductAssignedTags.filter((id) => id !== tagId);
            refreshTagAssignmentsUI();
        }
    });

    renderTagChipList('main_dialog_product_bulk_edit_tags_add_container', bulkEditTagsToAdd, {
        placeholderId: 'main_dialog_product_bulk_edit_tags_add_empty',
        onRemove: (tagId) => {
            bulkEditTagsToAdd = bulkEditTagsToAdd.filter((id) => id !== tagId);
            refreshTagAssignmentsUI();
        }
    });

    renderTagChipList('main_dialog_product_bulk_edit_tags_remove_container', bulkEditTagsToRemove, {
        placeholderId: 'main_dialog_product_bulk_edit_tags_remove_empty',
        onRemove: (tagId) => {
            bulkEditTagsToRemove = bulkEditTagsToRemove.filter((id) => id !== tagId);
            refreshTagAssignmentsUI();
        }
    });
}

function populateTagMenu(menuId, assignedTagIds, config = {}) {
    const {
        onSelectTag,
        allowCreate = false,
        onCreate = null,
        includeWithoutTagOption = false,
        excludeAssigned = true,
        emptyLabel,
        withoutTagLabel,
        withoutTagValue = '__WITHOUT__'
    } = config;
    const menu = document.getElementById(menuId);
    if (!menu) {
        return false;
    }
    menu.innerHTML = '';
    const counts = getTagUsageCounts();
    const labelProducts = langDataLocal?.products?.toLowerCase() || 'products';
    const availableTags = [...tags].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    let hasSelectable = false;

    availableTags.forEach((tag) => {
        if (excludeAssigned && assignedTagIds.includes(tag.id)) {
            return;
        }
        const item = document.createElement('md-menu-item');
        const colorDot = document.createElement('span');
        colorDot.slot = 'start';
        colorDot.classList.add('tag-menu-dot');
        colorDot.style.backgroundColor = tag.color || '#CBD5F5';
        item.appendChild(colorDot);
        const headline = document.createElement('div');
        headline.slot = 'headline';
        headline.innerText = tag.name || '—';
        item.appendChild(headline);
        const supporting = document.createElement('div');
        supporting.slot = 'supporting-text';
        supporting.innerText = `${counts[tag.id] || 0} ${labelProducts}`;
        item.appendChild(supporting);
        item.addEventListener('click', () => {
            menu.open = false;
            if (typeof onSelectTag === 'function') {
                onSelectTag(tag.id);
            }
        });
        menu.appendChild(item);
        hasSelectable = true;
    });

    if (includeWithoutTagOption) {
        const withoutItem = document.createElement('md-menu-item');
        const headline = document.createElement('div');
        headline.slot = 'headline';
        headline.innerText = withoutTagLabel || langDataLocal?.no_tags_assigned || 'No tags';
        withoutItem.appendChild(headline);
        withoutItem.addEventListener('click', () => {
            menu.open = false;
            if (typeof onSelectTag === 'function') {
                onSelectTag(withoutTagValue);
            }
        });
        menu.appendChild(withoutItem);
        hasSelectable = true;
    }

    if (!hasSelectable) {
        const emptyItem = document.createElement('md-menu-item');
        emptyItem.setAttribute('disabled', 'true');
        const headline = document.createElement('div');
        headline.slot = 'headline';
        headline.innerText = emptyLabel || langDataLocal?.no_tags_available || 'No tags available';
        emptyItem.appendChild(headline);
        menu.appendChild(emptyItem);
    }

    if (allowCreate) {
        const createItem = document.createElement('md-menu-item');
        const headline = document.createElement('div');
        headline.slot = 'headline';
        headline.innerText = langDataLocal?.create_tag || 'Create tag';
        createItem.appendChild(headline);
        const icon = document.createElement('md-icon');
        icon.slot = 'end';
        icon.innerText = 'add';
        icon.setAttribute('translate', 'no');
        createItem.appendChild(icon);
        createItem.addEventListener('click', () => {
            menu.open = false;
            if (typeof onCreate === 'function') {
                onCreate();
            }
        });
        menu.appendChild(createItem);
    }

    return hasSelectable;
}

// Reliable anchored opening for md-menu inside dialogs (handles timing + fallback positioning)
function openAnchoredMenu(menuElement, anchorId) {
    if (!menuElement) return;
    const anchorEl = document.getElementById(anchorId);
    if (!anchorEl) return;
    // Ensure both attribute and property (different library versions may use one or the other)
    try { menuElement.anchorElement = anchorEl; } catch (e) { /* ignore */ }
    menuElement.setAttribute('anchor', anchorId);
    // Defer open so layout can settle (especially inside md-dialog)
    requestAnimationFrame(() => {
        menuElement.open = true;
        // Fallback manual positioning if library anchoring fails (menu ends at 0,0)
        setTimeout(() => {
            const rect = anchorEl.getBoundingClientRect();
            const mrect = menuElement.getBoundingClientRect();
            if (mrect.left < 5 && mrect.top < 5) { // heuristically detect top-left fallback
                menuElement.style.position = 'fixed';
                menuElement.style.left = rect.left + 'px';
                menuElement.style.top = (rect.bottom + 4) + 'px';
            }
        }, 50);
    });
}

async function createTagRecord(name, color) {
    const sanitizedName = normalizeProductName(name);
    const sanitizedColor = color || '#006CFF';
    const payload = {
        name: sanitizedName,
        color: sanitizedColor,
        createdAt: moment().valueOf(),
        createdBy: auth?.currentUser?.uid || null
    };
    const docRef = await addDoc(collection(db, 'tags'), payload);
    const tag = { ...payload, id: docRef.id };
    upsertTag(tag);
    refreshTagAssignmentsUI();
    return tag;
}


function millisecondsToRelativeTime(milliseconds, notLocalize = false) {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (!notLocalize) {
        if (years > 0) {
            return years === 1 ? '1 ' + langDataLocal['year'] : `${years} ` + langDataLocal['years'];
        } else if (months > 0) {
            return months === 1 ? '1 ' + langDataLocal['month'] : `${months} ` + langDataLocal['months'];
        } else if (days > 0) {
            return days === 1 ? '1 ' + langDataLocal['day'] : `${days} ` + langDataLocal['days'];
        } else if (hours > 0) {
            return hours === 1 ? '1 ' + langDataLocal['hour'] : `${hours} ` + langDataLocal['hours'];
        } else if (minutes > 0) {
            return minutes === 1 ? '1 ' + langDataLocal['minute'] : `${minutes} ` + langDataLocal['minutes'];
        } else {
            return seconds === 1 ? '1 ' + langDataLocal['second'] : `${seconds} ` + langDataLocal['seconds'];
        }
    } else {
        if (years > 0) {
            return years === 1 ? '1 year' : `${years} years`;
        } else if (months > 0) {
            return months === 1 ? '1 month' : `${months} months`;
        } else if (days > 0) {
            return days === 1 ? '1 day' : `${days} days`;
        } else if (hours > 0) {
            return hours === 1 ? '1 hour' : `${hours} hours`;
        } else if (minutes > 0) {
            return minutes === 1 ? '1 minute' : `${minutes} minutes`;
        } else {
            return seconds === 1 ? '1 second' : `${seconds} seconds`;
        }

    }
}

document.getElementById('main_dialog_product_details_subcustomer').addEventListener('click', () => {
    document.getElementById('main_dialog_product_details').close();
    if (!isAdmin) {
        openSubCustomerDetails(document.getElementById('main_dialog_product_details_subcustomer').innerText);
    } else {
        const product = adminGetProduct(openedProduct)
        openedSubcustomerParentCustomer = product.customer;
        openSubCustomerDetails(document.getElementById('main_dialog_product_details_subcustomer').innerText, product.customer)
    }
});

document.getElementById('main_dialog_product_details_provider').addEventListener('click', () => {
    if (!isSubcustomer) {
        // Get opened product
        let oId = products.find(p => p.id === openedProduct);
        if (oId && oId.provider) {
            // Get provider data
            let provider = providers.find(p => p.id === oId.provider);
            if (provider) {
                document.getElementById('main_dialog_product_details').close();
                openProviderDetails(provider);
            }
        }
    }
});

document.getElementById('main_dialog_product_details_open_provider_details').addEventListener('click', () => {
    // Get opened product
    let oId = products.find(p => p.id === openedProduct);
    if (oId && oId.provider) {
        // Get provider data
        let provider = providers.find(p => p.id === oId.provider);
        if (provider) {
            document.getElementById('main_dialog_product_details').close();
            openProviderDetails(provider);
        }
    }
});

function renderSupportData(supportData, supportDivID) {
    let supportDiv = document.getElementById(supportDivID);
    if (supportData) {
        if (supportData.schedule) {
            let scheduleDiv = document.createElement('div');
            scheduleDiv.classList.add('supportDiv');
            let scheduleHeader = document.createElement('div');
            scheduleHeader.classList.add('supportHeader');
            let scheduleHeaderIcon = document.createElement('md-icon');
            scheduleHeaderIcon.innerText = 'schedule';
            scheduleHeaderIcon.setAttribute('translate', 'no');
            scheduleHeaderIcon.classList.add('supportHeaderIcon');
            scheduleHeader.appendChild(scheduleHeaderIcon);
            let scheduleHeaderText = document.createElement('span');
            scheduleHeaderText.innerText = langDataLocal['schedule'];
            scheduleHeader.appendChild(scheduleHeaderText);
            scheduleDiv.appendChild(scheduleHeader);
            let schedule = document.createElement('span');
            schedule.style.marginLeft = '2px';
            schedule.innerText = supportData.schedule;
            scheduleDiv.appendChild(schedule);
            supportDiv.appendChild(scheduleDiv);
        }
        if (supportData.phone) {
            let phoneDiv = document.createElement('div');
            phoneDiv.classList.add('supportDiv');
            let phoneHeader = document.createElement('div');
            phoneHeader.classList.add('supportHeader');
            let phoneHeaderIcon = document.createElement('md-icon');
            phoneHeaderIcon.innerText = 'phone';
            phoneHeaderIcon.setAttribute('translate', 'no');
            phoneHeaderIcon.classList.add('supportHeaderIcon');
            phoneHeader.appendChild(phoneHeaderIcon);
            let phoneHeaderText = document.createElement('span');
            phoneHeaderText.innerText = langDataLocal['phone'];
            phoneHeader.appendChild(phoneHeaderText);
            phoneDiv.appendChild(phoneHeader);
            let phone = document.createElement('span');
            phone.style.marginLeft = '2px';
            phone.innerHTML = '<a href="tel:' + supportData.phone + '">' + supportData.phone + '</a>';
            phoneDiv.appendChild(phone);
            supportDiv.appendChild(phoneDiv);
        }
        if (supportData.email) {
            let emailDiv = document.createElement('div');
            emailDiv.classList.add('supportDiv');
            let emailHeader = document.createElement('div');
            emailHeader.classList.add('supportHeader');
            let emailHeaderIcon = document.createElement('md-icon');
            emailHeaderIcon.innerText = 'email';
            emailHeaderIcon.setAttribute('translate', 'no');
            emailHeaderIcon.classList.add('supportHeaderIcon');
            emailHeader.appendChild(emailHeaderIcon);
            let emailHeaderText = document.createElement('span');
            emailHeaderText.innerText = langDataLocal['email'];
            emailHeader.appendChild(emailHeaderText);
            emailDiv.appendChild(emailHeader);
            let email = document.createElement('span');
            email.style.marginLeft = '2px';
            email.innerHTML = '<a href="mailto:' + supportData.email + '">' + supportData.email + '</a>';
            emailDiv.appendChild(email);
            supportDiv.appendChild(emailDiv);
        }
        if (supportData.website) {
            let websiteDiv = document.createElement('div');
            websiteDiv.classList.add('supportDiv');
            let websiteHeader = document.createElement('div');
            websiteHeader.classList.add('supportHeader');
            let websiteHeaderIcon = document.createElement('md-icon');
            websiteHeaderIcon.innerText = 'language';
            websiteHeaderIcon.setAttribute('translate', 'no');
            websiteHeaderIcon.classList.add('supportHeaderIcon');
            websiteHeader.appendChild(websiteHeaderIcon);
            let websiteHeaderText = document.createElement('span');
            websiteHeaderText.innerText = langDataLocal['website'];
            websiteHeader.appendChild(websiteHeaderText);
            websiteDiv.appendChild(websiteHeader);
            let website = document.createElement('span');
            website.style.marginLeft = '2px';
            website.innerHTML = '<a href="' + supportData.website + '" target="_blank">' + supportData.website + '</a>';
            websiteDiv.appendChild(website);
            supportDiv.appendChild(websiteDiv);
        }
    }
}

function adminGetCustomer(id) {
    return customersAdmin.find(c => c.id === id);
}

function renderProductLinesDetails(product) {
    const container = document.getElementById('main_dialog_product_details_subproducts');
    if (!container) {
        return;
    }
    const lines = getProductLines(product);
    const showPrices = !isSubcustomer && !product.externalCustomerView;
    container.innerHTML = '';
    lines.forEach((line) => {
        const row = document.createElement('div');
        row.className = 'product-subproducts-details__row';
        [
            line.name || '-',
            line.version || '-',
            `${line.units ?? 0} ${Number(line.units) === 1 ? langDataLocal['unit'].toLowerCase() : langDataLocal['units'].toLowerCase()}`,
            showPrices ? formatProductPrice(parseProductNumber(line.price) || 0) : ''
        ].forEach((value, index) => {
            const cell = document.createElement('span');
            cell.innerText = value;
            if (showPrices && index === 3) {
                cell.classList.add('sensitive');
            }
            row.appendChild(cell);
        });
        container.appendChild(row);
    });
    if (showPrices) {
        const total = document.createElement('div');
        total.className = 'product-subproducts-details__total';
        total.classList.add('sensitive');
        total.innerText = `${langDataLocal['total']}: ${formatProductPrice(getProductTotal(lines))}`;
        container.appendChild(total);
    }
}

function openProductDetails(product, isFromHistory = false, searchedTextO, historyIndex = null) {
    openedProduct = product.id;
    openedProductCustomer = product.customer;
    openedProductHistoryIndex = isFromHistory && Number.isInteger(historyIndex) ? historyIndex : null;
    document.getElementById('main_dialog_product_details').classList.toggle('viewing-history', isFromHistory);
    document.getElementById('main_dialog_product_details_history_admin_actions').style.display = isFromHistory && isAdmin ? 'flex' : 'none';
    if (isFromHistory) {
        document.getElementById('main_dialog_product_details_history_warn').style.display = 'flex';
    } else {
        document.getElementById('main_dialog_product_details_history_warn').style.display = 'none';
    }
    if (product.externalCustomerView) {
        document.getElementById('main_dialog_product_details_manage_product').style.display = 'none';
        document.getElementById('main_dialog_product_details_eye_button').style.display = 'none';
        document.getElementById('main_dialog_product_details_price_div').style.display = 'none';
        document.getElementById('main_dialog_product_details_observations').disabled = true;
        document.getElementById('main_dialog_product_details_provider_observations').disabled = true;
        document.getElementById('main_dialog_product_details_documents_upload_open').style.display = 'none';
        document.getElementById('main_dialog_product_details_notifications_button').style.display = 'none';
    } else {
        document.getElementById('main_dialog_product_details_manage_product').style.display = 'inline-flex';
        document.getElementById('main_dialog_product_details_eye_button').style.display = 'inline-flex';
        document.getElementById('main_dialog_product_details_price_div').style.display = 'flex';
        document.getElementById('main_dialog_product_details_observations').disabled = false;
        document.getElementById('main_dialog_product_details_provider_observations').disabled = false;
        document.getElementById('main_dialog_product_details_documents_upload_open').style.display = 'inline-flex';
        document.getElementById('main_dialog_product_details_notifications_button').style.display = 'inline-flex';
    }
    if (isFromHistory) {
        document.getElementById('main_dialog_product_details_observations').disabled = true;
        document.getElementById('main_dialog_product_details_provider_observations').disabled = true;
    }
    document.getElementById('main_dialog_product_details_name').innerText = product.name;
    document.getElementById('main_dialog_product_details_description').innerText = getProductDetails(product);
    document.getElementById('main_dialog_product_details_notes').innerText = product.notes || '';
    document.getElementById('main_dialog_product_details_licenses').innerText = product.licenses || '-';
    renderProductLinesDetails(product);
    renderProductDetailsTags(product);
    const priceDiv = document.getElementById('main_dialog_product_details_price_div');
    priceDiv.style.display = (!isSubcustomer && !product.externalCustomerView) ? 'flex' : 'none';
    document.getElementById('main_dialog_product_details_price').innerText = formatProductPrice(getProductTotal(product)) + ' (' + langDataLocal['without_iva'] + ')';
    if (isAdmin) {
        document.getElementById('main_dialog_product_details_calendar_button').style.display = 'inline-flex';
    }
    if (isAdmin && product.externalCustomersWithAccess && product.externalCustomersWithAccess.length > 0) {
        document.getElementById('main_dialog_product_details_product_externalAccessNotice').style.display = 'flex';
        const listOfCustomersWithAccess = [];
        product.externalCustomersWithAccess.forEach((customer) => {
            const customerData = adminGetCustomer(customer);
            if (customerData) {
                listOfCustomersWithAccess.push(customerData.name);
            }
        });
        document.getElementById('main_dialog_product_details_product_externalAccessNotice_text').innerText = langDataLocal['these_customers_have_access_to_the_product'] + ': ' + listOfCustomersWithAccess.join(', ');
    } else {
        document.getElementById('main_dialog_product_details_product_externalAccessNotice').style.display = 'none';
    }
    if (product.expires && product.contractStart) {
        let expires_contractStart = '<b>' + langDataLocal['start'] + ':</b> ' + moment(product.contractStart).format('DD/MM/YY') || '';
        let expires_contractEnd = '<b>' + langDataLocal['end'] + ':</b> ' + moment(product.expires).format('DD/MM/YY') + ' (' + moment(product.expires).fromNow() + ')' || '';
        if (isFromHistory) {
            expires_contractEnd = '<b>' + langDataLocal['end'] + ':</b> ' + moment(product.expires).format('DD/MM/YY');
        }
        let expires_contractDuration = '<b>' + langDataLocal['duration'] + ':</b> ' + millisecondsToRelativeTime(product.contractDuration) || '';
        let renewsAutomatically = '';
        if (product.autoRenewal) {
            renewsAutomatically = '<br><span style="color: var(--mdc-theme-green); font-weight: bold;">' + langDataLocal['auto_renewal_activated'] + '</span>';
        }
        document.getElementById('main_dialog_product_details_expires').innerHTML = expires_contractStart + ' - ' + expires_contractEnd + ' - ' + expires_contractDuration + renewsAutomatically;
    } else {
        let expires_contractDuration = '<b>' + langDataLocal['duration'] + ':</b> ' + millisecondsToRelativeTime(product.contractDuration) || '';
        document.getElementById('main_dialog_product_details_expires').innerHTML = expires_contractDuration + '. ' + langDataLocal['continous_renewal'];
    }
    // document.getElementById('main_dialog_product_details_expire_reminder_customer').checked = product.expireReminderCustomer || false;
    document.getElementById('main_dialog_product_details_subcustomer').innerText = product.subcustomer;
    document.getElementById('main_dialog_product_details_subcustomer').style.backgroundColor = stringToColour(product.subcustomer).bgColor;
    document.getElementById('main_dialog_product_details_subcustomer').style.color = stringToColour(product.subcustomer).color;
    if (isSubcustomer && !isAdmin) {
        document.getElementById('main_dialog_product_details_subcustomer').style.display = 'none';
        document.getElementById('main_dialog_product_details_manage_product').style.display = 'none';
        document.getElementById('main_dialog_product_details_eye_button').style.display = 'none';
        document.getElementById('main_dialog_product_details_open_provider_details').style.display = 'none';
    } else if (isAdmin) {
        document.getElementById('main_dialog_product_details_manage_product').style.display = 'none';
        document.getElementById('main_dialog_product_details_compose_mail_admin').style.display = 'inline-flex';
        document.getElementById('main_dialog_product_details_edit_button').style.display = 'inline-flex';
        document.getElementById('main_dialog_product_details_customer').innerText = customersAdmin.find(c => c.id === product.customer).name;
        document.getElementById('main_dialog_product_details_customer').style.backgroundColor = stringToColour(customersAdmin.find(c => c.id === product.customer).name).bgColor;
        document.getElementById('main_dialog_product_details_customer').style.color = stringToColour(customersAdmin.find(c => c.id === product.customer).name).color;
        if (adminVisibility) {
            document.getElementById('main_dialog_product_details_customer').style.display = 'inline-flex';
        } else {
            document.getElementById('main_dialog_product_details_customer').style.display = 'none';
        }
        if (product.subcustomer == customersAdmin.find(c => c.id === product.customer).name) {
            document.getElementById('main_dialog_product_details_subcustomer').style.display = 'none';
        } else {
            document.getElementById('main_dialog_product_details_subcustomer').style.display = 'inline-flex';
        }

    }
    document.getElementById('main_dialog_product_details_observations').value = product.customerNotes || '';
    console.log('isAdmin', isAdmin);
    if (!isSubcustomer && !isAdmin) {
        if (customer_data.providerNotes) {
            document.getElementById('main_dialog_product_details_provider_observations').value = customer_data.providerNotes[product.provider] || '';
        } else {
            document.getElementById('main_dialog_product_details_provider_observations').value = '';
        }
    } else if (isAdmin) {
        if (adminGetCustomer(product.customer).providerNotes) {
            document.getElementById('main_dialog_product_details_provider_observations').value = adminGetCustomer(product.customer).providerNotes[product.provider] || '';
        } else {
            document.getElementById('main_dialog_product_details_provider_observations').value = '';
        }
    }
    currentCustomerNotes = product.customerNotes || '';
    const productLines = getProductLines(product);
    if (productLines.length === 1) {
        document.getElementById('main_dialog_product_details_units').innerText = productLines[0].units + ' ' + (Number(productLines[0].units) === 1 ? langDataLocal['unit'].toLowerCase() : langDataLocal['units'].toLowerCase());
    } else {
        document.getElementById('main_dialog_product_details_units').innerText = productLines.length + ' ' + langDataLocal['subproducts'].toLowerCase();
    }
    if (product.status === 'inactive') {
        document.getElementById('main_dialog_product_details_state').innerText = langDataLocal['inactive'];
        document.getElementById('main_dialog_product_details_state').style.borderColor = 'var(--mdc-theme-red)';
        document.getElementById('main_dialog_product_details_state').style.color = 'var(--mdc-theme-red)';
        document.getElementById('main_dialog_product_details_product_inactiveReason').innerHTML = '<span style="font-weight: bold; color: var(--mdc-theme-red);">' + langDataLocal['inactive_reason'] + ':</span><br>' + product.statusReason.replaceAll('\n', '<br>') || '' + '<br><br>';
        document.getElementById('main_dialog_product_details_product_inactiveReason').style.marginBottom = '16px';
    } else if (product.status === 'renewal_pending') {
        document.getElementById('main_dialog_product_details_state').innerText = langDataLocal['renewal_pending'];
        document.getElementById('main_dialog_product_details_state').style.borderColor = 'var(--mdc-theme-orange)';
        document.getElementById('main_dialog_product_details_state').style.color = 'var(--mdc-theme-orange)';
        document.getElementById('main_dialog_product_details_product_inactiveReason').innerHTML = '<span style="font-weight: bold; color: var(--mdc-theme-orange);">' + langDataLocal['renewal_notes'] + ':</span><br>' + product.statusReason.replaceAll('\n', '<br>') || '' + '<br><br>';
        document.getElementById('main_dialog_product_details_product_inactiveReason').style.marginBottom = '16px';
    } else if (product.status === 'proposal_pending') {
        document.getElementById('main_dialog_product_details_state').innerText = langDataLocal['proposal_pending'];
        document.getElementById('main_dialog_product_details_state').style.borderColor = 'var(--mdc-theme-orange)';
        document.getElementById('main_dialog_product_details_state').style.color = 'var(--mdc-theme-orange)';
        document.getElementById('main_dialog_product_details_product_inactiveReason').innerHTML = '<span style="font-weight: bold; color: var(--mdc-theme-orange);">' + langDataLocal['renewal_notes'] + ':</span><br>' + product.statusReason.replaceAll('\n', '<br>') || '' + '<br><br>';
        document.getElementById('main_dialog_product_details_product_inactiveReason').style.marginBottom = '16px';
    } else {
        document.getElementById('main_dialog_product_details_state').innerText = langDataLocal['active'];
        document.getElementById('main_dialog_product_details_state').style.borderColor = 'var(--mdc-theme-green)';
        document.getElementById('main_dialog_product_details_state').style.color = 'var(--mdc-theme-green)';
        document.getElementById('main_dialog_product_details_product_inactiveReason').innerText = '';
        document.getElementById('main_dialog_product_details_product_inactiveReason').style.marginBottom = '0';
    }
    if (product.managedBy) {
        document.getElementById('main_dialog_product_details_managed_by').innerText = langDataLocal['managed_by'] + ': ' + product.managedBy;
    } else {
        document.getElementById('main_dialog_product_details_managed_by').innerText = langDataLocal['managed_by'] + ': ' + 'ZONATIC';
    }



    // Highlight searched text
    if (searchedTextO) {
        // Check if the searched text is in the product name, description, notes
        let name = product.name;
        let notes = product.notes;
        let details = getProductDetails(product);
        let customerNotes = product.customerNotes;
        let licenses = product.licenses;

        searchedTextO.forEach((searchedText) => {

            let nameIndex = -1;
            if (name) {
                nameIndex = name.toLowerCase().indexOf(searchedText.toLowerCase()) || -1;
            }
            let notesIndex = -1;
            if (notes) {
                notesIndex = notes.toLowerCase().indexOf(searchedText.toLowerCase()) || -1;
            }
            let detailsIndex = -1;
            if (details) {
                detailsIndex = details.toLowerCase().indexOf(searchedText.toLowerCase()) || -1;
            }
            let customerNotesIndex = -1;
            if (customerNotes) {
                customerNotesIndex = customerNotes.toLowerCase().indexOf(searchedText.toLowerCase()) || -1;
            }
            let licensesIndex = -1;
            if (licenses) {
                licensesIndex = licenses.toLowerCase().indexOf(searchedText.toLowerCase()) || -1;
            }

            if (nameIndex !== -1) {
                let nameStart = name.substring(0, nameIndex);
                let nameEnd = name.substring(nameIndex + searchedText.length, name.length);
                document.getElementById('main_dialog_product_details_name').innerHTML = nameStart + '<span class="highlight">' + name.substring(nameIndex, nameIndex + searchedText.length) + '</span>' + nameEnd;
                document.getElementById('main_dialog_product_details_name').innerHTML = document.getElementById('main_dialog_product_details_name').innerHTML.replace(/\n/g, '<br>');
                name = document.getElementById('main_dialog_product_details_name').innerHTML;
            }
            if (notesIndex !== -1) {
                let notesStart = notes.substring(0, notesIndex);
                let notesEnd = notes.substring(notesIndex + searchedText.length, notes.length);
                document.getElementById('main_dialog_product_details_notes').innerHTML = notesStart + '<span class="highlight">' + notes.substring(notesIndex, notesIndex + searchedText.length) + '</span>' + notesEnd;
                document.getElementById('main_dialog_product_details_notes').innerHTML = document.getElementById('main_dialog_product_details_notes').innerHTML.replace(/\n/g, '<br>');
                notes = document.getElementById('main_dialog_product_details_notes').innerHTML;
            }
            if (detailsIndex !== -1) {
                let detailsStart = details.substring(0, detailsIndex);
                let detailsEnd = details.substring(detailsIndex + searchedText.length, details.length);
                document.getElementById('main_dialog_product_details_description').innerHTML = detailsStart + '<span class="highlight">' + details.substring(detailsIndex, detailsIndex + searchedText.length) + '</span>' + detailsEnd;
                document.getElementById('main_dialog_product_details_description').innerHTML = document.getElementById('main_dialog_product_details_description').innerHTML.replace(/\n/g, '<br>');
                details = document.getElementById('main_dialog_product_details_description').innerHTML;
            }
            if (customerNotesIndex !== -1) {
                let customerNotesStart = customerNotes.substring(0, customerNotesIndex);
                let customerNotesEnd = customerNotes.substring(customerNotesIndex + searchedText.length, customerNotes.length);
                document.getElementById('main_dialog_product_details_observations').value = customerNotesStart + '<span class="highlight">' + customerNotes.substring(customerNotesIndex, customerNotesIndex + searchedText.length) + '</span>' + customerNotesEnd;
                document.getElementById('main_dialog_product_details_observations').value = document.getElementById('main_dialog_product_details_observations').value.replace(/\n/g, '<br>');
                customerNotes = document.getElementById('main_dialog_product_details_observations').value;
            }
            if (licensesIndex !== -1) {
                let licensesStart = licenses.substring(0, licensesIndex);
                let licensesEnd = licenses.substring(licensesIndex + searchedText.length, licenses.length);
                document.getElementById('main_dialog_product_details_licenses').value = licensesStart + '<span class="highlight">' + licenses.substring(licensesIndex, licensesIndex + searchedText.length) + '</span>' + licensesEnd;
                document.getElementById('main_dialog_product_details_licenses').value = document.getElementById('main_dialog_product_details_licenses').value.replace(/\n/g, '<br>');
                licenses = document.getElementById('main_dialog_product_details_licenses').value;
            }

            // if (product.history) {
            //     product.history.forEach((history) => {

            //     })
            // }
        });
    }


    let filesDiv = document.getElementById('main_dialog_product_details_documents');
    filesDiv.innerHTML = '';
    if (product.files && product.files.length > 0) {
        product.files.forEach((file) => {
            let fileDiv = document.createElement('div');
            fileDiv.classList.add('fileDiv');
            let leftDiv = document.createElement('div');
            leftDiv.classList.add('fileLeftDiv');
            let fileIcon = document.createElement('md-icon');
            fileIcon.innerText = 'description';
            fileIcon.setAttribute('translate', 'no');
            fileIcon.classList.add('fileIcon');
            leftDiv.appendChild(fileIcon);
            let fileLink = document.createElement('a');
            fileLink.href = file.url;
            fileLink.target = '_blank';
            fileLink.innerText = file.name;
            leftDiv.appendChild(fileLink);
            fileDiv.appendChild(leftDiv);
            let rightDiv = document.createElement('div');
            let deleteButton0 = document.createElement('md-icon-button');
            let deleteButton = document.createElement('md-icon');
            deleteButton.innerText = 'delete';
            deleteButton.setAttribute('translate', 'no');
            deleteButton0.classList.add('fileDelete');
            deleteButton0.appendChild(deleteButton);
            deleteButton0.addEventListener('click', (e) => {
                e.preventDefault();
                let newFiles = product.files.filter(f => f.name !== file.name);
                product.files = newFiles;
                updateDoc(doc(db, "products", product.id), {
                    files: newFiles
                })
                    .then(() => {
                        console.log("Document successfully updated!");
                        // Remove from cloud storage
                        let storageRef = ref(storage, 'customers/' + product.customer + '/' + file.name);
                        deleteObject(storageRef)
                            .then(() => {
                                console.log('File deleted');
                                openProductDetails(product, isFromHistory);
                            })
                            .catch((error) => {
                                console.log('Error deleting file', error);
                            });
                    })
                    .catch((error) => {
                        console.log("Error updating document: ", error);
                    });
            });
            if (isAdmin && !isFromHistory) {
                rightDiv.appendChild(deleteButton0);
            }
            fileDiv.appendChild(rightDiv);
            filesDiv.appendChild(fileDiv);
        });
    } else {
        let noFiles = document.createElement('div');
        let noFilesIcon = document.createElement('md-icon');
        noFiles.classList.add('fileDiv');
        noFiles.style.justifyContent = 'flex-start';
        noFilesIcon.innerText = 'info';
        noFilesIcon.setAttribute('translate', 'no');
        noFilesIcon.classList.add('fileIcon');
        noFiles.appendChild(noFilesIcon);
        let noFilesText = document.createElement('span');
        noFilesText.innerText = langDataLocal['no_files_attached'];
        noFiles.appendChild(noFilesText);
        filesDiv.appendChild(noFiles);
    }
    // Get provider data
    let found = false;
    providers.forEach((provider) => {
        if (provider.id === product.provider) {
            found = true;
            document.getElementById('main_dialog_product_details_provider').innerText = provider.name;
            if (product.providerSupportType) {
                let supportDiv = document.getElementById('main_dialog_product_details_provider_support');
                supportDiv.innerHTML = '';
                let supportData = provider.supportTypes[product.providerSupportType];
                document.getElementById('main_dialog_product_details_provider_support_name').innerText = supportData.name;
                renderSupportData(supportData, 'main_dialog_product_details_provider_support');
            } else {
                document.getElementById('main_dialog_product_details_provider_support_name').innerText = langDataLocal['no_support'];
                document.getElementById('main_dialog_product_details_provider_support').innerHTML = langDataLocal['no_support_data'];
            }
        }
    });
    if (!found) {
        getDoc(doc(db, "providers", product.provider)).then((doc) => {
            if (doc.exists()) {
                let provider = doc.data();
                provider.id = doc.id;
                upsertProvider(provider);
                document.getElementById('main_dialog_product_details_provider').innerText = provider.name;
            } else {
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }
    let product_history_list = document.getElementById('main_dialog_product_details_history');
    product_history_list.innerHTML = '';
    if (product.history && product.history.length > 0) {
        // let header = document.createElement('md-list-item');
        // header.classList.add('listHeaderH');
        // let headerMainDiv = document.createElement('div');
        // headerMainDiv.classList.add('listMainDiv');
        // let renewalDate = document.createElement('span');
        // renewalDate.innerText = langDataLocal['date'];
        // headerMainDiv.appendChild(renewalDate);
        // header.appendChild(headerMainDiv);
        // product_history_list.appendChild(header);
        product.history.forEach((history, historyIndex) => {
            let historyDiv = document.createElement('md-list-item');
            historyDiv.classList.add('listItemH');
            let historyMainDiv = document.createElement('div');
            historyMainDiv.classList.add('listMainDiv');
            let historyDate = document.createElement('span');
            historyDate.innerHTML = '<b>' + langDataLocal['contract_start'] + ':</b> ' + moment(history.contractStart).format('DD/MM/YYYY') + ' - <b>' + langDataLocal['end'] + ':</b> ' + moment(history.expires).format('DD/MM/YYYY') + ' - <b>' + langDataLocal['duration'] + ':</b> ' + millisecondsToRelativeTime(history.contractDuration);
            if (!isSubcustomer && !product.externalCustomerView) {
                historyDate.innerHTML += ' - <b>' + langDataLocal['total'] + ':</b> <span class="sensitive">' + formatProductPrice(getProductTotal(history)) + '</span>';
            }
            historyMainDiv.appendChild(historyDate);
            let viewButton = document.createElement('md-outlined-button');
            viewButton.innerText = langDataLocal['view'];
            viewButton.addEventListener('click', (e) => {
                e.preventDefault();
                // Patch newProduct with whatever is in the history using ...history
                let newProduct = { ...adminGetProduct(product.id), ...history };
                newProduct.id = product.id;
                openProductDetails(newProduct, true, undefined, historyIndex);
            });
            historyMainDiv.appendChild(viewButton);
            historyDiv.appendChild(historyMainDiv);
            product_history_list.appendChild(historyDiv);
        });
    } else {
        let header = document.createElement('md-list-item');
        header.classList.add('listHeaderH');
        let headerMainDiv = document.createElement('div');
        headerMainDiv.classList.add('listMainDiv');
        let noHistory = document.createElement('span');
        noHistory.innerText = langDataLocal['no_history'];
        headerMainDiv.appendChild(noHistory);
        header.appendChild(headerMainDiv);
        product_history_list.appendChild(header);
    }
    document.getElementById('main_dialog_product_details').show();
    // Scroll to top of dialog
    if (isFromHistory) {
        document.getElementById('main_dialog_product_details').getElementsByTagName('form')[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

}

function renderProductDetailsTags(product) {
    const container = document.getElementById('main_dialog_product_details_tags');
    const placeholder = document.getElementById('main_dialog_product_details_tags_empty');
    if (!container || !placeholder) {
        return;
    }
    container.innerHTML = '';
    const tagIds = ensureUniqueTagIds(product.tags || []);
    if (tagIds.length === 0) {
        placeholder.style.display = 'block';
        container.style.display = 'none';
        return;
    }
    placeholder.style.display = 'none';
    container.style.display = 'flex';
    tagIds.forEach((tagId) => {
        const tag = getTagById(tagId);
        if (!tag) {
            return;
        }
        const chip = document.createElement('div');
        chip.classList.add('tag-chip');
        chip.style.setProperty('--tag-bg-color', tag.color || '#CBD5F5');
        chip.style.setProperty('--tag-text-color', getAccessibleTextColor(tag.color || '#CBD5F5'));
        const label = document.createElement('span');
        label.innerText = tag.name || '-';
        chip.appendChild(label);
        container.appendChild(chip);
    });
}

function renderTagsInProductDetailsIfOpen() {
    const dialog = document.getElementById('main_dialog_product_details');
    if (!dialog || !dialog.open || !openedProduct) {
        return;
    }
    const currentProduct = products.find((p) => p.id === openedProduct);
    const history = currentProduct?.history?.[openedProductHistoryIndex];
    const product = history ? { ...currentProduct, ...history } : currentProduct;
    if (product) {
        renderProductDetailsTags(product);
    }
}

document.getElementById('main_dialog_product_details_documents_upload_open').addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('main_dialog_product_details_documents_upload').show();
});


// Allow user to click on main_dialog_product_details_documents_upload_dropdown_area or drop a file, or multiple files there, and uplad them to Firestore
document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('main_dialog_product_details_documents_upload_input').click();
});

document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').addEventListener('dragover', (e) => {
    e.preventDefault();
    document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').classList.add("dragover");
});

document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').addEventListener('dragleave', (e) => {
    e.preventDefault();
    document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').classList.remove("dragover");
});

document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').addEventListener('drop', (e) => {
    e.preventDefault();
    document.getElementById('main_dialog_product_details_documents_upload_dropdown_area').classList.remove("dragover");
    let files = e.dataTransfer.files;
    // Loop through files and upload them
    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let storageRef = ref(storage, 'customers/' + openedProductCustomer + '/' + file.name);
        let uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on('state_changed',
            (snapshot) => {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                // document.getElementById('main_dialog_product_details_documents_upload_progress').value = progress;
            },
            (error) => {
                showError('error', 'error_uploading_file');
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    // Save file to product
                    let product = products.find(p => p.id === openedProduct);
                    if (!product.files) {
                        product.files = [];
                    }
                    product.files.push({ name: file.name, url: downloadURL });
                    // Save product to Firestore
                    setDoc(doc(db, "products", openedProduct), product).then(() => {
                        console.log('Document successfully written!');
                        //document.getElementById('main_dialog_product_details_documents_upload_progress').value = 0;
                        openProductDetails(product);
                    }).catch((error) => {
                        console.log('Error writing document:', error);
                    });
                });
            }
        );
    }
    document.getElementById('main_dialog_product_details_documents_upload').close();
    // document.getElementById('main_dialog_product_details').close();
    // openProductDetails(products.find(p => p.id === openedProduct));
});

document.getElementById('main_dialog_product_details_documents_upload_input').addEventListener('change', (e) => {
    e.preventDefault();
    let files = e.target.files;
    // Loop through files and upload them
    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let storageRef = ref(storage, 'customers/' + openedProductCustomer + '/' + file.name);
        let uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on('state_changed',
            (snapshot) => {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                // document.getElementById('main_dialog_product_details_documents_upload_progress').value = progress;
            },
            (error) => {
                showError('error', 'error_uploading_file');
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    // Save file to product
                    let product = products.find(p => p.id === openedProduct);
                    if (!product.files) {
                        product.files = [];
                    }
                    product.files.push({ name: file.name, url: downloadURL });
                    // Save product to Firestore
                    setDoc(doc(db, "products", openedProduct), product).then(() => {
                        console.log('Document successfully written!');
                        // document.getElementById('main_dialog_product_details_documents_upload_progress').value = 0;
                        openProductDetails(product);
                    }).catch((error) => {
                        console.log('Error writing document:', error);
                    });
                });
            }
        );
    }
    document.getElementById('main_dialog_product_details_documents_upload').close();
    // document.getElementById('main_dialog_product_details').close();
    // openProductDetails(products.find(p => p.id === openedProduct));
});



document.getElementById('main_dialog_product_details_documents_upload_cancel').addEventListener('click', () => {
    document.getElementById('main_dialog_product_details_documents_upload').close();
});

document.getElementById('main_dialog_product_details_compose_mail_admin').addEventListener('click', () => {
    openAdminCompose(adminGetProduct(openedProduct), 'product');
});

document.getElementById('main_dialog_product_details_edit_button').addEventListener('click', () => {
    openEditProduct(openedProduct);
});

document.getElementById('main_dialog_product_edit').addEventListener('cancel', (e) => {
    e.preventDefault();
});

let editType = "edit";

function openEditProduct(openedProduct, historyIndex = null) {
    const currentProduct = adminGetProduct(openedProduct);
    const history = Number.isInteger(historyIndex) ? currentProduct?.history?.[historyIndex] : null;
    if (Number.isInteger(historyIndex) && !history) {
        showError('error', 'an_error_has_occurred');
        return;
    }
    const product = history ? { ...currentProduct, ...history, id: currentProduct.id } : currentProduct;
    editType = history ? "history" : "edit";

    // Remove "md-input-chip" from main_dialog_product_edit_external_customers, keeping other child elements
    document.querySelectorAll('#main_dialog_product_edit_external_customers md-input-chip').forEach((chip) => {
        chip.remove();
    });




    // Populate main_dialog_product_edit_external_customers_add_menu with customers
    let externalCustomersAddMenu = document.getElementById('main_dialog_product_edit_external_customers_add_menu');
    externalCustomersAddMenu.innerHTML = '';

    // Create md-input-chip with customer name, and reference to customer id, for each customer in externalCustomersWithAccess
    if (product.externalCustomersWithAccess) {
        product.externalCustomersWithAccess.forEach((externalCustomer) => {
            let customer = customersAdmin.find(c => c.id === externalCustomer);
            let chip = document.createElement('md-input-chip');
            chip.innerText = customer.name;
            chip.setAttribute('data-id', customer.id);
            chip.setAttribute('data-name', customer.name);
            // Add chip to main_dialog_product_edit_external_customers
            document.getElementById('main_dialog_product_edit_external_customers').appendChild(chip);
            // If chip removed, add customer back to main_dialog_product_edit_external_customers_add_menu
            chip.addEventListener('remove', () => {
                chip.remove();
                let menuItem = document.createElement('md-menu-item');
                menuItem.innerText = customer.name;
                menuItem.addEventListener('click', () => {
                    // Create md-input-chip with customer name, and reference to customer id
                    let chip = document.createElement('md-input-chip');
                    chip.innerText = customer.name;
                    chip.setAttribute('data-id', customer.id);
                    chip.setAttribute('data-name', customer.name);
                    // Add chip to main_dialog_product_edit_external_customers
                    document.getElementById('main_dialog_product_edit_external_customers').appendChild(chip);
                    // Remove customer from main_dialog_product_edit_external_customers_add_menu
                    menuItem.remove();
                    // Sort menu items
                    let items = externalCustomersAddMenu.querySelectorAll('md-menu-item');
                    let itemsArray = Array.from(items);
                    itemsArray.sort((a, b) => {
                        return a.innerText.localeCompare(b.innerText);
                    });
                    externalCustomersAddMenu.innerHTML = '';
                    itemsArray.forEach((item) => {
                        externalCustomersAddMenu.appendChild(item);
                    });
                });
                externalCustomersAddMenu.appendChild(menuItem);
            });
        });
    }



    customersAdmin.forEach((customer) => {
        // Check if customer is already in the product, either as customer (product.customer), or inside product.externalCustomersWithAccess
        let found = false;
        if (customer.id === openedProductCustomer) {
            found = true;
        }
        if (product.externalCustomersWithAccess) {
            product.externalCustomersWithAccess.forEach((externalCustomer) => {
                if (externalCustomer === customer.id) {
                    found = true;
                }
            });
        }
        if (!found) {
            let menuItem = document.createElement('md-menu-item');
            menuItem.innerText = customer.name;
            menuItem.addEventListener('click', () => {
                // Create md-input-chip with customer name, and reference to customer id
                let chip = document.createElement('md-input-chip');
                chip.innerText = customer.name;
                chip.setAttribute('data-id', customer.id);
                chip.setAttribute('data-name', customer.name);
                // Add chip to main_dialog_product_edit_external_customers 
                document.getElementById('main_dialog_product_edit_external_customers').appendChild(chip);
                // Remove customer from main_dialog_product_edit_external_customers_add_menu
                menuItem.remove();
                // If chip removed, add customer back to main_dialog_product_edit_external_customers_add_menu
                chip.addEventListener('remove', () => {
                    chip.remove();
                    externalCustomersAddMenu.appendChild(menuItem);
                    // Sort menu items
                    let items = externalCustomersAddMenu.querySelectorAll('md-menu-item');
                    let itemsArray = Array.from(items);
                    itemsArray.sort((a, b) => {
                        return a.innerText.localeCompare(b.innerText);
                    });
                    externalCustomersAddMenu.innerHTML = '';
                    itemsArray.forEach((item) => {
                        externalCustomersAddMenu.appendChild(item);
                    });
                });
            });
            externalCustomersAddMenu.appendChild(menuItem);
        }
    });


    document.getElementById('main_dialog_product_edit_title').innerText = langDataLocal[history ? 'edit_historical_renewal' : 'edit_product'];
    document.getElementById('main_dialog_product_edit_save').innerText = langDataLocal['save'];
    // Set contract start to previous + contract duration
    document.getElementById('main_dialog_product_edit_contract_start').value = moment(product.contractStart).format('YYYY-MM-DD');
    // Here's the edit product dialog HTML
    // <md-dialog id="main_dialog_product_edit" class="fwdialog">
    //       <div slot="headline" class="main_dialog_product_details_headline">
    //         <div class="align">
    //           <md-icon translate="no" slot="icon" class="mr10">edit</md-icon>
    //           <span data-i18n="edit_product">Edit product</span>
    //         </div>
    //         <div class="align">
    //           <md-icon-button id="main_dialog_product_edit_close">
    //             <md-icon translate="no">close</md-icon>
    //           </md-icon-button>
    //         </div>
    //       </div>
    //       <form slot="content" method="dialog" class="verticalDiv">
    //         <md-outlined-text-field data-label-i18n="name" label="Name" value="" type="text"
    //           id="main_dialog_product_edit_name" class="fw">
    //           <md-icon translate="no" slot="leading-icon">domain</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="details" label="Details" value="" type="textarea"
    //           id="main_dialog_product_edit_details" class="fw">
    //           <md-icon translate="no" slot="leading-icon">description</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="description" label="Description" value="" type="textarea"
    //           id="main_dialog_product_edit_description" class="fw">
    //           <md-icon translate="no" slot="leading-icon">description</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="notes" label="Notes" value="" type="textarea"
    //           id="main_dialog_product_edit_notes" class="fw">
    //           <md-icon translate="no" slot="leading-icon">notes</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="units" label="Units" value="" type="text"
    //           id="main_dialog_product_edit_units" class="fw">
    //           <md-icon translate="no" slot="leading-icon">tag</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="price" label="Price" value="" type="text"
    //           id="main_dialog_product_edit_price" class="fw">
    //           <md-icon translate="no" slot="leading-icon">attach_money</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="licenses" label="Licenses" value="" type="text"
    //           id="main_dialog_product_edit_licenses" class="fw">
    //           <md-icon translate="no" slot="leading-icon">confirmation_number</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="contract_start" label="contract_start" value="" type="text"
    //           id="main_dialog_product_edit_contract_start" class="fw">
    //           <md-icon translate="no" slot="leading-icon">event</md-icon>
    //         </md-outlined-text-field>
    //         <br>
    //         <br>
    //         <md-outlined-text-field data-label-i18n="contract_duration" label="contract_duration" value="" type="text"
    //           id="main_dialog_product_edit_contract_duration_number" class="fw">
    //           <md-icon translate="no" slot="leading-icon">event</md-icon>
    //         </md-outlined-text-field>
    //         <md-outlined-select id="main_dialog_product_edit_contract_duration_unit" data-label-i18n="contract_duration"
    //           label="Contract duration" class="fw">
    //         </md-outlined-select>
    //         <br>
    //         <br>
    //         <md-outlined-select id="main_dialog_product_edit_provider" data-label-i18n="manufacturer"
    //           label="Manufacturer" class="fw">
    //         </md-outlined-select>
    //         <br>
    //         <br>
    //         <md-outlined-select id="main_dialog_product_edit_state" data-label-i18n="status"
    //           label="Status" class="fw">
    //         </md-outlined-select>
    //         <br>
    //         <br>
    //         <md-outlined-select id="main_dialog_product_edit_managed_by" data-label-i18n="managed_by"
    //           label="Managed by" class="fw">
    //         </md-outlined-select>
    //         <br>
    //         <br>
    //         </form>
    //         <div slot="actions" class="align">
    //           <md-text-button id="main_dialog_product_edit_close" data-i18n="cancel">Cancel</md-text-button>
    //           <md-filled-button id="main_dialog_product_edit_save" class="ml15" data-i18n="save">Save</md-filled-button>
    //         </div>
    //     </md-dialog>
    document.getElementById('main_dialog_product_edit_make_duplicate').style.display = history ? 'none' : 'inline-flex';
    document.getElementById('main_dialog_product_edit_make_historic').style.display = history ? 'none' : 'inline-flex';
    if (isAdmin && !history) {
        if (product.deleted) {
            document.getElementById('main_dialog_product_edit_move_to_trash').style.display = 'none';
            document.getElementById('main_dialog_product_edit_restore_from_trash').style.display = 'flex';
        } else {
            document.getElementById('main_dialog_product_edit_move_to_trash').style.display = 'flex';
            document.getElementById('main_dialog_product_edit_restore_from_trash').style.display = 'none';
        }
    } else {
        document.getElementById('main_dialog_product_edit_move_to_trash').style.display = 'none';
        document.getElementById('main_dialog_product_edit_restore_from_trash').style.display = 'none';
    }
    document.getElementById('main_dialog_product_edit_name').value = product.name;
    document.getElementById('main_dialog_product_edit_details').value = getProductDetails(product);
    document.getElementById('main_dialog_product_edit_notes').value = product.notes || '';
    document.getElementById('main_dialog_product_edit_licenses').value = product.licenses || '';
    renderProductLineEditor('edit', product);
    document.getElementById('main_dialog_product_edit_contract_start').value = moment(product.contractStart).format('YYYY-MM-DD') || '';
    document.getElementById('main_dialog_product_edit_contract_duration_number').value = millisecondsToRelativeTime(product.contractDuration).split(' ')[0] || '';
    document.getElementById('main_dialog_product_edit_contract_duration_unit').innerHTML = '';
    document.getElementById('main_dialog_product_edit_status_reason').value = product.statusReason || '';
    let contractDurationUnit = document.getElementById('main_dialog_product_edit_contract_duration_unit');
    let contractDurationUnits = ['days', 'months', 'years'];
    contractDurationUnits.forEach((unit) => {
        let option = document.createElement('md-select-option');
        option.value = unit;
        option.innerText = langDataLocal[unit];
        contractDurationUnit.appendChild(option);
    });

    console.log(millisecondsToRelativeTime(product.contractDuration, true).split(' ')[1] || '')
    document.getElementById('main_dialog_product_edit_provider').innerHTML = '';
    let providerSelect = document.getElementById('main_dialog_product_edit_provider');
    const providers_temp = providers;
    // sort providers by name
    providers_temp.sort((a, b) => (a.name > b.name) ? 1 : -1);
    const temp_providers = []
    providers_temp.forEach((provider) => {
        if (temp_providers.indexOf(provider.id) === -1) {
            let option = document.createElement('md-select-option');
            option.value = provider.id;
            option.innerText = provider.name;
            providerSelect.appendChild(option);
            temp_providers.push(provider.id)
        }
    });

    document.getElementById('main_dialog_product_edit_state').innerHTML = '';
    let stateSelect = document.getElementById('main_dialog_product_edit_state');
    let states = ['active', 'inactive', 'renewal_pending', 'proposal_pending'];
    states.forEach((state) => {
        let option = document.createElement('md-select-option');
        option.value = state;
        option.innerText = langDataLocal[state];
        stateSelect.appendChild(option);
    });

    console.log(product)
    document.getElementById('main_dialog_product_edit_managed_by').innerHTML = '';
    let managedBySelect = document.getElementById('main_dialog_product_edit_managed_by');
    let managedByOptions = ['ZONATIC', customersAdmin.find(c => c.id === product.customer).name];
    managedByOptions.forEach((option) => {
        let optionElement = document.createElement('md-select-option');
        optionElement.value = option;
        optionElement.innerText = option;
        managedBySelect.appendChild(optionElement);
    });

    document.getElementById('main_dialog_product_edit_client').innerHTML = '';
    customersAdmin.forEach((customer) => {
        console.log(customer)
        let option = document.createElement('md-select-option');
        option.value = customer.id;
        option.innerText = customer.name;
        document.getElementById('main_dialog_product_edit_client').appendChild(option);
    });

    document.getElementById('main_dialog_product_edit_renewal_attention').checked = product.renewalAttention || false;

    editProductAssignedTags = ensureUniqueTagIds(product.tags || []);
    refreshTagAssignmentsUI();
    document.getElementById('main_dialog_product_edit_tags_name').value = '';
    document.getElementById('main_dialog_product_edit_tags_color').value = '#006CFF';
    toggleProductAddInline('main_dialog_product_edit_tags_inline', false);

    setTimeout(() => {
        document.getElementById('main_dialog_product_edit_details').shadowRoot.querySelector('textarea').style.height = 'auto';
        document.getElementById('main_dialog_product_edit_details').shadowRoot.querySelector('textarea').style.height = document.getElementById('main_dialog_product_edit_details').shadowRoot.querySelector('textarea').scrollHeight + 'px';
        document.getElementById('main_dialog_product_edit_notes').shadowRoot.querySelector('textarea').style.height = 'auto';
        document.getElementById('main_dialog_product_edit_notes').shadowRoot.querySelector('textarea').style.height = document.getElementById('main_dialog_product_edit_notes').shadowRoot.querySelector('textarea').scrollHeight + 'px';
        document.getElementById('main_dialog_product_edit_licenses').shadowRoot.querySelector('textarea').style.height = 'auto';
        document.getElementById('main_dialog_product_edit_licenses').shadowRoot.querySelector('textarea').style.height = document.getElementById('main_dialog_product_edit_licenses').shadowRoot.querySelector('textarea').scrollHeight + 'px';
        let temp_val = millisecondsToRelativeTime(product.contractDuration, true).split(' ')[1] || '';
        if (temp_val.startsWith('y')) {
            contractDurationUnit.value = 'years';
        } else if (temp_val.startsWith('m')) {
            contractDurationUnit.value = 'months';
        } else if (temp_val.startsWith('d')) {
            contractDurationUnit.value = 'days';
        }
        providerSelect.value = product.provider || '';
        stateSelect.value = product.status || 'active';
        managedBySelect.value = product.managedBy || 'ZONATIC';
        document.getElementById('main_dialog_product_edit_client').value = product.customer || '';
        const editSubclientSearchField = document.getElementById('main_dialog_product_edit_subclient_search');
        if (editSubclientSearchField) {
            editSubclientSearchField.value = '';
        }
        populateSubcustomerEditSelect(product.customer, product.subcustomer);
    }, 100)
    document.getElementById('main_dialog_product_edit').show();
}

function populateSubcustomerEditSelect(customerId, currentSubcustomer) {
    const select = document.getElementById('main_dialog_product_edit_subclient');
    if (!select) {
        return;
    }
    select.innerHTML = '';
    if (!customerId) {
        select.value = '';
        return;
    }

    const searchValue = (document.getElementById('main_dialog_product_edit_subclient_search')?.value || '').toLowerCase();
    const subcustomersSet = new Set();

    const adminCustomer = customersAdmin.find((customer) => customer.id === customerId);
    if (adminCustomer && adminCustomer.subcustomers) {
        Object.keys(adminCustomer.subcustomers).forEach((sub) => {
            if (sub) {
                subcustomersSet.add(sub);
            }
        });
    }

    products.forEach((product) => {
        if (product.customer === customerId && product.subcustomer) {
            subcustomersSet.add(product.subcustomer);
        }
    });

    let subcustomers = Array.from(subcustomersSet);
    if (searchValue) {
        subcustomers = subcustomers.filter((subcustomer) => subcustomer.toLowerCase().includes(searchValue));
    }
    subcustomers.sort((a, b) => a.localeCompare(b));

    subcustomers.forEach((subcustomer) => {
        const option = document.createElement('md-select-option');
        option.value = subcustomer;
        option.innerText = subcustomer;
        select.appendChild(option);
    });

    setTimeout(() => {
        if (currentSubcustomer && subcustomers.includes(currentSubcustomer)) {
            select.value = currentSubcustomer;
        } else if (subcustomers.length > 0) {
            select.value = subcustomers[0];
        } else {
            select.value = '';
        }
    }, 100);
}

document.getElementById('main_dialog_product_edit_client').addEventListener('change', (e) => {
    const searchField = document.getElementById('main_dialog_product_edit_subclient_search');
    if (searchField) {
        searchField.value = '';
    }
    document.getElementById('main_dialog_product_edit_subclient_name').value = '';
    toggleProductAddInline('main_dialog_product_edit_subclient_inline', false);
    populateSubcustomerEditSelect(e.target.value);
});

const main_dialog_product_edit_subclient_search = document.getElementById('main_dialog_product_edit_subclient_search');
if (main_dialog_product_edit_subclient_search) {
    main_dialog_product_edit_subclient_search.addEventListener('input', () => {
        const clientId = document.getElementById('main_dialog_product_edit_client').value;
        const currentSelection = document.getElementById('main_dialog_product_edit_subclient').value;
        populateSubcustomerEditSelect(clientId, currentSelection);
    });
}

document.getElementById('main_dialog_product_edit_subclient_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    const clientId = document.getElementById('main_dialog_product_edit_client').value;
    if (!clientId) {
        showError('error', 'select_a_client');
        return;
    }
    const inline = document.getElementById('main_dialog_product_edit_subclient_inline');
    const isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_edit_subclient_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_edit_subclient_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_edit_subclient_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_product_edit_subclient_name').value = '';
    toggleProductAddInline('main_dialog_product_edit_subclient_inline', false);
});

document.getElementById('main_dialog_product_edit_subclient_create').addEventListener('click', (event) => {
    event.preventDefault();
    handleProductEditSubcustomerCreate();
});

const main_dialog_product_edit_tags_add = document.getElementById('main_dialog_product_edit_tags_add');
const main_dialog_product_edit_tags_menu = document.getElementById('main_dialog_product_edit_tags_menu');

if (main_dialog_product_edit_tags_add && main_dialog_product_edit_tags_menu) {
    main_dialog_product_edit_tags_add.addEventListener('click', (event) => {
        event.preventDefault();
        if (main_dialog_product_edit_tags_menu.open) {
            main_dialog_product_edit_tags_menu.open = false;
            return;
        }
        toggleProductAddInline('main_dialog_product_edit_tags_inline', false);
        populateTagMenu('main_dialog_product_edit_tags_menu', editProductAssignedTags, {
            onSelectTag: (tagId) => {
                editProductAssignedTags = ensureUniqueTagIds([...editProductAssignedTags, tagId]);
                refreshTagAssignmentsUI();
            },
            allowCreate: true,
            onCreate: () => {
                toggleProductAddInline('main_dialog_product_edit_tags_inline', true);
                setTimeout(() => {
                    document.getElementById('main_dialog_product_edit_tags_name').focus();
                }, 100);
            },
            emptyLabel: langDataLocal?.no_tags_available || 'No tags available'
        });
        openAnchoredMenu(main_dialog_product_edit_tags_menu, 'main_dialog_product_edit_tags_add');
    });
}

document.getElementById('main_dialog_product_edit_tags_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    const inline = document.getElementById('main_dialog_product_edit_tags_inline');
    const isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_edit_tags_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_edit_tags_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_edit_tags_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_product_edit_tags_name').value = '';
    toggleProductAddInline('main_dialog_product_edit_tags_inline', false);
});

document.getElementById('main_dialog_product_edit_tags_create').addEventListener('click', async (event) => {
    event.preventDefault();
    const nameField = document.getElementById('main_dialog_product_edit_tags_name');
    const colorField = document.getElementById('main_dialog_product_edit_tags_color');
    const nameValue = nameField.value.trim();
    const colorValue = colorField.value || '#006CFF';
    if (!nameValue) {
        showError('error', 'fill_all_fields');
        return;
    }
    const exists = tags.some((tag) => tag.name && tag.name.toUpperCase() === nameValue.toUpperCase());
    if (exists) {
        showError('error', 'tag_already_exists');
        return;
    }
    const button = document.getElementById('main_dialog_product_edit_tags_create');
    button.setAttribute('disabled', 'true');
    try {
        const newTag = await createTagRecord(nameValue, colorValue);
        editProductAssignedTags = ensureUniqueTagIds([...editProductAssignedTags, newTag.id]);
        refreshTagAssignmentsUI();
        toggleProductAddInline('main_dialog_product_edit_tags_inline', false);
        nameField.value = '';
        colorField.value = '#006CFF';
        showMessage('success', 'tag_created');
    } catch (error) {
        console.error('Error creating tag', error);
        showError('error', 'error_creating_tag');
    } finally {
        button.removeAttribute('disabled');
    }
});

document.getElementById('main_dialog_product_edit_close').addEventListener('click', () => {
    document.getElementById('main_dialog_product_edit').close();
});

document.getElementById('main_dialog_product_edit_cancel').addEventListener('click', () => {
    document.getElementById('main_dialog_product_edit').close();
});

document.getElementById('main_dialog_product_edit_make_historic').addEventListener('click', () => {
    editType = "historic";
    document.getElementById('main_dialog_product_edit_title').innerText = langDataLocal['make_historic'];
    document.getElementById('main_dialog_product_edit_save').innerText = langDataLocal['make_historic'];
    document.getElementById('main_dialog_product_edit_contract_start').value = getNextContractStart(adminGetProduct(openedProduct));
});


// document.getElementById('main_dialog_product_edit_description').addEventListener('input', (e) => {
//     console.log(e.target.scrollHeight);
//     resizeTextArea(e.target);
// });

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.auto-resize-textarea').forEach((textField) => {
        if (!textField.shadowRoot) {
            return;
        }
        const textArea = textField.shadowRoot.querySelector('textarea');
        if (!textArea) {
            return;
        }
        const minimumHeight = 140;
        textArea.style.minHeight = `${minimumHeight}px`;

        const resizeTextarea = () => {
            textArea.style.height = 'auto';
            const nextHeight = Math.max(textArea.scrollHeight, minimumHeight);
            textArea.style.height = `${nextHeight}px`;
        };

        // Event listeners for input events
        textArea.addEventListener('input', resizeTextarea);
        textArea.addEventListener('change', resizeTextarea);

        // Initial call to set height based on initial content
        resizeTextarea();
    });
});

document.getElementById('main_dialog_product_edit_make_duplicate').addEventListener('click', () => {
    editType = "duplicate";
    document.getElementById('main_dialog_product_edit_title').innerText = langDataLocal['duplicate_product'];
    document.getElementById('main_dialog_product_edit_save').innerText = langDataLocal['duplicate_product'];
});

let isCreatingProduct = false;
let providersFetchedForAdd = false;
let providersLoadPromise = null;
const productNameSuggestionState = new Map();
let productLineSuggestionId = 0;

function formatProductPrice(value) {
    const locale = localStorage.getItem('language') || 'ca';
    return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) + ' €';
}

function readProductLineEditor(prefix) {
    const container = document.getElementById(`main_dialog_product_${prefix}_subproducts`);
    if (!container) {
        return [];
    }
    return Array.from(container.querySelectorAll('.product-subproduct-row')).map((row) => ({
        name: row.querySelector('[data-subproduct-field="name"]')?.value || '',
        version: row.querySelector('[data-subproduct-field="version"]')?.value || '',
        units: row.querySelector('[data-subproduct-field="units"]')?.value || '',
        price: row.querySelector('[data-subproduct-field="price"]')?.value || ''
    }));
}

function refreshProductLineEditor(prefix) {
    const rows = readProductLineEditor(prefix);
    document.querySelectorAll(`#main_dialog_product_${prefix}_subproducts .product-subproduct-remove`).forEach((button) => {
        button.style.visibility = rows.length > 1 ? 'visible' : 'hidden';
        button.disabled = rows.length === 1;
    });
    const total = document.getElementById(`main_dialog_product_${prefix}_subproducts_total`);
    if (total) {
        total.innerText = formatProductPrice(getProductTotal(rows));
    }
    if (prefix === 'add') {
        refreshProductAddSummary();
    }
}

function appendProductLineRow(prefix, line = {}) {
    const container = document.getElementById(`main_dialog_product_${prefix}_subproducts`);
    if (!container) {
        return;
    }
    const row = document.createElement('div');
    row.className = 'product-subproduct-row';
    const fieldsByKey = {};
    const fields = [
        ['name', langDataLocal?.name || 'Name', 'text', line.name || ''],
        ['version', langDataLocal?.version || 'Version', 'text', line.version || ''],
        ['units', langDataLocal?.units || 'Units', 'number', line.units ?? 1],
        ['price', langDataLocal?.price_per_unit || 'Price per unit', 'text', line.price ?? '']
    ];
    fields.forEach(([key, label, type, value]) => {
        const field = document.createElement('md-outlined-text-field');
        field.setAttribute('data-subproduct-field', key);
        field.setAttribute('data-label-i18n', key === 'price' ? 'price_per_unit' : key);
        field.setAttribute('label', label);
        field.setAttribute('type', type);
        field.value = String(value);
        field.id = `main_dialog_product_${prefix}_subproduct_${productLineSuggestionId}_${key}`;
        fieldsByKey[key] = field;
        if (key === 'units') {
            field.setAttribute('min', '1');
            field.setAttribute('step', '1');
        } else if (key === 'price') {
            field.setAttribute('inputmode', 'decimal');
        }
        if (key === 'name' || key === 'version') {
            const wrapper = document.createElement('div');
            wrapper.className = 'product-subproduct-field';
            const suggestions = document.createElement('div');
            suggestions.id = `${field.id}_suggestions`;
            suggestions.className = 'product-add-suggestions';
            suggestions.setAttribute('role', 'listbox');
            suggestions.style.display = 'none';
            wrapper.append(field, suggestions);
            row.appendChild(wrapper);
        } else {
            row.appendChild(field);
        }
    });
    productLineSuggestionId++;
    const remove = document.createElement('md-icon-button');
    remove.className = 'product-subproduct-remove';
    remove.type = 'button';
    remove.setAttribute('aria-label', langDataLocal?.remove_subproduct || 'Remove subproduct');
    remove.setAttribute('data-title-i18n', 'remove_subproduct');
    remove.title = langDataLocal?.remove_subproduct || 'Remove subproduct';
    const icon = document.createElement('md-icon');
    icon.setAttribute('translate', 'no');
    icon.innerText = 'delete';
    remove.appendChild(icon);
    remove.addEventListener('click', () => {
        if (container.children.length > 1) {
            row.remove();
            refreshProductLineEditor(prefix);
        }
    });
    row.appendChild(remove);
    container.appendChild(row);
    const versionState = getProductNameSuggestionState(fieldsByKey.version.id, `${fieldsByKey.version.id}_suggestions`);
    bindProductNameSuggestions(fieldsByKey.name.id, `${fieldsByKey.name.id}_suggestions`, () => {
        hideProductNameSuggestions(versionState);
        refreshProductLineEditor(prefix);
    }, getSubproductNameSuggestions);
    bindProductNameSuggestions(fieldsByKey.version.id, `${fieldsByKey.version.id}_suggestions`, () => refreshProductLineEditor(prefix), (query) => {
        return getSubproductVersionSuggestions(fieldsByKey.name.value, query);
    });
    fieldsByKey.name.addEventListener('input', () => hideProductNameSuggestions(versionState));
    refreshProductLineEditor(prefix);
}

function renderProductLineEditor(prefix, product = {}) {
    const container = document.getElementById(`main_dialog_product_${prefix}_subproducts`);
    if (!container) {
        return;
    }
    container.innerHTML = '';
    getProductLines(product).forEach((line) => appendProductLineRow(prefix, line));
}

function getValidatedProductLines(prefix) {
    const lines = readProductLineEditor(prefix);
    const allowMissingPrice = prefix === 'edit';
    return productLinesAreValid(lines, allowMissingPrice)
        ? normalizeProductLines(lines).map((line) => ({ ...line, name: normalizeProductName(line.name) }))
        : null;
}

['add', 'edit'].forEach((prefix) => {
    document.getElementById(`main_dialog_product_${prefix}_subproducts_add`)?.addEventListener('click', () => {
        appendProductLineRow(prefix, { name: '', version: '', units: 1, price: '' });
    });
    document.getElementById(`main_dialog_product_${prefix}_subproducts`)?.addEventListener('input', () => {
        refreshProductLineEditor(prefix);
    });
});

function resetProductAddForm() {
    document.getElementById('main_dialog_product_add_name').value = '';
    document.getElementById('main_dialog_product_add_details').value = '';
    document.getElementById('main_dialog_product_add_notes').value = '';
    document.getElementById('main_dialog_product_add_licenses').value = '';
    document.getElementById('main_dialog_product_add_status_reason').value = '';
    document.getElementById('main_dialog_product_add_renewal_attention').checked = false;
    document.getElementById('main_dialog_product_add_contract_start').value = moment().format('YYYY-MM-DD');
    document.getElementById('main_dialog_product_add_contract_duration_number').value = '1';
    document.getElementById('main_dialog_product_add_contract_duration_unit').innerHTML = '';
    document.getElementById('main_dialog_product_add_status').innerHTML = '';
    document.getElementById('main_dialog_product_add_managed_by').innerHTML = '';
    document.getElementById('main_dialog_product_add_customer').innerHTML = '';
    document.getElementById('main_dialog_product_add_subcustomer').innerHTML = '';
    document.getElementById('main_dialog_product_add_provider').innerHTML = '';
    document.getElementById('main_dialog_product_add_customer_inline').style.display = 'none';
    document.getElementById('main_dialog_product_add_subcustomer_inline').style.display = 'none';
    document.getElementById('main_dialog_product_add_provider_inline').style.display = 'none';
    document.getElementById('main_dialog_product_add_customer_name').value = '';
    document.getElementById('main_dialog_product_add_subcustomer_name').value = '';
    document.getElementById('main_dialog_product_add_provider_name').value = '';
    const customerSearch = document.getElementById('main_dialog_product_add_customer_search');
    if (customerSearch) {
        customerSearch.value = '';
    }
    const subcustomerSearch = document.getElementById('main_dialog_product_add_subcustomer_search');
    if (subcustomerSearch) {
        subcustomerSearch.value = '';
    }
    const providerSearch = document.getElementById('main_dialog_product_add_provider_search');
    if (providerSearch) {
        providerSearch.value = '';
    }
    addProductAssignedTags = [];
    refreshTagAssignmentsUI();
    toggleProductAddInline('main_dialog_product_add_tags_inline', false);
    const tagNameField = document.getElementById('main_dialog_product_add_tags_name');
    if (tagNameField) {
        tagNameField.value = '';
    }
    hideProductAddNameSuggestions();
    renderProductLineEditor('add', { details: '', units: 1, price: '' });
    refreshProductAddSummary();
}

function normalizeProductNameSuggestion(value) {
    return normalizeProductText(value);
}

function getMatchingProductSuggestions(values, query, allowEmpty = false) {
    const normalizedQuery = normalizeProductNameSuggestion(query);
    if (!normalizedQuery && !allowEmpty) {
        return [];
    }
    const uniqueSuggestions = new Map();
    values.forEach((value) => {
        const suggestion = normalizeProductName(value);
        const normalizedSuggestion = normalizeProductNameSuggestion(suggestion);
        if (!suggestion || !normalizedSuggestion || uniqueSuggestions.has(normalizedSuggestion)) {
            return;
        }
        if (!normalizedQuery || normalizedSuggestion.includes(normalizedQuery)) {
            uniqueSuggestions.set(normalizedSuggestion, suggestion);
        }
    });
    return Array.from(uniqueSuggestions.entries())
        .sort(([normalizedA, nameA], [normalizedB, nameB]) => {
            const startsA = normalizedA.startsWith(normalizedQuery);
            const startsB = normalizedB.startsWith(normalizedQuery);
            if (startsA !== startsB) {
                return startsA ? -1 : 1;
            }
            return nameA.localeCompare(nameB);
        })
        .slice(0, 8)
        .map(([, name]) => name);
}

function getProductAddNameSuggestions(query) {
    return getMatchingProductSuggestions(products.map((product) => product.name), query);
}

function getSubproductNameSuggestions(query) {
    return getMatchingProductSuggestions(products.flatMap((product) => getProductLines(product).map((line) => line.name)), query);
}

function getSubproductVersionSuggestions(name, query) {
    const normalizedName = normalizeProductNameSuggestion(name);
    if (!normalizedName) {
        return [];
    }
    const versions = products.flatMap((product) => getProductLines(product))
        .filter((line) => normalizeProductNameSuggestion(line.name) === normalizedName)
        .map((line) => line.version);
    return getMatchingProductSuggestions(versions, query, true);
}

function getProductNameSuggestionState(fieldId, containerId) {
    if (!productNameSuggestionState.has(containerId)) {
        productNameSuggestionState.set(containerId, { fieldId, containerId, suggestions: [], index: -1 });
    }
    return productNameSuggestionState.get(containerId);
}

function setProductNameSuggestionIndex(state, index) {
    const container = document.getElementById(state.containerId);
    if (!container) {
        return;
    }
    state.index = index;
    Array.from(container.querySelectorAll('.product-add-suggestion')).forEach((button, buttonIndex) => {
        const isActive = buttonIndex === state.index;
        button.classList.toggle('product-add-suggestion--active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
            button.scrollIntoView({ block: 'nearest' });
        }
    });
}

function hideProductNameSuggestions(state) {
    const container = document.getElementById(state.containerId);
    if (!container) {
        return;
    }
    container.innerHTML = '';
    container.style.display = 'none';
    state.suggestions = [];
    state.index = -1;
}

function hideProductAddNameSuggestions() {
    hideProductNameSuggestions(getProductNameSuggestionState('main_dialog_product_add_name', 'main_dialog_product_add_name_suggestions'));
}

function applyProductNameSuggestion(state, name, afterApply) {
    const field = document.getElementById(state.fieldId);
    if (!field) {
        return;
    }
    field.value = normalizeProductName(name);
    hideProductNameSuggestions(state);
    if (afterApply) {
        afterApply();
    }
    field.focus();
}

function updateProductNameSuggestions(state, afterApply) {
    const field = document.getElementById(state.fieldId);
    const container = document.getElementById(state.containerId);
    if (!field || !container) {
        return;
    }
    state.suggestions = (state.getSuggestions || getProductAddNameSuggestions)(field.value);
    state.index = -1;
    container.innerHTML = '';
    if (state.suggestions.length === 0) {
        container.style.display = 'none';
        return;
    }
    state.suggestions.forEach((suggestion, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-add-suggestion';
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', 'false');
        button.innerText = suggestion;
        button.addEventListener('mousedown', (event) => {
            event.preventDefault();
        });
        button.addEventListener('click', () => {
            applyProductNameSuggestion(state, suggestion, afterApply);
        });
        button.addEventListener('mouseenter', () => {
            setProductNameSuggestionIndex(state, index);
        });
        container.appendChild(button);
    });
    container.style.display = 'block';
}

function handleProductNameSuggestionKeydown(event, state, afterApply) {
    if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key)) {
        return;
    }
    const container = document.getElementById(state.containerId);
    const suggestionsAreVisible = container && container.style.display !== 'none' && state.suggestions.length > 0;
    if (!suggestionsAreVisible) {
        if (event.key === 'ArrowDown') {
            updateProductNameSuggestions(state, afterApply);
            if (state.suggestions.length > 0) {
                event.preventDefault();
                setProductNameSuggestionIndex(state, 0);
            }
        }
        return;
    }

    if (event.key === 'ArrowDown') {
        event.preventDefault();
        const nextIndex = state.index < state.suggestions.length - 1 ? state.index + 1 : 0;
        setProductNameSuggestionIndex(state, nextIndex);
        return;
    }
    if (event.key === 'ArrowUp') {
        event.preventDefault();
        const previousIndex = state.index > 0 ? state.index - 1 : state.suggestions.length - 1;
        setProductNameSuggestionIndex(state, previousIndex);
        return;
    }
    if (event.key === 'Enter' && state.index > -1) {
        event.preventDefault();
        applyProductNameSuggestion(state, state.suggestions[state.index], afterApply);
        return;
    }
    if (event.key === 'Escape') {
        event.preventDefault();
        hideProductNameSuggestions(state);
    }
}

function bindProductNameSuggestions(fieldId, containerId, afterApply, getSuggestions = getProductAddNameSuggestions) {
    const field = document.getElementById(fieldId);
    if (!field) {
        return;
    }
    const state = getProductNameSuggestionState(fieldId, containerId);
    state.getSuggestions = getSuggestions;
    field.addEventListener('input', () => updateProductNameSuggestions(state, afterApply));
    field.addEventListener('keydown', (event) => handleProductNameSuggestionKeydown(event, state, afterApply));
    field.addEventListener('focus', () => updateProductNameSuggestions(state, afterApply));
    field.addEventListener('blur', () => {
        setTimeout(() => hideProductNameSuggestions(state), 140);
    });
}

async function ensureProvidersLoaded() {
    if (providersFetchedForAdd) {
        return;
    }
    if (!providersLoadPromise) {
        providersLoadPromise = getDocs(collection(db, 'providers')).then((providersSnapshot) => {
            providersSnapshot.forEach((docSnap) => {
                let provider = docSnap.data();
                provider.id = docSnap.id;
                upsertProvider(provider);
            });
            providersFetchedForAdd = true;
        }).finally(() => {
            providersLoadPromise = null;
        });
    }
    await providersLoadPromise;
}

function populateProductAddContractUnits(selected = 'years') {
    let select = document.getElementById('main_dialog_product_add_contract_duration_unit');
    select.innerHTML = '';
    ['days', 'months', 'years'].forEach((unit) => {
        let option = document.createElement('md-select-option');
        option.value = unit;
        option.innerText = langDataLocal[unit] || unit;
        select.appendChild(option);
    });
    setTimeout(() => {
        select.value = selected;
        refreshProductAddSummary();
    }, 50);
}

function populateProductAddStatus(selected = 'active') {
    let select = document.getElementById('main_dialog_product_add_status');
    select.innerHTML = '';
    ['active', 'inactive', 'renewal_pending', 'proposal_pending'].forEach((state) => {
        let option = document.createElement('md-select-option');
        option.value = state;
        option.innerText = langDataLocal[state] || state;
        select.appendChild(option);
    });
    setTimeout(() => {
        select.value = selected;
        refreshProductAddSummary();
    }, 50);
}

function populateProductAddCustomers(selected) {
    let select = document.getElementById('main_dialog_product_add_customer');
    select.innerHTML = '';
    let customersList = [];
    if (isAdmin && customersAdmin.length > 0) {
        customersList = [...customersAdmin];
    } else if (customerData) {
        customersList.push({ id: customerData.id || userClaims?.customer || '', name: customerData.name || '' });
    }
    customersList.sort((a, b) => a.name.localeCompare(b.name));
    const searchValue = (document.getElementById('main_dialog_product_add_customer_search')?.value || '').toLowerCase();
    const filteredCustomers = customersList.filter((customer) =>
        customer.name && customer.name.toLowerCase().includes(searchValue)
    );
    filteredCustomers.forEach((customer) => {
        let option = document.createElement('md-select-option');
        option.value = customer.id;
        option.innerText = customer.name;
        select.appendChild(option);
    });
    setTimeout(() => {
        if (filteredCustomers.length === 0) {
            select.value = '';
            populateProductAddSubcustomers('');
            populateProductAddManagedBy('');
            refreshProductAddSummary();
            return;
        }
        let defaultCustomerId = '';
        if (selected) {
            if (filteredCustomers.some((customer) => customer.id === selected)) {
                defaultCustomerId = selected;
            }
        }
        if (!defaultCustomerId) {
            defaultCustomerId = filteredCustomers[0].id;
        }
        if (defaultCustomerId) {
            select.value = defaultCustomerId;
        }
        select.dispatchEvent(new Event('change'));
        refreshProductAddSummary();
    }, 100);
}

function populateProductAddSubcustomers(customerId, selected) {
    let select = document.getElementById('main_dialog_product_add_subcustomer');
    select.innerHTML = '';
    if (!customerId) {
        select.value = '';
        refreshProductAddSummary();
        return;
    }
    let subcustomersSet = new Set();
    let adminCustomer = customersAdmin.find((customer) => customer.id === customerId);
    if (adminCustomer && adminCustomer.subcustomers) {
        Object.keys(adminCustomer.subcustomers).forEach((sub) => {
            if (sub) {
                subcustomersSet.add(sub);
            }
        });
    }
    products.forEach((product) => {
        if (product.customer === customerId && product.subcustomer) {
            subcustomersSet.add(product.subcustomer);
        }
    });
    let subcustomers = Array.from(subcustomersSet);
    const searchValue = (document.getElementById('main_dialog_product_add_subcustomer_search')?.value || '').toLowerCase();
    if (searchValue) {
        subcustomers = subcustomers.filter((subcustomer) => subcustomer.toLowerCase().includes(searchValue));
    }
    subcustomers.sort((a, b) => a.localeCompare(b));
    subcustomers.forEach((subcustomer) => {
        let option = document.createElement('md-select-option');
        option.value = subcustomer;
        option.innerText = subcustomer;
        select.appendChild(option);
    });
    setTimeout(() => {
        if (subcustomers.length === 0) {
            select.value = '';
            refreshProductAddSummary();
            return;
        }
        let defaultSubcustomer = '';
        if (selected && subcustomers.includes(selected)) {
            defaultSubcustomer = selected;
        } else {
            defaultSubcustomer = subcustomers[0];
        }
        select.value = defaultSubcustomer;
        refreshProductAddSummary();
    }, 100);
}

function populateProductAddProviders(selected) {
    let select = document.getElementById('main_dialog_product_add_provider');
    select.innerHTML = '';
    let providersList = [...providers];
    providersList.sort((a, b) => a.name.localeCompare(b.name));
    const searchValue = (document.getElementById('main_dialog_product_add_provider_search')?.value || '').toLowerCase();
    providersList = providersList.filter((provider) => provider.name && provider.name.toLowerCase().includes(searchValue));
    providersList.forEach((provider) => {
        let option = document.createElement('md-select-option');
        option.value = provider.id;
        option.innerText = provider.name;
        select.appendChild(option);
    });
    setTimeout(() => {
        if (providersList.length === 0) {
            select.value = '';
            refreshProductAddSummary();
            return;
        }
        let defaultProvider = '';
        if (selected && providersList.some((provider) => provider.id === selected)) {
            defaultProvider = selected;
        } else {
            defaultProvider = providersList.find((provider) => normalizeEntityName(provider.name) === 'VMWARE - BROADCOM')?.id || providersList[0].id;
        }
        select.value = defaultProvider;
        refreshProductAddSummary();
    }, 100);
}

function populateProductAddManagedBy(customerId, selected) {
    let select = document.getElementById('main_dialog_product_add_managed_by');
    select.innerHTML = '';
    let options = ['ZONATIC'];
    if (customerId) {
        let customer = customersAdmin.find((c) => c.id === customerId);
        if (customer && customer.name) {
            options.push(customer.name);
        }
    }
    options = options.filter((value, index, array) => array.indexOf(value) === index);
    options.forEach((value) => {
        let option = document.createElement('md-select-option');
        option.value = value;
        option.innerText = value;
        select.appendChild(option);
    });
    setTimeout(() => {
        if (selected && options.includes(selected)) {
            select.value = selected;
            refreshProductAddSummary();
            return;
        }
        if (customerId) {
            let customer = customersAdmin.find((c) => c.id === customerId);
            if (customer && options.includes(customer.name)) {
                select.value = customer.name;
                refreshProductAddSummary();
                return;
            }
        }
        select.value = options[0] || 'ZONATIC';
        refreshProductAddSummary();
    }, 100);
}

function getSelectOptionText(selectId) {
    const select = document.getElementById(selectId);
    if (!select || !select.value) {
        return '';
    }
    const option = Array.from(select.querySelectorAll('md-select-option')).find((item) => item.value === select.value);
    return option?.innerText?.trim() || option?.textContent?.trim() || '';
}

function getProductAddContractEndLabel() {
    const startValue = document.getElementById('main_dialog_product_add_contract_start')?.value;
    const durationValue = document.getElementById('main_dialog_product_add_contract_duration_number')?.value;
    const durationUnit = document.getElementById('main_dialog_product_add_contract_duration_unit')?.value;
    const providerId = document.getElementById('main_dialog_product_add_provider')?.value;
    const expires = getContractEndDate(startValue, durationValue, durationUnit, providerId);
    return expires ? moment(expires).format('L') : '-';
}

function setProductAddSummaryValue(id, value) {
    const element = document.getElementById(id);
    if (element) {
        element.innerText = value || '-';
    }
}

function refreshProductAddSummary() {
    const name = normalizeProductName(document.getElementById('main_dialog_product_add_name')?.value);
    const customerId = document.getElementById('main_dialog_product_add_customer')?.value || '';
    const subcustomer = document.getElementById('main_dialog_product_add_subcustomer')?.value?.trim() || '';
    const providerId = document.getElementById('main_dialog_product_add_provider')?.value || '';
    const productLines = readProductLineEditor('add');

    const customerName = getSelectOptionText('main_dialog_product_add_customer')
        || customersAdmin.find((customer) => customer.id === customerId)?.name
        || customerData?.name
        || '';
    const providerName = getSelectOptionText('main_dialog_product_add_provider')
        || providersById.get(providerId)?.name
        || providers.find((provider) => provider.id === providerId)?.name
        || '';

    setProductAddSummaryValue('main_dialog_product_add_summary_product', name);
    setProductAddSummaryValue('main_dialog_product_add_summary_customer', customerName);
    setProductAddSummaryValue('main_dialog_product_add_summary_subcustomer', subcustomer);
    setProductAddSummaryValue('main_dialog_product_add_summary_provider', providerName);
    setProductAddSummaryValue('main_dialog_product_add_summary_contract', getProductAddContractEndLabel());

    const requiredFields = [
        { complete: !!name, label: langDataLocal?.name || 'Name' },
        { complete: !!customerId, label: langDataLocal?.customer || 'Customer' },
        { complete: !!subcustomer, label: langDataLocal?.subcustomer || 'Subcustomer' },
        { complete: !!providerId, label: langDataLocal?.manufacturer || 'Manufacturer' },
        { complete: productLinesAreValid(productLines), label: langDataLocal?.subproducts || 'Subproducts' }
    ];
    const missingFields = requiredFields.filter((field) => !field.complete);
    const missingPanel = document.getElementById('main_dialog_product_add_missing_panel');
    const readyPanel = document.getElementById('main_dialog_product_add_ready_panel');
    const missingList = document.getElementById('main_dialog_product_add_missing_list');

    if (missingList) {
        missingList.innerHTML = '';
        missingFields.forEach((field) => {
            const item = document.createElement('li');
            item.innerText = field.label;
            missingList.appendChild(item);
        });
    }
    if (missingPanel) {
        missingPanel.style.display = missingFields.length > 0 ? 'block' : 'none';
    }
    if (readyPanel) {
        readyPanel.style.display = missingFields.length > 0 ? 'none' : 'block';
    }

    const saveButton = document.getElementById('main_dialog_product_add_save');
    if (saveButton) {
        if (missingFields.length > 0 || isCreatingProduct) {
            saveButton.setAttribute('disabled', 'true');
        } else {
            saveButton.removeAttribute('disabled');
        }
    }
}

async function openProductAddDialog(prefillProductId) {
    const templateProduct = prefillProductId ? products.find((product) => product.id === prefillProductId) : null;
    resetProductAddForm();
    populateProductAddContractUnits();
    populateProductAddStatus();
    populateProductAddCustomers(templateProduct?.customer);
    populateProductAddProviders(templateProduct?.provider);
    document.getElementById('main_dialog_product_add').show();
    refreshProductAddSummary();
    setTimeout(() => {
        document.getElementById('main_dialog_product_add_name').focus();
    }, 150);

    try {
        await ensureProvidersLoaded();
        populateProductAddProviders(templateProduct?.provider || document.getElementById('main_dialog_product_add_provider').value);
    } catch (error) {
        console.error('Error loading providers', error);
        showError('error', 'error_loading_providers');
    }
    if (templateProduct) {
        document.getElementById('main_dialog_product_add_name').value = templateProduct.name || '';
        document.getElementById('main_dialog_product_add_details').value = getProductDetails(templateProduct);
        document.getElementById('main_dialog_product_add_notes').value = templateProduct.notes || '';
        document.getElementById('main_dialog_product_add_licenses').value = templateProduct.licenses || '';
        renderProductLineEditor('add', templateProduct);
        document.getElementById('main_dialog_product_add_status_reason').value = templateProduct.statusReason || '';
        document.getElementById('main_dialog_product_add_renewal_attention').checked = templateProduct.renewalAttention || false;
        populateProductAddCustomers(templateProduct.customer);
        addProductAssignedTags = ensureUniqueTagIds(templateProduct.tags || []);
        refreshTagAssignmentsUI();
        document.getElementById('main_dialog_product_add_tags_name').value = '';
        document.getElementById('main_dialog_product_add_tags_color').value = '#006CFF';
        toggleProductAddInline('main_dialog_product_add_tags_inline', false);
        setTimeout(() => {
            populateProductAddSubcustomers(templateProduct.customer, templateProduct.subcustomer);
            populateProductAddProviders(templateProduct.provider);
            populateProductAddManagedBy(templateProduct.customer, templateProduct.managedBy);
            document.getElementById('main_dialog_product_add_contract_start').value = moment(templateProduct.contractStart).format('YYYY-MM-DD');
            document.getElementById('main_dialog_product_add_contract_duration_number').value = millisecondsToRelativeTime(templateProduct.contractDuration, true).split(' ')[0] || '12';
            let unit = millisecondsToRelativeTime(templateProduct.contractDuration, true).split(' ')[1] || '';
            if (unit.startsWith('y')) {
                document.getElementById('main_dialog_product_add_contract_duration_unit').value = 'years';
            } else if (unit.startsWith('m')) {
                document.getElementById('main_dialog_product_add_contract_duration_unit').value = 'months';
            } else if (unit.startsWith('d')) {
                document.getElementById('main_dialog_product_add_contract_duration_unit').value = 'days';
            }
            refreshProductAddSummary();
        }, 150);
    }
}

function toggleProductAddInline(containerId, show) {
    let container = document.getElementById(containerId);
    if (!container) {
        return;
    }
    container.style.display = show ? 'flex' : 'none';
}

async function handleProductAddCustomerCreate() {
    let nameField = document.getElementById('main_dialog_product_add_customer_name');
    let name = nameField.value.trim();
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    let normalizedName = normalizeEntityName(name);
    if (customersAdmin.some((customer) => customer.name && customer.name.toUpperCase() === normalizedName)) {
        showError('error', 'customer_already_exists');
        return;
    }
    let button = document.getElementById('main_dialog_product_add_customer_create');
    button.setAttribute('disabled', 'true');
    try {
        let docRef = await addDoc(collection(db, 'customers'), {
            name: normalizedName,
            products: [],
            subcustomers: {},
            contacts: [],
            providerNotes: {},
            createdAt: moment().valueOf()
        });
        let newCustomer = {
            id: docRef.id,
            name: normalizedName,
            products: [],
            subcustomers: {},
            contacts: [],
            providerNotes: {}
        };
        customersAdmin.push(newCustomer);
        populateProductAddCustomers(newCustomer.id);
        toggleProductAddInline('main_dialog_product_add_customer_inline', false);
        nameField.value = '';
        showMessage('success', 'customer_created');
    } catch (error) {
        console.error('Error creating customer', error);
        showError('error', 'error_creating_customer');
    } finally {
        button.removeAttribute('disabled');
        refreshProductAddSummary();
    }
}

async function handleProductAddSubcustomerCreate() {
    let customerId = document.getElementById('main_dialog_product_add_customer').value;
    if (!customerId) {
        showError('error', 'select_a_client');
        return;
    }
    let nameField = document.getElementById('main_dialog_product_add_subcustomer_name');
    let name = nameField.value.trim();
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    let normalizedName = normalizeEntityName(name);
    let targetCustomer = customersAdmin.find((customer) => customer.id === customerId);
    if (targetCustomer && targetCustomer.subcustomers) {
        let exists = Object.keys(targetCustomer.subcustomers).some((sub) => sub.toUpperCase() === normalizedName.toUpperCase());
        if (exists) {
            showError('error', 'subcustomer_already_exists');
            return;
        }
    }
    let button = document.getElementById('main_dialog_product_add_subcustomer_create');
    button.setAttribute('disabled', 'true');
    try {
        await setDoc(doc(db, 'customers', customerId), {
            subcustomers: {
                [normalizedName]: {
                    notes: '',
                    contactPersons: []
                }
            }
        }, { merge: true });
        if (targetCustomer) {
            targetCustomer.subcustomers = targetCustomer.subcustomers || {};
            targetCustomer.subcustomers[normalizedName] = { notes: '', contactPersons: [] };
        }
        populateProductAddSubcustomers(customerId, normalizedName);
        nameField.value = '';
        toggleProductAddInline('main_dialog_product_add_subcustomer_inline', false);
        showMessage('success', 'subcustomer_created');
    } catch (error) {
        console.error('Error creating subcustomer', error);
        showError('error', 'error_creating_subcustomer');
    } finally {
        button.removeAttribute('disabled');
        refreshProductAddSummary();
    }
}

async function handleProductAddProviderCreate() {
    const nameField = document.getElementById('main_dialog_product_add_provider_name');
    const name = normalizeEntityName(nameField.value);
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    const exists = providers.some((provider) => provider.name && provider.name.toUpperCase() === name.toUpperCase());
    if (exists) {
        showError('error', 'manufacturer_already_exists');
        return;
    }
    const button = document.getElementById('main_dialog_product_add_provider_create');
    button.setAttribute('disabled', 'true');
    try {
        const docRef = await addDoc(collection(db, 'providers'), {
            name,
            supportTypes: {},
            createdAt: moment().valueOf()
        });
        const newProvider = {
            id: docRef.id,
            name,
            supportTypes: {}
        };
        upsertProvider(newProvider);
        providersFetchedForAdd = true;
        populateProductAddProviders(newProvider.id);
        nameField.value = '';
        toggleProductAddInline('main_dialog_product_add_provider_inline', false);
        showMessage('success', 'manufacturer_created');
    } catch (error) {
        console.error('Error creating manufacturer', error);
        showError('error', 'error_creating_manufacturer');
    } finally {
        button.removeAttribute('disabled');
        refreshProductAddSummary();
    }
}

async function handleProductEditSubcustomerCreate() {
    const customerId = document.getElementById('main_dialog_product_edit_client').value;
    if (!customerId) {
        showError('error', 'select_a_client');
        return;
    }
    const nameField = document.getElementById('main_dialog_product_edit_subclient_name');
    const name = nameField.value.trim();
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    const normalizedName = normalizeEntityName(name);
    const targetCustomer = customersAdmin.find((customer) => customer.id === customerId);
    if (targetCustomer && targetCustomer.subcustomers) {
        const exists = Object.keys(targetCustomer.subcustomers).some((sub) => sub.toUpperCase() === normalizedName.toUpperCase());
        if (exists) {
            showError('error', 'subcustomer_already_exists');
            return;
        }
    }
    const button = document.getElementById('main_dialog_product_edit_subclient_create');
    button.setAttribute('disabled', 'true');
    try {
        await setDoc(doc(db, 'customers', customerId), {
            subcustomers: {
                [normalizedName]: {
                    notes: '',
                    contactPersons: []
                }
            }
        }, { merge: true });
        if (targetCustomer) {
            targetCustomer.subcustomers = targetCustomer.subcustomers || {};
            targetCustomer.subcustomers[normalizedName] = { notes: '', contactPersons: [] };
        }
        populateSubcustomerEditSelect(customerId, normalizedName);
        nameField.value = '';
        toggleProductAddInline('main_dialog_product_edit_subclient_inline', false);
        showMessage('success', 'subcustomer_created');
    } catch (error) {
        console.error('Error creating subcustomer', error);
        showError('error', 'error_creating_subcustomer');
    } finally {
        button.removeAttribute('disabled');
    }
}

async function handleProductAddSave() {
    if (isCreatingProduct) {
        return;
    }
    let name = normalizeProductName(document.getElementById('main_dialog_product_add_name').value);
    let customerId = document.getElementById('main_dialog_product_add_customer').value;
    let subcustomer = document.getElementById('main_dialog_product_add_subcustomer').value.trim();
    let provider = document.getElementById('main_dialog_product_add_provider').value;
    if (!name || !customerId || !subcustomer || !provider) {
        showError('error', 'fill_all_fields');
        return;
    }
    const subproducts = getValidatedProductLines('add');
    if (!subproducts) {
        showError('error', 'invalid_subproducts');
        return;
    }
    const legacyCommercialFields = getLegacyCommercialFields(subproducts);
    let contractStartValue = document.getElementById('main_dialog_product_add_contract_start').value;
    let contractDurationNumber = document.getElementById('main_dialog_product_add_contract_duration_number').value.trim();
    let contractDurationUnit = document.getElementById('main_dialog_product_add_contract_duration_unit').value;
    let status = document.getElementById('main_dialog_product_add_status').value || 'active';
    let statusReason = document.getElementById('main_dialog_product_add_status_reason').value;
    let managedBy = document.getElementById('main_dialog_product_add_managed_by').value || 'ZONATIC';
    let details = document.getElementById('main_dialog_product_add_details').value;
    let notes = document.getElementById('main_dialog_product_add_notes').value;
    let licenses = document.getElementById('main_dialog_product_add_licenses').value;
    let renewalAttention = document.getElementById('main_dialog_product_add_renewal_attention').checked || false;

    let contractStart = contractStartValue ? moment(contractStartValue).valueOf() : moment().valueOf();
    let contractDuration = getContractDurationMs(contractDurationNumber, contractDurationUnit);
    let expires = getContractEndDate(contractStart, contractDurationNumber, contractDurationUnit, provider);

    let saveButton = document.getElementById('main_dialog_product_add_save');
    saveButton.setAttribute('disabled', 'true');
    isCreatingProduct = true;
    try {
        let newProduct = {
            name,
            details,
            subproducts,
            ...legacyCommercialFields,
            notes,
            licenses,
            contractStart,
            contractDuration,
            provider,
            status,
            statusReason,
            managedBy,
            expires,
            renewalAttention,
            customer: customerId,
            subcustomer,
            tags: ensureUniqueTagIds(addProductAssignedTags),
            history: [],
            externalCustomerView: false,
            createdAt: moment().valueOf(),
            type: 'software'
        };
        let docRef = await addDoc(collection(db, 'products'), newProduct);
        await updateDoc(doc(db, 'customers', customerId), {
            products: arrayUnion(docRef.id)
        });
        document.getElementById('main_dialog_product_add').close();
        resetProductAddForm();
        showMessage('success', 'product_created');
    } catch (error) {
        console.error('Error creating product', error);
        showError('error', 'error_creating_product');
    } finally {
        isCreatingProduct = false;
        saveButton.removeAttribute('disabled');
    }
}

let addProductButton = document.getElementById('main__content__card__my_products__add');
if (addProductButton) {
    addProductButton.addEventListener('click', (event) => {
        event.preventDefault();
        openProductAddDialog();
    });
}

document.getElementById('main_dialog_product_add_close').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_product_add').close();
    resetProductAddForm();
});

document.getElementById('main_dialog_product_add_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_product_add').close();
    resetProductAddForm();
});

document.getElementById('main_dialog_product_add_customer').addEventListener('change', (event) => {
    let customerId = event.target.value;
    let subcustomerSearchField = document.getElementById('main_dialog_product_add_subcustomer_search');
    if (subcustomerSearchField) {
        subcustomerSearchField.value = '';
    }
    populateProductAddSubcustomers(customerId);
    populateProductAddManagedBy(customerId);
    document.getElementById('main_dialog_product_add_subcustomer_name').value = '';
    toggleProductAddInline('main_dialog_product_add_subcustomer_inline', false);
});

document.getElementById('main_dialog_product_add_customer_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    let inline = document.getElementById('main_dialog_product_add_customer_inline');
    let isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_add_customer_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_add_customer_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_add_customer_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    toggleProductAddInline('main_dialog_product_add_customer_inline', false);
    document.getElementById('main_dialog_product_add_customer_name').value = '';
});

document.getElementById('main_dialog_product_add_customer_create').addEventListener('click', (event) => {
    event.preventDefault();
    handleProductAddCustomerCreate();
});

document.getElementById('main_dialog_product_add_subcustomer_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    let customerId = document.getElementById('main_dialog_product_add_customer').value;
    if (!customerId) {
        showError('error', 'select_a_client');
        return;
    }
    let inline = document.getElementById('main_dialog_product_add_subcustomer_inline');
    let isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_add_subcustomer_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_add_subcustomer_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_add_subcustomer_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    toggleProductAddInline('main_dialog_product_add_subcustomer_inline', false);
    document.getElementById('main_dialog_product_add_subcustomer_name').value = '';
});

document.getElementById('main_dialog_product_add_subcustomer_create').addEventListener('click', (event) => {
    event.preventDefault();
    handleProductAddSubcustomerCreate();
});

document.getElementById('main_dialog_product_add_provider_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    let inline = document.getElementById('main_dialog_product_add_provider_inline');
    let isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_add_provider_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_add_provider_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_add_provider_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    toggleProductAddInline('main_dialog_product_add_provider_inline', false);
    document.getElementById('main_dialog_product_add_provider_name').value = '';
});

document.getElementById('main_dialog_product_add_provider_create').addEventListener('click', (event) => {
    event.preventDefault();
    handleProductAddProviderCreate();
});

const main_dialog_product_add_tags_add = document.getElementById('main_dialog_product_add_tags_add');
const main_dialog_product_add_tags_menu = document.getElementById('main_dialog_product_add_tags_menu');

if (main_dialog_product_add_tags_add && main_dialog_product_add_tags_menu) {
    main_dialog_product_add_tags_add.addEventListener('click', (event) => {
        event.preventDefault();
        if (main_dialog_product_add_tags_menu.open) {
            main_dialog_product_add_tags_menu.open = false;
            return;
        }
        toggleProductAddInline('main_dialog_product_add_tags_inline', false);
        populateTagMenu('main_dialog_product_add_tags_menu', addProductAssignedTags, {
            onSelectTag: (tagId) => {
                addProductAssignedTags = ensureUniqueTagIds([...addProductAssignedTags, tagId]);
                refreshTagAssignmentsUI();
            },
            allowCreate: true,
            onCreate: () => {
                toggleProductAddInline('main_dialog_product_add_tags_inline', true);
                setTimeout(() => {
                    document.getElementById('main_dialog_product_add_tags_name').focus();
                }, 100);
            },
            emptyLabel: langDataLocal?.no_tags_available || 'No tags available'
        });
        openAnchoredMenu(main_dialog_product_add_tags_menu, 'main_dialog_product_add_tags_add');
    });
}

document.getElementById('main_dialog_product_add_tags_toggle').addEventListener('click', (event) => {
    event.preventDefault();
    const inline = document.getElementById('main_dialog_product_add_tags_inline');
    const isVisible = inline.style.display === 'flex';
    toggleProductAddInline('main_dialog_product_add_tags_inline', !isVisible);
    if (!isVisible) {
        setTimeout(() => {
            document.getElementById('main_dialog_product_add_tags_name').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_product_add_tags_cancel').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_product_add_tags_name').value = '';
    toggleProductAddInline('main_dialog_product_add_tags_inline', false);
});

document.getElementById('main_dialog_product_add_tags_create').addEventListener('click', async (event) => {
    event.preventDefault();
    const nameField = document.getElementById('main_dialog_product_add_tags_name');
    const colorField = document.getElementById('main_dialog_product_add_tags_color');
    const nameValue = nameField.value.trim();
    const colorValue = colorField.value || '#006CFF';
    if (!nameValue) {
        showError('error', 'fill_all_fields');
        return;
    }
    const exists = tags.some((tag) => tag.name && tag.name.toUpperCase() === nameValue.toUpperCase());
    if (exists) {
        showError('error', 'tag_already_exists');
        return;
    }
    const button = document.getElementById('main_dialog_product_add_tags_create');
    button.setAttribute('disabled', 'true');
    try {
        const newTag = await createTagRecord(nameValue, colorValue);
        addProductAssignedTags = ensureUniqueTagIds([...addProductAssignedTags, newTag.id]);
        refreshTagAssignmentsUI();
        toggleProductAddInline('main_dialog_product_add_tags_inline', false);
        nameField.value = '';
        colorField.value = '#006CFF';
        showMessage('success', 'tag_created');
    } catch (error) {
        console.error('Error creating tag', error);
        showError('error', 'error_creating_tag');
    } finally {
        button.removeAttribute('disabled');
    }
});

document.getElementById('main_dialog_product_add_save').addEventListener('click', (event) => {
    event.preventDefault();
    handleProductAddSave();
});

const main_dialog_product_add_customer_search = document.getElementById('main_dialog_product_add_customer_search');
if (main_dialog_product_add_customer_search) {
    main_dialog_product_add_customer_search.addEventListener('input', () => {
        populateProductAddCustomers(document.getElementById('main_dialog_product_add_customer').value);
    });
}

const main_dialog_product_add_subcustomer_search = document.getElementById('main_dialog_product_add_subcustomer_search');
if (main_dialog_product_add_subcustomer_search) {
    main_dialog_product_add_subcustomer_search.addEventListener('input', () => {
        let customerId = document.getElementById('main_dialog_product_add_customer').value;
        let currentSubcustomer = document.getElementById('main_dialog_product_add_subcustomer').value;
        populateProductAddSubcustomers(customerId, currentSubcustomer);
    });
}

const main_dialog_product_add_provider_search = document.getElementById('main_dialog_product_add_provider_search');
if (main_dialog_product_add_provider_search) {
    main_dialog_product_add_provider_search.addEventListener('input', () => {
        let currentProvider = document.getElementById('main_dialog_product_add_provider').value;
        populateProductAddProviders(currentProvider);
    });
}

bindProductNameSuggestions('main_dialog_product_add_name', 'main_dialog_product_add_name_suggestions', refreshProductAddSummary);
bindProductNameSuggestions('main_dialog_product_edit_name', 'main_dialog_product_edit_name_suggestions');

[
    'main_dialog_product_add_name',
    'main_dialog_product_add_customer',
    'main_dialog_product_add_subcustomer',
    'main_dialog_product_add_provider',
    'main_dialog_product_add_contract_start',
    'main_dialog_product_add_contract_duration_number',
    'main_dialog_product_add_contract_duration_unit',
    'main_dialog_product_add_status',
    'main_dialog_product_add_managed_by',
    'main_dialog_product_add_units',
    'main_dialog_product_add_price'
].forEach((fieldId) => {
    const field = document.getElementById(fieldId);
    if (!field) {
        return;
    }
    field.addEventListener('input', refreshProductAddSummary);
    field.addEventListener('change', refreshProductAddSummary);
});

document.getElementById('main_dialog_product_edit_move_to_trash').addEventListener('click', () => {
    if (confirm(langDataLocal['move_product_to_trash_confirm'])) {
        // Move product to trash
        let product = adminGetProduct(openedProduct);
        updateDoc(doc(db, "products", openedProduct), {
            deleted: true
        })
            .then(() => {
                console.log("Document successfully updated!");
                // Delete notifications related to this product
                deleteProductNotificationsFromCustomer(product.customer, openedProduct);
                deleteProductNotificationsFromSubcustomer(openedProduct, product.subcustomer);
                // Close dialog
                document.getElementById('main_dialog_product_edit').close();
                document.getElementById('main_dialog_product_details').close();
                showMessage(langDataLocal['product_moved_to_trash']);
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
                showError(langDataLocal['error_moving_product_to_trash']);
            });
    }
});

document.getElementById('main_dialog_product_edit_restore_from_trash').addEventListener('click', () => {
    updateDoc(doc(db, "products", openedProduct), {
        deleted: false
    })
        .then(() => {
            console.log("Document successfully updated!");
            // Close dialog
            document.getElementById('main_dialog_product_edit').close();
            document.getElementById('main_dialog_product_details').close();
            showMessage(langDataLocal['product_restored_from_trash']);
        })
        .catch((error) => {
            console.error("Error updating document: ", error);
            showError(langDataLocal['error_restoring_product_from_trash']);
        });
});

function deleteProductNotificationsFromCustomer(customerId, productId) {
    // Get all notifications, check if any of them are type "product" and the customer is the one we're deleting
    let notificationsToDelete = [];
    getDocs(collection(db, "notifications"))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                let notification = doc.data();
                if (notification.type === 'product' && notification.customer === customerId && notification.product === productId) {
                    notificationsToDelete.push(doc.id);
                }
            });
            notificationsToDelete.forEach((notification) => {
                deleteDoc(doc(db, "notifications", notification))
                    .then(() => {
                        console.log("Document successfully deleted!");
                    })
                    .catch((error) => {
                        console.error("Error removing document: ", error);
                    });
            });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });
}

function deleteProductNotificationsFromSubcustomer(productId, subcustomerId) {
    // Get all notifications, check if any of them are type "product" and the customer is the one we're deleting
    let notificationsToDelete = [];
    getDocs(collection(db, "notifications"))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                let notification = doc.data();
                if (notification.type === 'product' && notification.product === productId && notification.subcustomer === subcustomerId) {
                    notificationsToDelete.push(doc.id);
                }
            });
            notificationsToDelete.forEach((notification) => {
                deleteDoc(doc(db, "notifications", notification))
                    .then(() => {
                        console.log("Document successfully deleted!");
                    })
                    .catch((error) => {
                        console.error("Error removing document: ", error);
                    });
            });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });
}

document.getElementById('main_dialog_product_edit_save').addEventListener('click', () => {
    const subproducts = getValidatedProductLines('edit');
    if (!subproducts) {
        showError('error', 'invalid_subproducts');
        return;
    }
    if (!normalizeProductName(document.getElementById('main_dialog_product_edit_name').value)) {
        showError('error', 'fill_all_fields');
        return;
    }
    const legacyCommercialFields = getLegacyCommercialFields(subproducts);
    if (editType === 'edit') {
        let product = adminGetProduct(openedProduct);
        let name = normalizeProductName(document.getElementById('main_dialog_product_edit_name').value);
        let details = document.getElementById('main_dialog_product_edit_details').value;
        let notes = document.getElementById('main_dialog_product_edit_notes').value;
        let licenses = document.getElementById('main_dialog_product_edit_licenses').value;
        let contractStart = document.getElementById('main_dialog_product_edit_contract_start').value;
        let contractDurationNumber = document.getElementById('main_dialog_product_edit_contract_duration_number').value;
        let contractDurationUnit = document.getElementById('main_dialog_product_edit_contract_duration_unit').value;
        let provider = document.getElementById('main_dialog_product_edit_provider').value;
        let status = document.getElementById('main_dialog_product_edit_state').value;
        let statusReason = document.getElementById('main_dialog_product_edit_status_reason').value;
        let managedBy = document.getElementById('main_dialog_product_edit_managed_by').value;
        let contractDuration = getContractDurationMs(contractDurationNumber, contractDurationUnit);
        let client = document.getElementById('main_dialog_product_edit_client').value;
        let subclient = document.getElementById('main_dialog_product_edit_subclient').value;
        // Check if client exists and if subclient exists in the client
        let clientExists = false;
        let subclientExists = false;
        let customerChanged = false;
        let subcustomerChanged = false;
        let renewalAttention = document.getElementById('main_dialog_product_edit_renewal_attention').checked || false;
        customersAdmin.forEach((customer) => {
            if (customer.id === client) {
                clientExists = true;
                products.forEach((product) => {
                    if (product.customer === client && product.subcustomer === subclient) {
                        subclientExists = true;
                    }
                });
            }
        });
        if (client !== product.customer) {
            customerChanged = true;
        }
        if (subclient !== product.subcustomer) {
            subcustomerChanged = true;
        }
        if (!clientExists) {
            showError(langDataLocal['customer_not_found']);
            return;
        }
        if (!subclientExists) {
            showError(langDataLocal['subcustomer_not_found']);
            return;
        }


        // External customers with access
        let externalCustomersWithAccess = [];
        document.querySelectorAll('#main_dialog_product_edit_external_customers md-input-chip').forEach((chip) => {
            externalCustomersWithAccess.push(chip.getAttribute('data-id'));
        });



        updateDoc(doc(db, "products", openedProduct), {
            name,
            details,
            subproducts,
            ...legacyCommercialFields,
            notes,
            licenses,
            contractStart: moment(contractStart).valueOf(),
            contractDuration,
            provider,
            status,
            statusReason,
            managedBy,
            expires: getContractEndDate(contractStart, contractDurationNumber, contractDurationUnit, provider),
            customer: client,
            subcustomer: subclient,
            renewalAttention,
            externalCustomersWithAccess,
            tags: ensureUniqueTagIds(editProductAssignedTags)
        })
            .then(() => {
                console.log("Document successfully updated!");
                if (customerChanged) {
                    // Update customer data
                    // First, remove the product from the old customer
                    let oldCustomer = customersAdmin.find(c => c.id === product.customer);
                    let oldCustomerProducts = oldCustomer.products;
                    let index = oldCustomerProducts.indexOf(openedProduct);
                    if (index > -1) {
                        oldCustomerProducts.splice(index, 1);
                    }
                    updateDoc(doc(db, "customers", product.customer), {
                        products: oldCustomerProducts
                    })
                        .then(() => {
                            console.log("Document successfully updated!");
                            deleteProductNotificationsFromCustomer(product.customer, openedProduct);
                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                        });
                    // Then, add the product to the new customer
                    let newCustomer = customersAdmin.find(c => c.id === client);
                    let newCustomerProducts = newCustomer.products;
                    newCustomerProducts.push(openedProduct);
                    updateDoc(doc(db, "customers", client), {
                        products: newCustomerProducts
                    })
                        .then(() => {
                            console.log("Document successfully updated!");
                            refetchProduct(openedProduct);
                            document.getElementById('main_dialog_product_edit').close();
                            document.getElementById('main_dialog_product_details').close();

                            // setTimeout(() => {
                            //     openProductDetails(adminGetProduct(openedProduct));
                            // }, 500)
                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                        });

                } else {
                    if (subcustomerChanged) {
                        deleteProductNotificationsFromSubcustomer(openedProduct, product.subcustomer);
                        refetchProduct(openedProduct);
                        document.getElementById('main_dialog_product_edit').close();
                        document.getElementById('main_dialog_product_details').close();

                        // setTimeout(() => {
                        //     openProductDetails(adminGetProduct(openedProduct));
                        // }, 500)
                    } else {
                        refetchProduct(openedProduct);
                        document.getElementById('main_dialog_product_edit').close();
                        document.getElementById('main_dialog_product_details').close();

                        // setTimeout(() => {
                        //     openProductDetails(adminGetProduct(openedProduct));
                        // }, 500)
                    }
                }
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
            });
    } else if (editType === 'history') {
        const product = adminGetProduct(openedProduct);
        const previousHistory = product?.history?.[openedProductHistoryIndex];
        if (!previousHistory) {
            showError('error', 'an_error_has_occurred');
            return;
        }
        const name = normalizeProductName(document.getElementById('main_dialog_product_edit_name').value);
        const details = document.getElementById('main_dialog_product_edit_details').value;
        const notes = document.getElementById('main_dialog_product_edit_notes').value;
        const licenses = document.getElementById('main_dialog_product_edit_licenses').value;
        const contractStart = document.getElementById('main_dialog_product_edit_contract_start').value;
        const contractDurationNumber = document.getElementById('main_dialog_product_edit_contract_duration_number').value;
        const contractDurationUnit = document.getElementById('main_dialog_product_edit_contract_duration_unit').value;
        const provider = document.getElementById('main_dialog_product_edit_provider').value;
        const customer = document.getElementById('main_dialog_product_edit_client').value;
        const subcustomer = document.getElementById('main_dialog_product_edit_subclient').value;
        const customerExists = customersAdmin.some((item) => item.id === customer);
        const subcustomerExists = products.some((item) => item.customer === customer && item.subcustomer === subcustomer) ||
            Object.prototype.hasOwnProperty.call(customersAdmin.find((item) => item.id === customer)?.subcustomers || {}, subcustomer);
        if (!customerExists) {
            showError('error', 'customer_not_found');
            return;
        }
        if (!subcustomerExists) {
            showError('error', 'subcustomer_not_found');
            return;
        }
        const externalCustomersWithAccess = Array.from(
            document.querySelectorAll('#main_dialog_product_edit_external_customers md-input-chip'),
            (chip) => chip.getAttribute('data-id')
        );
        const nextHistoryEntry = {
            ...previousHistory,
            name,
            details,
            subproducts,
            ...legacyCommercialFields,
            notes,
            licenses,
            contractStart: moment(contractStart).valueOf(),
            contractDuration: getContractDurationMs(contractDurationNumber, contractDurationUnit),
            provider,
            status: document.getElementById('main_dialog_product_edit_state').value,
            statusReason: document.getElementById('main_dialog_product_edit_status_reason').value,
            managedBy: document.getElementById('main_dialog_product_edit_managed_by').value,
            expires: getContractEndDate(contractStart, contractDurationNumber, contractDurationUnit, provider),
            customer,
            subcustomer,
            renewalAttention: document.getElementById('main_dialog_product_edit_renewal_attention').checked || false,
            externalCustomersWithAccess,
            tags: ensureUniqueTagIds(editProductAssignedTags)
        };
        updateDoc(doc(db, "products", openedProduct), {
            history: replaceProductHistoryEntry(product.history, openedProductHistoryIndex, nextHistoryEntry)
        })
            .then(() => {
                refetchProduct(openedProduct);
                document.getElementById('main_dialog_product_edit').close();
                document.getElementById('main_dialog_product_details').close();
                showMessage('success', 'historical_renewal_updated');
            })
            .catch((error) => {
                console.error("Error updating historical renewal: ", error);
                showError('error', 'error_updating_historical_renewal');
            });
    } else if (editType === 'historic') {
        // We'll move current data to product.history and set the fields to the new values.

        let product = adminGetProduct(openedProduct);
        if (!product.history) {
            product.history = [];
        }
        let history = {
            name: product.name,
            description: getLegacyCommercialFields(getProductLines(product)).description,
            details: getProductDetails(product),
            subproducts: getProductLines(product).map((line) => ({ ...line })),
            notes: product.notes,
            licenses: product.licenses,
            units: product.units,
            price: product.price,
            contractStart: product.contractStart,
            contractDuration: product.contractDuration,
            provider: product.provider,
            status: product.status,
            statusReason: product.statusReason,
            managedBy: product.managedBy,
            expires: product.expires,
            customer: product.customer,
            subcustomer: product.subcustomer,
            renewalAttention: product.renewalAttention || false,
            externalCustomersWithAccess: [...(product.externalCustomersWithAccess || [])],
            customerNotes: product.customerNotes || '',
            providerSupportType: product.providerSupportType || null,
            autoRenewal: product.autoRenewal || false,
            autoRenewalPercent: product.autoRenewalPercent || 0,
            files: (product.files || []).map((file) => ({ ...file })),
            tags: ensureUniqueTagIds(product.tags || [])
        };
        product.history.push(history);
        let name = normalizeProductName(document.getElementById('main_dialog_product_edit_name').value);
        let details = document.getElementById('main_dialog_product_edit_details').value;
        let notes = document.getElementById('main_dialog_product_edit_notes').value;
        let licenses = document.getElementById('main_dialog_product_edit_licenses').value;
        let contractStart = document.getElementById('main_dialog_product_edit_contract_start').value;
        let contractDurationNumber = document.getElementById('main_dialog_product_edit_contract_duration_number').value;
        let contractDurationUnit = document.getElementById('main_dialog_product_edit_contract_duration_unit').value;
        let provider = document.getElementById('main_dialog_product_edit_provider').value;
        let status = document.getElementById('main_dialog_product_edit_state').value;
        let statusReason = document.getElementById('main_dialog_product_edit_status_reason').value;
        let managedBy = document.getElementById('main_dialog_product_edit_managed_by').value;
        let renewalAttention = document.getElementById('main_dialog_product_edit_renewal_attention').checked || false;
        let contractDuration = getContractDurationMs(contractDurationNumber, contractDurationUnit);
        updateDoc(doc(db, "products", openedProduct), {
            name,
            details,
            subproducts,
            ...legacyCommercialFields,
            notes,
            licenses,
            contractStart: moment(contractStart).valueOf(),
            contractDuration,
            provider,
            status,
            statusReason,
            managedBy,
            expires: getContractEndDate(contractStart, contractDurationNumber, contractDurationUnit, provider),
            renewalAttention,
            history: product.history,
            tags: ensureUniqueTagIds(editProductAssignedTags)
        })
            .then(() => {
                console.log("Document successfully updated!");
                refetchProduct(openedProduct);
                document.getElementById('main_dialog_product_edit').close();
                document.getElementById('main_dialog_product_details').close();
                filterProducts();
                // setTimeout(() => {
                //     openProductDetails(adminGetProduct(openedProduct));
                // }, 500)
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
            });
    } else if (editType === 'duplicate') {
        // Create new product with the same data, but new ID
        let product = adminGetProduct(openedProduct);
        const productData = { ...product };
        delete productData.id;
        let name = normalizeProductName(document.getElementById('main_dialog_product_edit_name').value);
        let details = document.getElementById('main_dialog_product_edit_details').value;
        let notes = document.getElementById('main_dialog_product_edit_notes').value;
        let licenses = document.getElementById('main_dialog_product_edit_licenses').value;
        let contractStart = document.getElementById('main_dialog_product_edit_contract_start').value;
        let contractDurationNumber = document.getElementById('main_dialog_product_edit_contract_duration_number').value;
        let contractDurationUnit = document.getElementById('main_dialog_product_edit_contract_duration_unit').value;
        let provider = document.getElementById('main_dialog_product_edit_provider').value;
        let status = document.getElementById('main_dialog_product_edit_state').value;
        let statusReason = document.getElementById('main_dialog_product_edit_status_reason').value;
        let managedBy = document.getElementById('main_dialog_product_edit_managed_by').value;
        let renewalAttention = document.getElementById('main_dialog_product_edit_renewal_attention').checked || false;
        let contractDuration = getContractDurationMs(contractDurationNumber, contractDurationUnit);
        let client = document.getElementById('main_dialog_product_edit_client').value;
        let subclient = document.getElementById('main_dialog_product_edit_subclient').value;
        // Check if client exists and if subclient exists in the client
        let clientExists = false;
        let subclientExists = false;
        customersAdmin.forEach((customer) => {
            if (customer.id === client) {
                clientExists = true;
                products.forEach((product) => {
                    if (product.customer === client && product.subcustomer === subclient) {
                        subclientExists = true;
                    }
                });
            }
        });
        if (!clientExists) {
            showError(langDataLocal['customer_not_found']);
            return;
        }
        if (!subclientExists) {
            showError(langDataLocal['subcustomer_not_found']);
            return;
        }
        addDoc(collection(db, "products"), {
            ...productData,
            name,
            details,
            subproducts: subproducts.map((line) => ({ ...line })),
            ...legacyCommercialFields,
            notes,
            licenses,
            contractStart: moment(contractStart).valueOf(),
            contractDuration,
            provider,
            status,
            statusReason,
            managedBy,
            expires: getContractEndDate(contractStart, contractDurationNumber, contractDurationUnit, provider),
            customer: client,
            renewalAttention,
            subcustomer: subclient,
            tags: ensureUniqueTagIds(editProductAssignedTags)
        })
            .then((newProductRef) => {
                console.log("Document successfully added!");
                // Add new product ID to customer's products array
                let id = newProductRef.id;
                let customer = client;
                getDoc(doc(db, "customers", customer)).then((docO) => {
                    let docData = docO.data();
                    let products = docData.products || [];
                    products.push(id);
                    updateDoc(doc(db, "customers", customer), {
                        products
                    })
                        .then(() => {
                            document.getElementById('main_dialog_product_edit').close();
                            document.getElementById('main_dialog_product_details').close();

                            // setTimeout(() => {
                            //     openProductDetails(adminGetProduct(id));
                            // }, 500)
                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                        });
                })
                    .catch((error) => {
                        console.error("Error adding document: ", error);
                    });
            })
            .catch((error) => {
                console.error("Error adding document: ", error);
            })
    }
});



let adminComposeType = null;
let mailDestinations = [];
function openAdminCompose(from, type) {
    adminComposeType = type;
    mailDestinations = [];
    document.getElementById('main_dialog_admin_compose_to').innerHTML = '';
    console.log('openAdminCompose', from);
    document.getElementById('main_dialog_admin_compose').show();

    // Get contacts from customer
    const customerCompose = products.find((p) => p.id === openedProduct).customer;
    customersAdmin.find((c) => c.id === customerCompose)?.contacts?.forEach((contact) => {
        let div = document.createElement('div');
        // Per cada contacte, crearem una fila amb tres chips: "Nom (correu)", "Cc", "Cco"
        let chip = document.createElement('md-filter-chip');
        chip.style.marginRight = '5px';
        chip.setAttribute('data-id', contact.email);
        chip.setAttribute('data-type', 'to');
        chip.innerHTML = `<span>${contact.name} (${contact.email})</span>`;
        chip.addEventListener('click', (e) => {
            if (e.target.hasAttribute('selected')) {
                e.target.removeAttribute('selected');
                // Remove from mailDestinations
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email || d.type !== 'to');
            } else {
                e.target.setAttribute('selected', '');
                // Remove selection from other chips with same email
                document.querySelectorAll(`md-filter-chip[data-id="${contact.email}"]`).forEach((c) => {
                    if (c !== e.target) {
                        c.removeAttribute('selected');
                    }
                });
                // Remove from mailDestinations if it exists, any type
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email);
                // Add to mailDestinations
                if (!mailDestinations.some((d) => d.email === contact.email && d.type === 'to')) {
                    mailDestinations.push({ email: contact.email, type: 'to' });
                }
            }
            console.log(mailDestinations);
        });
       div.appendChild(chip);
        // Add Cc and Cco chips
        let ccChip = document.createElement('md-filter-chip');
        ccChip.style.marginRight = '5px';
        ccChip.setAttribute('data-id', contact.email);
        ccChip.setAttribute('data-type', 'cc');
        ccChip.innerHTML = `<span>Cc</span>`;
        ccChip.addEventListener('click', (e) => {
            if (e.target.hasAttribute('selected')) {
                e.target.removeAttribute('selected');
                // Remove from mailDestinations
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email || d.type !== 'cc');
            } else {
                e.target.setAttribute('selected', '');
                // Remove selection from other chips with same email
                document.querySelectorAll(`md-filter-chip[data-id="${contact.email}"]`).forEach((c) => {
                    if (c !== e.target) {
                        c.removeAttribute('selected');
                    }
                });
                // Remove from mailDestinations if it exists, any type
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email);
                // Add to mailDestinations
                if (!mailDestinations.some((d) => d.email === contact.email && d.type === 'cc')) {
                    mailDestinations.push({ email: contact.email, type: 'cc' });
                }
            }
            console.log(mailDestinations);
        });
        div.appendChild(ccChip);
        let ccoChip = document.createElement('md-filter-chip');
        ccoChip.style.marginRight = '5px';
        ccoChip.setAttribute('data-id', contact.email);
        ccoChip.setAttribute('data-type', 'cco');
        ccoChip.innerHTML = `<span>Cco</span>`;
        ccoChip.addEventListener('click', (e) => {
            if (e.target.hasAttribute('selected')) {
                e.target.removeAttribute('selected');
                // Remove from mailDestinations
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email || d.type !== 'cco');
            } else {
                e.target.setAttribute('selected', '');
                // Remove selection from other chips with same email
                document.querySelectorAll(`md-filter-chip[data-id="${contact.email}"]`).forEach((c) => {
                    if (c !== e.target) {
                        c.removeAttribute('selected');
                    }
                });
                // Remove from mailDestinations if it exists, any type
                mailDestinations = mailDestinations.filter((d) => d.email !== contact.email);
                // Add to mailDestinations
                if (!mailDestinations.some((d) => d.email === contact.email && d.type === 'cco')) {
                    mailDestinations.push({ email: contact.email, type: 'cco' });
                }
            }
            console.log(mailDestinations);
        });
        div.appendChild(ccoChip);
        document.getElementById('main_dialog_admin_compose_to').appendChild(div);
    });
}

document.getElementById('main_dialog_admin_compose_aiprompt').addEventListener('keyup', async (e) => {
    if (e.key === 'Enter') {
        // Generate AI request
        let prompt = document.getElementById('main_dialog_admin_compose_aiprompt').value;
        let aiprompt = 'Genera l\'assumpte i el cos del correu electrònic que se\'t demana a continuació. Retorna la resposta en format JSON amb un objecte que contingui els camps "subject" i "body" (strings) i "success" (boolean).\n\n';
        if (adminComposeType == 'product') {
            aiprompt += 'Aquí tens la informació del producte al que has de fer referència al correu: \n\n';
            let product = adminGetProduct(openedProduct);
            aiprompt += JSON.stringify(product, null, 2);
        }
        if (auth.currentUser.displayName) {
            aiprompt += '\n\nNom del remitent: ' + auth.currentUser.displayName;
        }
        aiprompt += '\n\n Data i hora actual (pel context al generar el correu): ' + new Date().toLocaleString();
        aiprompt += '\n\n Prompt:\n' + prompt;

        // let response = await model.generateContent(aiprompt);
        document.getElementById('main_dialog_admin_compose_aiprompt').classList.add('aiprocessing');
        document.getElementById('main_dialog_admin_compose_aiprompt').disabled = true;
        let response = await ai(aiprompt);
        document.getElementById('main_dialog_admin_compose_aiprompt').classList.remove('aiprocessing');
        document.getElementById('main_dialog_admin_compose_aiprompt').disabled = false;
        console.log(response);

        if (response.success) {
            document.getElementById('main_dialog_admin_compose_subject').value = response.subject;
            document.getElementById('main_dialog_admin_compose_message').value = response.body;
        } else {
            showErrorAI('error', 'something_went_wrong_try_again');
        }
    }
});

async function ai(prompt) {
    try {
        let token = await auth.currentUser.getIdToken();
        let response = await fetch('https://customer-services.zonatic.tech/aiPrompt', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                prompt,
                token
            })
        });
        let data = await response.json();
        return data;
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}

document.getElementById('main_dialog_admin_compose_send').addEventListener('click', () => {
    let subject = document.getElementById('main_dialog_admin_compose_subject').value;
    let message = document.getElementById('main_dialog_admin_compose_message').value;
    if (subject === '' || message === '') {
        showError('error', 'subject_and_message_required');
        return;
    }
    if (mailDestinations.length === 0) {
        showError('error', 'at_least_one_recipient_required');
        return;
    }
    // Send email
    let emailData = {
        to: mailDestinations.filter(d => d.type === 'to').map(d => d.email),
        cc: mailDestinations.filter(d => d.type === 'cc').map(d => d.email),
        bcc: mailDestinations.filter(d => d.type === 'cco').map(d => d.email),
        subject,
        message,
        productId: openedProduct,
    };
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/sendEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(emailData)
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Network response was not ok');
                }
            })
            .then((data) => {
                console.log('Email sent successfully:', data);
                // Show success message
                // showMessage('Email sent successfully');
                // Close dialog
                document.getElementById('main_dialog_admin_compose').close();
                // Clear fields
                document.getElementById('main_dialog_admin_compose_subject').value = '';
                document.getElementById('main_dialog_admin_compose_message').value = '';
                document.getElementById('main_dialog_admin_compose_to').innerHTML = '';
                mailDestinations = [];
            })
            .catch((error) => {
                console.error('Error sending email:', error);
                // Show error message
                showError('error', 'something_went_wrong_try_again');
            });
    }).catch((error) => {
        console.error('Error getting token:', error);
        showError('error', 'something_went_wrong_try_again');
    });
});

document.getElementById('main_dialog_admin_compose_close').addEventListener('click', () => {
    document.getElementById('main_dialog_admin_compose').close();
});

document.getElementById('main_dialog_product_details_observations').addEventListener('focusout', () => {
    if (currentCustomerNotes !== document.getElementById('main_dialog_product_details_observations').value) {
        updateDoc(doc(db, "products", openedProduct), {
            customerNotes: document.getElementById('main_dialog_product_details_observations').value
        })
            .then(() => {
                currentCustomerNotes = document.getElementById('main_dialog_product_details_observations').value;
                console.log("Document successfully updated!");
                refetchProduct(openedProduct);
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
            });
    }
});

document.getElementById('main_dialog_product_details_provider_observations').addEventListener('focusout', () => {
    if (userClaims.customer) {
        if (currentProductNotes !== document.getElementById('main_dialog_product_details_provider_observations').value) {
            // Update db, "customers", userClaims.customer object. Find ID of provider and update value.
            let customer = userClaims.customer;
            // Get openedProduct data
            let oId = products.find(p => p.id === openedProduct);
            // Get provider data
            let provider = providers.find(p => p.id === oId.provider);
            if (provider) {
                // Update db customer's providerNotes object
                getDoc(doc(db, "customers", customer)).then((docO) => {
                    let docData = docO.data();
                    let providerNotes = docData.providerNotes || {};
                    providerNotes[provider.id] = document.getElementById('main_dialog_product_details_provider_observations').value;
                    if (providerNotes[provider.id] === '') {
                        delete providerNotes[provider.id];
                    }
                    updateDoc(doc(db, "customers", customer), {
                        providerNotes: providerNotes
                    })
                        .then(() => {
                            currentProductNotes = document.getElementById('main_dialog_product_details_provider_observations').value;
                            customer_data.providerNotes = providerNotes;
                            console.log("Document successfully updated!");

                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                            showError('error', 'something_went_wrong_try_again');
                        });
                })
                    .catch((error) => {
                        console.log("Error getting document:", error);
                        showError('error', 'something_went_wrong_try_again');
                    });
            }

        }
    } else if (isAdmin) {
        if (currentProductNotes !== document.getElementById('main_dialog_product_details_provider_observations').value) {
            // Update db, "customers", userClaims.customer object. Find ID of provider and update value.
            let customer = adminGetProduct(openedProduct).customer;
            // Get openedProduct data
            let oId = products.find(p => p.id === openedProduct);
            // Get provider data
            let provider = providers.find(p => p.id === oId.provider);
            if (provider) {
                // Update db customer's providerNotes object
                getDoc(doc(db, "customers", customer)).then((docO) => {
                    let docData = docO.data();
                    let providerNotes = docData.providerNotes || {};
                    providerNotes[provider.id] = document.getElementById('main_dialog_product_details_provider_observations').value;
                    if (providerNotes[provider.id] === '') {
                        delete providerNotes[provider.id];
                    }
                    updateDoc(doc(db, "customers", customer), {
                        providerNotes: providerNotes
                    })
                        .then(() => {
                            currentProductNotes = document.getElementById('main_dialog_product_details_provider_observations').value;
                            adminGetCustomer(customer).providerNotes = providerNotes;
                            console.log("Document successfully updated!");

                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                            showError('error', 'something_went_wrong_try_again');
                        });
                })
                    .catch((error) => {
                        console.log("Error getting document:", error);
                        showError('error', 'something_went_wrong_try_again');
                    });
            }

        }
    }
});

document.getElementById('main_dialog_provider_details_observations').addEventListener('focusout', () => {
    if (userClaims.customer) {
        if (currentProductNotes !== document.getElementById('main_dialog_provider_details_observations').value) {
            // Update db, "customers", userClaims.customer object. Find ID of provider and update value.
            let customer = userClaims.customer;
            // Get provider data
            let provider = providers.find(p => p.id === openedProvider);
            if (provider) {
                // Update db customer's providerNotes object
                getDoc(doc(db, "customers", customer)).then((docO) => {
                    let docData = docO.data();
                    let providerNotes = docData.providerNotes || {};
                    providerNotes[provider.id] = document.getElementById('main_dialog_provider_details_observations').value;
                    if (providerNotes[provider.id] === '') {
                        delete providerNotes[provider.id];
                    }
                    updateDoc(doc(db, "customers", customer), {
                        providerNotes: providerNotes
                    })
                        .then(() => {
                            currentProductNotes = document.getElementById('main_dialog_provider_details_observations').value;
                            customer_data.providerNotes[provider.id] = document.getElementById('main_dialog_provider_details_observations').value;
                            console.log("Document successfully updated!");

                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                            showError('error', 'something_went_wrong_try_again');
                        });
                })
                    .catch((error) => {
                        console.log("Error getting document:", error);
                        showError('error', 'something_went_wrong_try_again');
                    });
            }

        }
    } else if (isAdmin) {
        if (currentProductNotes !== document.getElementById('main_dialog_provider_details_observations').value) {
            // Update db, "customers", userClaims.customer object. Find ID of provider and update value.
            let customer = adminGetProduct(openedProduct).customer;
            // Get provider data
            let provider = providers.find(p => p.id === openedProvider);
            if (provider) {
                // Update db customer's providerNotes object
                getDoc(doc(db, "customers", customer)).then((docO) => {
                    let docData = docO.data();
                    let providerNotes = docData.providerNotes || {};
                    providerNotes[provider.id] = document.getElementById('main_dialog_provider_details_observations').value;
                    if (providerNotes[provider.id] === '') {
                        delete providerNotes[provider.id];
                    }
                    updateDoc(doc(db, "customers", customer), {
                        providerNotes: providerNotes
                    })
                        .then(() => {
                            currentProductNotes = document.getElementById('main_dialog_provider_details_observations').value;
                            adminGetCustomer(customer).providerNotes[provider.id] = document.getElementById('main_dialog_provider_details_observations').value;
                            console.log("Document successfully updated!");

                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                            showError('error', 'something_went_wrong_try_again');
                        });
                })
                    .catch((error) => {
                        console.log("Error getting document:", error);
                        showError('error', 'something_went_wrong_try_again');
                    });
            }

        }

    }
});

document.getElementById('main_dialog_product_details_close').addEventListener('click', () => {
    document.getElementById('main_dialog_product_details').close();
});

// document.getElementById('main_dialog_product_details_expire_reminder_customer').addEventListener('change', () => {
//     updateDoc(doc(db, "products", openedProduct), {
//         expireReminderCustomer: document.getElementById('main_dialog_product_details_expire_reminder_customer').checked
//     })
//         .then(() => {
//             console.log(products)
//             products.forEach((product) => {
//                 if (product.id === openedProduct) {
//                     product.expireReminderCustomer = document.getElementById('main_dialog_product_details_expire_reminder_customer').checked;
//                     console.log(product)
//                 }
//             });
//             console.log("Document successfully updated!");
//         })
//         .catch((error) => {
//             console.error("Error updating document: ", error);
//         });
// });

// document.getElementById('main_dialog_product_details_notifications_button').addEventListener('click', () => {

// });


let openedCustomer = null;

function openCustomerDetails(customer) {
    openedCustomer = customer.id;
    document.getElementById('main_dialog_customer_details').show();
    document.getElementById('main_dialog_customer_details_name_title').innerText = customer.name;
    document.getElementById('main_dialog_customer_details_users_progress').style.display = 'flex';
    document.getElementById('main_dialog_customer_details_contacts_progress').style.display = 'flex';
    document.getElementById('main_dialog_customer_details_users_content').style.display = 'none';
    // document.getElementById('main_dialog_customer_details_description').innerText = customer.description || '';
    document.getElementById('main_dialog_customer_details_name').value = customer.name;

    document.getElementById('main_dialog_customer_details_contacts').innerHTML = '';
    console.log('customer.contacts', customer.contacts);
    if (customer.contacts && customer.contacts.length > 0) {
        customer.contacts.forEach((contact) => {
            let contactItem = document.createElement('md-list-item');
            contactItem.classList.add('contact');
            contactItem.setAttribute('data-id', contact.id);
            let contactItemMainDiv = document.createElement('div');
            contactItemMainDiv.classList.add('contact-main');
            let contactItemLeftDiv = document.createElement('div');
            contactItemLeftDiv.classList.add('contact-left');
            let contactItemRightDiv = document.createElement('div');
            contactItemRightDiv.classList.add('contact-right');
            let contactItemName = document.createElement('span');
            contactItemName.innerText = contact.name;
            contactItemLeftDiv.appendChild(contactItemName);
            let contactItemMedaDiv = document.createElement('div');
            contactItemMedaDiv.classList.add('contact-meta');
            let contactItemEmail = document.createElement('span');
            contactItemEmail.innerText = contact.email || '';
            contactItemEmail.style.marginRight = '10px';
            contactItemMedaDiv.appendChild(contactItemEmail);
            let contactItemPhone = document.createElement('span');
            contactItemPhone.innerText = contact.phone || '';
            contactItemMedaDiv.appendChild(contactItemPhone);
            contactItemLeftDiv.appendChild(contactItemMedaDiv);
            let contactItemActions = document.createElement('span');
            contactItemActions.classList.add('contact-actions');
            let contactItemEdit = document.createElement('md-icon-button');
            let contactItemEditIcon = document.createElement('md-icon');
            contactItemEditIcon.innerText = 'edit';
            contactItemEdit.appendChild(contactItemEditIcon);
            contactItemEdit.addEventListener('click', (e) => {
                e.preventDefault();
                editingContactId = contact.id;
                document.getElementById('main_dialog_edit_contact_name').value = contact.name;
                document.getElementById('main_dialog_edit_contact_email').value = contact.email || '';
                document.getElementById('main_dialog_edit_contact_phone').value = contact.phone || '';
                document.getElementById('main_dialog_edit_contact_observations').value = contact.observations || '';
                document.getElementById('main_dialog_edit_contact').show();
            });
            contactItemActions.appendChild(contactItemEdit);

            contactItemRightDiv.appendChild(contactItemActions);
            contactItemMainDiv.appendChild(contactItemLeftDiv);
            contactItemMainDiv.appendChild(contactItemRightDiv);
            contactItem.appendChild(contactItemMainDiv);
            document.getElementById('main_dialog_customer_details_contacts').appendChild(contactItem);
        })

        document.getElementById('main_dialog_customer_details_contacts_progress').style.display = 'none';
        document.getElementById('main_dialog_customer_details_contacts_content').style.display = 'flex';
    } else {
        document.getElementById('main_dialog_customer_details_contacts_progress').style.display = 'none';
        document.getElementById('main_dialog_customer_details_contacts_content').style.display = 'flex';
        document.getElementById('main_dialog_customer_details_contacts').innerHTML = '<span style="text-align: center;">' + langDataLocal['no_contacts'] + '</span>';

    }


    auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {
            fetch('https://customer-services.zonatic.tech/getCustomerData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customer: customer.id,
                    token: idTokenResult.token
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    document.getElementById('main_dialog_customer_details_users_progress').style.display = 'none';
                    document.getElementById('main_dialog_customer_details_users_content').style.display = 'block';
                    document.getElementById('main_dialog_customer_details_users_users_from_company').innerText = langDataLocal['users_from'] + ' ' + customer.name;
                    document.getElementById('main_dialog_customer_details_users_list_company').innerHTML = '';
                    document.getElementById('main_dialog_customer_details_users_list_clients').innerHTML = '';
                    let companyHeader = document.createElement('md-list-item');
                    companyHeader.classList.add('user');
                    let companyHeaderMainDiv = document.createElement('div');
                    let companyHeaderRightDiv = document.createElement('div');
                    companyHeaderRightDiv.classList.add('user-right');
                    let span1 = document.createElement('span');
                    span1.innerText = langDataLocal['enabled'];
                    companyHeaderRightDiv.appendChild(span1);
                    let span2 = document.createElement('span');
                    span2.innerText = langDataLocal['admin'];
                    companyHeaderRightDiv.appendChild(span2);
                    let span3 = document.createElement('span');
                    span3.innerText = langDataLocal['edit'];
                    companyHeaderRightDiv.appendChild(span3);
                    let companyHeaderLeftDiv = document.createElement('div');
                    companyHeaderLeftDiv.classList.add('user-left');
                    let span4 = document.createElement('span');
                    span4.innerText = langDataLocal['name'];
                    companyHeaderLeftDiv.appendChild(span4);
                    companyHeaderMainDiv.appendChild(companyHeaderLeftDiv);
                    companyHeaderMainDiv.appendChild(companyHeaderRightDiv);
                    companyHeader.appendChild(companyHeaderMainDiv);

                    let clientsHeader = document.createElement('md-list-item');
                    clientsHeader.classList.add('user');
                    let clientsHeaderMainDiv = document.createElement('div');
                    let clientsHeaderRightDiv = document.createElement('div');
                    clientsHeaderRightDiv.classList.add('user-right');
                    let span5 = document.createElement('span');
                    span5.innerText = langDataLocal['enabled'];
                    clientsHeaderRightDiv.appendChild(span5);
                    let span6 = document.createElement('span');
                    span6.innerText = langDataLocal['edit'];
                    clientsHeaderRightDiv.appendChild(span6);
                    let clientsHeaderLeftDiv = document.createElement('div');
                    clientsHeaderLeftDiv.classList.add('user-left');
                    let span7 = document.createElement('span');
                    span7.innerText = langDataLocal['name'];
                    clientsHeaderLeftDiv.appendChild(span7);
                    clientsHeaderMainDiv.appendChild(clientsHeaderLeftDiv);
                    clientsHeaderMainDiv.appendChild(clientsHeaderRightDiv);
                    clientsHeader.appendChild(clientsHeaderMainDiv);
                    editingCustomerId = customer.id;
                    editingFromAdmin = true;

                    data.users.forEach((user) => {
                        if (user.subcustomer === undefined) {
                            document.getElementById('main_dialog_customer_details_users_list_company').appendChild(renderUser(user, true, customer.id));
                        } else {
                            document.getElementById('main_dialog_customer_details_users_list_clients').appendChild(renderUser(user, true, customer.id));
                        }
                    });

                    // Check if there are no users in any of the lists
                    if (document.getElementById('main_dialog_customer_details_users_list_company').innerHTML === '') {
                        document.getElementById('main_dialog_customer_details_users_list_company').innerHTML = '<span style="text-align: center;">' + langDataLocal['no_users'] + '</span>';
                    } else {
                        document.getElementById('main_dialog_customer_details_users_list_company').prepend(document.createElement('md-divider'));
                        document.getElementById('main_dialog_customer_details_users_list_company').prepend(companyHeader);
                    }
                    if (document.getElementById('main_dialog_customer_details_users_list_clients').innerHTML === '') {
                        document.getElementById('main_dialog_customer_details_users_list_clients').innerHTML = '<span style="text-align: center;">' + langDataLocal['no_users'] + '</span>';
                    } else {
                        document.getElementById('main_dialog_customer_details_users_list_clients').prepend(document.createElement('md-divider'));
                        document.getElementById('main_dialog_customer_details_users_list_clients').prepend(clientsHeader);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
        .catch((error) => {
            console.error('Error:', error);
        });

}

document.getElementById('main_dialog_customer_details_close').addEventListener('click', () => {
    document.getElementById('main_dialog_customer_details').close();
});

document.getElementById('main_dialog_customer_details_discard').addEventListener('click', () => {
    document.getElementById('main_dialog_customer_details').close();
});

document.getElementById('main_dialog_customer_details_save').addEventListener('click', () => {
    const name = normalizeEntityName(document.getElementById('main_dialog_customer_details_name').value);
    if (!name) {
        return;
    }
    updateDoc(doc(db, "customers", openedCustomer), {
        name: name
    })
        .then(() => {
            console.log("Document successfully updated!");
            document.getElementById('main_dialog_customer_details').close();
        })
        .catch((error) => {
            console.error("Error updating document: ", error);
        });
});

let searchChips = [];


function addSearchChip(text) {
    const searchText = (text || '').trim();
    if (!searchText || searchChips.includes(searchText)) {
        return;
    }
    searchChips.push(searchText);
    console.log(searchChips);
    let chip = document.createElement('md-input-chip');
    let chipIcon = document.createElement('md-icon');
    chipIcon.innerText = 'search';
    chipIcon.setAttribute('translate', 'no');
    chipIcon.setAttribute('slot', 'icon');
    chip.appendChild(chipIcon);
    chip.classList.add('searchChip');
    chip.setAttribute('remove-only', '');
    let displayText = searchText;
    if (displayText.length > 20) {
        displayText = displayText.substring(0, 20) + '...';
    }
    chip.label = displayText;
    filterProducts();
    document.getElementById('main__content__card__my_products__remove_search').style.display = 'block';
    // Append chip before last child
    document.getElementById('my_products__search_chips').insertBefore(chip, document.getElementById('my_products__search_chips').lastChild);
    setTimeout(() => {
        let shadow = chip.shadowRoot;
        shadow.querySelector('.trailing').addEventListener('click', (e) => {
            searchChips = searchChips.filter((chipText) => chipText !== searchText);
            chip.remove();
            if (searchChips.length === 0) {
                document.getElementById('main__content__card__my_products__remove_search').style.display = 'none';
            }
            filterProducts();
            console.log(searchChips);
        })
    }, 100);
}

document.getElementById('main__content__card__my_products__remove_search').addEventListener('click', () => {
    searchChips = [];
    document.getElementById('main__content__card__my_products__remove_search').style.display = 'none';
    // Remove all chips
    let chips = document.getElementsByClassName('searchChip');
    while (chips[0]) {
        chips[0].parentNode.removeChild(chips[0]);
    }
    filterProducts();
});

document.getElementById('main__content__card__my_products__search').addEventListener('keyup', (event) => {
    if (event.keyCode === 13) {
        event.preventDefault();
        // filterProducts(document.getElementById('main__content__card__my_products__search').value);
        addSearchChip(document.getElementById('main__content__card__my_products__search').value);
        document.getElementById('main__content__card__my_products__search').value = '';
    }
});

document.getElementById('main__content__card__my_products__remove_filters').addEventListener('click', () => {
    document.getElementById('main__content__card__my_products__remove_filters').style.display = 'none';
    document.getElementById('main__content__card__my_products__search').value = '';
    filtered = false;
    providerFiltered = false;
    activeFilters = [];
    providerActiveFilters = [];
    // document.getElementById('main__content__card__my_products__filter_text').innerText = langDataLocal['customers'];
    // document.getElementById('main__content__card__my_products__filter_provider_text').innerText = langDataLocal['manufacturers'];
    my_products__filters__status_activeFilters = [];
    my_products__filters__managedBy_activeFilters = [];
    my_products__filters__customers_activeFilters = [];
    my_products__filters__customersadmin_activeFilters = [];
    my_products__filters__subcustomersadmin_activeFilters = [];
    my_products__filters__providers_activeFilters = [];
    my_products__filters__subproducts_activeFilters = [];
    my_products__filters__versions_activeFilters = [];
    my_products__filters__others_activeFilters = [];
    my_products__filters__tags_activeFilters = [];
    my_products__filters__expiryDate_start = null;
    my_products__filters__expiryDate_end = null;
    document.getElementById('my_products__filters__status').removeAttribute('selected');
    document.getElementById('my_products__filters__managedBy').removeAttribute('selected');
    document.getElementById('my_products__filters__customers').removeAttribute('selected');
    document.getElementById('my_products__filters__providers').removeAttribute('selected');
    document.getElementById('my_products__filters__subproducts').removeAttribute('selected');
    document.getElementById('my_products__filters__versions').removeAttribute('selected');
    document.getElementById('my_products__filters__versions_wrapper').style.display = 'none';
    document.getElementById('my_products__filters__others').removeAttribute('selected');
    document.getElementById('my_products__filters__expiryDate').removeAttribute('selected');
    document.getElementById('my_products__filters__customersadmin').removeAttribute('selected');
    document.getElementById('my_products__filters__subcustomersadmin').removeAttribute('selected');
    document.getElementById('my_products__filters__tags').removeAttribute('selected');
    filterProducts();
});

function filterProducts() {
    rebuildProductsIndex();
    productsRenderLimit = PRODUCTS_RENDER_BATCH_SIZE;
    refreshVersionFilterAvailability();

    const hasActiveFilters = filtered ||
        providerFiltered ||
        my_products__filters__status_activeFilters.length > 0 ||
        my_products__filters__managedBy_activeFilters.length > 0 ||
        my_products__filters__customers_activeFilters.length > 0 ||
        my_products__filters__customersadmin_activeFilters.length > 0 ||
        my_products__filters__subcustomersadmin_activeFilters.length > 0 ||
        my_products__filters__providers_activeFilters.length > 0 ||
        my_products__filters__subproducts_activeFilters.length > 0 ||
        my_products__filters__versions_activeFilters.length > 0 ||
        my_products__filters__others_activeFilters.length > 0 ||
        my_products__filters__tags_activeFilters.length > 0 ||
        my_products__filters__expiryDate_start ||
        my_products__filters__expiryDate_end;

    document.getElementById('main__content__card__my_products__remove_filters').style.display = hasActiveFilters ? 'block' : 'none';

    const statusFilters = new Set(my_products__filters__status_activeFilters);
    const managedByFilters = new Set(my_products__filters__managedBy_activeFilters);
    const customerFilters = new Set(my_products__filters__customers_activeFilters);
    const customerAdminFilters = new Set(my_products__filters__customersadmin_activeFilters);
    const subcustomerAdminFilters = new Set(my_products__filters__subcustomersadmin_activeFilters);
    const providerFilters = new Set(my_products__filters__providers_activeFilters);
    const otherFilters = new Set(my_products__filters__others_activeFilters);
    const activeTags = my_products__filters__tags_activeFilters;
    const filterWithoutTags = activeTags.includes('__WITHOUT__');
    const tagFilters = new Set(activeTags.filter((tagId) => tagId !== '__WITHOUT__'));
    const searchTerms = searchChips.map((chip) => chip.toLowerCase()).filter(Boolean);
    const customersById = new Map(customersAdmin.map((customer) => [customer.id, customer]));

    const filteredProducts = products.filter((product) => {
        if (statusFilters.size > 0 && !statusFilters.has(product.status)) {
            return false;
        }

        if (managedByFilters.size > 0 && !managedByFilters.has(product.managedBy) && !(managedByFilters.has('ZONATIC') && !product.managedBy)) {
            return false;
        }

        if (customerFilters.size > 0 && !customerFilters.has(product.subcustomer)) {
            return false;
        }

        if (customerAdminFilters.size > 0) {
            const productCustomerName = customersById.get(product.customer)?.name || '';
            const matchesDirectCustomer = customerAdminFilters.has(productCustomerName);
            const matchesExternalCustomer = (product.externalCustomersWithAccess || []).some((customerId) => {
                const customerName = customersById.get(customerId)?.name || '';
                return customerAdminFilters.has(customerName);
            });

            if (!matchesDirectCustomer && !matchesExternalCustomer) {
                return false;
            }
        }

        if (subcustomerAdminFilters.size > 0 && !subcustomerAdminFilters.has(product.subcustomer)) {
            return false;
        }

        if (providerFilters.size > 0 && !providerFilters.has(product.provider)) {
            return false;
        }

        if (!productLinesMatchFilters(product, my_products__filters__subproducts_activeFilters, my_products__filters__versions_activeFilters)) {
            return false;
        }

        if (tagFilters.size > 0 || filterWithoutTags) {
            const productTags = ensureUniqueTagIds(product.tags || []);
            const matchesSelectedTags = tagFilters.size > 0 && productTags.some((tagId) => tagFilters.has(tagId));
            const matchesWithoutTags = filterWithoutTags && productTags.length === 0;
            if (!matchesSelectedTags && !matchesWithoutTags) {
                return false;
            }
        }

        if (otherFilters.has('selfbillable_product') && product.renewalAttention !== true) {
            return false;
        }

        if (otherFilters.has('externalAccess')) {
            const externalCustomers = product.externalCustomersWithAccess || [];
            if (externalCustomers.length === 0) {
                return false;
            }
            if (customerAdminFilters.size > 0) {
                const matchesSelectedExternalCustomer = externalCustomers.some((customerId) => {
                    const customerName = customersById.get(customerId)?.name || '';
                    return customerAdminFilters.has(customerName);
                });
                if (!matchesSelectedExternalCustomer) {
                    return false;
                }
            }
        }

        if (otherFilters.has('deleted_products')) {
            if (!product.deleted) {
                return false;
            }
        } else if (product.deleted) {
            return false;
        }

        if (my_products__filters__expiryDate_start || my_products__filters__expiryDate_end) {
            if (!product.expires) {
                return false;
            }
            if (my_products__filters__expiryDate_start && product.expires < my_products__filters__expiryDate_start) {
                return false;
            }
            if (my_products__filters__expiryDate_end && product.expires > my_products__filters__expiryDate_end) {
                return false;
            }
        }

        if (searchTerms.length > 0 && !searchTerms.every((term) => productMatchesText(product, term))) {
            return false;
        }

        return true;
    });

    const totalProducts = otherFilters.has('deleted_products')
        ? products.length
        : products.filter((product) => !product.deleted).length;
    updateProductsCount(filteredProducts.length, totalProducts, hasActiveFilters || searchTerms.length > 0);
    renderProducts(filteredProducts, searchChips);
}

let firstRender = true;
let openedAskedProduct = false;

let selected_products = [];

function processarCanviProductesSeleccionats() {
    if (selected_products.length > 0) {
        document.getElementById('my_products__selection_top').style.display = "flex";
        document.getElementById('my_products__selection_bottom').style.display = "flex";
        if (isAdmin) {
            document.getElementById('my_products__selection_top_bulk_edit').style.display = "flex";
            document.getElementById('my_products__selection_bottom_bulk_edit').style.display = "flex";
        }
        if (selected_products.length == 1) {
            document.getElementById('my_products__selection_top_selected_number').innerText = selected_products.length + ' ' + langDataLocal['product_selected'].toLowerCase();
            document.getElementById('my_products__selection_bottom_selected_number').innerText = selected_products.length + ' ' + langDataLocal['product_selected'].toLowerCase();
        } else {
            document.getElementById('my_products__selection_top_selected_number').innerText = selected_products.length + ' ' + langDataLocal['products_selected'].toLowerCase();
            document.getElementById('my_products__selection_bottom_selected_number').innerText = selected_products.length + ' ' + langDataLocal['products_selected'].toLowerCase();
        }
    } else {
        document.getElementById('my_products__selection_top').style.display = "none";
        document.getElementById('my_products__selection_bottom').style.display = "none";
    }
}

function openProductSelectionGenerateListDialog() {
    document.getElementById('my_products_dialog_generate_list_generate').disabled = false;
    document.getElementById('my_products_dialog_generate_list_generate_progress').style.display = 'none';
    document.getElementById('my_products_dialog_generate_list_generate').style.display = 'flex';
    document.getElementById('my_products_dialog_generate_list').show();
}

document.getElementById('my_products_dialog_generate_list_close').addEventListener('click', () => {
    document.getElementById('my_products_dialog_generate_list').close();
});

function clearSelectedProducts() {
    selected_products = [];
    document.querySelectorAll('.listMainDivHeader md-checkbox').forEach(checkbox => {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change'));
    });
    document.getElementById('main__content__card__my_products__checkbox').checked = false;
}

function selectAllProducts() {
    selected_products = [];
    document.querySelectorAll('.listMainDivHeader md-checkbox').forEach(checkbox => {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change'));
    });
}

document.getElementById('main__content__card__my_products__checkbox').addEventListener('change', () => {
    if (document.getElementById('main__content__card__my_products__checkbox').checked) {
        selectAllProducts();
    } else {
        clearSelectedProducts();
    }
});

document.getElementById('my_products__selection_bottom_clear').addEventListener('click', () => {
    clearSelectedProducts();
});

document.getElementById('my_products__selection_top_clear').addEventListener('click', () => {
    clearSelectedProducts();
});

document.getElementById('my_products_dialog_generate_list_generate').addEventListener('click', (e) => {
    e.preventDefault();
    let lang_selected = false;
    let pdf_lang = 'ca';
    if (document.getElementById('my_products_dialog_generate_list_lang_ca').checked) { pdf_lang = 'ca'; lang_selected = true; }
    if (document.getElementById('my_products_dialog_generate_list_lang_es').checked) { pdf_lang = 'es'; lang_selected = true; }
    if (document.getElementById('my_products_dialog_generate_list_lang_en').checked) { pdf_lang = 'en'; lang_selected = true; }
    if (!lang_selected) {
        return;
    }
    document.getElementById('my_products_dialog_generate_list_generate').disabled = true;
    document.getElementById('my_products_dialog_generate_list_generate_progress').style.display = 'flex';
    document.getElementById('my_products_dialog_generate_list_generate').style.display = 'none';
    const requested_fields = [];
    if (document.getElementById('my_products_dialog_generate_list_fields_details').hasAttribute('selected')) { requested_fields.push('details') }
    if (document.getElementById('my_products_dialog_generate_list_fields_description').hasAttribute('selected')) { requested_fields.push('description') }
    if (document.getElementById('my_products_dialog_generate_list_fields_notes').hasAttribute('selected')) { requested_fields.push('notes') }
    if (document.getElementById('my_products_dialog_generate_list_fields_licenses').hasAttribute('selected')) { requested_fields.push('licenses') }
    auth.currentUser.getIdToken().then(token => {
        fetch('https://customer-services.zonatic.tech/generateList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token,
                requested_fields,
                selected_products,
                lang: pdf_lang
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error(`Error en la resposta: ${res.status}`);
                }
                return res.blob();
            })
            .then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = fileURL;
                a.download = 'zonatic_product_list.pdf'; // substitueix per el nom i extensió desitjats
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(fileURL);
                document.getElementById('my_products_dialog_generate_list').close();
            })
            .catch(error => {
                console.log(error);
                showError('error', 'an_error_has_occurred');
                document.getElementById('my_products_dialog_generate_list_generate').disabled = false;
                document.getElementById('my_products_dialog_generate_list_generate').style.display = 'flex';
                document.getElementById('my_products_dialog_generate_list_generate_progress').style.display = 'none';
            });
    })
        .catch(err => {
            console.log(err);
            showError('error', 'an_error_has_occurred');
            document.getElementById('my_products_dialog_generate_list_generate').disabled = false;
            document.getElementById('my_products_dialog_generate_list_generate').style.display = 'flex';
            document.getElementById('my_products_dialog_generate_list_generate_progress').style.display = 'none';
        })
});

function openBulkEditProduct() {
    if (selected_products.length > 1) {
        const containsGroupedProduct = selected_products.some((id) => getProductLines(productsById.get(id)).length > 1);
        document.getElementById('main_dialog_product_bulk_edit_title').innerText = langDataLocal['bulk_edit'] + ' (' + selected_products.length + ' ' + langDataLocal['products'].toLowerCase() + ')';
        document.getElementById('main_dialog_product_bulk_edit').show();
        document.getElementById('main_dialog_product_bulk_edit_client').value = '';
        document.getElementById('main_dialog_product_bulk_edit_client').innerHTML = '';
        document.getElementById('main_dialog_product_bulk_edit_subclient').value = '';
        document.getElementById('main_dialog_product_bulk_edit_subclient').innerHTML = '';
        document.getElementById('main_dialog_product_bulk_edit_units').value = '';
        document.getElementById('main_dialog_product_bulk_edit_price').value = '';
        document.getElementById('main_dialog_product_bulk_edit_units').disabled = containsGroupedProduct;
        document.getElementById('main_dialog_product_bulk_edit_price').disabled = containsGroupedProduct;
        document.getElementById('main_dialog_product_bulk_edit_units').title = containsGroupedProduct ? langDataLocal['bulk_subproduct_prices_disabled'] : '';
        document.getElementById('main_dialog_product_bulk_edit_price').title = containsGroupedProduct ? langDataLocal['bulk_subproduct_prices_disabled'] : '';
        document.getElementById('main_dialog_product_bulk_edit_contract_start').value = '';
        document.getElementById('main_dialog_product_bulk_edit_contract_duration_number').value = '';
        document.getElementById('main_dialog_product_bulk_edit_contract_duration_unit').value = '';
        document.getElementById('main_dialog_product_bulk_edit_provider').value = '';
        document.getElementById('main_dialog_product_bulk_edit_provider').innerHTML = '';
        document.getElementById('main_dialog_product_bulk_edit_state').value = '';
        document.getElementById('main_dialog_product_bulk_edit_state').innerHTML = '';
        document.getElementById('main_dialog_product_bulk_edit_managed_by').value = '';
        document.getElementById('main_dialog_product_bulk_edit_renewal_attention').value = '';
        document.getElementById('main_dialog_product_bulk_edit_status_reason').value = '';
        document.getElementById('main_dialog_product_bulk_edit_product_name').value = '';
        document.getElementById('main_dialog_product_bulk_edit_single_subproduct_name').value = '';
        const subproductSource = document.getElementById('main_dialog_product_bulk_edit_subproduct_source');
        const subproductName = document.getElementById('main_dialog_product_bulk_edit_subproduct_name');
        const subproductVersion = document.getElementById('main_dialog_product_bulk_edit_subproduct_version');
        subproductSource.innerHTML = '';
        subproductSource.value = '';
        subproductName.value = '';
        subproductVersion.value = '';
        subproductName.disabled = true;
        subproductVersion.disabled = true;
        const emptySubproductOption = document.createElement('md-select-option');
        emptySubproductOption.value = '';
        emptySubproductOption.innerText = '';
        subproductSource.appendChild(emptySubproductOption);
        const availableSubproducts = new Map();
        selected_products.forEach((id) => {
            getProductLines(productsById.get(id)).forEach((line) => {
                const value = JSON.stringify([line.name, line.version]);
                if (!availableSubproducts.has(value)) {
                    availableSubproducts.set(value, line.version ? `${line.name} — ${line.version}` : line.name);
                }
            });
        });
        Array.from(availableSubproducts.entries())
            .sort((a, b) => a[1].localeCompare(b[1]))
            .forEach(([value, label]) => {
                const option = document.createElement('md-select-option');
                option.value = value;
                option.innerText = label;
                subproductSource.appendChild(option);
            });
        bulkEditTagsToAdd = [];
        bulkEditTagsToRemove = [];
        refreshTagAssignmentsUI();
        let option = document.createElement('md-select-option');
        option.value = '';
        option.innerText = '';
        let option2 = document.createElement('md-select-option');
        option2.value = '';
        option2.innerText = '';
        document.getElementById('main_dialog_product_bulk_edit_client').appendChild(option2);
        document.getElementById('main_dialog_product_bulk_edit_subclient').appendChild(option);

        customersAdmin.forEach((customer) => {
            let option = document.createElement('md-select-option');
            option.value = customer.id;
            option.innerText = customer.name;
            document.getElementById('main_dialog_product_bulk_edit_client').appendChild(option);
        });
        let addedProviders = [];
        let providersTemp = providers.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        let optionProvider = document.createElement('md-select-option');
        optionProvider.value = '';
        optionProvider.innerText = '';
        document.getElementById('main_dialog_product_bulk_edit_provider').appendChild(optionProvider);
        providersTemp.forEach((provider) => {
            if (addedProviders.indexOf(provider.id) !== -1) {
                return;
            }
            addedProviders.push(provider.id);
            let option = document.createElement('md-select-option');
            option.value = provider.id;
            option.innerText = provider.name;
            document.getElementById('main_dialog_product_bulk_edit_provider').appendChild(option);
        });
        let states = ['active', 'inactive', 'renewal_pending', 'proposal_pending'];
        document.getElementById('main_dialog_product_bulk_edit_state').value = '';
        document.getElementById('main_dialog_product_bulk_edit_state').innerHTML = '';
        let optionEmptyState = document.createElement('md-select-option');
        optionEmptyState.value = '';
        optionEmptyState.innerText = '';
        document.getElementById('main_dialog_product_bulk_edit_state').appendChild(optionEmptyState);
        states.forEach((state) => {
            let option = document.createElement('md-select-option');
            option.value = state;
            option.innerText = langDataLocal[state];
            document.getElementById('main_dialog_product_bulk_edit_state').appendChild(option);
        });
        document.getElementById('main_dialog_product_bulk_edit_managed_by').value = '';
        document.getElementById('main_dialog_product_bulk_edit_managed_by').innerHTML = '';
        let optionManagedBy = document.createElement('md-select-option');
        optionManagedBy.value = '';
        optionManagedBy.innerText = '';
        document.getElementById('main_dialog_product_bulk_edit_managed_by').appendChild(optionManagedBy);
        let optionManagedByClient = document.createElement('md-select-option');
        optionManagedByClient.value = 'CLIENT';
        optionManagedByClient.innerText = langDataLocal['client'];
        document.getElementById('main_dialog_product_bulk_edit_managed_by').appendChild(optionManagedByClient);
        let optionManagedByZonatic = document.createElement('md-select-option');
        optionManagedByZonatic.value = 'ZONATIC';
        optionManagedByZonatic.innerText = 'Zonatic';
        document.getElementById('main_dialog_product_bulk_edit_managed_by').appendChild(optionManagedByZonatic);
        let contractDurationUnit = document.getElementById('main_dialog_product_bulk_edit_contract_duration_unit');
        contractDurationUnit.innerHTML = '';
        let contractDurationUnits = ['days', 'months', 'years'];
        let contractDurationEmptyOption = document.createElement('md-select-option');
        contractDurationEmptyOption.value = '';
        contractDurationEmptyOption.innerText = '';
        contractDurationUnit.appendChild(contractDurationEmptyOption);
        contractDurationUnits.forEach((unit) => {
            let option = document.createElement('md-select-option');
            option.value = unit;
            option.innerText = langDataLocal[unit];
            contractDurationUnit.appendChild(option);
        });
        document.getElementById('main_dialog_product_bulk_edit_renewal_attention').value = '';
    } else if (selected_products.length == 1) {
        openEditProduct(selected_products[0]);
    }
}

document.getElementById('my_products__selection_bottom_bulk_edit').addEventListener('click', () => {
    openBulkEditProduct();
});

document.getElementById('my_products__selection_top_bulk_edit').addEventListener('click', () => {
    openBulkEditProduct();
});

document.getElementById('main_dialog_product_bulk_edit_client').addEventListener('change', () => {
    let subcustomers = [];
    products.forEach((product) => {
        if (product.customer === document.getElementById('main_dialog_product_bulk_edit_client').value && product.subcustomer) {
            if (subcustomers.indexOf(product.subcustomer) === -1) {
                subcustomers.push(product.subcustomer);
            }
        }
    });
    subcustomers.forEach((subcustomer) => {
        let option = document.createElement('md-select-option');
        option.value = subcustomer;
        option.innerText = subcustomer;
        document.getElementById('main_dialog_product_bulk_edit_subclient').appendChild(option);
    });
});

const main_dialog_product_bulk_edit_tags_add_button = document.getElementById('main_dialog_product_bulk_edit_tags_add_button');
const main_dialog_product_bulk_edit_tags_add_menu = document.getElementById('main_dialog_product_bulk_edit_tags_add_menu');

if (main_dialog_product_bulk_edit_tags_add_button && main_dialog_product_bulk_edit_tags_add_menu) {
    main_dialog_product_bulk_edit_tags_add_button.addEventListener('click', (event) => {
        event.preventDefault();
        if (main_dialog_product_bulk_edit_tags_add_menu.open) {
            main_dialog_product_bulk_edit_tags_add_menu.open = false;
            return;
        }
        populateTagMenu('main_dialog_product_bulk_edit_tags_add_menu', bulkEditTagsToAdd, {
            onSelectTag: (tagId) => {
                bulkEditTagsToAdd = ensureUniqueTagIds([...bulkEditTagsToAdd, tagId]);
                refreshTagAssignmentsUI();
            },
            emptyLabel: langDataLocal?.no_tags_available || 'No tags available'
        });
        openAnchoredMenu(main_dialog_product_bulk_edit_tags_add_menu, 'main_dialog_product_bulk_edit_tags_add_button');
    });
}

const main_dialog_product_bulk_edit_tags_remove_button = document.getElementById('main_dialog_product_bulk_edit_tags_remove_button');
const main_dialog_product_bulk_edit_tags_remove_menu = document.getElementById('main_dialog_product_bulk_edit_tags_remove_menu');

if (main_dialog_product_bulk_edit_tags_remove_button && main_dialog_product_bulk_edit_tags_remove_menu) {
    main_dialog_product_bulk_edit_tags_remove_button.addEventListener('click', (event) => {
        event.preventDefault();
        if (main_dialog_product_bulk_edit_tags_remove_menu.open) {
            main_dialog_product_bulk_edit_tags_remove_menu.open = false;
            return;
        }
        populateTagMenu('main_dialog_product_bulk_edit_tags_remove_menu', bulkEditTagsToRemove, {
            onSelectTag: (tagId) => {
                bulkEditTagsToRemove = ensureUniqueTagIds([...bulkEditTagsToRemove, tagId]);
                refreshTagAssignmentsUI();
            },
            emptyLabel: langDataLocal?.no_tags_available || 'No tags available'
        });
        openAnchoredMenu(main_dialog_product_bulk_edit_tags_remove_menu, 'main_dialog_product_bulk_edit_tags_remove_button');
    });
}

document.getElementById('main_dialog_product_bulk_edit_cancel').addEventListener('click', () => {
    document.getElementById('main_dialog_product_bulk_edit').close();
});
document.getElementById('main_dialog_product_bulk_edit_close').addEventListener('click', () => {
    document.getElementById('main_dialog_product_bulk_edit').close();
});

document.getElementById('main_dialog_product_bulk_edit_subproduct_source').addEventListener('change', (event) => {
    const nameField = document.getElementById('main_dialog_product_bulk_edit_subproduct_name');
    const versionField = document.getElementById('main_dialog_product_bulk_edit_subproduct_version');
    if (!event.target.value) {
        nameField.value = '';
        versionField.value = '';
        nameField.disabled = true;
        versionField.disabled = true;
        return;
    }
    const [name, version] = JSON.parse(event.target.value);
    nameField.value = name;
    versionField.value = version;
    nameField.disabled = false;
    versionField.disabled = false;
});


document.getElementById('main_dialog_product_bulk_edit_save').addEventListener('click', () => {
    let client = document.getElementById('main_dialog_product_bulk_edit_client').value;
    let subclient = document.getElementById('main_dialog_product_bulk_edit_subclient').value;
    let units = document.getElementById('main_dialog_product_bulk_edit_units').value;
    let price = document.getElementById('main_dialog_product_bulk_edit_price').value;
    let contract_start = document.getElementById('main_dialog_product_bulk_edit_contract_start').value;
    let contract_duration_number = document.getElementById('main_dialog_product_bulk_edit_contract_duration_number').value;
    let contract_duration_unit = document.getElementById('main_dialog_product_bulk_edit_contract_duration_unit').value;
    let provider = document.getElementById('main_dialog_product_bulk_edit_provider').value;
    let state = document.getElementById('main_dialog_product_bulk_edit_state').value;
    let managed_by = document.getElementById('main_dialog_product_bulk_edit_managed_by').value;
    let renewal_attention = document.getElementById('main_dialog_product_bulk_edit_renewal_attention').value;
    let state_reason = document.getElementById('main_dialog_product_bulk_edit_status_reason').value;
    const productNameInput = document.getElementById('main_dialog_product_bulk_edit_product_name').value;
    const productName = productNameInput.trim();
    const singleSubproductNameInput = document.getElementById('main_dialog_product_bulk_edit_single_subproduct_name').value;
    const singleSubproductName = singleSubproductNameInput.trim();
    const subproductSourceValue = document.getElementById('main_dialog_product_bulk_edit_subproduct_source').value;
    const subproductName = document.getElementById('main_dialog_product_bulk_edit_subproduct_name').value.trim();
    const subproductVersion = document.getElementById('main_dialog_product_bulk_edit_subproduct_version').value.trim();
    const productNameUpdateRequested = productNameInput !== '';
    if (productNameUpdateRequested && !productName) {
        showError('error', 'invalid_bulk_name_replacement');
        return;
    }
    const singleSubproductRenameRequested = singleSubproductNameInput !== '';
    if (singleSubproductRenameRequested && !singleSubproductName) {
        showError('error', 'invalid_bulk_subproduct');
        return;
    }
    let subproductSourceName = '';
    let subproductSourceVersion = '';
    if (subproductSourceValue) {
        [subproductSourceName, subproductSourceVersion] = JSON.parse(subproductSourceValue);
    }
    const subproductReplacementRequested = Boolean(subproductSourceValue) &&
        (subproductName !== subproductSourceName || subproductVersion !== subproductSourceVersion);
    if (subproductSourceValue && !subproductName) {
        showError('error', 'invalid_bulk_subproduct');
        return;
    }
    if (singleSubproductRenameRequested && subproductSourceValue) {
        showError('error', 'choose_one_subproduct_bulk_edit');
        return;
    }
    if (singleSubproductRenameRequested && selected_products.some((id) => getProductLines(productsById.get(id)).length !== 1)) {
        showError('error', 'bulk_single_subproduct_only');
        return;
    }

    // We'll only update the fields that are not empty or null
    let updates = {};
    if (client && subclient) {
        // First, check if subcustomer is on the list of subcustomers for the selected client
        let validSubcustomer = false;
        products.forEach((product) => {
            if (product.customer === client && product.subcustomer === subclient) {
                validSubcustomer = true;
            }
        });
        if (!validSubcustomer) {
            showError('error', 'invalid_subcustomer');
            return;
        }

        updates.customer = client;
        updates.subcustomer = subclient;
    }

    if (units) {
        const parsedUnits = parseProductNumber(units);
        if (!Number.isInteger(parsedUnits) || parsedUnits <= 0) {
            showError('error', 'invalid_number');
            return;
        }
        updates.units = parsedUnits;
    }
    if (price) {
        const parsedPrice = parseProductNumber(price);
        if (!Number.isFinite(parsedPrice) || parsedPrice < 0) {
            showError('error', 'invalid_number');
            return;
        }
        updates.price = parsedPrice;
    }
    if (contract_duration_number && contract_duration_unit && contract_start) {
        // Check if the date is valid
        let date = moment(contract_start);
        if (!date.isValid()) {
            showError('error', 'invalid_date');
            return;
        }
        updates.contractStart = date.valueOf();
        // Check if the number is valid
        if (isNaN(contract_duration_number)) {
            showError('error', 'invalid_number');
            return;
        }

        updates.contractDuration = getContractDurationMs(contract_duration_number, contract_duration_unit);
    }
    if (provider) {
        updates.provider = provider;
    }
    if (state) {
        updates.status = state;
    }
    if (state_reason) {
        updates.statusReason = state_reason;
    }

    if (managed_by) {
        updates.managedBy = managed_by;
    }
    if (renewal_attention) {
        if (renewal_attention === 'yes') {
            updates.renewalAttention = true;
        } else {
            updates.renewalAttention = false;
        }
    }
    if (Object.keys(updates).length === 0 && bulkEditTagsToAdd.length === 0 && bulkEditTagsToRemove.length === 0 &&
        !productNameUpdateRequested && !singleSubproductRenameRequested && !subproductReplacementRequested) {
        showError('error', 'no_fields_selected');
        return;
    }


    console.log('Updating products: ', selected_products);
    console.log('Updates: ', updates);

    const batch = writeBatch(db);

    selected_products.forEach((product) => {
        let customerChanged = false;
        let subcustomerChanged = false;
        const productRef = doc(db, "products", product);
        const currentProduct = products.find((p) => p.id === product);
        if (currentProduct.customer !== client && client && client !== '') {
            console.log('Customer changed', currentProduct.customer, client);
            customerChanged = true;
        }
        if (currentProduct.subcustomer !== subclient && subclient && subclient !== '') {
            subcustomerChanged = true;
        }

        const perProductUpdates = { ...updates };

        if (productNameUpdateRequested && currentProduct.name !== productName) {
            perProductUpdates.name = productName;
        }

        let nextLines = null;
        if (updates.units !== undefined || updates.price !== undefined) {
            nextLines = getProductLines(currentProduct).map((line) => ({ ...line }));
            if (updates.units !== undefined) {
                nextLines[0].units = updates.units;
            }
            if (updates.price !== undefined) {
                nextLines[0].price = updates.price;
            }
        }
        if (subproductReplacementRequested) {
            const sourceLines = nextLines || getProductLines(currentProduct);
            const hasMatchingLine = sourceLines.some((line) =>
                line.name === subproductSourceName && line.version === subproductSourceVersion
            );
            if (hasMatchingLine) {
                nextLines = replaceMatchingProductLines(
                    { ...currentProduct, subproducts: sourceLines },
                    subproductSourceName,
                    subproductSourceVersion,
                    subproductName,
                    subproductVersion
                );
            }
        }
        if (singleSubproductRenameRequested) {
            nextLines = renameSingleProductLine(
                nextLines ? { ...currentProduct, subproducts: nextLines } : currentProduct,
                singleSubproductName
            );
        }
        if (nextLines) {
            perProductUpdates.subproducts = nextLines;
            perProductUpdates.details = getProductDetails(currentProduct);
            Object.assign(perProductUpdates, getLegacyCommercialFields(nextLines));
        }

        if (updates.contractStart && updates.contractDuration) {
            perProductUpdates.expires = getContractEndDate(
                updates.contractStart,
                contract_duration_number,
                contract_duration_unit,
                provider || currentProduct.provider
            );
        }

        if (updates.statusReason) {
            if (currentProduct.statusReason) {
                perProductUpdates.statusReason = currentProduct.statusReason + '\n' + updates.statusReason;
            } else {
                perProductUpdates.statusReason = updates.statusReason;
            }
        }

        if (bulkEditTagsToAdd.length > 0 || bulkEditTagsToRemove.length > 0) {
            let nextTags = ensureUniqueTagIds(currentProduct.tags || []);
            if (bulkEditTagsToAdd.length > 0) {
                nextTags = ensureUniqueTagIds(nextTags.concat(bulkEditTagsToAdd));
            }
            if (bulkEditTagsToRemove.length > 0) {
                nextTags = nextTags.filter((tagId) => !bulkEditTagsToRemove.includes(tagId));
            }
            perProductUpdates.tags = nextTags;
        }


        if (customerChanged) {
            // Update customer data
            // First, remove the product from the old customer
            let oldCustomer = customersAdmin.find(c => c.id === currentProduct.customer);
            let oldCustomerProducts = oldCustomer.products;
            let index = oldCustomerProducts.indexOf(product);
            if (index > -1) {
                oldCustomerProducts.splice(index, 1);
            }
            let customerRef = doc(db, "customers", currentProduct.customer);
            batch.update(customerRef, {
                products: oldCustomerProducts
            })
            // Then, add the product to the new customer
            let newCustomer = customersAdmin.find(c => c.id === client);
            let newCustomerProducts = newCustomer.products;
            newCustomerProducts.push(product);
            let newCustomerRef = doc(db, "customers", client);
            batch.update(newCustomerRef, {
                products: newCustomerProducts
            })
        }


        if (subcustomerChanged) {
            deleteProductNotificationsFromSubcustomer(product, currentProduct.subcustomer);
        }


        // If updates.managed_by is client, change it to client name
        if (perProductUpdates.managedBy === 'CLIENT') {
            // Get client name
            customersAdmin.forEach((customer) => {
                if (customer.id === (perProductUpdates.customer || currentProduct.customer)) {
                    perProductUpdates.managedBy = customer.name;
                }
            });
        }
        // If updates.managed_by is zonatic, change it to 'ZONATIC'
        if (perProductUpdates.managedBy === 'ZONATIC') {
            perProductUpdates.managedBy = 'ZONATIC';
        }





        if (Object.keys(perProductUpdates).length > 0) {
            batch.update(productRef, perProductUpdates);
        }
    });

    console.log('Batch: ', batch);

    batch.commit()
        .then(() => {
            console.log("Products updated successfully");
            document.getElementById('main_dialog_product_bulk_edit').close();
            bulkEditTagsToAdd = [];
            bulkEditTagsToRemove = [];
            refreshTagAssignmentsUI();
        })
        .catch((error) => {
            console.error("Error updating products: ", error);
            showError('error', 'an_error_has_occurred');
        });


});



document.getElementById('my_products__selection_top_generate_list').addEventListener('click', () => {
    openProductSelectionGenerateListDialog();
});

document.getElementById('my_products__selection_bottom_generate_list').addEventListener('click', () => {
    openProductSelectionGenerateListDialog();
});

document.getElementById('main__content__card__my_products__toggle_selection_view').addEventListener('click', () => {
    const style = window.getComputedStyle(document.body)
    const display_state = style.getPropertyValue('--product-checkbox-display');
    if (display_state == "none") {
        document.documentElement.style.setProperty('--product-checkbox-display', 'block');
        if (selected_products.length > 0) {
            document.getElementById('my_products__selection_top').style.display = 'flex';
            document.getElementById('my_products__selection_bottom').style.display = 'flex';
        }
    } else {
        document.documentElement.style.setProperty('--product-checkbox-display', 'none');
        document.getElementById('my_products__selection_top').style.display = 'none';
        document.getElementById('my_products__selection_bottom').style.display = 'none';
    }
});

// Funció per crear un header amb checkbox
function createSectionHeader(textHeader, numberOfProducts) {
    let header = document.createElement('md-list-item');
    header.classList.add('listHeader');
    header.style.marginTop = '0px';

    let mainDiv = document.createElement('div');
    mainDiv.classList.add('listMainDivHeader');

    // Checkbox per controlar tots els elements de la secció
    let headerCheckbox = document.createElement('md-checkbox');
    headerCheckbox.style.display = 'var(--product-checkbox-display)';
    headerCheckbox.classList.add('listMR16');
    headerCheckbox.style.marginLeft = '15px';

    // Quan es canvia el checkbox, s'aplica a tots els productes de la secció
    headerCheckbox.addEventListener('change', () => {
        let checked = headerCheckbox.checked;
        let next = header.nextElementSibling;
        while (next && !next.classList.contains('listHeader')) {
            let productCheckbox = next.querySelector('md-checkbox');
            if (productCheckbox) {
                productCheckbox.checked = checked;
                productCheckbox.dispatchEvent(new Event('change'));
            }
            next = next.nextElementSibling;
        }
    });

    // Botó per expandir o contraure la secció (ja existent)
    let closeSection = document.createElement('md-icon-button');
    let closeSectionIcon = document.createElement('md-icon');
    closeSectionIcon.innerText = 'expand_less';
    closeSectionIcon.setAttribute('translate', 'no');
    closeSection.appendChild(closeSectionIcon);
    closeSection.addEventListener('click', () => {
        let next = header.nextElementSibling;
        while (next && !next.classList.contains('listHeader')) {
            if (next.style.display === 'none') {
                next.style.display = 'flex';
                closeSectionIcon.innerText = 'expand_less';
                header.classList.remove('eLess');
            } else {
                next.style.display = 'none';
                closeSectionIcon.innerText = 'expand_more';
                header.classList.add('eLess');
            }
            next = next.nextElementSibling;
        }
    });

    // Inserim el checkbox i el botó d'expansió
    mainDiv.appendChild(headerCheckbox);
    mainDiv.appendChild(closeSection);

    // Afegim el text de l'encapçalament
    let headerspan = document.createElement('span');
    headerspan.style.fontWeight = 'bold';
    headerspan.innerText = textHeader + ' (' + (numberOfProducts || '-') + ')';
    mainDiv.appendChild(headerspan);

    header.appendChild(mainDiv);












    return header;
}

function formatProductsShownText(shown, total) {
    const template = langDataLocal['showing_products_count'] || 'Showing {shown} of {total} products';
    return template.replace('{shown}', shown).replace('{total}', total);
}

function updateProductsCount(shown, total, hasFilters) {
    const element = document.getElementById('main__content__card__my_products__count');
    const template = hasFilters
        ? (langDataLocal['showing_products_count'] || 'Showing {shown} of {total} products')
        : (langDataLocal['total_products_count'] || 'Total: {total} products');
    element.innerText = template.replace('{shown}', shown).replace('{total}', total);
}

function createLoadMoreProductsItem(shown, total) {
    const container = document.createElement('div');
    container.classList.add('productsLoadMore');

    const text = document.createElement('span');
    text.innerText = formatProductsShownText(shown, total);
    container.appendChild(text);

    const button = document.createElement('md-filled-tonal-button');
    button.classList.add('ml15');
    const icon = document.createElement('md-icon');
    icon.setAttribute('slot', 'icon');
    icon.setAttribute('translate', 'no');
    icon.innerText = 'expand_more';
    button.appendChild(icon);
    const label = document.createElement('span');
    label.innerText = langDataLocal['show_more_products'] || 'Show more products';
    button.appendChild(label);
    button.addEventListener('click', () => {
        productsRenderLimit += PRODUCTS_RENDER_BATCH_SIZE;
        renderProducts(lastRenderedProducts, lastRenderedSearchedText, true);
    });
    container.appendChild(button);

    return container;
}

function renderProducts(products, searchedText, preserveRenderLimit = false) {
    let debugTime = console.time('renderProducts');
    if (searchedText === undefined) {
        updateProductsCount(products.length, products.length, false);
    }
    if (!preserveRenderLimit) {
        productsRenderLimit = PRODUCTS_RENDER_BATCH_SIZE;
    }
    if (isAdmin) {
        document.getElementById('main__content__card__my_products__search_with_ai').style.display = 'flex';
    }
    rebuildProductsIndex();
    if (firstRender) {
        generateAllColors(products);
    }
    products.sort((a, b) => {
        if (a.expires === null) {
            a.expires = 4099676400000;
        }
        if (b.expires === null) {
            b.expires = 4099676400000;
        }
        return a.expires - b.expires;
    });

    const numberOfProductsTemp = {
        active: 0,
        proposal_pending: 0,
        inactive: 0,
        expired: 0,
        no_expiration: 0,
        expires_in_less_than_a_month: 0,
        expires_in_less_than_two_months: 0,
        expires_in_less_than_a_year: 0,
        expires_in_more_than_a_year: 0
    }
    // For each section, count the number of products
    products.forEach((product) => {
        if (product.expires === 4099676400000) {
            numberOfProductsTemp.no_expiration++;
        } else if (product.expires < new Date().getTime() && product.status !== 'inactive' && product.status !== 'proposal_pending') {
            numberOfProductsTemp.expired++;
        } else if (product.status === 'inactive') {
            numberOfProductsTemp.inactive++;
        } else if (product.status === 'proposal_pending') {
            numberOfProductsTemp.proposal_pending++;
        } else if (product.expires < new Date().setMonth(new Date().getMonth() + 1) && product.expires >= new Date().getTime()) {
            numberOfProductsTemp.expires_in_less_than_a_month++;
        } else if (product.expires < new Date().setMonth(new Date().getMonth() + 2) && product.expires >= new Date().setMonth(new Date().getMonth() + 1)) {
            numberOfProductsTemp.expires_in_less_than_two_months++;
        } else if (product.expires < new Date().setFullYear(new Date().getFullYear() + 1) && product.expires >= new Date().setMonth(new Date().getMonth() + 2)) {
            numberOfProductsTemp.expires_in_less_than_a_year++;
        } else if (product.expires >= new Date().setFullYear(new Date().getFullYear() + 1)) {
            numberOfProductsTemp.expires_in_more_than_a_year++;
        } else {
            numberOfProductsTemp.active++;
        }
    });



    // Move all products with expires 4099676400000 to the top.
    let noExpiresProducts = products.filter((product) => {
        return product.expires === 4099676400000;
    });
    let otherProducts = products.filter((product) => {
        return product.expires !== 4099676400000;
    });
    products = noExpiresProducts.concat(otherProducts);

    // Move all products with status 'inactive' to the end of the list
    let inactiveProducts = products.filter((product) => {
        return product.status === 'inactive';
    });
    let proposalPendingProducts = products.filter((product) => {
        return product.status === 'proposal_pending';
    });
    let activeProducts = products.filter((product) => {
        return product.status !== 'inactive' && product.status !== 'proposal_pending';
    });
    products = proposalPendingProducts.concat(activeProducts).concat(inactiveProducts);
    lastRenderedProducts = products;
    lastRenderedSearchedText = searchedText || [];
    const productsToRender = products.slice(0, productsRenderLimit);

    let productsList = document.getElementById('main_list_my_products');
    // let customersSelect = document.getElementById('main__content__card__my_products__filter_clients');
    // customersSelect.innerHTML = '';
    // let customersSelectArray = [];
    productsList.innerHTML = '';
    if (products.length > 0) {
        document.getElementById('main__content__card__my_products__no_products').style.display = 'none';
        const listFragment = document.createDocumentFragment();
        // document.getElementById('main_list_my_products').style.display = 'flex';
        let jump = 0;
        let now = new Date().getTime();
        let month = new Date().setMonth(new Date().getMonth() + 1);
        month = new Date(month).getTime();
        let twoMonths = new Date().setMonth(new Date().getMonth() + 2);
        twoMonths = new Date(twoMonths).getTime();
        let oneYear = new Date().setFullYear(new Date().getFullYear() + 1);
        oneYear = new Date(oneYear).getTime();
        productsToRender.forEach((product, index) => {
            if (index === 0) {
                if (product.expires === null || product.expires === undefined || product.expires === 4099676400000) {
                    // Add no expiration date header
                    let header = createSectionHeader(langDataLocal['continous_renewal'], numberOfProductsTemp.no_expiration);
                    listFragment.appendChild(header);
                } else if (product.expires !== 4099676400000 && product.expires < now && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['expired_products'], numberOfProductsTemp.expired);
                    listFragment.appendChild(header);
                } else if (product.status === 'proposal_pending') {
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['proposal_pending'], numberOfProductsTemp.proposal_pending);
                    listFragment.appendChild(header);
                } else if (product.status === 'inactive') {
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['inactive_products'], numberOfProductsTemp.inactive);
                    listFragment.appendChild(header);
                } else if (product.expires < month && product.expires >= now) {
                    // Add expiring in less than a month header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_a_month'], numberOfProductsTemp.expires_in_less_than_a_month);
                    listFragment.appendChild(header);
                } else if (product.expires < twoMonths && product.expires >= month) {
                    // Add expiring in less than two months header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_two_months'], numberOfProductsTemp.expires_in_less_than_two_months);
                    listFragment.appendChild(header);
                } else if (product.expires < oneYear && product.expires >= twoMonths) {
                    // Add expiring in less than a year header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_a_year'], numberOfProductsTemp.expires_in_less_than_a_year);
                    listFragment.appendChild(header);
                } else if (product.expires >= oneYear) {
                    // Add expiring in more than a year header
                    let header = createSectionHeader(langDataLocal['expires_in_more_than_a_year'], numberOfProductsTemp.expires_in_more_than_a_year);
                    listFragment.appendChild(header);
                }

            } else {
                if (productsToRender[index - 1].status !== 'proposal_pending' && product.status === 'proposal_pending' && product.status !== 'inactive') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['proposal_pending'], numberOfProductsTemp.proposal_pending);
                    listFragment.appendChild(header);
                } else if ((productsToRender[index - 1].expires > now || productsToRender[index - 1].status === 'proposal_pending') && product.expires < now && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['expired_products'], numberOfProductsTemp.expired);
                    listFragment.appendChild(header);
                } else if (productsToRender[index - 1].status !== 'inactive' && product.status === 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expired header
                    let header = createSectionHeader(langDataLocal['inactive_products'], numberOfProductsTemp.inactive);
                    listFragment.appendChild(header);
                } else if (productsToRender[index - 1].expires < now && product.expires < month && product.expires >= now && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expiring in less than a month header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_a_month'], numberOfProductsTemp.expires_in_less_than_a_month);
                    listFragment.appendChild(header);
                } else if (productsToRender[index - 1].expires < month && product.expires < twoMonths && product.expires >= month && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expiring in less than two months header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_two_months'], numberOfProductsTemp.expires_in_less_than_two_months);
                    listFragment.appendChild(header);
                } else if (productsToRender[index - 1].expires < twoMonths && product.expires < oneYear && product.expires >= twoMonths && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expiring in less than a year header
                    let header = createSectionHeader(langDataLocal['expires_in_less_than_a_year'], numberOfProductsTemp.expires_in_less_than_a_year);
                    listFragment.appendChild(header);
                } else if (productsToRender[index - 1].expires < oneYear && product.expires >= oneYear && product.expires < 4099676400000 && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add expiring in more than a year header
                    let header = createSectionHeader(langDataLocal['expires_in_more_than_a_year'], numberOfProductsTemp.expires_in_more_than_a_year);
                    listFragment.appendChild(header);
                } else if ((productsToRender[index - 1].expires !== null && productsToRender[index - 1].expires < 4099676400000) && (product.expires === null || product.expires >= 4099676400000) && product.status !== 'inactive' && product.status !== 'proposal_pending') {
                    // Add class 'lastItem' to previous item
                    let previous = listFragment.lastChild;
                    if (previous) {
                        previous.classList.add('lastItem');
                    }
                    // Add no expiration date header
                    let header = createSectionHeader(langDataLocal['continous_renewal'], numberOfProductsTemp.no_expiration);
                    listFragment.appendChild(header);
                }

            }
            // }
            let productItem = document.createElement('md-list-item');
            productItem.setAttribute('data-product-id', product.id);
            productItem.setAttribute('interactive', 'true');
            let mainDiv = document.createElement('div');
            mainDiv.classList.add('listMainDiv');
            let leftDiv = document.createElement('div');
            leftDiv.classList.add('listLeftDiv');
            let productCheckbox = document.createElement('md-checkbox');
            productCheckbox.id = 'product_checkbox_' + product.id;
            productCheckbox.style.display = 'var(--product-checkbox-display)';
            productCheckbox.setAttribute('touch-target', 'wrapper');
            productCheckbox.checked = selected_products.includes(product.id);
            productCheckbox.addEventListener('click', (e) => {
                // e.preventDefault();
                productCheckbox.checked = !productCheckbox.checked;
                productCheckbox.dispatchEvent(new Event('change'));
            });
            productCheckbox.addEventListener('change', () => {
                const checked = productCheckbox.checked;
                if (checked) {
                    if (!selected_products.includes(product.id)) {
                        selected_products.push(product.id);
                    }
                } else {
                    selected_products = selected_products.filter(item => item !== product.id);
                }
                processarCanviProductesSeleccionats();
            });
            productCheckbox.classList.add('listMR16');
            leftDiv.append(productCheckbox);
            let productIcon = document.createElement('md-icon');
            productIcon.setAttribute('translate', 'no');
            if (product.type === 'server') {
                productIcon.innerText = 'dns';
            } else if (product.type === 'software') {
                productIcon.innerText = 'wysiwyg';
            } else if (product.type === 'router') {
                productIcon.innerText = 'router';
            } else if (product.type === 'security') {
                productIcon.innerText = 'security';
            } else if (product.type === 'monitoring') {
                productIcon.innerText = 'monitoring';
            } else if (product.type === 'remote') {
                productIcon.innerText = 'monitor';
            } else if (product.type === 'maintenance') {
                productIcon.innerText = 'build';
            } else if (product.type === 'storage') {
                productIcon.innerText = 'storage';
            }
            productIcon.setAttribute('slot', 'start');
            productIcon.classList.add('listMR16');
            leftDiv.appendChild(productIcon);
            let divProductMeta1 = document.createElement('div');
            let badgeCustomer = document.createElement('span');
            let cstmn = "";
            if (isAdmin) {
                badgeCustomer.classList.add('badgeOutlined');
                badgeCustomer.classList.add('ml15');
                badgeCustomer.classList.add('badgeFusionRight');
                const customerName = customersAdmin.find((customer) => {
                    return customer.id === product.customer;
                })?.name || product.customer || '';
                badgeCustomer.innerText = customerName;
                cstmn = customerName;
                // badgeCustomer.addEventListener('click', (e) => {
                //     e.preventDefault();
                //     openCustomerDetails(customerName);
                // });
            }
            let badgeSubcustomer = document.createElement('span');
            badgeSubcustomer.classList.add('badge');
            if (!isAdmin) {
                badgeSubcustomer.classList.add('ml15');
            } else {
                badgeSubcustomer.classList.add('badgeFusionLeft');
            }
            badgeSubcustomer.innerText = product.subcustomer;
            badgeSubcustomer.addEventListener('click', (e) => {
                e.preventDefault();
                if (!isAdmin) {
                    openSubCustomerDetails(product.subcustomer);
                } else {
                    openSubCustomerDetails(product.subcustomer, product.customer);
                }
            });
            registerCustomerFilterValue(product.subcustomer);
            ensureProviderLoaded(product.provider);
            // if (found) {
            //     document.getElementById('main__content__card__my_products__progress').value = index / products.length;
            // }
            // if (customersSelectArray.includes(product.subcustomer) === false) {
            //     customersSelectArray.push(product.subcustomer);
            //     let customerOption = document.createElement('md-select-option');
            //     customerOption.setAttribute('value', product.subcustomer);
            //     customerOption.innerText = product.subcustomer;
            //     customerOption.addEventListener('click', (e) => {
            //         e.preventDefault();
            //         if (activeFilters.includes(product.subcustomer)) {
            //             activeFilters.splice(activeFilters.indexOf(product.subcustomer), 1);
            //         } else {
            //             activeFilters.push(product.subcustomer);
            //         }
            //         filterProducts();
            //         customersSelect.setAttribute('opened', 'true')
            //     });
            //     customersSelect.appendChild(customerOption);
            // }
            if (isAdmin) {
                let colorA = stringToColour(cstmn);
                badgeCustomer.style.borderColor = colorA.bgColor;
                badgeCustomer.style.backgroundColor = colorA.bgColor + '11';
                badgeCustomer.style.color = 'black';
            }
            let color = stringToColour(product.subcustomer);
            badgeSubcustomer.style.backgroundColor = color.bgColor;
            badgeSubcustomer.style.color = color.color;
            let productName = document.createElement('span');
            const productLines = getProductLines(product);
            productName.innerText = productLines.length === 1
                ? `${productLines[0].units || 1} x ${product.name}`
                : `${product.name} · ${productLines.length} ${langDataLocal['subproducts'].toLowerCase()}`;
            if (product.status === 'inactive') {
                // productName.style.textDecoration = 'line-through';
                productItem.style.opacity = '0.5';
            }
            divProductMeta1.appendChild(productName);
            divProductMeta1.classList.add('verticalDiv');
            let productExpires = document.createElement('span');
            productExpires.classList.add('sub');
            if (product.expires === null || product.expires === undefined || product.expires === 4099676400000) {

            } else {
                productExpires.innerText = langDataLocal['expiry_date'] + ': ' + moment(product.expires).format('DD/MM/YY');
            }
            divProductMeta1.appendChild(productExpires);
            leftDiv.appendChild(divProductMeta1);
            if (isAdmin) {
                leftDiv.appendChild(badgeCustomer);
            }
            if (!isSubcustomer) {
                if (isAdmin && product.subcustomer == cstmn) {
                    badgeCustomer.style.backgroundColor = color.bgColor;
                    badgeCustomer.style.color = color.color;
                    badgeCustomer.classList.remove('badgeFusionRight');
                } else {
                    leftDiv.appendChild(badgeSubcustomer);
                }
            }
            if (product.history && product.history.length > 0) {
                // add history icon next to subcustomer badge
                let historyIcon = document.createElement('md-icon');
                historyIcon.innerText = 'history';
                historyIcon.classList.add('ml15');
                historyIcon.classList.add('historyIcon');
                leftDiv.appendChild(historyIcon);
            }
            if (isAdmin && product.renewalAttention) {
                let attentionIcon = document.createElement('md-icon');
                attentionIcon.innerText = 'sync_problem';
                attentionIcon.classList.add('mr5');
                attentionIcon.classList.add('ml5');
                attentionIcon.style.color = '#FF0000';
                leftDiv.appendChild(attentionIcon);
            }
            if (isAdmin && product.externalCustomersWithAccess && product.externalCustomersWithAccess.length > 0) {
                // add external customers icon next to subcustomer badge (icon: visibility)
                let externalCustomersIcon = document.createElement('md-icon');
                externalCustomersIcon.innerText = 'visibility';
                externalCustomersIcon.classList.add('ml15');
                externalCustomersIcon.classList.add('externalCustomersIcon');
                externalCustomersIcon.style.color = '#777777';
                leftDiv.appendChild(externalCustomersIcon);
            }
            if (product.status === 'renewal_pending') {
                // add 'manage_history' icon inside a badge with text 'renewal_pending' next to subcustomer badge
                let badgeRenewalPending = document.createElement('div');
                badgeRenewalPending.style.display = 'flex';
                badgeRenewalPending.style.alignItems = 'center';
                badgeRenewalPending.style.justifyContent = 'center';
                badgeRenewalPending.classList.add('badge2');
                badgeRenewalPending.classList.add('ml15');
                let badgeRenewalPendingText = document.createElement('span');
                badgeRenewalPendingText.style.fontSize = '14px';
                badgeRenewalPendingText.innerText = langDataLocal['renewal_pending'];
                badgeRenewalPendingText.style.fontWeight = '400';
                badgeRenewalPendingText.style.cursor = 'default';
                badgeRenewalPending.appendChild(badgeRenewalPendingText);
                let badgeRenewalPendingIcon = document.createElement('md-icon');
                badgeRenewalPendingIcon.innerText = 'manage_history';
                badgeRenewalPendingIcon.classList.add('mr5');
                badgeRenewalPendingIcon.style.fontSize = '18px';
                badgeRenewalPendingIcon.style.display = 'flex';
                badgeRenewalPendingIcon.style.alignItems = 'center';
                badgeRenewalPending.prepend(badgeRenewalPendingIcon);
                leftDiv.appendChild(badgeRenewalPending);
            }
            if (product.managedBy === 'ZONATIC') {
                let iconManagedBy = document.createElement('img');
                iconManagedBy.src = 'assets/ztbl.svg';
                iconManagedBy.classList.add('iconManagedBy');
                iconManagedBy.title = langDataLocal['managed_by_zonatic'];
                leftDiv.appendChild(iconManagedBy);
            }
            const productTagIds = ensureUniqueTagIds(product.tags || []);
            if (productTagIds.length > 0) {
                const tagsContainer = document.createElement('div');
                tagsContainer.classList.add('tag-chip-container');
                productTagIds.forEach((tagId) => {
                    const tag = getTagById(tagId);
                    if (!tag) {
                        return;
                    }
                    const chip = document.createElement('div');
                    chip.classList.add('tag-chip');
                    chip.style.setProperty('--tag-bg-color', tag.color || '#CBD5F5');
                    chip.style.setProperty('--tag-text-color', getAccessibleTextColor(tag.color || '#CBD5F5'));
                    const chipLabel = document.createElement('span');
                    chipLabel.innerText = tag.name || '-';
                    chip.appendChild(chipLabel);
                    tagsContainer.appendChild(chip);
                });
                leftDiv.appendChild(tagsContainer);
            }
            mainDiv.appendChild(leftDiv);
            let rightDiv = document.createElement('div');
            rightDiv.classList.add('listRightDiv');
            let buttonDetails = document.createElement('md-icon-button');
            let buttonDetailsIcon = document.createElement('md-icon');
            buttonDetailsIcon.innerText = 'expand_content';
            buttonDetailsIcon.setAttribute('translate', 'no');
            buttonDetails.appendChild(buttonDetailsIcon);
            buttonDetails.addEventListener('click', () => {
                openProductDetails(product, false, searchedText);
            });
            rightDiv.appendChild(buttonDetails);
            mainDiv.appendChild(rightDiv);
            productItem.appendChild(mainDiv);
            // Detect double click
            let lastClick = 0;
            productItem.addEventListener('click', (e) => {
                e.preventDefault();
                let now = new Date().getTime();
                let timesince = now - lastClick;
                if ((timesince < 600) && (timesince > 0)) {
                    openProductDetails(product, false, searchedText);
                }
                lastClick = new Date().getTime();
            });


            listFragment.appendChild(productItem);
            if (index < productsToRender.length - 1) {
                let divider = document.createElement('md-divider');
                listFragment.appendChild(divider);
            }
            if (index === productsToRender.length - 1) {
                // document.getElementById('main__content__card__my_products__progress').value = 1;
                setTimeout(() => {

                    document.getElementById('main__content__card__my_products__progress').style.display = 'none';
                    document.getElementById('main_list_my_products').style.display = 'flex';
                    if (openProduct && !openedAskedProduct) {
                        products.forEach((product) => {
                            if (product.id === openProduct) {
                                openedAskedProduct = true;
                                openProductDetails(product, false, searchedText);
                                if (action == 'manage_product') {
                                    setTimeout(() => {
                                        document.getElementById('main_dialog_product_details_manage_product').click();
                                    }, 400);
                                }
                            }
                        });
                    }
                }, 300);
            }
        });

        productsList.appendChild(listFragment);

        if (firstRender) {
            // Collapse all products except the expired ones and the ones expiring in less than a month
            let headers = productsList.querySelectorAll('.listHeader');
            headers.forEach((header) => {
                // if (!header.querySelector('span').innerText.startsWith(langDataLocal['expired_products']) && !header.querySelector('span').innerText.startsWith(langDataLocal['expires_in_less_than_a_month'])) {
                let next = header.nextElementSibling;
                while (next && !next.classList.contains('listHeader')) {
                    next.style.display = 'none';
                    next = next.nextElementSibling;
                }
                // Set icon to expand_more
                header.querySelector('md-icon').innerText = 'expand_more';
                header.classList.add('eLess');
                // }
            });
            firstRender = false;

        }

        if (products.length > productsToRender.length) {
            productsList.appendChild(createLoadMoreProductsItem(productsToRender.length, products.length));
        }

        //filterProducts();

    } else {
        document.getElementById('main__content__card__my_products__no_products').style.display = 'block';
        document.getElementById('main__content__card__my_products__progress').style.display = 'none';
        document.getElementById('main_list_my_products').style.display = 'none';
        if (document.getElementById('main__content__card__my_products__remove_filters').style.display === 'block' || searchChips.length > 0 || document.getElementById('main__content__card__my_products__search').value) {
            document.getElementById('main__content__card__my_products__no_products_filters').style.display = 'flex';
        } else {
            document.getElementById('main__content__card__my_products__no_products_filters').style.display = 'none';
        }
    }

    // End debug time
    console.timeEnd('renderProducts');
}

let badge_color_count = 0;
let generatedColors = [];
let generatedColorsByString = new Map();
var generateAllColors = function (products) {
    products = [...products].sort((a, b) => (a.subcustomer || '').localeCompare(b.subcustomer || ''));
    products.forEach((product) => {
        let color = stringToColour(product.subcustomer);
    });
}
var stringToColour = function (str) {
    if (str === 'AETECH') {
        const aetechColor = {
            str,
            bgColor: '#2b3679',
            color: '#FFFFFF'
        };
        generatedColorsByString.set(str, aetechColor);
        return aetechColor;
    }
    // Check if we already generated a color for this string
    if (generatedColorsByString.has(str)) {
        return generatedColorsByString.get(str);
    }
    // Get BADGE_COLORS[badge_color_count] and calculate text color
    let bgColor = BADGE_COLORS[badge_color_count];
    let color = '#000000';
    let c = bgColor.substring(1);      // strip #
    let rgb = parseInt(c, 16);   // convert rrggbb to decimal
    let r = (rgb >> 16) & 0xff;  // extract red
    let g = (rgb >> 8) & 0xff;  // extract green
    let b = (rgb >> 0) & 0xff;  // extract blue
    let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    if (brightness < 160) {
        color = '#FFFFFF';
    }
    badge_color_count++;
    if (badge_color_count === BADGE_COLORS.length) {
        badge_color_count = 0;
    }
    const generatedColor = {
        str,
        bgColor,
        color
    };
    generatedColors.push(generatedColor);
    generatedColorsByString.set(str, generatedColor);
    return generatedColor;
}

let adminVisibility = true;
document.getElementById('main__header__right__global_eye').addEventListener('click', () => {
    if (adminVisibility) {
        document.getElementById('main__header__right__global_eye').querySelector('md-icon').innerText = 'visibility_off';
        adminVisibility = false;
        // Set --customer-badge-visibility to hidden
        document.documentElement.style.setProperty('--customer-badge-visibility', 'none');
        document.documentElement.style.setProperty('--customer-badge-margin', '15px');
    } else {
        document.getElementById('main__header__right__global_eye').querySelector('md-icon').innerText = 'visibility';
        adminVisibility = true;
        // Set --customer-badge-visibility to visible
        document.documentElement.style.setProperty('--customer-badge-visibility', 'block');
        document.documentElement.style.setProperty('--customer-badge-margin', '0px');
    }
});


let filter_clients_from = null;
let filter_provider_from = null;

let activeFilters = [];
let filtered = false;

let providerActiveFilters = [];
let providerFiltered = false;

function openFilterClients(clients) {
    console.log(clients);
    document.getElementById('main_content_filter_clients').show();
    let clientsList = document.getElementById('main_content_filter_clients__list');
    clientsList.innerHTML = '';
    clients.sort((a, b) => {
        return a.localeCompare(b);
    });
    clients.forEach((client, index) => {
        let clientButton = document.createElement('md-outlined-button');
        clientButton.setAttribute('data-client-id', client);
        if (activeFilters.includes(client)) {
            clientButton.setAttribute('active', 'true');
        } else {
            clientButton.setAttribute('active', 'false');
        }
        clientButton.classList.add('clientButton');
        clientButton.classList.add('buttonIconHidden');
        clientButton.innerText = client;
        let clientIcon = document.createElement('md-icon');
        clientIcon.innerText = 'check';
        clientIcon.setAttribute('translate', 'no');
        if (activeFilters.includes(client)) {
            clientIcon.style.display = 'block';
        } else {
            clientIcon.style.display = 'none';
        }
        clientIcon.setAttribute('slot', 'icon');
        clientButton.appendChild(clientIcon);
        clientButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (clientButton.getAttribute('active') === 'false') {
                clientButton.setAttribute('active', 'true');
                clientButton.classList.remove('buttonIconHidden');
                clientIcon.style.display = 'block';
            } else {
                clientButton.setAttribute('active', 'false');
                clientIcon.style.display = 'none';
                clientButton.classList.add('buttonIconHidden');
            }
            document.getElementById('main_content_filter_clients_apply').focus();
        });
        clientsList.appendChild(clientButton);
    });
    document.getElementById('main_content_filter_clients_apply').focus();
}

document.getElementById('main_content_filter_clients__deselect_all').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.clientButton').forEach((clientButton) => {
        clientButton.setAttribute('active', 'false');
        clientButton.querySelector('md-icon').style.display = 'none';
    });
});

document.getElementById('main_content_filter_clients__select_all').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.clientButton').forEach((clientButton) => {
        clientButton.setAttribute('active', 'true');
        clientButton.querySelector('md-icon').style.display = 'block';
    });
});


document.getElementById('main_content_filter_clients_close').addEventListener('click', () => {
    document.getElementById('main_content_filter_clients').close();
});

function openFilterProviders(providers) {
    console.log(providers);
    document.getElementById('main_content_filter_providers').show();
    let providersList = document.getElementById('main_content_filter_providers__list');
    providersList.innerHTML = '';
    providers.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
    // Remove duplicates checking provider.id
    providers = providers.filter((provider, index, self) =>
        index === self.findIndex((t) => (
            t.id === provider.id
        ))
    );
    providers.forEach((provider, index) => {
        let providerButton = document.createElement('md-outlined-button');
        providerButton.setAttribute('data-provider-id', provider.id);
        if (providerActiveFilters.includes(provider.id)) {
            providerButton.setAttribute('active', 'true');
        } else {
            providerButton.setAttribute('active', 'false');
        }
        providerButton.classList.add('providerButton');
        providerButton.classList.add('buttonIconHidden');
        providerButton.innerText = provider.name;
        let providerIcon = document.createElement('md-icon');
        providerIcon.innerText = 'check';
        providerIcon.setAttribute('translate', 'no');
        if (providerActiveFilters.includes(provider.id)) {
            providerIcon.style.display = 'block';
        } else {
            providerIcon.style.display = 'none';
        }
        providerIcon.setAttribute('slot', 'icon');
        providerButton.appendChild(providerIcon);
        providerButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (providerButton.getAttribute('active') === 'false') {
                providerButton.setAttribute('active', 'true');
                providerButton.classList.remove('buttonIconHidden');
                providerIcon.style.display = 'block';
            } else {
                providerButton.setAttribute('active', 'false');
                providerButton.classList.add('buttonIconHidden');
                providerIcon.style.display = 'none';
            }
            document.getElementById('main_content_filter_providers_apply').focus();
        });
        providersList.appendChild(providerButton);
    });
    document.getElementById('main_content_filter_providers_apply').focus();
}

document.getElementById('main_content_filter_providers__deselect_all').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.providerButton').forEach((providerButton) => {
        providerButton.setAttribute('active', 'false');
        providerButton.querySelector('md-icon').style.display = 'none';
    });
});

document.getElementById('main_content_filter_providers__select_all').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.providerButton').forEach((providerButton) => {
        providerButton.setAttribute('active', 'true');
        providerButton.querySelector('md-icon').style.display = 'block';
    });
});

document.getElementById('main_content_filter_providers_close').addEventListener('click', () => {
    document.getElementById('main_content_filter_providers').close();
});

document.getElementById('main_dialog_file_upload_close').addEventListener('click', () => {
    document.getElementById('main_dialog_file_upload').close();
});

let file_upload_reference = null;

function openFileUpload(reference) {
    document.getElementById('main_dialog_file_upload').show();
    file_upload_reference = reference;
}

document.getElementById('main_dialog_file_upload_dragAndDropArea').addEventListener('dragover', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_file_upload_dragAndDropArea').classList.add('dragging');
});

document.getElementById('main_dialog_file_upload_dragAndDropArea').addEventListener('dragleave', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_file_upload_dragAndDropArea').classList.remove('dragging');
});

document.getElementById('main_dialog_file_upload_dragAndDropArea').addEventListener('drop', (event) => {
    event.preventDefault();
    document.getElementById('main_dialog_file_upload_dragAndDropArea').classList.remove('dragging');
    let files = event.dataTransfer.files;
    if (files.length > 0) {
        // document.getElementById('main_dialog_file_upload_file').files = files;
        // document.getElementById('main_dialog_file_upload_file').dispatchEvent(new Event('change'));
        // Upload files to Firebase Storage, in /customers/{customerId}/
        // Get customer ID
        let customerId = userClaims.customer;
        if (!customerId) {
            return;
        }
        let storageRef = ref(storage, 'customers/' + customerId + '/');
        let promises = [];
        let filesUploaded = 0;
        // Upload files and save references to database file_upload_reference
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let fileRef = ref(storageRef, file.name);
            promises.push(uploadBytesResumable(fileRef, file).then((snapshot) => {
                console.log('Uploaded a blob or file!');
                filesUploaded++;
                if (filesUploaded === files.length) {
                    document.getElementById('main_dialog_file_upload').close();
                    showMessage('success', 'files_uploaded_successfully');
                }
                return getDownloadURL(snapshot.ref);
            }));
        }
        Promise.all(promises).then((downloadURLs) => {
            console.log(downloadURLs);
            // Save references to database
            let promises = [];
            downloadURLs.forEach((downloadURL) => {
                // Save reference to database, in the path specified in file_upload_reference variable
                promises.push(updateDoc(doc(db, file_upload_reference.collection, file_upload_reference.document), {
                    files: arrayUnion({
                        name: file_upload_reference.name,
                        url: downloadURL,
                        fileId: file_upload_reference.fileId
                    })
                }));
            });
            Promise.all(promises).then(() => {
                console.log('References saved successfully');
            }).catch((error) => {
                console.log('Error saving references', error);
            });
        }).catch((error) => {
            console.log('Error uploading files', error);
        });
    }
});

// setTimeout(() => {
//     openFileUpload({
//         collection: 'products',
//         document: '6PKUYgX93RFTR52JYFa7',
//         name: 'PPT',
//         fileId: genUUID()
//     });
// }, 1000);

function genUUID() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}



var beforeInstallPrompt = null;
window.addEventListener("beforeinstallprompt", eventHandler, errorHandler);

function eventHandler(event) {
    beforeInstallPrompt = event;
}
function errorHandler(e) {
    console.log('error: ' + e);
}

document.getElementById('main_dialog_customers_text').addEventListener('input', () => {
    let text = document.getElementById('main_dialog_customers_text').value;
    let filteredCustomers = [];
    if (!isAdmin) {
        customers.forEach(customer => {
            if (customer.toLowerCase().includes(text.toLowerCase())) {
                filteredCustomers.push(customer)
            }
        });
        filteredCustomers.sort((a, b) => {
            return a.localeCompare(b);
        });
        let list = document.getElementById('main_dialog_customers_list');
        list.innerHTML = '';
        filteredCustomers.forEach((customer, index) => {
            generateCustomerItem(filteredCustomers, customer, index, list)
        });
    } else {
        customersAdmin.forEach(customer => {
            if (customer.name.toLowerCase().includes(text.toLowerCase())) {
                filteredCustomers.push(customer);
            }
        });
        filteredCustomers.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
        let list = document.getElementById('main_dialog_customers_list');
        list.innerHTML = '';
        filteredCustomers.forEach((customer, index) => {
            generateCustomerAdminItem(filteredCustomers, customer, index, list);
        });
    }
});

function generateCustomerItem(customers, customer, index, list) {
    let item = document.createElement('md-list-item');
    item.setAttribute('data-customer', customer);
    item.setAttribute('interactive', 'true');
    let mainDiv = document.createElement('div');
    mainDiv.classList.add('listMainDiv');
    let leftDiv = document.createElement('div');
    leftDiv.classList.add('listLeftDiv');
    let customerIcon = document.createElement('md-icon');
    customerIcon.setAttribute('slot', 'start');
    customerIcon.innerText = 'domain';
    customerIcon.classList.add('listMR16');
    leftDiv.appendChild(customerIcon);
    let divCustomerMeta1 = document.createElement('div');
    let customerName = document.createElement('span');
    customerName.innerText = customer;
    divCustomerMeta1.appendChild(customerName);
    divCustomerMeta1.classList.add('verticalDiv');
    // let customerEmail = document.createElement('span');
    // customerEmail.classList.add('sub');
    // customerEmail.innerText = customer.email;
    // divCustomerMeta1.appendChild(customerEmail);
    leftDiv.appendChild(divCustomerMeta1);
    mainDiv.appendChild(leftDiv);
    let rightDiv = document.createElement('div');
    rightDiv.classList.add('listRightDiv');


    let buttonDetails = document.createElement('md-icon-button');
    let buttonDetailsIcon = document.createElement('md-icon');
    buttonDetailsIcon.innerText = 'expand_content';
    buttonDetailsIcon.setAttribute('translate', 'no');
    buttonDetails.appendChild(buttonDetailsIcon);
    buttonDetails.addEventListener('click', () => {
        customers.forEach((customer) => {
            if (customer === item.getAttribute('data-customer')) {
                console.log(customer);
                openSubCustomerDetails(customer);
            }
        });
    });
    rightDiv.appendChild(buttonDetails);


    let buttonNotif = document.createElement('md-icon-button');
    let buttonNotifIcon = document.createElement('md-icon');
    buttonNotifIcon.innerText = 'edit_notifications';
    buttonNotifIcon.setAttribute('translate', 'no');
    buttonNotif.appendChild(buttonNotifIcon);
    buttonNotif.addEventListener('click', () => {
        // customers.forEach((customer) => {
        //     if (customer.id === item.getAttribute('data-customer')) {
        //         openSubCustomerNotif(customer);
        //     }
        // });
        openNotificationDialog('subcustomer', customer);
    });
    rightDiv.appendChild(buttonNotif);
    mainDiv.appendChild(rightDiv);
    item.appendChild(mainDiv);
    // Detect double click
    let lastClick = 0;
    item.addEventListener('click', (e) => {
        e.preventDefault();
        let now = new Date().getTime();
        let timesince = now - lastClick;
        if ((timesince < 600) && (timesince > 0)) {
            openSubCustomerDetails(customer);
        }
        lastClick = new Date().getTime();
    });
    list.appendChild(item);
    if (index < customers.length - 1) {
        let divider = document.createElement('md-divider');
        list.appendChild(divider);
    }
}


function generateCustomerAdminItem(customers, customer, index, list) {
    let item = document.createElement('md-list-item');
    item.setAttribute('data-customer', customer.id);
    item.setAttribute('interactive', 'true');
    let mainDiv = document.createElement('div');
    mainDiv.classList.add('listMainDiv');
    let leftDiv = document.createElement('div');
    leftDiv.classList.add('listLeftDiv');
    let customerIcon = document.createElement('md-icon');
    customerIcon.setAttribute('slot', 'start');
    customerIcon.innerText = 'domain';
    customerIcon.classList.add('listMR16');
    leftDiv.appendChild(customerIcon);
    let divCustomerMeta1 = document.createElement('div');
    let customerName = document.createElement('span');
    customerName.innerText = customer.name;
    divCustomerMeta1.appendChild(customerName);
    divCustomerMeta1.classList.add('verticalDiv');
    // let customerEmail = document.createElement('span');
    // customerEmail.classList.add('sub');
    // customerEmail.innerText = customer.email;
    // divCustomerMeta1.appendChild(customerEmail);
    leftDiv.appendChild(divCustomerMeta1);
    mainDiv.appendChild(leftDiv);
    let rightDiv = document.createElement('div');
    rightDiv.classList.add('listRightDiv');


    let buttonDetails = document.createElement('md-icon-button');
    let buttonDetailsIcon = document.createElement('md-icon');
    buttonDetailsIcon.innerText = 'expand_content';
    buttonDetailsIcon.setAttribute('translate', 'no');
    buttonDetails.appendChild(buttonDetailsIcon);
    buttonDetails.addEventListener('click', () => {
        customers.forEach((customer) => {
            if (customer.id === item.getAttribute('data-customer')) {
                console.log(customer);
                openCustomerDetails(customer);
            }
        });
    });
    rightDiv.appendChild(buttonDetails);


    let buttonNotif = document.createElement('md-icon-button');
    let buttonNotifIcon = document.createElement('md-icon');
    buttonNotifIcon.innerText = 'edit_notifications';
    buttonNotifIcon.setAttribute('translate', 'no');
    buttonNotif.appendChild(buttonNotifIcon);
    buttonNotif.addEventListener('click', () => {
        // customers.forEach((customer) => {
        //     if (customer.id === item.getAttribute('data-customer')) {
        //         openSubCustomerNotif(customer);
        //     }
        // });
        notification_admin_opened_customer = customer.id;
        openNotificationDialog('customer', customer.id);
    });
    rightDiv.appendChild(buttonNotif);
    mainDiv.appendChild(rightDiv);
    item.appendChild(mainDiv);
    // Detect double click
    let lastClick = 0;
    item.addEventListener('click', (e) => {
        e.preventDefault();
        let now = new Date().getTime();
        let timesince = now - lastClick;
        if ((timesince < 600) && (timesince > 0)) {
            openCustomerDetails(customer);
        }
        lastClick = new Date().getTime();
    });
    list.appendChild(item);
    if (index < customers.length - 1) {
        let divider = document.createElement('md-divider');
        list.appendChild(divider);
    }
}

document.getElementById('main__header__right__customers').addEventListener('click', () => {
    if (isAdmin) {
        document.getElementById('main_dialog_customers').show();
        let list = document.getElementById('main_dialog_customers_list');
        document.getElementById('main_dialog_customers_text').value = '';
        list.innerHTML = '';
        customersAdmin.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
        customersAdmin.forEach((customer, index) => {
            generateCustomerAdminItem(customersAdmin, customer, index, list);
        });
        setTimeout(() => {
            document.getElementById('main_dialog_customers_text').focus();
        }, 100);
    } else {
        document.getElementById('main_dialog_customers').show();
        let list = document.getElementById('main_dialog_customers_list');
        document.getElementById('main_dialog_customers_text').value = '';
        list.innerHTML = '';
        customers.sort((a, b) => {
            return a.localeCompare(b);
        });
        customers.forEach((customer, index) => {
            generateCustomerItem(customers, customer, index, list);
        });
        setTimeout(() => {
            document.getElementById('main_dialog_customers_text').focus();
        }, 100);
    }
});

document.getElementById('main_dialog_providers_text').addEventListener('input', () => {
    let text = document.getElementById('main_dialog_providers_text').value;
    let filteredProviders = [];
    providers.forEach(provider => {
        if (provider.name.toLowerCase().includes(text.toLowerCase())) {
            filteredProviders.push(provider)
        }
    });
    filteredProviders = filteredProviders.filter((provider, index, self) =>
        index === self.findIndex((t) => (
            t.id === provider.id
        ))
    );
    filteredProviders.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
    let list = document.getElementById('main_dialog_providers_list');
    list.innerHTML = '';
    filteredProviders.forEach((provider, index) => {
        generateProviderItem(filteredProviders, provider, index, list)
    });
});

function generateProviderItem(newProviders, provider, index, list) {
    let item = document.createElement('md-list-item');
    item.setAttribute('data-provider', provider.id);
    item.setAttribute('interactive', 'true');
    let mainDiv = document.createElement('div');
    mainDiv.classList.add('listMainDiv');
    let leftDiv = document.createElement('div');
    leftDiv.classList.add('listLeftDiv');
    let providerIcon = document.createElement('md-icon');
    providerIcon.setAttribute('slot', 'start');
    providerIcon.innerText = 'factory';
    providerIcon.classList.add('listMR16');
    leftDiv.appendChild(providerIcon);
    let divProviderMeta1 = document.createElement('div');
    let providerName = document.createElement('span');
    providerName.innerText = provider.name;
    divProviderMeta1.appendChild(providerName);
    divProviderMeta1.classList.add('verticalDiv');
    leftDiv.appendChild(divProviderMeta1);
    mainDiv.appendChild(leftDiv);
    let rightDiv = document.createElement('div');
    rightDiv.classList.add('listRightDiv');
    let buttonDetails = document.createElement('md-icon-button');
    let buttonDetailsIcon = document.createElement('md-icon');
    buttonDetailsIcon.innerText = 'expand_content';
    buttonDetailsIcon.setAttribute('translate', 'no');
    buttonDetails.appendChild(buttonDetailsIcon);
    buttonDetails.addEventListener('click', () => {
        newProviders.forEach((provider) => {
            if (provider.id === item.getAttribute('data-provider')) {
                openProviderDetails(provider);
            }
        });
    });
    rightDiv.appendChild(buttonDetails);
    mainDiv.appendChild(rightDiv);
    item.appendChild(mainDiv);
    // Detect double click
    let lastClick = 0;
    item.addEventListener('click', (e) => {
        e.preventDefault();
        let now = new Date().getTime();
        let timesince = now - lastClick;
        if ((timesince < 600) && (timesince > 0)) {
            openProviderDetails(provider);
        }
        lastClick = new Date().getTime();
    });
    list.appendChild(item);
    if (index < newProviders.length - 1) {
        let divider = document.createElement('md-divider');
        list.appendChild(divider);
    }
}

document.getElementById('main__header__right__manufacturers').addEventListener('click', () => {
    document.getElementById('main_dialog_providers').show();
    let list = document.getElementById('main_dialog_providers_list');
    document.getElementById('main_dialog_providers_text').value = '';
    list.innerHTML = '';
    let newProviders = [];
    // Remove duplicates checking provider.id
    newProviders = providers.filter((provider, index, self) =>
        index === self.findIndex((t) => (
            t.id === provider.id
        ))
    );
    newProviders.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
    newProviders.forEach((provider, index) => {
        generateProviderItem(newProviders, provider, index, list);
    });
    setTimeout(() => {
        document.getElementById('main_dialog_providers_text').focus();
    }, 100);
});

document.getElementById('main_dialog_providers_close').addEventListener('click', () => {
    document.getElementById('main_dialog_providers').close();
});





// FILTER CHIP SUPER MENU CUSTOMER

function render_customers_filter(smenu, action) {
    let item = document.createElement('div');
    item.classList.add('smenu_button');
    let icon = document.createElement('md-icon');
    icon.innerText = 'check';
    icon.setAttribute('translate', 'no');
    icon.classList.add('smenu_icon');
    if (my_products__filters__customers_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
        icon.style.opacity = '1';
    } else {
        icon.style.opacity = '0';
    }
    item.appendChild(icon);
    let text = document.createElement('span');
    text.innerText = action;
    item.appendChild(text);
    if (my_products__filters__customers_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
    } else {
        item.setAttribute('active', 'false');
    }
    item.setAttribute('data-action', action);
    item.addEventListener('click', () => {
        if (item.getAttribute('active') === 'false') {
            item.setAttribute('active', 'true');
            icon.style.opacity = '1';
        } else {
            item.setAttribute('active', 'false');
            icon.style.opacity = '0';
        }
        my_products__filters__customers__check();
    });
    smenu.appendChild(item);
}

document.getElementById('my_products__filters__customers').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__customers__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__customers__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = [];
        customers.forEach((customer) => {
            actions.push(customer);
        });
        actions.sort((a, b) => {
            return a.localeCompare(b);
        });
        let search_field = document.createElement('md-filled-text-field');
        search_field.setAttribute('type', 'text');
        search_field.setAttribute('label', langDataLocal['search']);
        search_field.classList.add('smenu_search');
        search_field.addEventListener('input', (e) => {
            let value = e.target.value.toLowerCase();
            smenu.querySelectorAll('.smenu_button').forEach((button) => {
                if (button.innerText.toLowerCase().indexOf(value) > -1) {
                    button.style.display = 'block';
                } else {
                    button.style.display = 'none';
                }
            });
        });
        search_field.addEventListener('keyup', (e) => {
            // If enter, toggle first element of list
            if (e.key === 'Enter') {
                let f = false;
                document.querySelectorAll('#my_products__filters__customers__menu .smenu_button').forEach((button, index) => {
                    if (f) {
                        return
                    }
                    if (button.style.display === 'block') {
                        f = true;
                        button.click();
                    }
                })
            }
        });
        smenu.appendChild(search_field);
        setTimeout(() => {
            search_field.focus();
        }, 100);
        actions.forEach((action) => {
            render_customers_filter(smenu, action);
        });
    } else {
        document.getElementById('my_products__filters__customers__menu').style.display = 'none';
    }
});

let my_products__filters__customers_activeFilters = [];
function my_products__filters__customers__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__customers_activeFilters = [];
    document.querySelectorAll('#my_products__filters__customers__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__customers_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__customers').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__customers').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__customers__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__customers' && e.target.id !== 'my_products__filters__customers__menu' && e.target.parentElement.id !== 'my_products__filters__customers__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__customers__menu') {
            document.getElementById('my_products__filters__customers__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__customers__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            document.getElementById('my_products__filters__customers__menu').style.display = 'none';
        }
    }
});

// END FILTER CHIP SUPER MENU CUSTOMER


// FILTER CHIP SUPER MENU SUBCUSTOMER ADMIN

function render_subcustomers_admin_filter(smenu, action) {
    let item = document.createElement('div');
    item.classList.add('smenu_button');
    let icon = document.createElement('md-icon');
    icon.innerText = 'check';
    icon.setAttribute('translate', 'no');
    icon.classList.add('smenu_icon');
    if (my_products__filters__subcustomersadmin_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
        icon.style.opacity = '1';
    } else {
        icon.style.opacity = '0';
    }
    item.appendChild(icon);
    let text = document.createElement('span');
    text.innerText = action;
    item.appendChild(text);
    if (my_products__filters__subcustomersadmin_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
    } else {
        item.setAttribute('active', 'false');
    }
    item.setAttribute('data-action', action);
    item.addEventListener('click', () => {
        if (item.getAttribute('active') === 'false') {
            item.setAttribute('active', 'true');
            icon.style.opacity = '1';
        } else {
            item.setAttribute('active', 'false');
            icon.style.opacity = '0';
        }
        my_products__filters__subcustomersadmin__check();
    });
    smenu.appendChild(item);
}

document.getElementById('my_products__filters__subcustomersadmin').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__subcustomersadmin__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__subcustomersadmin__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = [];
        customers.forEach((customer) => {
            actions.push(customer);
        });
        actions.sort((a, b) => {
            return a.localeCompare(b);
        });
        let search_field = document.createElement('md-filled-text-field');
        search_field.setAttribute('type', 'text');
        search_field.setAttribute('label', langDataLocal['search']);
        search_field.classList.add('smenu_search');
        search_field.addEventListener('input', (e) => {
            let value = e.target.value.toLowerCase();
            smenu.querySelectorAll('.smenu_button').forEach((button) => {
                if (button.innerText.toLowerCase().indexOf(value) > -1) {
                    button.style.display = 'block';
                } else {
                    button.style.display = 'none';
                }
            });
        });
        search_field.addEventListener('keyup', (e) => {
            // If enter, toggle first element of list
            if (e.key === 'Enter') {
                let f = false;
                document.querySelectorAll('#my_products__filters__subcustomersadmin__menu .smenu_button').forEach((button, index) => {
                    if (f) {
                        return
                    }
                    if (button.style.display === 'block') {
                        f = true;
                        button.click();
                    }
                })
            }
        });
        smenu.appendChild(search_field);
        setTimeout(() => {
            search_field.focus();
        }, 100);
        actions.forEach((action) => {
            render_subcustomers_admin_filter(smenu, action);
        });
    } else {
        document.getElementById('my_products__filters__subcustomersadmin__menu').style.display = 'none';
    }
});

let my_products__filters__subcustomersadmin_activeFilters = [];
function my_products__filters__subcustomersadmin__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__subcustomersadmin_activeFilters = [];
    document.querySelectorAll('#my_products__filters__subcustomersadmin__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__subcustomersadmin_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__subcustomersadmin').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__subcustomersadmin').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__subcustomersadmin__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__subcustomersadmin' && e.target.id !== 'my_products__filters__subcustomersadmin__menu' && e.target.parentElement.id !== 'my_products__filters__subcustomersadmin__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__subcustomersadmin__menu') {
            document.getElementById('my_products__filters__subcustomersadmin__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__subcustomersadmin__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            if (document.getElementById('my_products__filters__subcustomersadmin__menu').getElementsByTagName('md-filled-text-field')[0].value.length > 0) {
                document.getElementById('my_products__filters__subcustomersadmin__menu').getElementsByTagName('md-filled-text-field')[0].value = ''
                document.getElementById('my_products__filters__subcustomersadmin__menu').getElementsByTagName('md-filled-text-field')[0].dispatchEvent(new Event('input'))
            } else {
                document.getElementById('my_products__filters__subcustomersadmin__menu').style.display = 'none';
            }
        }
    }
});

// END FILTER CHIP SUPER MENU SUBCUSTOMER ADMIN

// FILTER CHIP SUPER MENU CUSTOMER ADMIN

function render_customersadmin_filter(smenu, action) {
    let item = document.createElement('div');
    item.classList.add('smenu_button');
    let icon = document.createElement('md-icon');
    icon.innerText = 'check';
    icon.setAttribute('translate', 'no');
    icon.classList.add('smenu_icon');
    if (my_products__filters__customersadmin_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
        icon.style.opacity = '1';
    } else {
        icon.style.opacity = '0';
    }
    item.appendChild(icon);
    let text = document.createElement('span');
    text.innerText = action;
    item.appendChild(text);
    if (my_products__filters__customersadmin_activeFilters.includes(action)) {
        item.setAttribute('active', 'true');
    } else {
        item.setAttribute('active', 'false');
    }
    item.setAttribute('data-action', action);
    item.addEventListener('click', () => {
        if (item.getAttribute('active') === 'false') {
            item.setAttribute('active', 'true');
            icon.style.opacity = '1';
        } else {
            item.setAttribute('active', 'false');
            icon.style.opacity = '0';
        }
        my_products__filters__customersadmin__check();
    });
    smenu.appendChild(item);
}

document.getElementById('my_products__filters__customersadmin').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__customersadmin__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__customersadmin__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = [];
        customersAdmin.forEach((customer) => {
            actions.push(customer.name);
        });
        actions.sort((a, b) => {
            return a.localeCompare(b);
        });
        let search_field = document.createElement('md-filled-text-field');
        search_field.setAttribute('type', 'text');
        search_field.setAttribute('label', langDataLocal['search']);
        search_field.classList.add('smenu_search');
        search_field.addEventListener('input', (e) => {
            let value = e.target.value.toLowerCase();
            smenu.querySelectorAll('.smenu_button').forEach((button) => {
                if (button.innerText.toLowerCase().indexOf(value) > -1) {
                    button.style.display = 'block';
                } else {
                    button.style.display = 'none';
                }
            });
        });
        search_field.addEventListener('keyup', (e) => {
            // If enter, toggle first element of list
            if (e.key === 'Enter') {
                let f = false;
                document.querySelectorAll('#my_products__filters__customersadmin__menu .smenu_button').forEach((button, index) => {
                    if (f) {
                        return
                    }
                    if (button.style.display === 'block') {
                        f = true;
                        button.click();
                    }
                })
            }
        });
        smenu.appendChild(search_field);
        setTimeout(() => {
            search_field.focus();
        }, 100);
        actions.forEach((action) => {
            render_customersadmin_filter(smenu, action);
        });
    } else {
        document.getElementById('my_products__filters__customersadmin__menu').style.display = 'none';
    }
});

let my_products__filters__customersadmin_activeFilters = [];
function my_products__filters__customersadmin__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__customersadmin_activeFilters = [];
    document.querySelectorAll('#my_products__filters__customersadmin__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__customersadmin_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__customersadmin').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__customersadmin').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__customersadmin__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__customersadmin' && e.target.id !== 'my_products__filters__customersadmin__menu' && e.target.parentElement.id !== 'my_products__filters__customersadmin__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__customersadmin__menu') {
            document.getElementById('my_products__filters__customersadmin__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__customersadmin__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            if (document.getElementById('my_products__filters__customersadmin__menu').getElementsByTagName('md-filled-text-field')[0].value.length > 0) {
                document.getElementById('my_products__filters__customersadmin__menu').getElementsByTagName('md-filled-text-field')[0].value = ''
                document.getElementById('my_products__filters__customersadmin__menu').getElementsByTagName('md-filled-text-field')[0].dispatchEvent(new Event('input'))
            } else {
                document.getElementById('my_products__filters__customersadmin__menu').style.display = 'none';
            }
        }
        // if (e.key === 'ArrowDown') {
        //     document.getElementById('my_products__filters__customersadmin__menu').getElementsByClassName('smenu_button')[0].focus()
        // }
    }
});

// END FILTER CHIP SUPER MENU CUSTOMER ADMIN

// FILTER CHIP SUPER MENU PROVIDER

function render_providers_filter(smenu, action) {
    let item = document.createElement('div');
    item.classList.add('smenu_button');
    let icon = document.createElement('md-icon');
    icon.innerText = 'check';
    icon.setAttribute('translate', 'no');
    icon.classList.add('smenu_icon');
    // Get provider ID by name
    let provider = providers.find(provider => provider.name === action);
    if (!provider) {
        return;
    }
    let id = provider.id;
    if (my_products__filters__providers_activeFilters.includes(id)) {
        item.setAttribute('active', 'true');
        icon.style.opacity = '1';
    } else {
        icon.style.opacity = '0';
    }
    item.appendChild(icon);
    let text = document.createElement('span');
    text.innerText = action;
    item.appendChild(text);
    if (my_products__filters__providers_activeFilters.includes(id)) {
        item.setAttribute('active', 'true');
    } else {
        item.setAttribute('active', 'false');
    }
    item.setAttribute('data-action', action);
    item.setAttribute('data-provider-id', id);
    item.addEventListener('click', () => {
        if (item.getAttribute('active') === 'false') {
            item.setAttribute('active', 'true');
            icon.style.opacity = '1';
        } else {
            item.setAttribute('active', 'false');
            icon.style.opacity = '0';
        }
        my_products__filters__providers__check();
    });
    smenu.appendChild(item);
}

document.getElementById('my_products__filters__providers').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__providers__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__providers__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = [];
        providers.forEach((provider) => {
            if (actions.indexOf(provider.name) === -1) {
                actions.push(provider.name);
            }
        });
        actions.sort((a, b) => {
            return a.localeCompare(b);
        });
        let search_field = document.createElement('md-filled-text-field');
        search_field.setAttribute('type', 'text');
        search_field.setAttribute('label', langDataLocal['search']);
        search_field.classList.add('smenu_search');
        search_field.addEventListener('input', (e) => {
            let value = e.target.value.toLowerCase();
            smenu.querySelectorAll('.smenu_button').forEach((button) => {
                if (button.innerText.toLowerCase().indexOf(value) > -1) {
                    button.style.display = 'block';
                } else {
                    button.style.display = 'none';
                }
            });
        });
        search_field.addEventListener('keyup', (e) => {
            // If enter, toggle first element of list
            if (e.key === 'Enter') {
                let f = false;
                document.querySelectorAll('#my_products__filters__providers__menu .smenu_button').forEach((button, index) => {
                    if (f) {
                        return
                    }
                    if (button.style.display === 'block') {
                        f = true;
                        button.click();
                    }
                })
            }
        });
        smenu.appendChild(search_field);
        setTimeout(() => {
            search_field.focus();
        }, 100);
        actions.forEach((action) => {
            render_providers_filter(smenu, action);
        });
    } else {
        document.getElementById('my_products__filters__providers__menu').style.display = 'none';
    }
});

let my_products__filters__providers_activeFilters = [];
function my_products__filters__providers__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__providers_activeFilters = [];
    document.querySelectorAll('#my_products__filters__providers__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            let id = button.getAttribute('data-provider-id');
            my_products__filters__providers_activeFilters.push(id);
        }
    });
    if (active) {
        document.getElementById('my_products__filters__providers').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__providers').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__providers__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__providers' && e.target.id !== 'my_products__filters__providers__menu' && e.target.parentElement.id !== 'my_products__filters__providers__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__providers__menu') {
            document.getElementById('my_products__filters__providers__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__providers__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            if (document.getElementById('my_products__filters__providers__menu').getElementsByTagName('md-filled-text-field')[0].value.length > 0) {
                document.getElementById('my_products__filters__providers__menu').getElementsByTagName('md-filled-text-field')[0].value = ''
                document.getElementById('my_products__filters__providers__menu').getElementsByTagName('md-filled-text-field')[0].dispatchEvent(new Event('input'))
            } else {
                document.getElementById('my_products__filters__providers__menu').style.display = 'none';
            }
        }
    }
});

// END FILTER CHIP SUPER MENU PROVIDER

let my_products__filters__subproducts_activeFilters = [];
let my_products__filters__versions_activeFilters = [];

function getUniqueProductLineOptions(values) {
    const options = new Map();
    values.forEach((value) => {
        const label = normalizeProductName(value);
        const normalized = normalizeProductText(label);
        if (label && normalized && !options.has(normalized)) {
            options.set(normalized, label);
        }
    });
    return Array.from(options, ([value, label]) => ({ value, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
}

function getSubproductFilterOptions() {
    return getUniqueProductLineOptions(products.flatMap((product) => getProductLines(product).map((line) => line.name)));
}

function getVersionFilterOptions() {
    const selectedNames = new Set(my_products__filters__subproducts_activeFilters);
    return getUniqueProductLineOptions(products.flatMap((product) => getProductLines(product))
        .filter((line) => selectedNames.has(normalizeProductText(line.name)))
        .map((line) => line.version));
}

function setProductLineFilterChipState(chipId, activeFilters) {
    const chip = document.getElementById(chipId);
    if (activeFilters.length > 0) {
        chip.setAttribute('selected', 'true');
    } else {
        chip.removeAttribute('selected');
    }
}

function refreshVersionFilterAvailability() {
    const wrapper = document.getElementById('my_products__filters__versions_wrapper');
    const options = getVersionFilterOptions();
    const availableVersions = new Set(options.map((option) => option.value));
    my_products__filters__versions_activeFilters = my_products__filters__versions_activeFilters.filter((version) => availableVersions.has(version));
    const visible = my_products__filters__subproducts_activeFilters.length > 0 && options.length > 0;
    wrapper.style.display = visible ? 'inline-flex' : 'none';
    if (!visible) {
        document.getElementById('my_products__filters__versions__menu').style.display = 'none';
    }
    setProductLineFilterChipState('my_products__filters__versions', my_products__filters__versions_activeFilters);
}

function positionProductLineFilterMenu(menu) {
    menu.style.left = '0px';
    const rect = menu.getBoundingClientRect();
    const rightOverflow = rect.right - (window.innerWidth - 16);
    if (rightOverflow > 0) {
        menu.style.left = `${-rightOverflow}px`;
    }
}

function bindProductLineFilter(chipId, menuId, getOptions, getActiveFilters, setActiveFilters, onChange) {
    const chip = document.getElementById(chipId);
    const menu = document.getElementById(menuId);
    chip.addEventListener('click', (event) => {
        event.preventDefault();
        if (menu.style.display === 'block') {
            menu.style.display = 'none';
            return;
        }
        menu.innerHTML = '';
        menu.style.display = 'block';
        const search = document.createElement('md-filled-text-field');
        search.type = 'text';
        search.label = langDataLocal['search'];
        search.classList.add('smenu_search');
        menu.appendChild(search);
        getOptions().forEach((option) => {
            const item = document.createElement('div');
            item.className = 'smenu_button';
            item.tabIndex = 0;
            item.setAttribute('role', 'option');
            const icon = document.createElement('md-icon');
            icon.innerText = 'check';
            icon.setAttribute('translate', 'no');
            icon.className = 'smenu_icon';
            const text = document.createElement('span');
            text.innerText = option.label;
            item.append(icon, text);
            const renderSelection = () => {
                const selected = getActiveFilters().includes(option.value);
                item.setAttribute('active', selected ? 'true' : 'false');
                item.setAttribute('aria-selected', selected ? 'true' : 'false');
                icon.style.opacity = selected ? '1' : '0';
            };
            const toggle = () => {
                const active = new Set(getActiveFilters());
                if (active.has(option.value)) {
                    active.delete(option.value);
                } else {
                    active.add(option.value);
                }
                setActiveFilters(Array.from(active));
                renderSelection();
                setProductLineFilterChipState(chipId, getActiveFilters());
                onChange();
            };
            renderSelection();
            item.addEventListener('click', toggle);
            item.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggle();
                }
            });
            menu.appendChild(item);
        });
        search.addEventListener('input', () => {
            const query = normalizeProductText(search.value);
            menu.querySelectorAll('.smenu_button').forEach((item) => {
                item.style.display = normalizeProductText(item.innerText).includes(query) ? 'flex' : 'none';
            });
        });
        positionProductLineFilterMenu(menu);
        setTimeout(() => search.focus(), 100);
    });
    document.addEventListener('click', (event) => {
        const path = event.composedPath();
        if (menu.style.display === 'block' && !path.includes(chip) && !path.includes(menu)) {
            menu.style.display = 'none';
        }
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.style.display === 'block') {
            menu.style.display = 'none';
        }
    });
    window.addEventListener('resize', () => {
        if (menu.style.display === 'block') {
            positionProductLineFilterMenu(menu);
        }
    });
}

bindProductLineFilter(
    'my_products__filters__subproducts',
    'my_products__filters__subproducts__menu',
    getSubproductFilterOptions,
    () => my_products__filters__subproducts_activeFilters,
    (filters) => { my_products__filters__subproducts_activeFilters = filters; },
    () => {
        refreshVersionFilterAvailability();
        filterProducts();
    }
);

bindProductLineFilter(
    'my_products__filters__versions',
    'my_products__filters__versions__menu',
    getVersionFilterOptions,
    () => my_products__filters__versions_activeFilters,
    (filters) => { my_products__filters__versions_activeFilters = filters; },
    filterProducts
);


// FILTER CHIP SUPER MENU OTHERS

document.getElementById('my_products__filters__others').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__others__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__others__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = ['externalAccess'];
        if (isAdmin) {
            actions.push('selfbillable_product');
            actions.push('deleted_products');
        }
        actions.forEach((action) => {
            let item = document.createElement('div');
            item.classList.add('smenu_button');
            let icon = document.createElement('md-icon');
            icon.innerText = 'check';
            icon.setAttribute('translate', 'no');
            icon.classList.add('smenu_icon');
            if (my_products__filters__others_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
                icon.style.opacity = '1';
            } else {
                icon.style.opacity = '0';
            }
            item.appendChild(icon);
            let text = document.createElement('span');
            text.innerText = langDataLocal[action];
            item.appendChild(text);
            if (my_products__filters__others_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
            } else {
                item.setAttribute('active', 'false');
            }
            item.setAttribute('data-action', action);
            item.addEventListener('click', () => {
                if (item.getAttribute('active') === 'false') {
                    item.setAttribute('active', 'true');
                    icon.style.opacity = '1';
                } else {
                    item.setAttribute('active', 'false');
                    icon.style.opacity = '0';
                }
                my_products__filters__others__check();
            });
            smenu.appendChild(item);
        });
    } else {
        document.getElementById('my_products__filters__others__menu').style.display = 'none';
    }
});

let my_products__filters__others_activeFilters = [];
function my_products__filters__others__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__others_activeFilters = [];
    document.querySelectorAll('#my_products__filters__others__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__others_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__others').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__others').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__others__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__others' && e.target.id !== 'my_products__filters__others__menu' && e.target.parentElement.id !== 'my_products__filters__others__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__others__menu') {
            document.getElementById('my_products__filters__others__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__others__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            document.getElementById('my_products__filters__others__menu').style.display = 'none';
        }
    }
});





// END FILTER CHIP SUPER MENU OTHERS



// FILTER CHIP SUPER MENU TAGS

let my_products__filters__tags_activeFilters = [];

document.getElementById('my_products__filters__tags').addEventListener('click', (e) => {
    e.preventDefault();
    const menu = document.getElementById('my_products__filters__tags__menu');
    if (menu.style.display !== 'block') {
        menu.style.display = 'block';
        menu.innerHTML = '';
        const counts = getTagUsageCounts();
        const sortedTags = [...tags].sort((a, b) => (a.name || '').localeCompare(b.name || ''));

        if (sortedTags.length === 0) {
            const empty = document.createElement('div');
            empty.classList.add('smenu_empty');
            empty.innerText = langDataLocal?.no_tags_available || 'No tags available';
            menu.appendChild(empty);
        }

        sortedTags.forEach((tag) => {
            const item = document.createElement('div');
            item.classList.add('smenu_button');
            const icon = document.createElement('md-icon');
            icon.innerText = 'check';
            icon.setAttribute('translate', 'no');
            icon.classList.add('smenu_icon');
            if (my_products__filters__tags_activeFilters.includes(tag.id)) {
                item.setAttribute('active', 'true');
                icon.style.opacity = '1';
            } else {
                item.setAttribute('active', 'false');
                icon.style.opacity = '0';
            }
            item.appendChild(icon);
            const dot = document.createElement('span');
            dot.classList.add('tag-menu-dot');
            dot.style.backgroundColor = tag.color || '#CBD5F5';
            item.appendChild(dot);
            const text = document.createElement('span');
            const count = counts[tag.id] || 0;
            text.innerText = `${tag.name || '-'} (${count})`;
            item.appendChild(text);
            item.setAttribute('data-action', tag.id);
            item.addEventListener('click', () => {
                const isActive = item.getAttribute('active') === 'true';
                if (isActive) {
                    item.setAttribute('active', 'false');
                    icon.style.opacity = '0';
                } else {
                    item.setAttribute('active', 'true');
                    icon.style.opacity = '1';
                }
                my_products__filters__tags__check();
            });
            menu.appendChild(item);
        });

        const withoutCount = products.filter((product) => !product.tags || product.tags.length === 0).length;
        const withoutItem = document.createElement('div');
        withoutItem.classList.add('smenu_button');
        const withoutIcon = document.createElement('md-icon');
        withoutIcon.innerText = 'check';
        withoutIcon.setAttribute('translate', 'no');
        withoutIcon.classList.add('smenu_icon');
        if (my_products__filters__tags_activeFilters.includes('__WITHOUT__')) {
            withoutItem.setAttribute('active', 'true');
            withoutIcon.style.opacity = '1';
        } else {
            withoutItem.setAttribute('active', 'false');
            withoutIcon.style.opacity = '0';
        }
        withoutItem.appendChild(withoutIcon);
        const withoutText = document.createElement('span');
        withoutText.innerText = `${langDataLocal?.no_tags_assigned || 'No tags'} (${withoutCount})`;
        withoutItem.appendChild(withoutText);
        withoutItem.setAttribute('data-action', '__WITHOUT__');
        withoutItem.addEventListener('click', () => {
            const isActive = withoutItem.getAttribute('active') === 'true';
            if (isActive) {
                withoutItem.setAttribute('active', 'false');
                withoutIcon.style.opacity = '0';
            } else {
                withoutItem.setAttribute('active', 'true');
                withoutIcon.style.opacity = '1';
            }
            my_products__filters__tags__check();
        });
        menu.appendChild(withoutItem);
    } else {
        menu.style.display = 'none';
    }
});

function my_products__filters__tags__check() {
    my_products__filters__tags_activeFilters = [];
    document.querySelectorAll('#my_products__filters__tags__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            my_products__filters__tags_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (my_products__filters__tags_activeFilters.length > 0) {
        document.getElementById('my_products__filters__tags').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__tags').removeAttribute('selected');
    }
    filterProducts();
}

function updateTagFilterSelectionState() {
    if (my_products__filters__tags_activeFilters.length > 0) {
        document.getElementById('my_products__filters__tags').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__tags').removeAttribute('selected');
    }
}

document.addEventListener('click', (e) => {
    const menu = document.getElementById('my_products__filters__tags__menu');
    if (menu.style.display === 'block') {
        if (e.target.id !== 'my_products__filters__tags' && e.target.id !== 'my_products__filters__tags__menu' && e.target.parentElement?.id !== 'my_products__filters__tags__menu' && e.target.parentElement?.parentElement?.id !== 'my_products__filters__tags__menu') {
            menu.style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const menu = document.getElementById('my_products__filters__tags__menu');
        if (menu.style.display === 'block') {
            menu.style.display = 'none';
        }
    }
});

// FILTER CHIP SUPER MENU STATUS

document.getElementById('my_products__filters__status').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__status__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__status__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = ['active', 'inactive', 'renewal_pending', 'proposal_pending'];
        actions.forEach((action) => {
            let item = document.createElement('div');
            item.classList.add('smenu_button');
            let icon = document.createElement('md-icon');
            icon.innerText = 'check';
            icon.setAttribute('translate', 'no');
            icon.classList.add('smenu_icon');
            if (my_products__filters__status_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
                icon.style.opacity = '1';
            } else {
                icon.style.opacity = '0';
            }
            item.appendChild(icon);
            let text = document.createElement('span');
            text.innerText = langDataLocal[action];
            item.appendChild(text);
            if (my_products__filters__status_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
            } else {
                item.setAttribute('active', 'false');
            }
            item.setAttribute('data-action', action);
            item.addEventListener('click', () => {
                if (item.getAttribute('active') === 'false') {
                    item.setAttribute('active', 'true');
                    icon.style.opacity = '1';
                } else {
                    item.setAttribute('active', 'false');
                    icon.style.opacity = '0';
                }
                my_products__filters__status__check();
            });
            smenu.appendChild(item);
        });
    } else {
        document.getElementById('my_products__filters__status__menu').style.display = 'none';
    }
});

let my_products__filters__status_activeFilters = [];
function my_products__filters__status__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__status_activeFilters = [];
    document.querySelectorAll('#my_products__filters__status__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__status_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__status').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__status').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__status__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__status' && e.target.id !== 'my_products__filters__status__menu' && e.target.parentElement.id !== 'my_products__filters__status__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__status__menu') {
            document.getElementById('my_products__filters__status__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__status__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            document.getElementById('my_products__filters__status__menu').style.display = 'none';
        }
    }
});

// END FILTER CHIP SUPER MENU STATUS


// FILTER CHIP SUPER MENU MANAGED BY

document.getElementById('my_products__filters__managedBy').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__managedBy__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__managedBy__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';
        let actions = ['ZONATIC'];
        products.forEach((product) => {
            if (product.managedBy && !actions.includes(product.managedBy)) {
                actions.push(product.managedBy);
            }
        });
        actions.sort((a, b) => {
            return a.localeCompare(b);
        });
        actions.forEach((action) => {
            let item = document.createElement('div');
            item.classList.add('smenu_button');
            let icon = document.createElement('md-icon');
            icon.innerText = 'check';
            icon.setAttribute('translate', 'no');
            icon.classList.add('smenu_icon');
            if (my_products__filters__managedBy_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
                icon.style.opacity = '1';
            } else {
                icon.style.opacity = '0';
            }
            item.appendChild(icon);
            let text = document.createElement('span');
            text.innerText = action;
            item.appendChild(text);
            if (my_products__filters__managedBy_activeFilters.includes(action)) {
                item.setAttribute('active', 'true');
            } else {
                item.setAttribute('active', 'false');
            }
            item.setAttribute('data-action', action);
            item.addEventListener('click', () => {
                if (item.getAttribute('active') === 'false') {
                    item.setAttribute('active', 'true');
                    icon.style.opacity = '1';
                } else {
                    item.setAttribute('active', 'false');
                    icon.style.opacity = '0';
                }
                my_products__filters__managedBy__check();
            });
            smenu.appendChild(item);
        });
    } else {
        document.getElementById('my_products__filters__managedBy__menu').style.display = 'none';
    }
});

let my_products__filters__managedBy_activeFilters = [];
function my_products__filters__managedBy__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__managedBy_activeFilters = [];
    document.querySelectorAll('#my_products__filters__managedBy__menu .smenu_button').forEach((button) => {
        if (button.getAttribute('active') === 'true') {
            active = true;
            my_products__filters__managedBy_activeFilters.push(button.getAttribute('data-action'));
        }
    });
    if (active) {
        document.getElementById('my_products__filters__managedBy').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__managedBy').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__managedBy__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__managedBy' && e.target.id !== 'my_products__filters__managedBy__menu' && e.target.parentElement.id !== 'my_products__filters__managedBy__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__managedBy__menu') {
            document.getElementById('my_products__filters__managedBy__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__managedBy__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            document.getElementById('my_products__filters__managedBy__menu').style.display = 'none';
        }
    }
});

// END FILTER CHIP SUPER MENU MANAGED BY







// FILTER CHIP SUPER MENU EXPIRY DATE

document.getElementById('my_products__filters__expiryDate').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('my_products__filters__expiryDate__menu').style.display !== 'block') {
        let smenu = document.getElementById('my_products__filters__expiryDate__menu');
        smenu.style.display = 'block';
        smenu.innerHTML = '';

        let startDiv = document.createElement('div');
        startDiv.classList.add('align')
        let startRange = document.createElement('md-outlined-text-field');
        startRange.setAttribute('label', langDataLocal['start']);
        startRange.setAttribute('type', 'date');
        startRange.setAttribute('id', 'my_products__filters__expiryDate__start');
        startDiv.classList.add('smenu_button');
        startRange.addEventListener('input', () => {
            my_products__filters__expiryDate__check();
        });
        startRange.addEventListener('click', () => {
            // Get shadow-root
            let shadowRoot = startRange.shadowRoot;
            shadowRoot.querySelector('input').showPicker();
        });
        startRange.value = moment(my_products__filters__expiryDate_start).format('YYYY-MM-DD') || '';
        startDiv.appendChild(startRange);
        let startClear = document.createElement('md-icon-button');
        startClear.classList.add('ml5');
        let startClearIcon = document.createElement('md-icon');
        startClearIcon.innerText = 'clear';
        startClearIcon.setAttribute('translate', 'no');
        startClear.appendChild(startClearIcon);
        startClear.addEventListener('click', () => {
            startRange.value = '';
            my_products__filters__expiryDate__check();
        });
        startDiv.appendChild(startClear);
        smenu.appendChild(startDiv);
        let endDiv = document.createElement('div');
        endDiv.classList.add('align')
        let endRange = document.createElement('md-outlined-text-field');
        endRange.setAttribute('label', langDataLocal['end']);
        endRange.setAttribute('type', 'date');
        endRange.setAttribute('id', 'my_products__filters__expiryDate__end');
        endDiv.classList.add('smenu_button');
        endRange.addEventListener('input', () => {
            my_products__filters__expiryDate__check();
        });
        endRange.addEventListener('click', () => {
            // Get shadow-root
            let shadowRoot = endRange.shadowRoot;
            shadowRoot.querySelector('input').showPicker();
        });
        endRange.value = moment(my_products__filters__expiryDate_end).format('YYYY-MM-DD') || '';
        endDiv.appendChild(endRange);
        let endClear = document.createElement('md-icon-button');
        endClear.classList.add('ml5');
        let endClearIcon = document.createElement('md-icon');
        endClearIcon.innerText = 'clear';
        endClearIcon.setAttribute('translate', 'no');
        endClear.appendChild(endClearIcon);
        endClear.addEventListener('click', () => {
            endRange.value = '';
            my_products__filters__expiryDate__check();
        });
        endDiv.appendChild(endClear);
        smenu.appendChild(endDiv);
    } else {
        document.getElementById('my_products__filters__expiryDate__menu').style.display = 'none';
    }
});

let my_products__filters__expiryDate_start = null;
let my_products__filters__expiryDate_end = null;
function my_products__filters__expiryDate__check() {
    // Check if any filter is active
    let active = false;
    my_products__filters__expiryDate_start = moment(document.getElementById('my_products__filters__expiryDate__start').value).valueOf() || null;
    my_products__filters__expiryDate_end = moment(document.getElementById('my_products__filters__expiryDate__end').value).valueOf() || null;
    if (my_products__filters__expiryDate_start || my_products__filters__expiryDate_end) {
        active = true;
    }
    console.log(my_products__filters__expiryDate_start, my_products__filters__expiryDate_end);
    if (active) {
        document.getElementById('my_products__filters__expiryDate').setAttribute('selected', 'true');
    } else {
        document.getElementById('my_products__filters__expiryDate').removeAttribute('selected');
    }
    filterProducts();
}

// Close menu on click outside or escape
document.addEventListener('click', (e) => {
    if (document.getElementById('my_products__filters__expiryDate__menu').style.display === 'block') {
        if (e.target.id !== 'my_products__filters__expiryDate' && e.target.id !== 'my_products__filters__expiryDate__menu' && e.target.parentElement.id !== 'my_products__filters__expiryDate__menu' && e.target.parentElement.parentElement.id !== 'my_products__filters__expiryDate__menu') {
            document.getElementById('my_products__filters__expiryDate__menu').style.display = 'none';
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (document.getElementById('my_products__filters__expiryDate__menu').style.display === 'block') {
        if (e.key === 'Escape') {
            document.getElementById('my_products__filters__expiryDate__menu').style.display = 'none';
        }
    }
});

// END FILTER CHIP SUPER MENU EXPIRY DATE




document.getElementById('main__header__right__global_tools').addEventListener('click', (e) => {
    document.getElementById('main_dialog_admin_tools').show();
});

document.getElementById('main_dialog_admin_tools_close').addEventListener('click', (e) => {
    document.getElementById('main_dialog_admin_tools').close();
});



let openedProvider = null;

function openProviderDetails(provider) {
    document.getElementById('main_dialog_providers').close();
    console.log(provider);
    if (isAdmin) {
        document.getElementById('main_dialog_provider_details_send_message').style.display = 'none';
    }
    openedProvider = provider.id;
    document.getElementById('main_dialog_product_details_provider_details_support').innerHTML = '';
    document.getElementById('main_dialog_provider_details').show();
    document.getElementById('main_dialog_provider_details_name').innerText = provider.name;
    let count = 0;
    let chipSet = document.createElement('md-chip-set');
    if (provider.supportTypes) {
        console.log(provider.supportTypes);
        Object.keys(provider.supportTypes).forEach((key) => {
            count++;
            console.log(provider.supportTypes[key]);
            let chip = document.createElement('md-filter-chip');
            chip.label = provider.supportTypes[key].name;
            chip.addEventListener('click', () => {
                // On click, get attribute 'selected' and if it's there (doesn't say true), modify the rest of chips to false
                if (chip.getAttribute('selected') !== '') {
                    chipSet.querySelectorAll('md-filter-chip').forEach((c) => {
                        c.removeAttribute('selected');
                    });
                    chip.setAttribute('selected', 'true');
                    document.getElementById('main_dialog_product_details_provider_details_support').innerHTML = '';
                    renderSupportData(provider.supportTypes[key], 'main_dialog_product_details_provider_details_support');
                }
            });
            chipSet.appendChild(chip);
        });
    }
    document.getElementById('main_dialog_provider_details_chips').innerHTML = '';
    if (count > 0) {
        document.getElementById('main_dialog_provider_details_chips').appendChild(chipSet);
    } else {
        document.getElementById('main_dialog_provider_details_chips').innerHTML = langDataLocal['no_support_data'];
    }
    if (!isAdmin) {
        document.getElementById('main_dialog_provider_details_observations').value = customer_data.providerNotes[provider.id] || '';
        currentProductNotes = customer_data.providerNotes[provider.id] || '';
    } else {
        document.getElementById('main_dialog_provider_details_observations').value = adminGetCustomer(adminGetProduct(openedProduct).customer).providerNotes[provider.id] || '';
        currentProductNotes = adminGetCustomer(adminGetProduct(openedProduct).customer).providerNotes[provider.id] || '';
    }
}

function adminGetProduct(id) {
    return productsById.get(id) || products.find(product => product.id === id);
}

document.getElementById('main_dialog_provider_details_close').addEventListener('click', () => {
    document.getElementById('main_dialog_provider_details').close();
});

document.getElementById('main_dialog_provider_details_send_message').addEventListener('click', () => {
    document.getElementById('main_dialog_provider_details').close();
    document.getElementById('main_dialog_send_message_from_provider').show();
    document.getElementById('main_dialog_send_message_from_provider_p').innerHTML = langDataLocal['did_you_find_a_mistake_in_the_provider'] + ' ' + document.getElementById('main_dialog_provider_details_name').innerText + '? ' + langDataLocal['let_us_know_and_we_will_fix_it'];
});

document.getElementById('main_dialog_message_from_provider_send').addEventListener('click', () => {
    let message = document.getElementById('main_dialog_message_from_provider_text').value;
    if (!message) {
        return;
    }
    let provider = openedProvider;
    let date = new Date().getTime();
    let user = auth.currentUser.uid;
    let messageObject = {
        message,
        provider,
        date,
        user,
        origin: 'customer',
        destination: 'admin'
    };
    let messagesRef = collection(db, 'messages');
    addDoc(messagesRef, messageObject).then((docRef) => {
        console.log('Message sent successfully', docRef.id);
        document.getElementById('main_dialog_send_message_from_provider').close();
        showMessage('success', 'message_sent_successfully');
    }).catch((error) => {
        console.error('Error sending message', error);
        showError('error', 'error_sending_message');
    });
});

document.getElementById('main_dialog_product_details_eye_button').addEventListener('click', () => {
    let icon = document.getElementById('main_dialog_product_details_eye_button').querySelector('md-icon');
    if (icon.innerText === 'visibility') {
        icon.innerText = 'visibility_off';
        document.documentElement.style.setProperty('--blur', '5px');
    } else {
        icon.innerText = 'visibility';
        document.documentElement.style.setProperty('--blur', '0px');
    }
});

document.getElementById('main_dialog_message_from_provider_close').addEventListener('click', () => {
    document.getElementById('main_dialog_send_message_from_provider').close();
    // Repoen provider details
    // Get provider by id
    let provider = providers.find(provider => provider.id === openedProvider);
    if (provider) {
        openProviderDetails(provider);
    } else {
        showError('error', 'an_error_has_occurred');
    }
});

document.getElementById('main_dialog_customers_close').addEventListener('click', () => {
    document.getElementById('main_dialog_customers').close();
});

let openedSubcustomer = null;
let openedContactPerson = null;
let openedSubcustomerParentCustomer = null;
async function openSubCustomerDetails(customer, parentCustomer) {
    openedSubcustomerParentCustomer = parentCustomer;
    if (!isAdmin) {
        customerData = await getCustomerData();
    } else {
        customerData = (await getDoc(doc(db, 'customers', parentCustomer))).data();
        console.log(customerData);
    }
    openedSubcustomer = customer;
    console.log(customerData);
    console.log(customer);
    document.getElementById('main_dialog_subcustomer_details').show();
    let subcustomer = customerData.subcustomers[customer] || {};
    document.getElementById('main_dialog_subcustomer_details_name_title').innerText = customer;
    document.getElementById('main_dialog_subcustomer_details_observations').value = subcustomer.notes || '';
    // currentSubcustomerNotes = subcustomer.notes || '';
    if (subcustomer.contactPersons && subcustomer.contactPersons.length > 0) {
        document.getElementById('main_dialog_subcustomer_details_contact_persons').style.display = 'grid';
        document.getElementById('main_dialog_subcustomer_details_contact_persons').innerHTML = '';
        document.getElementById('main_dialog_subcustomer_details_contact_persons_empty').style.display = 'none';
        subcustomer.contactPersons.forEach((contactPerson) => {
            let item = document.createElement('div');
            let name = document.createElement('span');
            name.innerText = contactPerson.name;
            item.appendChild(name);
            let email = document.createElement('span');
            email.innerText = trimText(contactPerson.email, 15) || '';
            item.appendChild(email);
            let phone = document.createElement('span');
            phone.innerText = trimText(contactPerson.phone, 15) || '';
            item.appendChild(phone);
            item.classList.add('contact_person');
            item.addEventListener('click', () => {
                openedContactPerson = contactPerson;
                // Open contact person details
                document.getElementById('main_dialog_contact_person_edit_delete').style.display = 'flex';
                document.getElementById('main_dialog_contact_person_edit_delete_step2').style.display = 'none';
                document.getElementById('main_dialog_contact_person_edit_name').value = contactPerson.name;
                document.getElementById('main_dialog_contact_person_edit_email').value = contactPerson.email;
                document.getElementById('main_dialog_contact_person_edit_phone').value = contactPerson.phone;
                document.getElementById('main_dialog_contact_person_edit_observations').value = contactPerson.observations || '';
                document.getElementById('main_dialog_contact_person_edit_save').setAttribute('disabled', 'true');
                document.getElementById('main_dialog_subcustomer_details').close();
                document.getElementById('main_dialog_contact_person_edit').show();
            });
            document.getElementById('main_dialog_subcustomer_details_contact_persons').appendChild(item);
        });
    } else {
        document.getElementById('main_dialog_subcustomer_details_contact_persons').style.display = 'none';
        document.getElementById('main_dialog_subcustomer_details_contact_persons_empty').style.display = 'block';
    }
}

function checkContactPersonEdit() {
    let name = document.getElementById('main_dialog_contact_person_edit_name').value;
    let email = document.getElementById('main_dialog_contact_person_edit_email').value;
    let phone = document.getElementById('main_dialog_contact_person_edit_phone').value;
    let observations = document.getElementById('main_dialog_contact_person_edit_observations').value;
    if (name != openedContactPerson.name || email != openedContactPerson.email || phone != openedContactPerson.phone || observations != openedContactPerson.observations) {
        document.getElementById('main_dialog_contact_person_edit_save').removeAttribute('disabled');
    } else {
        document.getElementById('main_dialog_contact_person_edit_save').setAttribute('disabled', 'true');
    }
}

document.getElementById('main_dialog_contact_person_edit_close').addEventListener('click', () => {
    document.getElementById('main_dialog_contact_person_edit').close();
    openSubCustomerDetails(openedSubcustomer);
});

document.getElementById('main_dialog_contact_person_edit_save').addEventListener('click', () => {
    let subcustomer = document.getElementById('main_dialog_subcustomer_details_name_title').innerText;
    let newContactPerson = {
        name: document.getElementById('main_dialog_contact_person_edit_name').value,
        email: document.getElementById('main_dialog_contact_person_edit_email').value,
        phone: document.getElementById('main_dialog_contact_person_edit_phone').value,
        observations: document.getElementById('main_dialog_contact_person_edit_observations').value
    };
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/updateContactPerson', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                subcustomer,
                contactPerson: openedContactPerson,
                newContactPerson,
                customer: openedSubcustomerParentCustomer || ''
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_updating_contact_person');
                } else {
                    console.log('Contact person updated successfully');
                    openedContactPerson = newContactPerson;
                    document.getElementById('main_dialog_contact_person_edit').close();
                    openSubCustomerDetails(subcustomer, openedSubcustomerParentCustomer);
                }
            })
            .catch((error) => {
                console.error('Error updating contact person', error);
                showError('error', 'error_updating_contact_person');
            });
    });
});

document.getElementById('main_dialog_contact_person_edit_name').addEventListener('input', () => {
    checkContactPersonEdit();
});

document.getElementById('main_dialog_contact_person_edit_email').addEventListener('input', () => {
    checkContactPersonEdit();
});

document.getElementById('main_dialog_contact_person_edit_phone').addEventListener('input', () => {
    checkContactPersonEdit();
});

document.getElementById('main_dialog_contact_person_edit_observations').addEventListener('input', () => {
    checkContactPersonEdit();
});

document.getElementById('main_dialog_contact_person_edit_delete').addEventListener('click', () => {
    document.getElementById('main_dialog_contact_person_edit_delete').style.display = 'none';
    document.getElementById('main_dialog_contact_person_edit_delete_step2').style.display = 'flex';
    let currentEdit = openedContactPerson;
    setTimeout(() => {
        if (currentEdit === openedContactPerson) {
            document.getElementById('main_dialog_contact_person_edit_delete').style.display = 'flex';
            document.getElementById('main_dialog_contact_person_edit_delete_step2').style.display = 'none';
        }
    }, 5000);
});

document.getElementById('main_dialog_contact_person_edit_delete_step2').addEventListener('click', () => {
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/deleteContactPerson', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                subcustomer: openedSubcustomer,
                contactPerson: openedContactPerson,
                customer: openedSubcustomerParentCustomer || ''
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_deleting_contact_person');
                } else {
                    console.log('Contact person deleted successfully');
                    document.getElementById('main_dialog_contact_person_edit').close();
                    openSubCustomerDetails(openedSubcustomer, openedSubcustomerParentCustomer);
                }
            })
            .catch((error) => {
                console.error('Error deleting contact person', error);
                showError('error', 'error_deleting_contact_person');
            });
    });
});

function trimText(text, length) {
    if (text.length > length) {
        return text.substring(0, length) + '...';
    }
    return text;
}

document.getElementById('main_dialog_subcustomer_details_close').addEventListener('click', () => {
    document.getElementById('main_dialog_subcustomer_details').close();
});

document.getElementById('main_dialog_subcustomer_details_save').addEventListener('click', () => {
    let subcustomer = document.getElementById('main_dialog_subcustomer_details_name_title').innerText;
    let notes = document.getElementById('main_dialog_subcustomer_details_observations').value;
    let customer = customerData.subcustomers[subcustomer] || {};
    customer.notes = notes;
    customerData.subcustomers[subcustomer] = customer;
    updateCustomerData();
    document.getElementById('main_dialog_subcustomer_details').close();
});

function updateCustomerData() {
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/updateCustomerData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                customerData,
                customer: openedSubcustomerParentCustomer || ''
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_updating_customer_data');
                } else {
                    console.log('Customer data updated successfully');
                }
            })
            .catch((error) => {
                console.error('Error updating customer data', error);
                showError('error', 'error_updating_customer_data');
            });
    })
        .catch((error) => {
            console.error('Error getting token', error);
        });
}



function genFormattedText(product) {
    let providerName = providers.find(provider => provider.id === product.provider).name;
    let text = '';
    text += langDataLocal['product'] + ': ' + product.name + '\n';
    text += langDataLocal['details'] + ':\n' + getProductDetails(product) + '\n\n';
    text += langDataLocal['manufacturer'] + ': ' + providerName + '\n';
    text += langDataLocal['subproducts'] + ':\n';
    getProductLines(product).forEach((line) => {
        text += `- ${line.name}`;
        if (line.version) {
            text += ` · ${langDataLocal['version']}: ${line.version}`;
        }
        text += ` · ${line.units} ${langDataLocal['units'].toLowerCase()}`;
        if (!isSubcustomer && !product.externalCustomerView) {
            text += ` · ${formatProductPrice(parseProductNumber(line.price) || 0)} / ${langDataLocal['unit'].toLowerCase()}`;
        }
        text += '\n';
    });
    if (!isSubcustomer && !product.externalCustomerView) {
        text += `${langDataLocal['total']}: ${formatProductPrice(getProductTotal(product))}\n`;
    }
    text += langDataLocal['status'] + ': ' + langDataLocal[product.status] + '\n';
    text += langDataLocal['managed_by'] + ': ' + product.managedBy + '\n\n';
    text += langDataLocal['start'] + ': ' + moment(product.contractStart).format('DD-MM-YYYY') + '\n';
    text += langDataLocal['expiry_date'] + ': ' + moment(product.expires).format('DD-MM-YYYY') + '\n';
    text += langDataLocal['duration'] + ': ' + millisecondsToRelativeTime(product.contractDuration) + '\n\n';
    text += langDataLocal['notes'] + ':\n' + product.notes + '\n\n';
    text += langDataLocal['licenses'] + ':\n' + product.licenses + '\n\n';
    if (product.customerNotes) {
        text += langDataLocal['client_observations'] + ':\n' + product.customerNotes + '\n\n';
    }
    return text;
}

document.getElementById('main_dialog_product_details_copy_button').addEventListener('click', () => {
    // Get product by id
    let product = products.find(product => product.id === openedProduct);

    if (product) {
        let text = genFormattedText(product);

        // Copy to clipboard
        navigator.clipboard.writeText(text).then(() => {

        }).catch((error) => {
            showError('error', 'error_copying_to_clipboard');
        });
    }
});

document.getElementById('main_dialog_product_details_mail_button').addEventListener('click', () => {
    // Get product by id
    let product = products.find(product => product.id === openedProduct);

    if (product) {
        let text = genFormattedText(product);

        // Open mailto in new tab
        window.open('mailto:?subject=' + product.subcustomer + ' - ' + product.name + '&body=' + encodeURIComponent(text));
    }
});

document.getElementById('main_dialog_product_details_calendar_button').addEventListener('click', () => {
    let product = products.find(product => product.id === openedProduct);
    if (product) {
        let customerName = product.customer;
        if (isAdmin) {
            const customer = customersAdmin.find(c => c.id === product.customer);
            if (customer) {
                customerName = customer.name;
            }
        }
        const subcustomerName = product.subcustomer;
        const eventTitle = `[Customer Portal] - ${customerName} - ${subcustomerName}`;
        const url = `${window.location.origin}?product=${product.id}`;
        const calendarUrl = 'https://calendar.google.com/calendar/u/0/r/eventedit?text=' +
            encodeURIComponent(eventTitle) +
            '&details=' + encodeURIComponent(url);
        window.open(calendarUrl, '_blank');
    }
});


document.getElementById('main_dialog_product_details_manage_product').addEventListener('click', () => {
    if (!openedProduct) {
        return;
    }
    document.getElementById('main_dialog_product_details').close();
    document.getElementById('main_dialog_manage_product').show();
    closeAllManageProductsCards();
    document.getElementById('main_dialog_manage_product_others_text').value = '';
    let product = products.find(product => product.id === openedProduct);
    document.getElementById('main_dialog_manage_product_name').innerHTML = product.name || '';
    document.getElementById('main_dialog_manage_product_send').setAttribute('disabled', 'true');
    let intro_message = '';
    if (auth.currentUser.displayName) {
        intro_message = auth.currentUser.displayName + ', ' + langDataLocal['what_can_we_help_you_with_today'];
    } else {
        intro_message = langDataLocal['what_can_we_help_you_with_today'];
    }
    // Start with uppercase
    intro_message = intro_message.charAt(0).toUpperCase() + intro_message.slice(1);
    document.getElementById('main_dialog_manage_product_introduction').innerHTML = intro_message;
});

document.getElementById('main_dialog_manage_product_others_text').addEventListener('input', () => {
    if (document.getElementById('main_dialog_manage_product_others_text').value) {
        document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
    } else {
        document.getElementById('main_dialog_manage_product_send').setAttribute('disabled', 'true');
    }
});

document.getElementById('main_dialog_manage_product_request_cancel_confirmation').addEventListener('change', () => {
    let product = products.find(product => product.id === openedProduct);
    if (document.getElementById('main_dialog_manage_product_request_cancel_confirmation').checked && document.getElementById('main_dialog_manage_product_request_cancel_text_copied').value == product.name) {
        document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
    } else {
        document.getElementById('main_dialog_manage_product_send').setAttribute('disabled', 'true');
    }
});

document.getElementById('main_dialog_manage_product_request_cancel_text_copied').addEventListener('input', () => {
    let product = products.find(product => product.id === openedProduct);
    if (document.getElementById('main_dialog_manage_product_request_cancel_confirmation').checked && document.getElementById('main_dialog_manage_product_request_cancel_text_copied').value == product.name) {
        document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
    } else {
        document.getElementById('main_dialog_manage_product_send').setAttribute('disabled', 'true');
    }
});

function closeAllManageProductsCards() {
    document.getElementById('main_dialog_manage_product_request_quote_div').style.display = 'none';
    // document.getElementById('main_dialog_manage_product_request_renewal_div').style.display = 'none';
    document.getElementById('main_dialog_manage_product_auto_renewal_div').style.display = 'none';
    document.getElementById('main_dialog_manage_product_request_cancel_div').style.display = 'none';
    document.getElementById('main_dialog_manage_product_others_div').style.display = 'none';
    document.getElementById('main_dialog_manage_product_send').setAttribute('disabled', 'true');
}

document.getElementById('main_dialog_manage_product_request_quote').addEventListener('click', (e) => {
    e.preventDefault();
    closeAllManageProductsCards();
    document.getElementById('main_dialog_manage_product_request_quote_div').style.display = 'block';
    document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
});

// document.getElementById('main_dialog_manage_product_request_renewal').addEventListener('click', (e) => {
//     e.preventDefault();
//     closeAllManageProductsCards();
//     document.getElementById('main_dialog_manage_product_request_renewal_div').style.display = 'block';
// });

document.getElementById('main_dialog_manage_product_auto_renewal').addEventListener('click', (e) => {
    e.preventDefault();
    closeAllManageProductsCards();
    document.getElementById('main_dialog_manage_product_auto_renewal_div').style.display = 'block';
    let product = products.find(product => product.id === openedProduct);
    const productLines = getProductLines(product);
    const productTotal = getProductTotal(product);
    document.getElementById('main_dialog_manage_product_auto_renewal_toggle').checked = product.autoRenewal || false;
    document.getElementById('main_dialog_manage_product_auto_renewal_percentage').value = (product.autoRenewalPercent || 0) + '%' || '0%';
    document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
    document.getElementById('main_dialog_manage_product_auto_renewal_last_price').innerHTML = langDataLocal['last_price'] + ': ' + formatProductPrice(productTotal) + ' (' + langDataLocal['without_iva'] + ')';
    document.getElementById('main_dialog_manage_product_auto_renewal_between_prices').innerHTML = langDataLocal['renews_if_price_is_less_or_equal_than'] + ': ' + formatProductPrice(calculateRenwalPricePercentage(productTotal, product.autoRenewalPercent));
    let historyList = document.getElementById('main_dialog_manage_product_auto_renewal_list');
    historyList.innerHTML = '';
    let item0 = document.createElement('md-list-item');
    let mainDiv0 = document.createElement('div');
    mainDiv0.classList.add('renewal-history-item');
    mainDiv0.classList.add('header');
    let itemRenewalDate0 = document.createElement('span');
    itemRenewalDate0.style.textAlign = 'left';
    itemRenewalDate0.innerText = langDataLocal['date'];
    mainDiv0.appendChild(itemRenewalDate0);
    let itemPrice0 = document.createElement('span');
    itemPrice0.style.textAlign = 'center';
    itemPrice0.innerText = langDataLocal['price_per_unit'];
    mainDiv0.appendChild(itemPrice0);
    let itemUnits0 = document.createElement('span');
    itemUnits0.style.textAlign = 'center';
    itemUnits0.innerText = langDataLocal['units'];
    mainDiv0.appendChild(itemUnits0);
    let itemTotal0 = document.createElement('span');
    itemTotal0.style.textAlign = 'center';
    itemTotal0.innerText = langDataLocal['total'];
    mainDiv0.appendChild(itemTotal0);
    let itemPercentage0 = document.createElement('span');
    itemPercentage0.style.textAlign = 'right';
    itemPercentage0.innerText = langDataLocal['percentage'];
    mainDiv0.appendChild(itemPercentage0);
    item0.appendChild(mainDiv0);
    historyList.appendChild(item0);
    let item1 = document.createElement('md-list-item');
    let mainDiv1 = document.createElement('div');
    mainDiv1.classList.add('renewal-history-item');
    let itemRenewalDate1div = document.createElement('div');
    itemRenewalDate1div.style.display = 'flex';
    itemRenewalDate1div.style.flexDirection = 'column';
    let itemRenewalDate1 = document.createElement('span');
    itemRenewalDate1.style.textAlign = 'left';
    itemRenewalDate1.innerText = moment(product.contractStart).format('DD/MM/YYYY');
    itemRenewalDate1div.appendChild(itemRenewalDate1);
    let itemRenewalDate1sub = document.createElement('span');
    itemRenewalDate1sub.style.textAlign = 'left';
    itemRenewalDate1sub.innerText = ' - ' + moment(product.expires).format('DD/MM/YYYY');
    itemRenewalDate1sub.classList.add('sub');
    itemRenewalDate1div.appendChild(itemRenewalDate1sub);
    mainDiv1.appendChild(itemRenewalDate1div);
    let itemPrice1 = document.createElement('span');
    itemPrice1.style.textAlign = 'center';
    itemPrice1.innerText = productLines.length === 1 ? formatProductPrice(parseProductNumber(productLines[0].price) || 0) : '-';
    mainDiv1.appendChild(itemPrice1);
    let itemUnits1 = document.createElement('span');
    itemUnits1.style.textAlign = 'center';
    itemUnits1.innerText = productLines.length === 1 ? productLines[0].units : productLines.length + ' ' + langDataLocal['subproducts'].toLowerCase();
    mainDiv1.appendChild(itemUnits1);
    let itemTotal1 = document.createElement('span');
    itemTotal1.style.textAlign = 'center';
    itemTotal1.innerText = formatProductPrice(productTotal);
    mainDiv1.appendChild(itemTotal1);
    let itemPercentage1 = document.createElement('span');
    itemPercentage1.style.textAlign = 'right';
    if (product.history) {
        if (product.history[0]) {
            let calc1 = calculatePercentageFromHistory(productTotal, getProductTotal(product.history[0]));
            if (calc1) {
                if (String(calc1).substring(0, 1) === '-') {
                    itemPercentage1.innerText = calc1.toFixed(2) + ' %';
                } else {
                    itemPercentage1.innerText = '+' + calc1.toFixed(2) + ' %';
                }
            }
        } else {
            itemPercentage1.innerText = '- %';
        }
    } else {
        itemPercentage1.innerText = '- %';
    }
    mainDiv1.appendChild(itemPercentage1);
    item1.appendChild(mainDiv1);
    historyList.appendChild(item1);
    let itemDivider = document.createElement('md-divider');
    historyList.appendChild(itemDivider);
    if (product.history) {
        product.history.forEach((history, index) => {
            const historyLines = getProductLines(history);
            const historyTotal = getProductTotal(history);
            let item = document.createElement('md-list-item');
            let mainDiv = document.createElement('div');
            mainDiv.classList.add('renewal-history-item');
            let itemRenewalDateDiv = document.createElement('div');
            itemRenewalDateDiv.style.display = 'flex';
            itemRenewalDateDiv.style.flexDirection = 'column';
            let itemRenewalDate = document.createElement('span');
            itemRenewalDate.style.textAlign = 'left';
            itemRenewalDate.innerText = moment(history.contractStart).format('DD/MM/YYYY');
            let itemRenewalDateSub = document.createElement('span');
            itemRenewalDateSub.style.textAlign = 'left';
            itemRenewalDateSub.innerText = ' - ' + moment(history.expires).format('DD/MM/YYYY');
            itemRenewalDateSub.classList.add('sub');
            itemRenewalDateDiv.appendChild(itemRenewalDate);
            itemRenewalDateDiv.appendChild(itemRenewalDateSub);
            mainDiv.appendChild(itemRenewalDateDiv);
            let itemPrice = document.createElement('span');
            itemPrice.style.textAlign = 'center';
            itemPrice.innerText = historyLines.length === 1 ? formatProductPrice(parseProductNumber(historyLines[0].price) || 0) : '-';
            mainDiv.appendChild(itemPrice);
            let itemUnits = document.createElement('span');
            itemUnits.style.textAlign = 'center';
            itemUnits.innerText = historyLines.length === 1 ? historyLines[0].units : historyLines.length + ' ' + langDataLocal['subproducts'].toLowerCase();
            mainDiv.appendChild(itemUnits);
            let itemTotal = document.createElement('span');
            itemTotal.style.textAlign = 'center';
            itemTotal.innerText = formatProductPrice(historyTotal);
            mainDiv.appendChild(itemTotal);
            let itemPercentage = document.createElement('span');
            itemPercentage.style.textAlign = 'right';
            if (index < product.history.length - 1) {
                let calc = calculatePercentageFromHistory(historyTotal, getProductTotal(product.history[index + 1]));
                if (calc) {
                    if (String(calc).substring(0, 1) === '-') {
                        itemPercentage.innerText = calc.toFixed(2) + ' %';
                    } else {
                        itemPercentage.innerText = '+' + calc.toFixed(2) + ' %';
                    }
                }
            }
            mainDiv.appendChild(itemPercentage);
            item.appendChild(mainDiv);
            historyList.appendChild(item);
            if (index < product.history.length - 1) {
                let itemDivider = document.createElement('md-divider');
                historyList.appendChild(itemDivider);
            }
        })
    }
});

function calculatePercentageFromHistory(currentPrice, previousPrice) {
    if (!currentPrice || !previousPrice) {
        return null;
    }
    return ((Number(currentPrice) - Number(previousPrice)) / Number(previousPrice)) * 100;
}

function calculateRenwalPricePercentage(currentPrice, percentage) {
    if (!currentPrice) {
        return 0;
    }
    if (percentage === 0 || !percentage) {
        return currentPrice;
    }
    return Number(currentPrice) + (Number(currentPrice) * (Number(percentage) / 100));
}

document.getElementById('main_dialog_manage_product_auto_renewal_percentage').addEventListener('input', (e) => {
    let f = document.getElementById('main_dialog_manage_product_auto_renewal_percentage');
    f.value = f.value.replace(/[^\d\.]/g, '') + '%';
    let end = f.value.length;
    f.setSelectionRange(end, end - 1);
    f.focus();
    let product = products.find(product => product.id === openedProduct);
    document.getElementById('main_dialog_manage_product_auto_renewal_between_prices').innerHTML = langDataLocal['renews_if_price_is_less_or_equal_than'] + ': ' + formatProductPrice(calculateRenwalPricePercentage(getProductTotal(product), document.getElementById('main_dialog_manage_product_auto_renewal_percentage').value.replace(/[^\d\.]/g, '')));
});

document.getElementById('main_dialog_manage_product_auto_renewal_toggle').addEventListener('change', (e) => {
    document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
});

document.getElementById('main_dialog_manage_product_request_cancel').addEventListener('click', (e) => {
    e.preventDefault();
    closeAllManageProductsCards();
    document.getElementById('main_dialog_manage_product_request_cancel_div').style.display = 'block';
    document.getElementById('main_dialog_manage_product_request_cancel_confirmation').checked = false;
    let product = products.find(product => product.id === openedProduct);
    document.getElementById('main_dialog_manage_product_request_cancel_text_to_copy').innerHTML = langDataLocal['copy_this_text'] + ':<br><br><b>' + product.name + '</b>';
    document.getElementById('main_dialog_manage_product_request_cancel_text_copied').value = '';
});

document.getElementById('main_dialog_manage_product_others').addEventListener('click', (e) => {
    e.preventDefault();
    closeAllManageProductsCards();
    document.getElementById('main_dialog_manage_product_others_div').style.display = 'block';
    if (document.getElementById('main_dialog_manage_product_others_text').value !== '') {
        document.getElementById('main_dialog_manage_product_send').removeAttribute('disabled');
    }
});


document.getElementById('main_dialog_manage_product_send').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.getElementById('main_dialog_manage_product_others_div').style.display == 'block') {
        let message = document.getElementById('main_dialog_manage_product_others_text').value;
        if (!message || message === '') {
            return;
        }
        let product = openedProduct;
        let date = new Date().getTime();
        let user = auth.currentUser.uid;
        let messageObject = {
            message,
            product,
            date,
            user,
            origin: 'customer',
            destination: 'admin',
            type: 'other'
        };
        let messagesRef = collection(db, 'messages');
        addDoc(messagesRef, messageObject).then((docRef) => {
            console.log('Message sent successfully', docRef.id);
            document.getElementById('main_dialog_manage_product').close();
            showMessage('success', 'message_sent_successfully');
        }).catch((error) => {
            console.error('Error sending message', error);
            showError('error', 'error_sending_message');
        });
    } else if (document.getElementById('main_dialog_manage_product_request_quote_div').style.display == 'block') {
        let product = openedProduct;
        let date = new Date().getTime();
        let user = auth.currentUser.uid;
        let messageObject = {
            message: document.getElementById('main_dialog_manage_product_request_quote_text').value || '',
            product,
            date,
            user,
            origin: 'customer',
            destination: 'admin',
            type: 'quote'
        };
        let messagesRef = collection(db, 'messages');
        addDoc(messagesRef, messageObject).then((docRef) => {
            console.log('Message sent successfully', docRef.id);
            document.getElementById('main_dialog_manage_product').close();
            showMessage('success', 'quote_request_sent_successfully');
        }).catch((error) => {
            console.error('Error sending message', error);
            showError('error', 'error_sending_message');
        });
    } else if (document.getElementById('main_dialog_manage_product_auto_renewal_div').style.display == 'block') {
        let product = openedProduct;
        console.log(product);
        // Update product doc and modify autoRenewal
        let autoRenewalVal = document.getElementById('main_dialog_manage_product_auto_renewal_toggle').checked;
        let autoRenewalPercent = document.getElementById('main_dialog_manage_product_auto_renewal_percentage').value.replace(/[^\d\.]/g, '') || 0;
        updateDoc(doc(db, 'products', openedProduct), {
            autoRenewal: autoRenewalVal,
            autoRenewalPercent: Number(autoRenewalPercent) || 0
        }).then(() => {
            console.log('AutoRenewal updated successfully');
            document.getElementById('main_dialog_manage_product').close();
            // Repoen product details
            // Get product by id
            let product = products.find(product => product.id === openedProduct);
            if (product) {
                product.autoRenewal = autoRenewalVal;
            }
            // if (product) {
            //     openProductDetails(product);
            // }
            if (autoRenewalVal) {
                showMessage('success', 'auto_renewal_enabled_successfully');
            } else {
                showMessage('success', 'auto_renewal_disabled_successfully');
            }
        }).catch((error) => {
            console.error('Error updating autoRenewal', error);
            showError('error', 'error_updating_auto_renewal');
        });
    } else if (document.getElementById('main_dialog_manage_product_request_cancel_div').style.display == 'block') {
        let product = openedProduct;
        let date = new Date().getTime();
        let user = auth.currentUser.uid;
        let messageObject = {
            product,
            date,
            user,
            origin: 'customer',
            destination: 'admin',
            type: 'cancel'
        };
        let messagesRef = collection(db, 'messages');
        addDoc(messagesRef, messageObject).then((docRef) => {
            console.log('Message sent successfully', docRef.id);
            document.getElementById('main_dialog_manage_product').close();
            showMessage('success', 'cancel_request_sent_successfully');
        }).catch((error) => {
            console.error('Error sending message', error);
            showError('error', 'error_sending_message');
        });
    }
});


document.getElementById('main_dialog_manage_product_close').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_product').close();
    // Repoen product details
    // Get product by id
    let product = products.find(product => product.id === openedProduct);
    if (product) {
        openProductDetails(product);
    } else {
        showError('error', 'an_error_has_occurred');
    }
});




// document.getElementById('main_dialog_message_from_product_send').addEventListener('click', () => {
//     let message = document.getElementById('main_dialog_message_from_product_text').value;
//     if (!message) {
//         return;
//     }
//     let product = openedProduct;
//     let date = new Date().getTime();
//     let user = auth.currentUser.uid;
//     let messageObject = {
//         message,
//         product,
//         date,
//         user,
//         origin: 'customer',
//         destination: 'admin'
//     };
//     let messagesRef = collection(db, 'messages');
//     addDoc(messagesRef, messageObject).then((docRef) => {
//         console.log('Message sent successfully', docRef.id);
//         document.getElementById('main_dialog_send_message_from_product').close();
//         showMessage('success', 'message_sent_successfully');
//     }).catch((error) => {
//         console.error('Error sending message', error);
//         showError('error', 'error_sending_message');
//     });
// });

document.getElementById('main__content__card__my_products__expand').addEventListener('click', () => {
    // Expand or collapse all products in the list
    let headers = document.querySelectorAll('.listHeader');
    let expand = document.getElementById('main__content__card__my_products__expand');
    if (expand.getAttribute('expanded') === 'false') {
        expand.getElementsByTagName('md-icon')[0].innerText = 'unfold_less';
        headers.forEach((header) => {
            let next = header.nextElementSibling;
            while (next && !next.classList.contains('listHeader')) {
                next.style.display = 'flex';
                next = next.nextElementSibling;
            }
            // Set icon to expand_less
            header.querySelector('md-icon').innerText = 'expand_less';
            header.classList.remove('eLess');
        });
        expand.setAttribute('expanded', 'true');
    } else {
        expand.getElementsByTagName('md-icon')[0].innerText = 'unfold_more';
        headers.forEach((header) => {
            let next = header.nextElementSibling;
            while (next && !next.classList.contains('listHeader')) {
                next.style.display = 'none';
                next = next.nextElementSibling;
            }
            // Set icon to expand_more
            header.querySelector('md-icon').innerText = 'expand_more';
            header.classList.add('eLess');
        });
        expand.setAttribute('expanded', 'false');
    }
});

document.getElementById('main_dialog_product_details_history_warn_button').addEventListener('click', (e) => {
    e.preventDefault();
    console.log(openedProduct)
    let p = products.find(p => p.id === openedProduct);
    console.log(p)
    if (p) {
        openProductDetails(p);
    } else {
        showError('error', 'an_error_has_occurred');
    }
});

function getOpenedProductHistoryEntry() {
    return adminGetProduct(openedProduct)?.history?.[openedProductHistoryIndex] || null;
}

document.getElementById('main_dialog_product_details_history_edit').addEventListener('click', (event) => {
    event.preventDefault();
    if (!isAdmin || !getOpenedProductHistoryEntry()) {
        showError('error', 'an_error_has_occurred');
        return;
    }
    openEditProduct(openedProduct, openedProductHistoryIndex);
});

document.getElementById('main_dialog_product_details_history_delete').addEventListener('click', (event) => {
    event.preventDefault();
    const history = getOpenedProductHistoryEntry();
    if (!isAdmin || !history) {
        showError('error', 'an_error_has_occurred');
        return;
    }
    const date = moment(history.contractStart);
    const template = langDataLocal['confirm_delete_historical_renewal'] || 'Delete the renewal dated {date} permanently? This action cannot be undone.';
    document.getElementById('main_dialog_product_history_delete_confirm_text').innerText = template.replace('{date}', date.isValid() ? date.format('DD/MM/YYYY') : '-');
    document.getElementById('main_dialog_product_history_delete_confirm').show();
});

document.getElementById('main_dialog_product_history_delete_cancel').addEventListener('click', () => {
    document.getElementById('main_dialog_product_history_delete_confirm').close();
});

document.getElementById('main_dialog_product_history_delete_confirm_button').addEventListener('click', async () => {
    const product = adminGetProduct(openedProduct);
    if (!isAdmin || !product?.history?.[openedProductHistoryIndex]) {
        document.getElementById('main_dialog_product_history_delete_confirm').close();
        showError('error', 'an_error_has_occurred');
        return;
    }
    const button = document.getElementById('main_dialog_product_history_delete_confirm_button');
    button.setAttribute('disabled', 'true');
    try {
        await updateDoc(doc(db, 'products', openedProduct), {
            history: removeProductHistoryEntry(product.history, openedProductHistoryIndex)
        });
        await refetchProduct(openedProduct);
        document.getElementById('main_dialog_product_history_delete_confirm').close();
        document.getElementById('main_dialog_product_details').close();
        showMessage('success', 'historical_renewal_deleted');
    } catch (error) {
        console.error('Error deleting historical renewal: ', error);
        showError('error', 'error_deleting_historical_renewal');
    } finally {
        button.removeAttribute('disabled');
    }
});

document.getElementById('main_dialog_my_profile_manage_users').addEventListener('click', () => {
    openManageUsers();
});

function openManageUsers() {
    document.getElementById('main_dialog_manage_users').show();
    document.getElementById('main_dialog_manage_users_progress').style.display = 'flex';
    document.getElementById('main_dialog_manage_users_content').style.display = 'none';
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/users?token=' + token)
            .then(res => res.json())
            .then(res => {
                document.getElementById('main_dialog_manage_users_progress').style.display = 'none';
                document.getElementById('main_dialog_manage_users_content').style.display = 'block';
                document.getElementById('main_dialog_manage_users_list_company').innerHTML = '';
                document.getElementById('main_dialog_manage_users_list_clients').innerHTML = '';
                let companyHeader = document.createElement('md-list-item');
                companyHeader.classList.add('user');
                let companyHeaderMainDiv = document.createElement('div');
                let companyHeaderRightDiv = document.createElement('div');
                companyHeaderRightDiv.classList.add('user-right');
                let span1 = document.createElement('span');
                span1.innerText = langDataLocal['enabled'];
                companyHeaderRightDiv.appendChild(span1);
                let span2 = document.createElement('span');
                span2.innerText = langDataLocal['admin'];
                companyHeaderRightDiv.appendChild(span2);
                let span3 = document.createElement('span');
                span3.innerText = langDataLocal['edit'];
                companyHeaderRightDiv.appendChild(span3);
                let companyHeaderLeftDiv = document.createElement('div');
                companyHeaderLeftDiv.classList.add('user-left');
                let span4 = document.createElement('span');
                span4.innerText = langDataLocal['name'];
                companyHeaderLeftDiv.appendChild(span4);
                companyHeaderMainDiv.appendChild(companyHeaderLeftDiv);
                companyHeaderMainDiv.appendChild(companyHeaderRightDiv);
                companyHeader.appendChild(companyHeaderMainDiv);

                let clientsHeader = document.createElement('md-list-item');
                clientsHeader.classList.add('user');
                let clientsHeaderMainDiv = document.createElement('div');
                let clientsHeaderRightDiv = document.createElement('div');
                clientsHeaderRightDiv.classList.add('user-right');
                let span5 = document.createElement('span');
                span5.innerText = langDataLocal['enabled'];
                clientsHeaderRightDiv.appendChild(span5);
                let span6 = document.createElement('span');
                span6.innerText = langDataLocal['edit'];
                clientsHeaderRightDiv.appendChild(span6);
                let clientsHeaderLeftDiv = document.createElement('div');
                clientsHeaderLeftDiv.classList.add('user-left');
                let span7 = document.createElement('span');
                span7.innerText = langDataLocal['name'];
                clientsHeaderLeftDiv.appendChild(span7);
                clientsHeaderMainDiv.appendChild(clientsHeaderLeftDiv);
                clientsHeaderMainDiv.appendChild(clientsHeaderRightDiv);
                clientsHeader.appendChild(clientsHeaderMainDiv);

                res.forEach(user => {
                    if (user.subcustomer === undefined) {
                        document.getElementById('main_dialog_manage_users_list_company').appendChild(renderUser(user));
                    } else {
                        document.getElementById('main_dialog_manage_users_list_clients').appendChild(renderUser(user));
                    }
                });

                // Check if there are no users in any of the lists
                if (document.getElementById('main_dialog_manage_users_list_company').innerHTML === '') {
                    document.getElementById('main_dialog_manage_users_list_company').innerHTML = '<span style="text-align: center;">' + langDataLocal['no_users'] + '</span>';
                } else {
                    document.getElementById('main_dialog_manage_users_list_company').prepend(document.createElement('md-divider'));
                    document.getElementById('main_dialog_manage_users_list_company').prepend(companyHeader);
                }
                if (document.getElementById('main_dialog_manage_users_list_clients').innerHTML === '') {
                    document.getElementById('main_dialog_manage_users_list_clients').innerHTML = '<span style="text-align: center;">' + langDataLocal['no_users'] + '</span>';
                } else {
                    document.getElementById('main_dialog_manage_users_list_clients').prepend(document.createElement('md-divider'));
                    document.getElementById('main_dialog_manage_users_list_clients').prepend(clientsHeader);
                }
            })
            .catch(err => {
                console.error(err);
            });
    })
        .catch((error) => {
            console.error('Error getting token', error);
        });
}

let add_user_type = '';
let editingCustomerId = null;

document.getElementById('main_dialog_manage_users_add').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users').close();
    document.getElementById('main_dialog_manage_users_add_user').show();
    editingFromAdmin = false;
    editingCustomerId = null;
});

document.getElementById('main_dialog_customer_details_users_add').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users_add_user').show();
    editingFromAdmin = true;
    document.getElementById('main_dialog_manage_users_add_user_name').value = '';
    document.getElementById('main_dialog_manage_users_add_user_email').value = '';
    document.getElementById('main_dialog_manage_users_add_user__company_admin').checked = false;
});

document.getElementById('main_dialog_manage_users_close').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users').close();
});

document.getElementById('main_dialog_manage_users_add_user_close').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users_add_user').close();
    if (!editingFromAdmin) {
        openManageUsers();
    }
});

document.getElementById('main_dialog_manage_users_add_user__chipset__company').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users_add_user__chipset__company').setAttribute('selected', 'true');
    document.getElementById('main_dialog_manage_users_add_user__chipset__client').removeAttribute('selected');
    document.getElementById('main_dialog_manage_users_add_user__company').style.display = 'block';
    document.getElementById('main_dialog_manage_users_add_user__client').style.display = 'none';
    add_user_type = 'company';
});

document.getElementById('main_dialog_manage_users_add_user__chipset__client').addEventListener('click', () => {
    document.getElementById('main_dialog_manage_users_add_user__chipset__company').removeAttribute('selected');
    document.getElementById('main_dialog_manage_users_add_user__chipset__client').setAttribute('selected', 'true');
    document.getElementById('main_dialog_manage_users_add_user__client').style.display = 'block';
    document.getElementById('main_dialog_manage_users_add_user__company').style.display = 'none';
    document.getElementById('main_dialog_manage_users_add_user__client_select').innerHTML = '';
    add_user_type = 'client';
    let subcustomers = [];
    if (!editingFromAdmin) {
        products.forEach(product => {
            if (product.subcustomer && !subcustomers.includes(product.subcustomer)) {
                subcustomers.push(product.subcustomer);
            }
        });
    } else {
        products.forEach(product => {
            if (product.customer === editingCustomerId && product.subcustomer && !subcustomers.includes(product.subcustomer)) {
                subcustomers.push(product.subcustomer);
            }
        });
    }
    subcustomers.forEach((subcustomer, index) => {
        let option = document.createElement('md-select-option');
        option.value = subcustomer;
        option.innerText = subcustomer;
        document.getElementById('main_dialog_manage_users_add_user__client_select').appendChild(option);
    });
});

document.getElementById('main_dialog_manage_users_add_user_save').addEventListener('click', () => {
    let email = document.getElementById('main_dialog_manage_users_add_user_email').value;
    let name = document.getElementById('main_dialog_manage_users_add_user_name').value;
    let lang = document.getElementById('main_dialog_manage_users_add_user_language').value;
    let user = {};
    if (add_user_type === 'company') {
        user.admin = document.getElementById('main_dialog_manage_users_add_user__company_admin').checked;
    } else if (add_user_type === 'client') {
        if (document.getElementById('main_dialog_manage_users_add_user__client_select').value === '') {
            showError('error', 'select_a_client');
            return;
        }
        user.subcustomer = document.getElementById('main_dialog_manage_users_add_user__client_select').value;
    } else {
        showError('error', 'error_adding_user');
        return;
    }
    if (!email || !name) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!editingFromAdmin) {
        addUser(email, name, user.admin, user.subcustomer, lang);
    } else {
        addUser(email, name, user.admin, user.subcustomer, lang, editingCustomerId);
    }
});

function renderUser(user, managingFromAdmin, customerId) {
    let item = document.createElement('md-list-item');
    item.classList.add('user');
    let mainDiv = document.createElement('div');
    let divLeft = document.createElement('div');
    divLeft.classList.add('user-left');
    divLeft.style.display = 'flex';
    divLeft.style.flexDirection = 'row';
    divLeft.style.justifyContent = 'flex-start';
    divLeft.style.alignItems = 'center';
    let divRight = document.createElement('div');
    divRight.classList.add('user-right');
    let divLeftMain = document.createElement('div');
    divLeftMain.style.display = 'flex';
    divLeftMain.style.flexDirection = 'column';
    divLeftMain.style.justifyContent = 'center';
    divLeftMain.style.alignItems = 'flex-start';
    let name = document.createElement('span');
    // name.style.fontWeight = 'bold';
    name.innerText = user.displayName || '';
    divLeftMain.appendChild(name);
    let email = document.createElement('span');
    email.style.fontSize = '14px';
    email.innerText = user.email || '';
    divLeftMain.appendChild(email);
    divLeft.appendChild(divLeftMain);
    if (user.subcustomer !== undefined) {
        let subcustomer = document.createElement('span');
        subcustomer.classList.add('badge');
        subcustomer.style.marginLeft = '15px';
        subcustomer.innerText = user.subcustomer || '';
        let color = stringToColour(user.subcustomer);
        subcustomer.style.backgroundColor = color.bgColor;
        subcustomer.style.color = color.color;
        divLeft.appendChild(subcustomer);
    }
    let checkboxDisabled = document.createElement('md-checkbox');
    checkboxDisabled.checked = !user.disabled;
    checkboxDisabled.disabled = true;
    divRight.appendChild(checkboxDisabled);
    if (user.subcustomer === undefined) {
        let checkboxAdmin = document.createElement('md-checkbox');
        checkboxAdmin.checked = user.customerAdmin || false;
        checkboxAdmin.disabled = true;
        divRight.appendChild(checkboxAdmin);
    }
    let buttonEdit = document.createElement('md-icon-button');
    buttonEdit.classList.add('edit');
    let buttonEditIcon = document.createElement('md-icon');
    buttonEditIcon.innerText = 'edit';
    buttonEdit.appendChild(buttonEditIcon);
    buttonEdit.addEventListener('click', () => {
        openEditUser(user, managingFromAdmin, customerId);
    });
    if (user.uid === auth.currentUser.uid) {
        buttonEdit.setAttribute('disabled', 'true');
    }
    divRight.appendChild(buttonEdit);
    mainDiv.appendChild(divLeft);
    mainDiv.appendChild(divRight);
    item.appendChild(mainDiv);
    return item;
}

let editingFromAdmin = false;

function openEditUser(user, managingFromAdmin, customerId) {
    console.log(user);
    editingUser = user.uid;
    editingFromAdmin = managingFromAdmin;
    document.getElementById('main_dialog_manage_users_edit_user_name').value = user.displayName || '';
    document.getElementById('main_dialog_manage_users_edit_user_email').value = user.email || '';
    document.getElementById('main_dialog_manage_users_edit_user_email').setAttribute('disabled', 'true');
    document.getElementById('main_dialog_manage_users_edit_user__active').checked = !user.disabled;
    document.getElementById('main_dialog_manage_users_edit_user_reset_mfa').style.display =
        (userClaims.admin || userClaims.customerAdmin) && user.uid !== auth.currentUser.uid ? 'inline-flex' : 'none';
    if (user.subcustomer !== undefined) {
        document.getElementById('main_dialog_manage_users_edit_user__client').style.display = 'block';
        document.getElementById('main_dialog_manage_users_edit_user__company').style.display = 'none';
        document.getElementById('main_dialog_manage_users_edit_user__client_select').innerHTML = '';
        let subcustomers = [];
        if (managingFromAdmin) {
            console.log(managingFromAdmin, customerId);
            products.forEach(product => {
                if (product.customer === customerId && product.subcustomer && !subcustomers.includes(product.subcustomer)) {
                    subcustomers.push(product.subcustomer);
                }
            });
        } else {
            products.forEach(product => {
                if (product.subcustomer && !subcustomers.includes(product.subcustomer)) {
                    subcustomers.push(product.subcustomer);
                }
            });
        }
        subcustomers.forEach((subcustomer, index) => {
            let option = document.createElement('md-select-option');
            option.value = subcustomer;
            option.innerText = subcustomer;
            document.getElementById('main_dialog_manage_users_edit_user__client_select').appendChild(option);
        });
        document.getElementById('main_dialog_manage_users_edit_user__client_select').value = user.subcustomer || '';
    } else {
        document.getElementById('main_dialog_manage_users_edit_user__client').style.display = 'none';
        document.getElementById('main_dialog_manage_users_edit_user__company').style.display = 'block';
        document.getElementById('main_dialog_manage_users_edit_user__company_admin').checked = user.customerAdmin || false;
    }
    document.getElementById('main_dialog_manage_users_edit_user').show();
}

document.getElementById('main_dialog_manage_users_edit_user_close').addEventListener('click', () => {
    editingUser = '';
    document.getElementById('main_dialog_manage_users_edit_user').close();
    if (!editingFromAdmin) {
        openManageUsers();
    }
});

let editingUser = '';

document.getElementById('main_dialog_manage_users_edit_user_reset_mfa').addEventListener('click', async () => {
    const uid = editingUser;
    if (!uid || !window.confirm(langDataLocal['confirm_reset_mfa'].replace('{email}',
        document.getElementById('main_dialog_manage_users_edit_user_email').value))) {
        return;
    }
    const button = document.getElementById('main_dialog_manage_users_edit_user_reset_mfa');
    button.disabled = true;
    try {
        const token = await auth.currentUser.getIdToken();
        const response = await fetch('https://customer-services.zonatic.tech/user/mfa/reset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, uid })
        });
        if (!response.ok) throw new Error('MFA reset failed');
        showMessage('success', 'mfa_reset_success');
    } catch (error) {
        showError('error', 'mfa_reset_error');
    } finally {
        button.disabled = false;
    }
});

document.getElementById('main_dialog_manage_users_edit_user_save').addEventListener('click', () => {
    let email = document.getElementById('main_dialog_manage_users_edit_user_email').value;
    let name = document.getElementById('main_dialog_manage_users_edit_user_name').value;
    let user = {};
    if (document.getElementById('main_dialog_manage_users_edit_user__client').style.display === 'block') {
        user.subcustomer = document.getElementById('main_dialog_manage_users_edit_user__client_select').value;
    } else {
        user.admin = document.getElementById('main_dialog_manage_users_edit_user__company_admin').checked;
    }
    user.disabled = !document.getElementById('main_dialog_manage_users_edit_user__active').checked;
    if (!email || !name || !editingUser) {
        showError('error', 'fill_all_fields');
        return;
    }
    updateUser(editingUser, email, name, user.admin, user.subcustomer, user.disabled, editingFromAdmin ? editingCustomerId : null);
});

function updateUser(uid, email, displayName, customerAdmin, subcustomer, disabled, customer) {
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/user', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                uid,
                email,
                displayName,
                customerAdmin,
                subcustomer,
                disabled,
                customer
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_updating_user');
                } else {
                    console.log('User updated successfully');
                    document.getElementById('main_dialog_manage_users_edit_user').close();
                    if (!editingFromAdmin) {
                        openManageUsers();
                    }
                }
            })
            .catch((error) => {
                console.error('Error updating user', error);
                showError('error', 'error_updating_user');
            });
    })
        .catch((error) => {
            console.error('Error getting token', error);
        });
}

function addUser(email, displayName, admin, subcustomer, lang, customer) {
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                email,
                displayName,
                admin,
                subcustomer,
                lang,
                customer
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_adding_user');
                } else {
                    console.log('User added successfully');
                    if (!editingFromAdmin) {
                        openManageUsers();
                    } else {
                        document.getElementById('main_dialog_manage_users_add_user').close();
                    }
                }
            })
            .catch((error) => {
                console.error('Error adding user', error);
                showError('error', 'error_adding_user');
            });
    })
        .catch((error) => {
            console.error('Error getting token', error);
        });
}

document.getElementById('main_dialog_subcustomer_details_add_contact_person').addEventListener('click', (e) => {
    document.getElementById('main_dialog_contact_person_add_name').value = '';
    document.getElementById('main_dialog_contact_person_add_email').value = '';
    document.getElementById('main_dialog_contact_person_add_phone').value = '';
    document.getElementById('main_dialog_contact_person_add_observations').value = '';
    document.getElementById('main_dialog_contact_person_add').show();
});

document.getElementById('main_dialog_contact_person_add_close').addEventListener('click', () => {
    document.getElementById('main_dialog_contact_person_add').close();
    openSubCustomerDetails(openedSubcustomer, openedSubcustomerParentCustomer);
});

document.getElementById('main_dialog_contact_person_add_save').addEventListener('click', () => {
    let name = document.getElementById('main_dialog_contact_person_add_name').value;
    let email = document.getElementById('main_dialog_contact_person_add_email').value;
    let phone = document.getElementById('main_dialog_contact_person_add_phone').value;
    let observations = document.getElementById('main_dialog_contact_person_add_observations').value;
    if (!name) {
        return;
    }
    addContactPerson(name, email, phone, observations);
});

function addContactPerson(name, email, phone, observations) {
    let subcustomer = openedSubcustomer;
    let contactPerson = {
        name,
        email,
        phone,
        observations
    };
    auth.currentUser.getIdToken().then((token) => {
        fetch('https://customer-services.zonatic.tech/subcustomer_contact_persons', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subcustomer,
                contactPerson,
                token,
                customer: openedSubcustomerParentCustomer || ''
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    console.error(data.error);
                    showError('error', 'error_adding_contact_person');
                } else {
                    console.log('Contact person added successfully');
                    document.getElementById('main_dialog_contact_person_add').close();
                    openSubCustomerDetails(openedSubcustomer, openedSubcustomerParentCustomer);
                }
            })
            .catch((error) => {
                console.error('Error adding contact person', error);
                showError('error', 'error_adding_contact_person');
            });
    })
        .catch((error) => {
            console.error('Error getting token', error);
        });
}

async function speechRecognitionAI() {
    return new Promise((resolve, reject) => {
        // Verifiquem si el navegador suporta la SpeechRecognition API
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            reject(new Error("El navegador no suporta la SpeechRecognition API."));
            return;
        }

        // Inicialitzem el reconeixement de veu
        const recognition = new SpeechRecognition();
        recognition.interimResults = false; // Només resultats definitius
        recognition.maxAlternatives = 1; // Agafem una única transcripció

        // Event: Quan es completa la transcripció
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            resolve(transcript);
        };

        // Event: Quan acaba la gravació
        recognition.onaudioend = () => {
            console.log("El reconeixement de veu ha acabat.");
        };

        // Event: Quan hi ha un error
        recognition.onerror = (event) => {
            if (event.error == 'network') {
                showErrorAI('error', 'error_starting_voice_recognition');
            }
            reject(new Error(`Error en el reconeixement de veu: ${event.error}`));
        };

        // Event: Quan es cancela el reconeixement
        recognition.onend = () => {
            console.log("El reconeixement de veu s'ha finalitzat.");
        };

        // Començar el reconeixement de veu
        try {
            recognition.start();
            console.log("Reconeixement de veu iniciat.");
        } catch (error) {
            showErrorAI('error', 'error_starting_voice_recognition');
            reject(new Error("No s'ha pogut iniciar el reconeixement de veu."));
        }
    });
}

async function searchProductsWithAI(input) {
    console.log(input);
    if (!input) {
        return;
    }
    let prompt = {};
    prompt.userPrompt = input;
    prompt.availableFilters = {};
    prompt.availableFilters.customers = [];
    products.forEach(product => {
        if (isAdmin) {
            let cust = adminGetCustomer(product.customer);
            if (cust && !prompt.availableFilters.customers.includes(cust.name)) {
                prompt.availableFilters.customers.push(cust.name);
            }
        }
    });
    prompt.availableFilters.subcustomers = [];
    products.forEach(product => {
        if (product.subcustomer && !prompt.availableFilters.subcustomers.includes(product.subcustomer)) {
            prompt.availableFilters.subcustomers.push(product.subcustomer);
        }
    });
    prompt.availableFilters.providers = [];
    products.forEach(product => {
        providers.forEach(provider => {
            if (product.provider === provider.id && !prompt.availableFilters.providers.includes(provider.name)) {
                prompt.availableFilters.providers.push(provider.name);
            }
        });
    });
    prompt.availableFilters.managedBy = [];
    products.forEach(product => {
        if (product.managedBy && !prompt.availableFilters.managedBy.includes(product.managedBy)) {
            prompt.availableFilters.managedBy.push(product.managedBy);
        }
    });
    prompt.availableFilters.status = ['inactive', 'proposal_pending', 'renewal_pending', 'active'];

    return await auth.currentUser.getIdToken().then(async (token) => {
        return await fetch('https://customer-services.zonatic.tech/aiSearch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                prompt
            })
        })
            .then(res => res.json())
            .then(res => {
                console.log(res);
                return res;
            })
            .catch(err => {
                console.error(err);
                return null;
            });
    })
        .catch(err => {
            console.error(err);
            return null;
        });

}

document.getElementById('main__content__card__my_products__search_with_ai').addEventListener('click', () => {
    document.getElementById('main__content__card__my_products__search_with_ai_input').value = '';
    document.getElementById('main__content__card__my_products__search_with_ai_dialog').show();
});

document.getElementById('main__content__card__my_products__search_with_ai_input').addEventListener('keyup', (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
        document.getElementById('main__content__card__my_products__search_with_ai_input').classList.add('aiprocessing');
        document.getElementById('main__content__card__my_products__search_with_ai_input').disabled = true;
        searchProductsWithAI(document.getElementById('main__content__card__my_products__search_with_ai_input').value).then((response) => {
            console.log(response);
            document.getElementById('main__content__card__my_products__search_with_ai_dialog').close();
            document.getElementById('main__content__card__my_products__search_with_ai_input').classList.remove('aiprocessing');
            document.getElementById('main__content__card__my_products__search_with_ai_input').disabled = false;

            // Apply filters
            my_products__filters__customers_activeFilters = response.subcustomers;
            if (response.subcustomers.length > 0) {
                document.getElementById('my_products__filters__subcustomersadmin').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__subcustomersadmin').removeAttribute('selected');
            }
            my_products__filters__subcustomersadmin_activeFilters = response.customers;
            if (response.customers.length > 0) {
                document.getElementById('my_products__filters__customersadmin').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__customersadmin').removeAttribute('selected');
            }
            let providers_to_filter = [];
            providers.forEach(provider => {
                if (response.providers.includes(provider.name)) {
                    providers_to_filter.push(provider.id);
                }
            });
            if (providers_to_filter.length > 0) {
                document.getElementById('my_products__filters__providers').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__providers').removeAttribute('selected');
            }
            my_products__filters__providers_activeFilters = providers_to_filter;
            // if (others_to_filter.length > 0) {
            //     document.getElementById('my_products__filters__others').setAttribute('selected', 'true');
            // } else {
            //     document.getElementById('my_products__filters__others').removeAttribute('selected');
            // }
            // my_products__filters__others_activeFilters = others_to_filter;
            if (response.managedBy.length > 0) {
                document.getElementById('my_products__filters__managedBy').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__managedBy').removeAttribute('selected');
            }
            my_products__filters__managedBy_activeFilters = response.managedBy;
            if (response.status.length > 0) {
                document.getElementById('my_products__filters__status').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__status').removeAttribute('selected');
            }
            my_products__filters__status_activeFilters = response.status;
            my_products__filters__tags_activeFilters = ensureUniqueTagIds(response.tags || []);
            updateTagFilterSelectionState();
            if (response.expiresRangeStart || response.expiresRangeEnd) {
                document.getElementById('my_products__filters__expiryDate').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__expiryDate').removeAttribute('selected');
            }
            my_products__filters__expiryDate_start = response.expiresRangeStart;
            my_products__filters__expiryDate_end = response.expiresRangeEnd;
            // If any of expiryDate filters is set, set the icon to selected
            if (my_products__filters__expiryDate_start || my_products__filters__expiryDate_end) {
                document.getElementById('my_products__filters__expiryDate').setAttribute('selected', 'true');
            } else {
                document.getElementById('my_products__filters__expiryDate').removeAttribute('selected');
            }
            filterProducts();
        });
    }
});

document.getElementById('main__content__card__my_products__search_with_ai_dialog_apply').addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('main__content__card__my_products__search_with_ai_input').classList.add('aiprocessing');
    document.getElementById('main__content__card__my_products__search_with_ai_input').disabled = true;
    searchProductsWithAI(document.getElementById('main__content__card__my_products__search_with_ai_input').value).then((response) => {
        console.log(response);
        document.getElementById('main__content__card__my_products__search_with_ai_dialog').close();
        document.getElementById('main__content__card__my_products__search_with_ai_input').classList.remove('aiprocessing');
        document.getElementById('main__content__card__my_products__search_with_ai_input').disabled = false;
    });
});

document.getElementById('main__content__card__my_products__search_with_ai_dialog_close').addEventListener('click', () => {
    document.getElementById('main__content__card__my_products__search_with_ai_dialog').close();
});

document.querySelectorAll('#main_dialog_product_edit_status_reason_chips md-assist-chip').forEach(chip => {
    chip.addEventListener('click', () => {
        const preset = chip.getAttribute('data-text');
        let field = document.getElementById('main_dialog_product_edit_status_reason');
        let text = field.value;
        if (text.trim() !== '') {
            text += '\n';
        }
        text += moment().format('DD/MM/YYYY') + ' ' + preset;
        field.value = text;
        // Set the cursor to the end of the input field
        field.focus();
        field.setSelectionRange(text.length, text.length);
    });
});



const anchorExternalCustomer = document.getElementById('main_dialog_product_edit_external_customers_add');
const menuExternalCustomer = document.getElementById('main_dialog_product_edit_external_customers_add_menu');

anchorExternalCustomer.addEventListener('click', (e) => {
    e.preventDefault();
    menuExternalCustomer.open = !menuExternalCustomer.open;
});

document.querySelectorAll('md-dialog').forEach(dialog => {
    dialog.addEventListener('cancel', (event) => {
        event.preventDefault(); // Evita el tancament quan es fa clic a l'exterior
    });
});


document.getElementById('main_dialog_customers_add').addEventListener('click', () => {
    document.getElementById('main_dialog_add_client').show();
    document.getElementById('main_dialog_add_client_name').value = '';
    setTimeout(() => {
        document.getElementById('main_dialog_add_client_name').focus();
    }, 150);
});

document.getElementById('main_dialog_add_client_close').addEventListener('click', () => {
    document.getElementById('main_dialog_add_client').close();
});

document.getElementById('main_dialog_add_client_save').addEventListener('click', () => {
    let name = normalizeEntityName(document.getElementById('main_dialog_add_client_name').value);
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }

    const customerExists = customersAdmin.some((customer) => normalizeEntityName(customer.name) === name)
        || products.some((product) => product.customer && product.customer.toUpperCase() === name);
    if (customerExists) {
        showError('error', 'customer_already_exists');
        return;
    }

    // Add customer to firestore
    addDoc(collection(db, 'customers'), {
        name: name,
    })
        .then(() => {
            console.log('Customer added successfully');
            document.getElementById('main_dialog_add_client').close();
            window.location.reload(); // Reload the page to reflect the changes
        })
        .catch((error) => {
            console.error('Error adding customer', error);
            showError('error', 'error_adding_customer');
        });
});

document.getElementById('main_dialog_customer_details_delete').addEventListener('click', () => {
    if (confirm(langDataLocal['confirm_delete_customer'])) {
        let customerId = openedCustomer;
        deleteDoc(doc(db, 'customers', customerId))
            .then(() => {
                console.log('Customer deleted successfully');
                // Remove all products associated with this customer
                let batch = writeBatch(db);
                products.forEach(product => {
                    if (product.customer === customerId) {
                        batch.delete(doc(db, 'products', product.id));
                    }
                });
                return batch.commit();
            })
            .then(() => {
                console.log('All products associated with the customer deleted successfully');
                // Reload the page to reflect the changes
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting customer or associated products', error);
                showError('error', 'error_deleting_customer');
            });
    }
});

document.getElementById('main_dialog_customer_details_contacts_add').addEventListener('click', () => {
    document.getElementById('main_dialog_add_contact_name').value = '';
    document.getElementById('main_dialog_add_contact_email').value = '';
    document.getElementById('main_dialog_add_contact_phone').value = '';
    document.getElementById('main_dialog_add_contact_observations').value = '';
    document.getElementById('main_dialog_add_contact').show();
});

document.getElementById('main_dialog_add_contact_close').addEventListener('click', () => {
    document.getElementById('main_dialog_add_contact').close();
});

/**
 * Valida si una cadena és un correu electrònic vàlid.
 *
 * @param {string} email - La cadena a validar com a correu electrònic.
 * @returns {boolean} - Retorna true si l'email és vàlid, false en cas contrari.
 */
function isValidEmail(email) {
    // Regex basat en l'estàndard RFC 5322 (simplificat per a usos comuns)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

document.getElementById('main_dialog_add_contact_save').addEventListener('click', () => {
    let name = document.getElementById('main_dialog_add_contact_name').value;
    let email = document.getElementById('main_dialog_add_contact_email').value;
    let phone = document.getElementById('main_dialog_add_contact_phone').value;
    let observations = document.getElementById('main_dialog_add_contact_observations').value
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!email) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!phone) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!isValidEmail(email)) {
        showError('error', 'invalid_email');
        return;
    }
    const contactId = crypto.randomUUID(); // Generate a unique ID for the contact
    let contact = {
        name,
        email,
        phone,
        observations,
        id: contactId,
    };
    let customerId = openedCustomer;

    // Add contact to firestore's customer document
    updateDoc(doc(db, 'customers', customerId), {
        contacts: arrayUnion(contact)
    })
        .then(() => {
            console.log('Contact added successfully');
            document.getElementById('main_dialog_add_contact').close();
            setTimeout(() => {
                reopenCustomerDetails(customersAdmin.find(item => item.id === openedCustomer));
            }, 200);
        })
        .catch((error) => {
            console.error('Error adding contact', error);
            showError('error', 'error_adding_contact');
        });
});

let editingContactId = '';

document.getElementById('main_dialog_edit_contact_save').addEventListener('click', () => {
    let name = document.getElementById('main_dialog_edit_contact_name').value;
    let email = document.getElementById('main_dialog_edit_contact_email').value;
    let phone = document.getElementById('main_dialog_edit_contact_phone').value;
    let observations = document.getElementById('main_dialog_edit_contact_observations').value
    if (!name) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!email) {
        showError('error', 'fill_all_fields');
        return;
    }
    if (!phone) {
        showError('error', 'fill_all_fields');
    }
    if (!isValidEmail(email)) {
        showError('error', 'invalid_email');
        return;
    }
    let customerId = openedCustomer;
    let contact = {
        name,
        email,
        phone,
        observations,
        id: editingContactId,
    };

    const currentContact = customersAdmin.find(item => item.id === openedCustomer)?.contacts?.find(contact => contact.id === editingContactId);
    if (!currentContact) {
        showError('error', 'contact_not_found');
        return;
    }
    // Update contact in firestore's customer document
    updateDoc(doc(db, 'customers', customerId), {
        contacts: arrayRemove(currentContact) // Remove the old contact
    })
        .then(() => {
            return updateDoc(doc(db, 'customers', customerId), {
                contacts: arrayUnion(contact) // Add the updated contact
            });
        })
        .then(() => {
            console.log('Contact updated successfully');
            document.getElementById('main_dialog_edit_contact').close();
            setTimeout(() => {
                reopenCustomerDetails(customersAdmin.find(item => item.id === openedCustomer));
            }, 200);
        })
        .catch((error) => {
            console.error('Error updating contact', error);
            showError('error', 'error_updating_contact');
        });
});

document.getElementById('main_dialog_edit_contact_delete').addEventListener('click', () => {
    if (confirm(langDataLocal['delete_contact'] + '?')) {
        let customerId = openedCustomer;
        const currentContact = customersAdmin.find(item => item.id === openedCustomer)?.contacts?.find(contact => contact.id === editingContactId);
        if (!currentContact) {
            showError('error', 'contact_not_found');
            return;
        }
        // Remove contact from firestore's customer document
        updateDoc(doc(db, 'customers', customerId), {
            contacts: arrayRemove(currentContact) // Remove the contact
        })
            .then(() => {
                console.log('Contact deleted successfully');
                document.getElementById('main_dialog_edit_contact').close();
                setTimeout(() => {
                    reopenCustomerDetails(customersAdmin.find(item => item.id === openedCustomer));
                }, 200);
            })
            .catch((error) => {
                console.error('Error deleting contact', error);
                showError('error', 'error_deleting_contact');
            });
    }
});


document.getElementById('main_dialog_edit_contact_close').addEventListener('click', () => {
    document.getElementById('main_dialog_edit_contact').close();
});


function reopenCustomerDetails(customer) {
    document.getElementById('main_dialog_customer_details').close();
    setTimeout(() => {
        openCustomerDetails(customer);
    }, 500);
}
